/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title membership.js: Feature level module
	 * @description This is entry point for the application page.
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(93), __webpack_require__(95), __webpack_require__(96)], __WEBPACK_AMD_DEFINE_RESULT__ = function (application, QuickApplication, QuickMembershipCheckout) {
		/**
	  * Initializing the membership related functionality including
	  * 	1. Membership Application
	  * 	2. Quick Membership Checkout
	  * @return {void}
	  */
		function init() {
			//application.init();
	
			var page = $('[data-page]').data('page') || '';
	
			switch (page) {
	
				case 'quick-membership':
					QuickApplication.init();
					break;
	
				case 'quick-membership-purchase':
					QuickMembershipCheckout.init(page);
					break;
	
				case 'quick-membership-renew':
					QuickMembershipCheckout.init(page);
					break;
	
				default:
					application.init();
			}
		}
		if (typeof window.COSTCO == 'undefined') {
			window.COSTCO = {};
		}
		if (typeof window.COSTCO.Global == 'undefined') {
			document.addEventListener('CostcoGlobalLoaded', init, false);
		} else {
			init();
		}
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 1 */,
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Password Strength indiciator
	 *  Used in account.module.js
	 *    for create account
	 *    for forgot password
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	  var PasswordStrength = {
	    init: function init() {
	      if (!$('#logonPassword').length > 0 || $('#RegisterForm, #ChangePasswordForm, #RegisterFormBD').length == 0) return;
	      $('#logonPassword:not(.nostrength)').keyup(this.passwordStrength).focusin(function () {
	        $('#PasswordStrength').show();
	      });
	      $('#logonPasswordVerify').keyup(this.passwordMatch).focusin(function () {
	        $('#PasswordStrength').show();
	      });
	    },
	    passwordStrength: function passwordStrength() {
	      var value = $(this).val();
	      var entropy = ['short', 'weak', 'fair', 'good', 'strong'];
	      var degree = 0;
	      if (/.{8,20}/.test(value)) {
	        degree++;
	        $('.chars').removeClass('invalid').addClass('valid');
	        if (/.{10,20}/.test(value)) {
	          if (/(?=.*[a-z])/.test(value)) {
	            degree++;
	          }
	          if (/(?=.*[A-Z])/.test(value)) {
	            degree++;
	          }
	          if (/(?=.*\d)/.test(value)) {
	            degree++;
	          }
	          if (/[!,%,&,@,#,$,^,*,?,_,~]/.test(value)) {
	            degree++;
	          }
	          degree--;
	        }
	      } else {
	        $('.chars').removeClass('valid').addClass('invalid');
	      }
	      if (/[a-z,A-Z]/.test(value)) {
	        $('.letters').removeClass('invalid').addClass('valid');
	      } else {
	        $('.letters').removeClass('valid').addClass('invalid');
	      }
	      if (/[<,>,",\\,\s,\.]/.test(value)) {
	        $('.special').removeClass('valid').addClass('invalid');
	      } else {
	        $('.special').removeClass('invalid').addClass('valid');
	      }
	      $('#PasswordStrength').removeClass().addClass(entropy[degree]);
	      if ($('#logonPasswordVerify').val().length > 0) {
	        PasswordStrength.passwordMatch();
	      } else if ($('#logonPassword').val().length == 0 && $('#logonPasswordVerify').val().length == 0) {
	        $('.valid').removeClass('valid');
	        $('.invalid').removeClass('invalid');
	      }
	    },
	    passwordMatch: function passwordMatch() {
	      if ($('#logonPasswordVerify').val().length > 0) {
	        if ($('#logonPasswordVerify').val() == $('#logonPassword').val()) {
	          $('.match').removeClass('invalid').addClass('valid');
	        } else {
	          $('.match').removeClass('valid').addClass('invalid');
	        }
	      }
	      if ($('#logonPassword').val().length == 0 && $('#logonPasswordVerify').val().length == 0) {
	        $('.valid').removeClass('valid');
	        $('.invalid').removeClass('invalid');
	      }
	    }
	  };
	  if (typeof window.COSTCO == 'undefined') {
	    window.COSTCO = {};
	  }
	  window.COSTCO.PasswordStrength = PasswordStrength;
	  return PasswordStrength;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (passwordStrength) {
	  var Logon = {
	    /**
	     * Initializing the module.
	     */
	    init: function init() {
	
	      COSTCO.util.maskMembershipInput();
	
	      this.allowSignIn();
	      this.validationRules();
	      this.validate();
	      this.validateMemberRestricted();
	      this.popovers();
	      this.focusInput();
	      this.addMaskToZipInput($('#deliveryZipCode'));
	      this.addMaskToZipInput($('#userRegdeliveryZipCode'));
	      passwordStrength.init();
	    },
	    /**
	     * We want to focus the user on the logon id (email) if
	     * it exists, otherwise we want to focus on the password input
	     * in the case of "change password"
	     * @return {void}
	     */
	    focusInput: function focusInput() {
	      // Adding a window load so the focus waits until the login form is drawn.
	      // Causes the footer to be viewed if logon form has been drawn yet.
	      $(window).on('load', function () {
	        var $focusInput = $('#ChangePasswordForm #membershipNumber').length > 0 ? $('#ChangePasswordForm #membershipNumber') : $('#logonId, #register_email1, #logonPasswordOld');
	        var $password = $('#logonPassword');
	        $focusInput.length > 0 ? $focusInput.focus() : $password.focus();
	        window.scrollTo(0, 0);
	      });
	    },
	    /**
	     * ALM2982
	     * We want to disable sign in before the whole logon page is loaded, because clicking sign in button before end of page load, may result in odd behaviour
	     * 
	     * @return {void}
	     */
	    allowSignIn: function allowSignIn() {
	      $('#sign_in_button').attr('disabled', true);
	      $(window).on('load', function () {
	        $('#sign_in_button').attr('disabled', false);
	        referrerURL = document.referrer;
	        url = document.URL;
	
	        // if we're redirectd from the ChangePassword Page, We need to show the success page
	        if ((!COSTCO.util.isBusinessDelivery($('#isBDAppVar').val()) && (referrerURL.indexOf('ChangePassword') > -1 || referrerURL.indexOf('ResetPassword') > -1) || COSTCO.util.isBusinessDelivery($('#isBDAppVar').val()) && referrerURL.indexOf('AccountPasswordUpdate') > -1) && url.indexOf('LogonForm') > -1 && !$('#passwordSuccessMessage').length > 0) {
	          $('#passwordSuccessLogonMessage').removeClass('hide');
	        } else {
	          $('#passwordSuccessLogonMessage').addClass('hide');
	        }
	      });
	    },
	    /**
	     * Tool tips.
	     */
	    popovers: function popovers() {
	      $('.co-info, .co-help').popover();
	    },
	    /**
	     * The validation rules for the inputs assoicated with signing in,
	     * creating an account, and forgot password.
	     */
	    validationRules: function validationRules() {
	      $.validator.addMethod('email', function (value, element) {
	        return this.optional(element) || /^.+@(([^.])+\.)+([^.])+$/i.test(value);
	      }, messages.JS_VALID_EMAIL);
	      $.validator.addMethod('passwordRule', function (value, element) {
	        return (/^[^<,>,",\\,\s,\.]{8,20}$/.test(value) && /[a-zA-Z]/.test(value)
	        );
	      }, messages.JS_VALID_REQUIRED);
	      $.validator.addMethod('costcoMembership', function (value, element) {
	        return this.optional(element) || /^\d{12,16}$/.test(value);
	      }, messages.ERR_INVALID_MEMBERSHIP_NO);
	      $.validator.addMethod('countryspecificpostalcode', function (value, element, params) {
	        var zip_pattern = new RegExp(document.getElementById('zipcode_patterns').getAttribute('value'));
	        return this.optional(element) || zip_pattern.test($.trim(value));
	      }, messages.ERR_ENTER_ZIPCODE);
	    },
	    /**
	     * Used in the LogonForm submit handler, this logic sets the cookie based
	     * on the user's choice of checking the "Remember Me" checkbox.
	     */
	    rememberMe: function rememberMe() {
	      if ($('#option1').is(':checked')) {
	        $.cookie('rememberedLogonId', $('#logonId').val(), {
	          expires: 14,
	          path: '/'
	        });
	      } else if ($('#option1').length > 0) {
	        $.cookie('rememberedLogonId', null, {
	          path: '/'
	        });
	      }
	    },
	    /**
	     * gets base64 encoded referrer for redirecting user back to the page
	     * they were on after logging in.
	     */
	    getLogonRedirectURL: function getLogonRedirectURL() {
	      var url = void 0;
	      // if there is already a value for this input (pharmacy is always home-delivery),
	      // then don't change the redirect url to the previous page.
	      if ($('#WC_AccountDisplay_FormInput_URL_In_Logon_1').val()) {
	        url = $('#WC_AccountDisplay_FormInput_URL_In_Logon_1').val();
	      } else {
	        url = document.referrer;
	        // if the referrer isn't a category/search/landing/product and isn't our domain,
	        // set the url to homepage
	        if (!((url.indexOf('.html') > -1 || url.indexOf('/CatalogSearch') > -1) && url.indexOf(location.protocol + '//' + location.host) == 0)) {
	          url = '/';
	        }
	      }
	      // need to encode to get past xss filter
	      return COSTCO.util.encode(url);
	    },
	
	    requireMembership: function requireMembership(form, fieldName) {
	      if ($(form).length == 0) {
	        return;
	      }
	
	      form.rules('add', {
	        required: true,
	        costcoMembership: true,
	        messages: {
	          required: messages.JS_VALID_REQUIRED,
	          costcoMembership: messages.ERR_INVALID_MEMBERSHIP_NO
	        }
	      });
	    },
	    /**
	     * Validation for the membership restricted form
	     */
	    validateMemberRestricted: function validateMemberRestricted() {
	      $('#MembershipInformationUpdate').validate({
	        rules: {
	          membershipNumber: {
	            required: true,
	            costcoMembership: true
	          }
	        },
	        messages: {
	          membershipNumber: {
	            required: messages.ERR_INVALID_MEMBERSHIP_NO
	          }
	        },
	        submitHandler: function submitHandler(form) {
	          // This we don't want trailing whitespace.
	          $('#membershipNumber').val($('#membershipNumber').val().trim());
	          form.submit();
	        }
	      });
	    },
	    /**
	     * Add mask to zip input in case US (global var shippingCountries[0] used to determine country)
	     */
	    addMaskToZipInput: function addMaskToZipInput(zipInput) {
	      if (zipInput) {
	        // Add mask to zip input in case US (global var shippingCountries[0] used to determine country)
	        if (shippingCountries != null && shippingCountries.length > 0 && shippingCountries[0] == "US") {
	          zipInput.unmask().mask('00000-0000');
	        }
	      }
	    },
	    /**
	     * Validate the given forms.
	     */
	    validate: function validate() {
	      $('#LogonForm, #LogonFormBD, #ResetPasswordForm').validate({
	        rules: {
	          logonId: {
	            required: true,
	            email: true,
	            maxlength: 251
	          },
	          logonPassword: {
	            required: true
	          },
	          deliveryZipCode: {
	            required: true,
	            countryspecificpostalcode: true
	          }
	        },
	        messages: {
	          logonId: {
	            required: messages.ERR_REQUIRED_LOGON,
	            email: messages.ERR_INVALID_EMAIL,
	            maxlength: messages.ERR_EMAIL_MAX_LENGTH
	          },
	          logonPassword: {
	            required: messages.ERR_REQUIRED_PASSWORD
	          },
	          deliveryZipCode: {
	            required: messages.ERR_INVALID_DELIVERY_ZIP_CODE,
	            countryspecificpostalcode: messages.ERR_INVALID_DELIVERY_ZIP_CODE
	          }
	        },
	        submitHandler: function (form) {
	          this.rememberMe();
	          // This we don't want trailing whitespace.
	          $('#logonId').val($('#logonId').val().trim());
	
	          var url = this.getLogonRedirectURL();
	          $('#WC_AccountDisplay_FormInput_URL_In_Logon_1').val(url);
	
	          //remove changeValidationFlag from storage session
	          sessionStorage.removeItem("changeValidationFlag");
	
	          form.submit();
	        }.bind(this)
	      });
	      if (COSTCO.util.isBusinessDelivery($('#isBDAppVar').val())) {
	        $('#ChangePasswordForm').validate({
	          rules: {
	            logonPasswordOld: {
	              required: true
	            },
	            logonPassword: {
	              passwordRule: true
	            },
	            logonPasswordVerify: {
	              required: true,
	              passwordRule: true,
	              equalTo: '#logonPassword'
	            }
	          },
	          messages: {
	            logonPasswordOld: {
	              password: messages.JS_VALID_REQUIRED
	            },
	            logonPassword: {
	              passwordRule: messages.JS_VALID_REQUIRED
	            },
	            logonPasswordVerify: {
	              required: messages.CONFIRM_PASSWORD,
	              passwordRule: messages.ERR_REQUIRED_PASSWORD,
	              equalTo: messages.ERR_REQUIRED_PASSWORD_MATCH
	            }
	          }
	        });
	        $('#RegisterForm').validate({
	          rules: {
	            email1: {
	              required: true,
	              email: true,
	              maxlength: 251
	            },
	            logonPassword: {
	              passwordRule: true
	            },
	            logonPasswordVerify: {
	              required: true,
	              passwordRule: true,
	              equalTo: '#logonPassword'
	            },
	            userField2: {
	              costcoMembership: true
	            },
	            userRegdeliveryZipCode: {
	              required: true,
	              countryspecificpostalcode: true
	            }
	          },
	          messages: {
	            email1: {
	              required: messages.ERR_REQUIRED_LOGON,
	              email: messages.ERR_INVALID_EMAIL,
	              maxlength: messages.ERR_EMAIL_MAX_LENGTH
	            },
	            logonPassword: {
	              passwordRule: messages.ERR_REQUIRED_PASSWORD
	            },
	            logonPasswordVerify: {
	              required: messages.CONFIRM_PASSWORD,
	              passwordRule: messages.ERR_REQUIRED_PASSWORD,
	              equalTo: messages.ERR_REQUIRED_PASSWORD_MATCH
	            },
	            userField2: {
	              costcoMembership: messages.ERR_INVALID_MEMBERSHIP_NO
	            },
	            userRegdeliveryZipCode: {
	              required: messages.ERR_INVALID_DELIVERY_ZIP_CODE,
	              countryspecificpostalcode: messages.ERR_INVALID_DELIVERY_ZIP_CODE
	            }
	          }
	        });
	      } else {
	        $('#RegisterForm, #ChangePasswordForm').validate({
	          rules: {
	            email1: {
	              required: true,
	              email: true,
	              maxlength: 251
	            },
	            logonPassword: {
	              passwordRule: true
	            },
	            logonPasswordVerify: {
	              required: true,
	              passwordRule: true,
	              equalTo: '#logonPassword'
	            },
	            userField2: {
	              costcoMembership: true
	            },
	            userRegdeliveryZipCode: {
	              required: true,
	              countryspecificpostalcode: true
	            }
	          },
	          messages: {
	            email1: {
	              required: messages.ERR_REQUIRED_LOGON,
	              email: messages.ERR_INVALID_EMAIL,
	              maxlength: messages.ERR_EMAIL_MAX_LENGTH
	            },
	            logonPassword: {
	              passwordRule: messages.ERR_REQUIRED_PASSWORD
	            },
	            logonPasswordVerify: {
	              required: messages.CONFIRM_PASSWORD,
	              passwordRule: messages.ERR_REQUIRED_PASSWORD,
	              equalTo: messages.ERR_REQUIRED_PASSWORD_MATCH
	            },
	            userField2: {
	              costcoMembership: messages.ERR_INVALID_MEMBERSHIP_NO
	            },
	            userRegdeliveryZipCode: {
	              required: messages.ERR_INVALID_DELIVERY_ZIP_CODE,
	              countryspecificpostalcode: messages.ERR_INVALID_DELIVERY_ZIP_CODE
	            }
	          }
	        });
	      }
	
	      if (typeof instacartStatic !== 'undefined' && instacartStatic.enabled) {
	        var _$membership = $('[name="userField2"]');
	        COSTCO.Logon.requireMembership(_$membership);
	      }
	      $('#RegisterFormBD').validate({
	        rules: {
	          email1: {
	            required: true,
	            email: true,
	            maxlength: 251
	          },
	          logonPassword: {
	            passwordRule: true
	          },
	          logonPasswordVerify: {
	            required: true,
	            passwordRule: true,
	            equalTo: '#logonPassword'
	          },
	          userField2: {
	            required: true,
	            costcoMembership: true
	          },
	          userRegdeliveryZipCode: {
	            required: true,
	            countryspecificpostalcode: true
	          }
	        },
	        messages: {
	          email1: {
	            required: messages.ERR_REQUIRED_LOGON,
	            email: messages.ERR_INVALID_EMAIL,
	            maxlength: messages.ERR_EMAIL_MAX_LENGTH
	          },
	          logonPassword: {
	            passwordRule: messages.ERR_REQUIRED_PASSWORD
	          },
	          logonPasswordVerify: {
	            required: messages.CONFIRM_PASSWORD,
	            passwordRule: messages.ERR_REQUIRED_PASSWORD,
	            equalTo: messages.ERR_REQUIRED_PASSWORD_MATCH
	          },
	          userField2: {
	            required: messages.ERR_REQUIRED_COSTCO_BD_MEMBERSHIP_NO,
	            costcoMembership: messages.ERR_INVALID_MEMBERSHIP_NO
	          },
	          userRegdeliveryZipCode: {
	            required: messages.ERR_INVALID_DELIVERY_ZIP_CODE,
	            countryspecificpostalcode: messages.ERR_INVALID_DELIVERY_ZIP_CODE
	          }
	        }
	      });
	      var $membership = $('#ChangePasswordForm #membershipNumber');
	      if ($membership.length > 0) {
	        // This is for the case where we arrive on the change password
	        // page as part of the manual authentication flow
	        COSTCO.Logon.requireMembership($membership);
	      }
	
	      $('#LinkMembershipForm').validate({
	        rules: {
	          membershipNumber: {
	            required: true,
	            costcoMembership: true
	          }
	        },
	        messages: {
	          membershipNumber: {
	            required: messages.JS_VALID_REQUIRED,
	            costcoMembership: messages.ERR_INVALID_MEMBERSHIP_NO
	          }
	        }
	      });
	    }
	  };
	  if (typeof window.COSTCO == 'undefined') {
	    window.COSTCO = {};
	  }
	  window.COSTCO.Logon = Logon;
	  return Logon;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title account-helper.js: Sub-module for Account pages
	 * @description This module is used to handle various account tasks
	 * @dependency
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
	  var AccountHelper = {
	
	    /**
	     * Initialization of the module.
	     */
	    init: function init() {
	      console.log('Account Helper module intialized.');
	      if (COSTCO.util.isRunningOnMobileApp() && !COSTCO.util.isBusinessDelivery()) {
	        if (document.readyState == 'complete') {
	          $('#my-account-top-nav').on("click", function () {
	            COSTCO.AccountHelper.showMobileMyAccountMenu();
	          });
	        } else {
	          $(window).on('load', function () {
	            $('#my-account-top-nav').on("click", function () {
	              COSTCO.AccountHelper.showMobileMyAccountMenu();
	            });
	          });
	        }
	      }
	    },
	    /**
	     * Constants
	     */
	    notificationType: {
	      SUCCESS: 'SUCCESS',
	      WARNING: 'WARNING',
	      ERROR: 'ERROR'
	    },
	
	    /**
	     * Displays error, warning, or success notification
	     * @param  {String} notificationType Notification type
	     * @param  {Array} notifications     Notification messages
	     * @return {void}
	     */
	    displayTopNotification: function displayTopNotification(notificationType, notifications) {
	
	      this.clearNotification();
	
	      var topNotificationClass = '';
	      var topNotificationInnerHtml = '';
	
	      switch (notificationType) {
	        case this.notificationType.SUCCESS:
	          topNotificationClass = 'success-notification';
	          break;
	        case this.notificationType.WARNING:
	          topNotificationClass = 'warning';
	          break;
	        case this.notificationType.ERROR:
	          topNotificationClass = 'critical-notification';
	          break;
	        default:
	          break;
	      }
	
	      notifications.forEach(function (notification) {
	        topNotificationInnerHtml += '<p automation-id="notificationMessage">' + notification + '</p>';
	      });
	      $('#notification-message').addClass(topNotificationClass);
	      $('#notification-message').html(topNotificationInnerHtml);
	    },
	    /**
	     * Clears top notification
	     */
	    clearNotification: function clearNotification() {
	
	      $('#notification-message').removeClass();
	      $('#notification-message').html('');
	    },
	    /**
	     * Makes dropdown menu options clickable and redirecting to URL stated in
	     * option value attribute, when this HTML class attribute is used.
	     * Used in Top Navigation dropdown menu.
	     */
	    activateDropdownMenuRedirect: function activateDropdownMenuRedirect() {
	      $('.dropdown-menu-redirect').unbind('change').change(function () {
	        window.location.href = $(this).val();
	      });
	    },
	    /**
	     * Reinitializes value selected in  a dropdown manu when the back button is clicked
	     */
	    reinitDropDownMenu: function reinitDropDownMenu() {
	      $('.dropdown-menu-redirect').each(function () {
	        var select = $(this);
	        var selectedValue = select.find('option[selected]').val();
	
	        if (selectedValue) {
	          select.val(selectedValue);
	        } else {
	          select.prop('selectedIndex', 0);
	        }
	      });
	    },
	    /**
	    * Function used to invoke the mobile app My Account navigation
	    */
	    showMobileMyAccountMenu: function showMobileMyAccountMenu() {
	      console.log('Initializing Mobile My Account Menu');
	      try {
	        if (typeof Android != 'undefined') {
	          Android.showMyAccount();
	        } else if (typeof webkit != 'undefined') {
	          webkit.messageHandlers.showMyAccount.postMessage('myaccount');
	        }
	      } catch (e) {
	        console.warn(e);
	      }
	    },
	
	    /**
	        * Adds aria-current for ADA Compliance on "Left Navbar" link for account.
	       * @return void
	       */
	    addAdaComplianceOnLeftNabarForAccount: function addAdaComplianceOnLeftNabarForAccount() {
	      $('#leftnav li.active a').attr('aria-current', "page");
	    }
	  };
	
	  if (typeof window.COSTCO === 'undefined') {
	    window.COSTCO = {};
	  }
	
	  window.COSTCO.AccountHelper = AccountHelper;
	
	  return AccountHelper;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title utility.js: Global sub-module - combination of utility1.js and utility2.js
	 * @description A collection of functions used
	 * application wide. This module should contain
	 * generic utility code. No module specifics.
	 * 
	 * 07/27/2022
	 * utility.js was split into two files, utility1.js and utility2.js
	 * utility2.js contains fucntions that are not invoked on Home, Browse 
	 * and Product pages. Rest of the functions are in utility1.js
	 * 
	 * Only utility1.js is imported into new global module called global.hbp.js for Home, Browser & Product (HBP) pages
	 * Rest of the site will continue to load existing global.module.js which will inlcude both utility1.js and utility2.js
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(9), __webpack_require__(10)], __WEBPACK_AMD_DEFINE_RESULT__ = function (util1, util2) {
	    var util = Object.assign({}, util1, util2);
	    if (typeof window.COSTCO == 'undefined') {
	        window.COSTCO = new Object();
	    }
	    window.COSTCO.util = util;
	    return util;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * @title utility1.js: Global sub-module
	 * @description A collection of functions used
	 * application wide. This module should contain
	 * generic utility code. No module specifics.
	 */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	  var util = {
	    POSTAL_CODE_REGEX_US: /^(\d{5}(-\d{4})?$)$/,
	    POSTAL_CODE_REGEX_CA: /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1} \d{1}[A-Za-z]{1}\d{1}$/,
	    ATLEAST_ONE_ALPHABET: /^(?=.*[A-Za-z\u00C0-\u017F]).+/,
	    CC_NAME_FIELD_REGEX: /[^0-9A-Z\.\'\-\&\s\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u2030\u20AC]/i,
	    /**
	     * John Resig's micro-templating function
	     * @param  {[string]} str  String ID of template
	     * @param  {[object]} data Object representing dynamic values
	     * @return {[string]}      HTML representation as
	     * a string
	     */
	    tmpl: function tmpl(str, data) {
	      var fn = !/\W/.test(str) ? this.tmpl(document.getElementById(str).innerHTML) : new Function('obj', 'var p=[],print=function(){p.push.apply(p,arguments);};' + 'with(obj){p.push(\'' + str.replace(/[\r\t\n]/g, ' ').split('<&').join('\t').replace(/((^|&>)[^\t]*)'/g, '$1\r').replace(/\t=(.*?)&>/g, '\',$1,\'').split('\t').join('\');').split('&>').join('p.push(\'').split('\r').join('\\\'') + '\');}return p.join(\'\');');
	      return data ? fn(data) : fn;
	    },
	    /**
	     * http://kenwheeler.github.io/slick/
	     * Generalized intialization of carousel.
	     * [carousel description]
	     * @param  {[string]} id        [description]
	     * @param  {[object]} options   [description]
	     * @param  {[object]} settings  [description]
	     * @return {[void]}             [description]
	     */
	    carousel: function carousel(id, options, settings) {
	      options = options || {};
	      $slider = $(id);
	      if (settings && settings.initFn) {
	        $slider.on('init', settings.initFn);
	      }
	      // Initialize the carousel. Waits for the application style sheet
	      // to load before initializing to ensure we have the correct
	      // CSS attributes attached to DOM elements
	      if (window.stylesLoaded) {
	        COSTCO.util.initCarousel($slider, options, settings);
	      } else {
	        document.addEventListener('styles-loaded', function initCarouselEvent() {
	          this.util.initCarousel(this.slider, options, settings);
	        }.bind({
	          util: COSTCO.util,
	          slider: $slider
	        }), false);
	      }
	    },
	
	    /**
	     * Initializes the carousel and does any additional bindings and/or
	     * settings.
	     * @param  {[type]} $slider  [description]
	     * @param  {[type]} options  [description]
	     * @param  {[type]} settings [description]
	     * @return {void}
	     */
	    initCarousel: function initCarousel($slider, options, settings) {
	      $slider.slick(options);
	      if (settings && settings.hasPause) {
	        // append a pause button
	        $slider.find('.slick-dots').append('<li class="pause"><button class="playToggle" role="button" type="button" aria-label="' + messages.PAUSE + '"></button></li>');
	        $slider.find('.pause button').unbind().on('click', function () {
	          // define slider to pause/play as the closest parent of the play/pause button
	          // cannot use $slider as by the time the page is initialized $slider points to a different carousel
	          var mySlider = $(this).closest('.slick-slider');
	          $(this).toggleClass('active');
	          if ($(this).hasClass('active')) {
	            mySlider.slick('slickPause');
	            $(this).attr('aria-label', messages.PLAY);
	          } else {
	            mySlider.slick('slickPlay');
	            $(this).attr('aria-label', messages.PAUSE);
	          }
	        });
	      }
	
	      if (options && options.arrows) {
	        // Update the aria label on the arrows
	        $slider.find('.slick-next').attr('aria-label', settings != undefined && settings.nextLabel != undefined ? settings.nextLabel : messages.NEXT_SLIDE);
	        $slider.find('.slick-prev').attr('aria-label', settings != undefined && settings.prevLabel != undefined ? settings.prevLabel : messages.PREV_SLIDE);
	      }
	
	      // put descriptive text for carousel dot buttons for ADA
	      $slider.each(function () {
	        $(this).find('li button[data-role=none]').each(function (index) {
	          $(this).text('slide set ' + (index + 1));
	        });
	        $(this).find('li').removeAttr('aria-hidden');
	      });
	
	      // Are there any events beforeChange/afterChange we are binding?
	      if (settings && settings.beforeFn) {
	        $slider.on('beforeChange', settings.beforeFn);
	      }
	      if (settings && settings.afterFn) {
	        $slider.on('afterChange', settings.afterFn);
	      }
	      if (settings && settings.destroyFn) {
	        $slider.on('destroy', settings.destroyFn);
	      }
	    },
	    setStyleRule: function setStyleRule(selector, rule) {
	      var stylesheet = document.styleSheets[document.styleSheets.length - 1];
	      COSTCO.util.safe(function () {
	        for (var i in document.styleSheets) {
	          if (document.styleSheets[i].href && document.styleSheets[i].href.indexOf('rwd') >= 0) {
	            stylesheet = document.styleSheets[i];
	            break;
	          }
	        }
	      })();
	      if (stylesheet.addRule) {
	        stylesheet.addRule(selector, rule);
	      } else if (stylesheet.insertRule) {
	        stylesheet.insertRule(selector + ' { ' + rule + ' }', stylesheet.cssRules.length);
	      }
	    },
	    /**
	     * Function decorator that wraps a provided function in a try/catch
	     * to mitigate breaking JS execution. Returns a new function which
	     * must be called.
	     * @param {[function]} fn
	     * @param {[string]} signature
	     * @return {[function]}
	     */
	    safe: function safe(fn, signature) {
	      return function util_safe() {
	        try {
	          fn.apply(this, arguments);
	        } catch (e) {
	          console.error(e, 'at ' + signature);
	        }
	      };
	    },
	    /**
	     * Function used to call bing to obtain location data based on query value
	     *
	     * Param
	     * 	  postalCode -> postalCode that we want to get the city or state for
	     * 	  sucessCallback -> function to be fired after the sucess of the ajax request
	     *
	     */
	    callBing: function callBing(postalCode, successCallback, errorCallback) {
	
	      var globalBingStaticKeyVar = $('#globalBingStaticKey').val();
	      var geocodeRequest = 'https://dev.virtualearth.net/REST/v1/Locations?postalCode=' + postalCode + '&includeNeighborhood=true&include=ciso2&maxResults=5&key=' + globalBingStaticKeyVar;
	
	      $.ajax({
	        url: geocodeRequest,
	        dataType: 'jsonp',
	        jsonp: 'jsonp',
	        error: function error(XMLHttpRequest, textStatus, errorThrown) {
	          console.log('error getting City / State' + postalCode);
	          if (errorCallback) errorCallback(XMLHttpRequest, textStatus, errorThrown);
	        },
	        success: function success(data, textstatus, XMLHttpRequest) {
	          console.log('BING - Success retrieving location');
	          successCallback(data, textstatus, XMLHttpRequest);
	        }
	      });
	    },
	
	    /**
	     * Calls the GeocodeAPI to obtain location data based on the provided postal code.
	     *
	     * @param {string} postalCode - The postal for which to get city/state data.
	     * @param {function} successCallback - The function to be called on successful AJAX request.
	     * @param {function} errorCallback - The function to be called if the AJAX request fails.
	     */
	    callGeocodeAPI: function callGeocodeAPI(postalCode, successCallback, errorCallback) {
	      var country = 'USA';
	      if (COSTCO.util.isCAStore() || COSTCO.util.isCABDStore()) {
	        country = 'CAN';
	        postalCode = postalCode.toUpperCase();
	      }
	
	      var geocodeRequestUrl = $('#geocodeServiceEndpoint').val() + '?q=' + postalCode + '&country=' + country;
	
	      var deriveCityStateFromZipCodeEnabled = costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED && $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === 'true';
	      var allowedCityTypes = deriveCityStateFromZipCodeEnabled ? ['A', 'D'] : ['D'];
	
	      errorCallback = errorCallback || successCallback;
	      var handleError = function handleError() {
	        console.log('Error getting City/State for ' + postalCode);
	        var errData = [{ invalidZip: true }];
	        errorCallback(errData);
	      };
	
	      $.ajax({
	        url: geocodeRequestUrl,
	        dataType: 'json',
	        error: function error(jqXHR, textStatus, errorThrown) {
	          if (textStatus === 'error') {
	            handleError();
	          }
	        },
	        success: function success(data, textStatus, jqXHR) {
	          var filteredElements = data && data.length > 0 ? data.filter(function (element) {
	            return allowedCityTypes.includes(element.cityType);
	          }) : [];
	          if (filteredElements.length) {
	            console.log('GeocodeAPI - Success retrieving location');
	            successCallback(filteredElements, textStatus, jqXHR);
	          } else {
	            handleError();
	          }
	        }
	      });
	    },
	
	    /**
	     * BD only: calls Bing Location service and updates WC_BD_LOC cookie as pipe-separated City|ST|CC value.
	     * @param {string} zipCode
	     * @returns {object} Deferred
	     */
	    callBingAndUpdateBDLocationCookie: function callBingAndUpdateBDLocationCookie(zipCode) {
	      var deferred = $.Deferred();
	      var updateCookie = function updateCookie(data) {
	        if (data && data.resourceSets && data.resourceSets[0] && data.resourceSets[0].estimatedTotal > 0) {
	          var city = '' + data.resourceSets[0].resources[0].address.locality;
	          var state = '' + data.resourceSets[0].resources[0].address.adminDistrict;
	          var countryCode = '' + data.resourceSets[0].resources[0].address.countryRegionIso2;
	          var locationCookie = encodeURI(city.trim() + '|' + state.trim() + '|' + countryCode.trim());
	          var expiration = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000);
	          document.cookie = 'WC_BD_LOC=' + locationCookie + '; expires=' + expiration + '; path=/';
	          deferred.resolve(data);
	        } else {
	          document.cookie = 'WC_BD_LOC=; expires=' + new Date(0) + '; path=/';
	          console.log('BING - No location for ZIP/postal code: ' + zipCode + ', location cookie deleted.');
	          deferred.resolve(data);
	        }
	      };
	      COSTCO.util.callBing(zipCode, updateCookie);
	      return deferred.promise();
	    },
	    /**
	     * BD only: calls Geocode API service and updates WC_BD_LOC cookie as pipe-separated City|ST|CC value.
	     * @param {string} zipCode
	     * @returns {object} Deferred
	     */
	    callGeocodeApiAndUpdateBDLocationCookie: function callGeocodeApiAndUpdateBDLocationCookie(zipCode) {
	      var deferred = $.Deferred();
	      var updateCookie = function updateCookie(data) {
	        var totalResponses = data.length;
	        if (totalResponses != 0) {
	          var city = '' + data[0].city;
	          var state = '' + data[0].stateProvinceAbbreviation;
	          var countryCode = '' + data[0].country === "USA" ? "US" : "CA";
	          var locationCookie = encodeURI(city.trim() + '|' + state.trim() + '|' + countryCode.trim());
	          var expiration = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000);
	          document.cookie = 'WC_BD_LOC=' + locationCookie + '; expires=' + expiration + '; path=/';
	          COSTCO.util.setInSession("finalZipcode", data[0].postalCode);
	          deferred.resolve(data);
	        } else {
	          document.cookie = 'WC_BD_LOC=; expires=' + new Date(0) + '; path=/';
	          console.log('Geocode API - No location for ZIP/postal code: ' + zipCode + ', location cookie deleted.');
	          deferred.resolve(data);
	        }
	      };
	      COSTCO.util.callGeocodeAPI(zipCode, updateCookie);
	      return deferred.promise();
	    },
	    /**
	     * Calls bing and updates zip/state/city cookies
	     * @retrns jquery Deferred object
	     */
	    callBingAndUpdateCookies: function callBingAndUpdateCookies(zipcode) {
	
	      var deferred = $.Deferred();
	
	      var updateCookieValues = function updateCookieValues(data) {
	        var totalResponses = data.resourceSets[0].estimatedTotal;
	        if (totalResponses != 0) {
	          var province = null;
	          var country = null;
	          var city = data.resourceSets[0].resources[0].address.locality;
	          try {
	            //Check out if country is Puerto Rico specific
	            country = data.resourceSets[0].resources[0].address.countryRegionIso2;
	            if (country != undefined && country === 'PR') {
	              province = data.resourceSets[0].resources[0].address.countryRegionIso2;
	              country = 'US';
	            } else {
	              province = data.resourceSets[0].resources[0].address.adminDistrict;
	            }
	          } catch (e) {
	            province = "";
	          }
	          $.cookie("invCheckPostalCode", zipcode);
	          $.cookie("invCheckStateCode", province);
	          $.cookie("invCheckCity", city);
	          deferred.resolve(data);
	        } else {
	          deferred.reject();
	        }
	      };
	
	      COSTCO.util.callBing(zipcode, updateCookieValues);
	
	      return deferred.promise();
	    },
	    /**
	     * Calls GeocodeAPI and updates zip/state/city cookies
	     * @retrns jquery Deferred object
	     */
	    callGeocodeAPIAndUpdateCookies: function callGeocodeAPIAndUpdateCookies(zipcode) {
	
	      var deferred = $.Deferred();
	
	      var updateCookieValues = function updateCookieValues(data) {
	        var province = null;
	        var country = null;
	        var city = null;
	        var totalResponses = data.length;
	        if (totalResponses != 0) {
	          try {
	            city = data[0].city;
	            province = data[0].stateProvinceAbbreviation;
	            if (province == null) {
	              province = data[0].stateProvince;
	            }
	            country = data[0].country;
	          } catch (e) {
	            console.error('Error: ' + e.message);
	          }
	
	          //SFSTRY0035043 don't update header zip on multishipping page
	          if (typeof checkoutPage == 'undefined' || checkoutPage !== 'multi-shipping') {
	            $.cookie("invCheckPostalCode", zipcode);
	            $.cookie("invCheckStateCode", province);
	            $.cookie("invCheckCity", city);
	          }
	
	          deferred.resolve(data);
	        } else {
	          deferred.reject();
	        }
	      };
	
	      COSTCO.util.callGeocodeAPI(zipcode, updateCookieValues);
	
	      return deferred.promise();
	    },
	
	    hover_click_popover: function hover_click_popover(selector, _content, trigger, placement) {
	      var hoverClickElement = $(selector);
	      hoverClickElement.attr({
	        'aria-haspopup': 'true',
	        'aria-expanded': 'false'
	      });
	      hoverClickElement.popover({
	        html: true,
	        sanitize: false,
	        animation: false,
	        delay: {
	          show: 400,
	          hide: 400
	        },
	        content: function content() {
	          return $(_content).html();
	        },
	        container: selector,
	        placement: placement || 'bottom',
	        trigger: trigger || 'hover click'
	      }).on('keydown', function (e) {
	        if (e.which == 13) {
	          if ($(this).attr('data-flyout') && $(this).attr('aria-expanded') == 'false') {
	            e.preventDefault();
	            $(this).popover('show');
	          }
	        }
	      }).on('mouseleave focusout', '.popover', {
	        selector: selector,
	        content: _content,
	        placement: placement || 'bottom'
	      }, this.popoverLeave)
	      // Adding listener to toggle the aria tags when popover shown/hidden
	      .on('shown.bs.popover', function () {
	        if (('#warehouse-locations' == selector || '#warehouse-locations-t' == selector) && $.cookie('WC_BD_ZIP') != null) {
	          $('#warehouse-search-field').val($.cookie('WC_BD_ZIP').replace('+', ' '));
	        }
	        $(this).attr('aria-expanded', 'true');
	
	        // used to create ada required attributes on popover
	        var identifierSrting = $(selector)[0].id;
	        $(this).find('.popover-content').attr('id', identifierSrting + '-id');
	        // Add tabindex of -1 to the content to prevent a safari bug where the relatedTarget
	        // is not populated when no tabindex is specified this caused all a and input
	        // to not function on click event
	        $(this).find('.popover-content').attr('tabindex', '-1');
	        // New requirement to focus on the first visible input on popover shown
	        var firstInput = $(this).find('a,input[type!=hidden]')[0];
	        $(this).removeAttr('aria-describedby');
	        $(this).find('.popover-content').removeAttr('aria-label');
	        $(this).find('.popover').removeAttr('role');
	        if (firstInput) $(firstInput).focus();
	      }).on('hidden.bs.popover', function () {
	        $(this).attr('aria-expanded', 'false');
	      })
	      // stry0123297 - issue with IE with user having to double-click on text boxes in pop-overs
	      // solution to trigger the focus on text boxes on mousedown event
	      .on('mousedown', 'input[type=search], input[type=text]', function () {
	        $(this).trigger('focus');
	      });
	    },
	    click_popover: function click_popover(selector, _content2, trigger, placement) {
	      var ClickElement = $(selector);
	      ClickElement.attr({
	        'aria-expanded': 'false'
	      });
	      ClickElement.popover({
	        html: true,
	        sanitize: false,
	        animation: false,
	        delay: {
	          show: 400,
	          hide: 400
	        },
	        content: function content() {
	          return $(_content2).html();
	        },
	        container: selector,
	        placement: placement || 'bottom',
	        trigger: trigger || 'click'
	      }).on('keydown', function (e) {
	        if (e.which == 13) {
	          if ($(this).attr('data-flyout') && $(this).attr('aria-expanded') == 'false') {
	            e.preventDefault();
	            $(this).popover('show');
	          }
	        }
	      }).on('click focusout', '.popover', {
	        selector: selector,
	        content: _content2,
	        placement: placement || 'bottom'
	      }, this.clickpopoverLeave)
	      // Adding listener to toggle the aria tags when popover shown/hidden
	      .on('shown.bs.popover', function () {
	        if (('#warehouse-locations' == selector || '#warehouse-locations-t' == selector) && $.cookie('WC_BD_ZIP') != null) {
	          $('#warehouse-search-field').val($.cookie('WC_BD_ZIP').replace('+', ' '));
	        }
	        $(this).attr('aria-expanded', 'true');
	
	        if (_content2 === '#ca-grocery-delivery-postal-code-popover') {
	          $(this).find('#postal-code-input').val($('.user-entered-zip:first').text());
	        }
	
	        $('#delivery-postal-change,  #set-delivery-zipcode').removeAttr('aria-describedby');
	        $('#delivery-postal-change,  #set-delivery-zipcode').find('.popover').removeAttr('role');
	
	        // used to create ada required attributes on popover
	        var identifierSrting = $(selector)[0].id;
	        $(this).find('.popover-content').attr('id', identifierSrting + '-id');
	        // Add tabindex of -1 to the content to prevent a safari bug where the relatedTarget
	        // is not populated when no tabindex is specified this caused all a and input
	        // to not function on click event
	        $(this).find('.popover-content').attr('tabindex', '-1');
	        $(this).find('.popover-content').removeAttr('aria-label');
	        // New requirement to focus on the first visible input on popover shown
	        var firstInput = $(this).find('a,input[type!=hidden]')[0];
	        if (firstInput) $(firstInput).focus();
	        var firstBDInput = $(this).find('div > input[type!=hidden]')[0];
	        setTimeout(function () {
	          if (firstBDInput) {
	            $(firstBDInput).focus();
	          }
	        }, 100);
	        $('#postal-code-input-grocery').on('focusout', function () {
	          var content = $('#postal-code-input-grocery').val();
	          if (content !== undefined && content != '') {
	            $('#postal-code-input-grocery-label').addClass('active');
	          }
	        });
	        var nameOfCategoryInput = $('#delivery-postal-code-popover-container').parent().parent().parent().attr('id');
	        $('#delivery-postal-form').append('<input type="hidden" name="category-grocery-delivery" value="' + nameOfCategoryInput + '">');
	      }).on('hidden.bs.popover', function () {
	        $(this).attr('aria-expanded', 'false');
	      })
	      // stry0123297 - issue with IE with user having to double-click on text boxes in pop-overs
	      // solution to trigger the focus on text boxes on mousedown event
	      .on('mousedown', 'input[type=search], input[type=text]', function () {
	        $(this).trigger('focus');
	      });
	    },
	    hover_click_popover_nav: function hover_click_popover_nav(selector, _content3, trigger) {
	      var hoverClickElement = $(selector);
	      hoverClickElement.attr({
	        'aria-haspopup': 'true',
	        'aria-expanded': 'false'
	      });
	      hoverClickElement.popover({
	        html: true,
	        animation: false,
	        delay: {
	          show: 400,
	          hide: 400
	        },
	        content: function content() {
	          return $(_content3).html();
	        },
	        container: selector,
	        placement: 'bottom',
	        trigger: trigger || 'hover click'
	      }).on('keydown', function (e) {
	        if (e.which == 13) {
	          if ($(this).attr('data-flyout') && $(this).attr('aria-expanded') == 'false') {
	            e.preventDefault();
	            $(this).popover('show');
	          }
	        }
	      }).on('mouseleave focusout', '.popover', {
	        selector: selector,
	        content: _content3
	      }, this.popoverLeave)
	      // Adding listener to toggle the aria tags when popover shown/hidden
	      .on('shown.bs.popover', function () {
	        $(this).attr('aria-expanded', 'true');
	        $(this).find('.popover').addClass('top50pixels');
	        $(this).find('.popover-content').attr('role', 'region');
	        // used to create ada attributes on popover
	        var identifierSrting = $(selector)[0].id;
	        $(this).find('.popover-content').attr('id', identifierSrting + '_id');
	        $(this).find('.popover-content').attr('aria-label', identifierSrting + '_label');
	      }).on('hidden.bs.popover', function () {
	        $(this).attr('aria-expanded', 'false');
	      });
	    },
	    /*
	     * Function used to handle closing the pop-over based on which element is receiving focus
	     * If it is not a child element of the pop-over the pop-over will close
	     */
	    popoverLeave: function popoverLeave(event) {
	      var eventType = event.type;
	      var isInput = $(event.target).is('input');
	      // relatedTarget of a focusout event is the element which is receiving focus.
	      var relatedTargetIsContained = $(event.data.selector).get(0) == event.relatedTarget || $.contains($(event.data.selector).get(0), event.relatedTarget);
	      // the first condition is to stop popover from closing if the user tries to select from the browser autocomplete box
	      // the second condition is to keep popover open if focus stays within the popover.
	      if (eventType == 'mouseleave' && !isInput || eventType == 'focusout' && event.target && !relatedTargetIsContained) {
	        if (eventType == 'mouseleave' && COSTCO.Header.checkIsZipSetByAkamai() && COSTCO.zipCodeModal) {
	          // If ZIP code is set by Akamai, force-submit on popover leave
	          COSTCO.zipCodeModal.forceSubmitZipCode();
	        } else {
	          $(event.data.selector).popover('destroy');
	          COSTCO.util.hover_click_popover(event.data.selector, event.data.content, undefined, event.data.placement);
	        }
	      }
	    },
	    clickpopoverLeave: function clickpopoverLeave(event) {
	      event.stopPropagation();
	      var eventType = event.type;
	      var isInput = $(event.target).is('input');
	      // relatedTarget of a focusout event is the element which is receiving focus.
	      var relatedTargetIsContained = $(event.data.selector).get(0) == event.relatedTarget || $.contains($(event.data.selector).get(0), event.relatedTarget);
	      // the first condition is to stop popover from closing if the user tries to select from the browser autocomplete box
	      // the second condition is to keep popover open if focus stays within the popover.
	      if (eventType == 'click' && !isInput && isInput.length === 0 || eventType == 'focusout' && event.target && !relatedTargetIsContained) {
	        if (eventType == 'mouseleave' && COSTCO.Header.checkIsZipSetByAkamai() && COSTCO.zipCodeModal) {
	          // If ZIP code is set by Akamai, force-submit on popover leave
	          COSTCO.zipCodeModal.forceSubmitZipCode();
	        } else {
	          setTimeout(function () {
	            $(event.data.selector).popover('destroy');
	            COSTCO.util.click_popover(event.data.selector, event.data.content, undefined, event.data.placement);
	          }, 100);
	        }
	      }
	    },
	    /*
	     * Function used to get whether or not the element is within the last or first
	     * link within the target level container
	     *
	     * If the need arise we can actually return the decimal position of the element
	     * by looping through the array not exactly needed here
	     *
	     * If the element is the first function will return 0
	     * If the element is the last function will return 1
	     * If other -1
	     */
	    get_element_position: function get_element_position(element, searchCriteria) {
	      var containerDivLinkArr = $(searchCriteria);
	      if (containerDivLinkArr.first()[0] == element) return 0;
	      if (containerDivLinkArr.last()[0] == element) return 1;
	      return -1;
	    },
	    /**
	     * This function makes icons in social networks popover content tabbable for ADA purposes
	     * @param {string} selector - the element which contains a social networks popover
	     * @return {void}
	     */
	    socialNetworksPopover: function socialNetworksPopover(selector) {
	      var popoverElement = $('.' + selector);
	      var popoverContent = $(".social-popover-container").html();
	      popoverElement.attr({
	        'data-content': popoverContent,
	        'aria-haspopup': 'true',
	        'aria-expanded': 'false',
	        'tabindex': 0,
	        'role': 'tooltip'
	      });
	      popoverElement.popover({ sanitize: false }).on('keydown', function (event) {
	        //Enter event keycode
	        if (event.which === 13) {
	          $(this).popover('toggle');
	          //Esc event keycode
	        } else if (event.which === 27) {
	          $(this).popover('hide');
	          //Shift+Tab event keycode
	        } else if (event.shiftKey && event.keyCode === 9) {
	          $(this).popover('hide');
	        }
	      }).on('focus', function () {
	        $(this).popover('toggle');
	        var tooltipElement = $(this);
	        var lastIconArr = document.getElementsByClassName('last-icon');
	        var popoverContentId = $(this).attr('aria-describedby');
	        $.each(lastIconArr, function (index, value) {
	          if (popoverContentId !== undefined && $(lastIconArr[index]).length !== 0) {
	            $(lastIconArr[index]).on('blur', function () {
	              tooltipElement.popover('hide');
	            });
	          }
	        });
	        var contentElements = $('body').find('.social-popover');
	        contentElements.find('img').each(function () {
	          $(this).on('keypress', function () {
	            this.onclick();
	          });
	        });
	      }).on('shown.bs.popover', function () {
	        $(this).attr('aria-expanded', 'true');
	      }).on('hidden.bs.popover', function () {
	        $(this).attr('aria-expanded', 'false');
	      });
	      $(':not(.' + selector + ')').on('click', function () {
	        $('.co-help').each(function () {
	          if ($(this).attr('aria-expanded') === 'true') {
	            $(this).popover('hide');
	          }
	        });
	      });
	    },
	
	    /**
	     * Function used to simply show/hide popover capability to add accesibility features
	     * function popover parameters are expected to be defined in the element as normal bootsrap popover
	     *  hover and focus been triggered using data-trigger functionality. 
	     */
	    swatch_accesible_popover: function swatch_accesible_popover(selector) {
	      var popoverElement = $(selector);
	      popoverElement.attr({
	        'aria-haspopup': 'true',
	        'aria-expanded': 'false',
	        'tabindex': 0,
	        'role': 'tooltip'
	      });
	      popoverElement.popover().on('shown.bs.popover', function () {
	        $(this).attr('aria-expanded', 'true');
	      }).on('hidden.bs.popover', function () {
	        $(this).attr('aria-expanded', 'false');
	      });
	    },
	    signupFormValidation: function signupFormValidation(element) {
	      $(element).validate({
	        rules: {
	          emailSignUp: {
	            required: true,
	            email: true
	          }
	        },
	        messages: {
	          emailSignUp: messages.ERR_INVALID_EMAIL
	        },
	        errorPlacement: function errorPlacement(error, element) {
	          var p = element.parent('div');
	          error.addClass('emailSignUp');
	          p.after(error);
	        }
	      });
	
	      if ($(element).valid()) {
	        if ($('input[name="emailSignUpFeatureV2"]').val() === 'true') {
	          COSTCO.util.emailSignUpV2Submit('footer');
	        } else {
	          util.emailSubmit(element);
	        }
	      }
	
	      return false;
	    },
	    getMemberCookie: function getMemberCookie() {
	      var isSignedIn = void 0,
	          isMember = false,
	          isValidated = false,
	          isVerified = false,
	          isActive = false,
	          usage = '',
	          membershipNumber = '';
	      var m = $.cookie('wcMember'),
	          h = $.cookie('hashedUserId'),
	          p = $.cookie('rrDisabledPref'),
	          r = $.cookie('rrStoreFlag');
	      if (h != null && h == '""' || h == null && p == null && r == null || h == null && (p != null && p == '""' || r != null && r == '""')) {
	        isSignedIn = false;
	      } else if (h != null && h == '' || h == null && p == null && r == null || h == null && (p != null && p == '' || r != null && r == '')) {
	        isSignedIn = false;
	      } else if (h != null & h != '""' || h == null && p != null && p != '""' && r != null && r != '""') {
	        isSignedIn = true;
	      } else {
	        isSignedIn = 'undefined';
	      }
	      if (m != null && m != 'undefined') {
	        var cArray = m.split(',');
	        if (cArray.length > 1) {
	          if (cArray[1] == '1') {
	            isMember = true;
	          }
	          if (typeof cArray[3] !== 'undefined') {
	            usage = cArray[3];
	          }
	          if (cArray[4] == '1') {
	            isValidated = true;
	          }
	          if (cArray[5] == '1') {
	            isVerified = true;
	          }
	          if (cArray[6] == 'E0002') {
	            isActive = true;
	          }
	          if (typeof cArray[8] !== 'undefined') {
	            membershipNumber = cArray[8];
	          }
	        }
	      } else {
	        isMember = 'undefined';
	      }
	      return {
	        signedIn: isSignedIn,
	        costcoMember: isMember,
	        validated: isValidated,
	        verified: isVerified,
	        active: isActive,
	        usage: usage,
	        membershipNumber: membershipNumber
	      };
	    },
	    /**
	     * This function checks if the user has signed in
	     */
	    isUserSignedIn: function isUserSignedIn() {
	      return this.getMemberCookie().signedIn === "true";
	    },
	    checkSsoLogin: function checkSsoLogin(aTag) {
	      aTag.href += aTag.href.indexOf("?") < 0 ? "?redirectLogin=" + COSTCO.util.isUserLoggedIn() : "&redirectLogin=" + COSTCO.util.isUserLoggedIn();
	    },
	    disbleElementById: function disbleElementById(id) {
	      $("#" + id).hide();
	    },
	    checkAndDisableSignInButton: function checkAndDisableSignInButton() {
	      if (this.isUserLoggedIn()) this.disbleElementById("bd-specific-sign-in-button");
	    },
	
	    /**
	     * This function checks if the user has valid membership
	     */
	    isCostcoMember: function isCostcoMember() {
	      return this.getMemberCookie().costcoMember != 'undefined' ? userInfo.costcoMember : false;
	    },
	    /**
	     * sets a cookie with given name, value, expiration and domain
	     *
	     * @param  {[string]} cookieName - The name of the cookie to set
	     * @param  {[string]} cookieValue - The value for the cookie to set
	     * @param  {[int]} cookieExpires - The number of days until the cookie expires
	     * @parm   {[string]} cookieDomain - The domain of the cookie to set
	     * @return {void}
	     */
	    setCookie: function setCookie(cookieName, cookieVal, cookieExpires, cookieDomain) {
	      cookieExpires = parseInt(cookieExpires);
	      if (typeof cookieDomain !== 'undefined') {
	        $.cookie(cookieName, cookieVal, {
	          expires: cookieExpires,
	          path: '/',
	          domain: cookieDomain
	        });
	      } else {
	        $.cookie(cookieName, cookieVal, {
	          expires: cookieExpires,
	          path: '/'
	        });
	      }
	    },
	
	    /**
	     * Gets the language id of the users's session. default is -1(English)
	     * for US and -24(English) for CA
	     * @return {[int]} the langId
	     */
	    getLangId: function getLangId() {
	      var selectedLang = $.cookie(cookies.SELECTED_LANG_COOKIE);
	      var host = window.location.host;
	      var cookieDomain = wcs.domain;
	      if (host.indexOf('bd-cmc.vqa') > -1 || host.indexOf('bd-cmc.vuat') > -1 || host.indexOf('bd-cmc.ecom') > -1) {
	        cookieDomain = '.costco.com';
	      }
	      if (typeof selectedLang == 'undefined' || !selectedLang) {
	        if (wcs.hasOwnProperty('langId')) {
	          COSTCO.util.setCookie(cookies.SELECTED_LANG_COOKIE, wcs.langId, cookies.SELECTED_LANG_EXPIRES, cookieDomain);
	          return parseInt(wcs.langId);
	        } else {
	          // check for stgbrowse costco domains
	          if (host.indexOf('stgbrowseca') > -1 || host.indexOf('stgbrowse-ca') > -1 || host.indexOf('ca-cmc') > -1 || host.indexOf('ca-stage') > -1) {
	            return -24;
	          }
	          if (host.indexOf('.com') > -1) {
	            return -1; // Default .com lang
	          } else {
	            COSTCO.util.setCookie(cookies.SELECTED_LANG_COOKIE, "-24", cookies.SELECTED_LANG_EXPIRES, cookieDomain);
	            return -24; // Default .ca lang
	          }
	        }
	      } else {
	        // The selectedLanguage cookie exists and the selectedLanguageOld cookie does not exist. 
	        this.registerLanguageListener();
	      }
	      return selectedLang;
	    },
	    /**
	     * Get the warehouse number for the user's session - used mainly for image templates
	     */
	    getWarehouseNumber: function getWarehouseNumber() {
	      var langId = this.getLangId();
	      if (langId < -1) {
	        return 894;
	      } else {
	        return 847;
	      }
	    },
	    /**
	     * Gets the string value of the user's region. Default is null.
	     * @return {[string]} the string value of SELECTED_REGION_COOKIE
	     */
	    getRegion: function getRegion() {
	      var selectedRegion = $.cookie(cookies.SELECTED_REGION_COOKIE);
	      if (typeof selectedRegion == 'undefined' || !selectedRegion) {
	        selectedRegion = null;
	      }
	      return selectedRegion;
	    },
	    getScreenType: function getScreenType() {
	      var width = $(window).width();
	      if (width >= 1025) return 'DESKTOP';
	      if (width >= 769) return 'TABLET-LANDSCAPE';
	      if (width >= 668) return 'TABLET-PORTRAIT';
	      if (width >= 376) return 'PHONE-LANDSCAPE';
	      return 'PHONE-PORTRAIT';
	    },
	    is_touch_device: function is_touch_device() {
	      return 'ontouchstart' in window // works on most browsers
	      || navigator.maxTouchPoints; // works on IE10/11 and Surface
	    },
	    buildEmailSignUpV2Req: function buildEmailSignUpV2Req(sel) {
	      var userEmail = '';
	      var userMemberNum = '';
	      var userWhNum = '';
	      var userLangPref = '';
	      var userSite = '';
	      var dataSource = '';
	
	      var zipCookieKey = 'invCheckPostalCode';
	      if (COSTCO.util.isBDStore()) {
	        zipCookieKey = 'WC_BD_ZIP';
	      }
	      var rawZip = COSTCO.util.getCookieByName(zipCookieKey) || '';
	      var userZip = decodeURIComponent(rawZip);
	
	      if (COSTCO.util.isBDStore()) {
	        userWhNum = COSTCO.util.getCookieByName('WC_BD_WHS') || '';
	      } else {
	        var prefWhDetails = localStorage.getItem('preferredWarehouse');
	        var pWhDetailsJSON = prefWhDetails ? JSON.parse(prefWhDetails) : {};
	        userWhNum = pWhDetailsJSON.warehouseId || '';
	      }
	
	      var signUpForm = $('form[id="signup_form"]');
	      var emailOffersForm = $('form[id="EmailOffersForm"]');
	
	      if (sel === 'page' && signUpForm.length > 0) {
	        dataSource = 'Signup page';
	        userEmail = signUpForm.find('input[name="email"]').val().trim() || '';
	        userMemberNum = signUpForm.find('input[name="custom_membernumber"]').val().trim() || '';
	
	        if (COSTCO.util.isUSStore()) {
	          userWhNum = signUpForm.find('select[name="custom_local_whse_number"]').val() || '';
	        } else if (COSTCO.util.isCAStore()) {
	          userWhNum = signUpForm.find('select[name="custom_warehouse_number"]').val() || '';
	        }
	
	        if (COSTCO.util.isUSBDStore()) {
	          userZip = signUpForm.find('input[name="zip"]').val().trim() || '';
	        } else if (COSTCO.util.isCABDStore()) {
	          userZip = signUpForm.find('input[name="custom_postalcode"]').val().trim() || '';
	        }
	      } else if (sel === 'footer' && emailOffersForm.length > 0) {
	        dataSource = 'Footer Signup';
	        userEmail = emailOffersForm.find('input[name="emailSignUp"]').val().trim() || '';
	
	        var wcMember = COSTCO.util.getCookieByName('wcMember');
	        if (wcMember !== null && typeof wcMember !== 'undefined') {
	          var cArray = wcMember.split(',');
	          if (cArray.length > 1) {
	            if (typeof cArray[8] !== 'undefined') {
	              membershipNumber = cArray[8];
	            }
	          }
	        }
	      }
	
	      var enCheck = signUpForm.find('input[name="slid_1"][id="en"]:not([type="hidden"])');
	      var frCheck = signUpForm.find('input[name="slid_1"][id="fr"]:not([type="hidden"])');
	      if (enCheck.length > 0 && enCheck.prop('checked')) {
	        userLangPref = 'EN';
	      } else if (frCheck.length > 0 && frCheck.prop('checked')) {
	        userLangPref = 'FR';
	      } else {
	        userLangPref = COSTCO.util.getLocale().slice(0, 2).toUpperCase();
	      }
	
	      if (COSTCO.util.isUSStore()) {
	        userSite = 'USBC';
	      } else if (COSTCO.util.isCAStore()) {
	        userSite = 'CABC';
	      } else if (COSTCO.util.isUSBDStore()) {
	        userSite = 'USBD';
	      } else if (COSTCO.util.isCABDStore()) {
	        userSite = 'CABD';
	      } else {
	        userSite = 'USBC';
	      }
	
	      var reqBody = {
	        'emailAddress': userEmail,
	        'memberNumber': userMemberNum,
	        'warehouse': userWhNum,
	        'languagePref': userLangPref,
	        'zip': userZip,
	        'site': userSite,
	        'dataSource': dataSource
	      };
	
	      return reqBody;
	    },
	    emailSignUpV2Submit: function emailSignUpV2Submit(sel) {
	      var emailSignUpV2URL = $('input[name="emailSignUpV2URL"]').val();
	      var emailSignUpV2ClientId = $('input[name="emailSignUpV2ClientId"]').val();
	
	      var requestBody = COSTCO.util.buildEmailSignUpV2Req(sel);
	
	      if (!requestBody.emailAddress || !requestBody.emailAddress.trim()) {
	        return;
	      }
	
	      var requestOptions = {
	        method: 'POST',
	        headers: {
	          'Content-Type': 'application/json',
	          'client-identifier': emailSignUpV2ClientId
	        },
	        body: JSON.stringify(requestBody)
	      };
	
	      fetch(emailSignUpV2URL, requestOptions).then(function (response) {
	        if (!response.ok) throw new Error(response.status);
	        return response.json();
	      }).then(function (data) {
	        if (sel === 'footer') {
	          var successP = '<p class=\'success emailSignUp\'><i class=\'co-checkmark\'></i>' + messages.RWD_VALID_EMAIL_THANKYOU + '.</p>';
	          $('form[id="EmailOffersForm"]').after(successP);
	          $('form[id="EmailOffersForm"]').addClass('hide');
	        }
	      }).catch(function (error) {
	        return console.error(error);
	      });
	    },
	    emailSubmit: function emailSubmit(form) {
	      var locale = COSTCO.util.getLocale();
	      var isWhatCountsEnabled = $("input[name='whatCountsEventsFeatureFlagFooter']").val();
	      var isAdobeEnabled = $("input[name='adobePreferencesFeatureFlagFooter']").val();
	      if (isAdobeEnabled == 'true') {
	        if (locale != 'en-US') {
	          var url = form.action;
	          document.location.href = url;
	        } else {
	          var data = {
	            memberNumber: '',
	            emailAddress: $('#footer-email-offers').val().trim(),
	            listSource: 'Footer SignUp'
	          };
	          COSTCO.AdobeEvents.sendEmailSubscriptionEvent($("input[name='adobeSubscribeEndpointFooter']").val(), contextVariables, data);
	        }
	      }
	      if (isWhatCountsEnabled == 'true' || isWhatCountsEnabled === '1') {
	        if (locale != 'en-US') {
	          var _url = form.action;
	          document.location.href = _url;
	        } else {
	          $.ajax({
	            type: 'POST',
	            url: form.action,
	            data: 'emailSignUp=' + form['emailSignUp'].value,
	            success: function success() {
	              $(form).find('input[type=text]').each(function () {
	                $(this).val('');
	              });
	            }
	          });
	        }
	      }
	      var successP = '<p class=\'success emailSignUp\'><i class=\'co-checkmark\'></i>' + messages.RWD_VALID_EMAIL_THANKYOU + '.</p>';
	      $(form).after(successP);
	      $(form).addClass('hide');
	      return false;
	    },
	
	    emailSubscribeForm: function emailSubscribeForm(element) {
	      $.validator.addMethod('countryspecificpostalcodePassCountrySelectorModal', function (value, element) {
	        return !(COSTCO.util.getLangId() == -1) ? this.optional(element) || COSTCO.util.POSTAL_CODE_REGEX_CA.test($.trim(value)) : this.optional(element) || COSTCO.util.POSTAL_CODE_REGEX_US.test($.trim(value));
	      }, messages.ERR_ENTER_ZIPCODE);
	      $.validator.addMethod('email', function (value, element) {
	        return (/^[_a-zA-Z0-9-]+(\.[_a-zA-Z0-9-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,4})$/.test(value.toLowerCase())
	        );
	      }, messages.JS_VALID_EMAIL);
	      $(element).validate({
	        rules: {
	          emailAddress: {
	            required: true,
	            email: true
	          },
	          deliveryZipCode: {
	            required: true,
	            countryspecificpostalcodePassCountrySelectorModal: true
	          }
	        },
	        messages: {
	          emailAddress: messages.ERR_INVALID_EMAIL,
	          deliveryZipCode: messages.ERR_ENTER_ZIPCODE
	        },
	        errorPlacement: function errorPlacement(error, element) {
	          if (element.attr('name') == 'emailAddress') {
	            element.parent().addClass('error');
	            error.insertAfter($('[name=emailAddress]'));
	          } else if (element.attr('name') == 'deliveryZipCode') {
	            element.parent().addClass('error');
	            error.insertAfter($('[name=deliveryZipCode]'));
	          } else {
	            error.insertAfter(element);
	          }
	        }
	      });
	      if ($(element).valid()) {
	        util.emailSubscribeSubmit(element);
	      }
	      return false;
	    },
	
	    emailSubscribeSubmit: function emailSubscribeSubmit(form) {
	      $.ajax({
	        type: 'POST',
	        url: form.action,
	        data: 'emailAddress=' + form['emailAddress'].value + '&deliveryZipCode=' + form['deliveryZipCode'].value + '&newLocation=' + form['newLocation'].value,
	        success: function success() {
	          $(form).find('input[type=text]').each(function () {
	            $(this).val('');
	          });
	        }
	      });
	      var successP = '<p class=\'success emailAddress\'><i class=\'co-checkmark\'></i>' + messages.RWD_VALID_EMAIL_THANKYOU + '.</p>';
	      $(form).after(successP);
	      $(form).addClass('hide');
	      return false;
	    },
	
	    emailTruckloadSubscribeForm: function emailTruckloadSubscribeForm(element) {
	      var errorElement = null; // Variable to store the first error element
	      $.validator.addMethod('email', function (value, element) {
	        return this.optional(element) || /^.+@(([^.])+\.)+([^.])+$/i.test(value);
	      }, messages.ERR_INVALID_EMAIL);
	      $.validator.addMethod('costcoMembership', function (value, element) {
	        return this.optional(element) || /^\d{12,16}$/.test(value);
	      }, messages.ERR_INVALID_MEMBERSHIP_NO_BD);
	      $(element).validate({
	        rules: {
	          userName: { required: true },
	          membershipNo: { required: true, costcoMembership: true },
	          emailAddress: { required: true, email: true }
	        },
	        messages: {
	          userName: messages.ERR_USERNAME_REQUIRED,
	          membershipNo: { required: messages.ERR_MEMBERSHIP_NUMBER_REQUIRED, costcoMembership: messages.ERR_INVALID_MEMBERSHIP },
	          emailAddress: { required: messages.ERR_REQUIRED_EMAIL_MY, email: messages.ERR_INVALID_EMAIL }
	        },
	        errorPlacement: function errorPlacement(error, element) {
	          if (!errorElement) {
	            // Store the first error element
	            errorElement = element;
	          } else if (element.attr('name') == 'userName') {
	            element.parent().addClass('error');
	            error.insertAfter($('[name=userName]'));
	          } else if (element.attr('name') == 'membershipNo') {
	            element.parent().addClass('error');
	            error.insertAfter($('[name=membershipNo]'));
	          } else if (element.attr('name') == 'emailAddress') {
	            element.parent().addClass('error');
	            error.insertAfter($('[name=emailAddress]'));
	          } else {
	            error.insertAfter(element);
	          }
	        }
	      });
	      if ($(element).valid()) {
	        util.emailTruckloadSubscribeSubmit(element);
	      } else {
	        errorElement.focus();
	      }
	      return false;
	    },
	
	    emailTruckloadSubscribeSubmit: function emailTruckloadSubscribeSubmit(form) {
	      event.preventDefault();
	      $.ajax({
	        type: 'POST',
	        url: form.action,
	        data: 'emailAddress=' + form['emailAddress'].value + '&userName=' + form['userName'].value + '&membershipNo=' + form['membershipNo'].value + '&BusinessName=' + form['BusinessName'].value + '&Address1=' + form['Address1'].value + '&Address2=' + form['Address2'].value + '&City=' + form['City'].value + '&State=' + form['State'].value + '&zipcode=' + form['zipcode'].value + '&phonenumber=' + form['phonenumber'].value + '&items=' + form['items'].value,
	        success: function success() {
	          $(form).find('input[type=text]').each(function () {
	            $(this).val('');
	          });
	          $(form).find('input[type=email]').each(function () {
	            $(this).val('');
	          });
	        }
	      });
	      var successP = '<p id="successP" tabindex="0" class=\'success emailAddress\'><i class=\'co-checkmark\'></i>' + " " + messages.MSG_EMAIL_RECEIVED + '.</p>';
	      $(form).before(successP);
	      $(form).addClass('hide');
	      document.getElementById('successP').focus();
	      return false;
	    },
	
	    /**
	     * This function appends an additional panel to an existing accordion using
	     * the accordion_id. The header and body represent the HTML that will display
	     * for this add on.
	     * @param  {[string]} accordion_id - The accordion data structure's id
	     * @param  {[string]} header - String (html) to display as the panel header
	     * @param  {[string]} body - String (html) to display as the panel body
	     * @return {[void]}
	     */
	    accordion_addon: function accordion_addon(accordion_id, header, body, handlers, parent) {
	      var position = $('#' + accordion_id).children().length + 1;
	      var handlerTemplate = void 0;
	      if (typeof handlers == 'undefined') {
	        handlerTemplate = '';
	      } else {
	        handlerTemplate = handlers;
	      }
	      $('#' + accordion_id).append(this.tmpl('tmpl_accordion_addon', {
	        accordion_id: accordion_id,
	        pos: position,
	        header: header,
	        body: body,
	        handlers: handlerTemplate,
	        parent: parent !== 'undefined' ? parent : true
	      }));
	    },
	    /**
	     * Retrieve the value of the 'rememberedShowMemberItem' cookie
	     * used to display member-only pricing without the need to sign in
	     */
	    getRememberedShowMemberItem: function getRememberedShowMemberItem() {
	      var rememberMeCookie = $.cookie('rememberedShowMemberItem');
	      var cookieExists = rememberMeCookie === undefined || rememberMeCookie === null ? false : true;
	      return cookieExists;
	    },
	    /**
	     * If the user is signed in and has a Costco membership number stored,
	     * show the member-only prices else don't.
	     * @return {[void]}
	     */
	    display_member_prices: function display_member_prices() {
	      var member_cookie = this.getMemberCookie(),
	          signed_in = member_cookie.signedIn || false,
	          is_member = member_cookie.costcoMember || false,
	          is_validated = member_cookie.validated || false,
	          is_active = member_cookie.active || false,
	          is_bd = util.isBusinessDelivery();
	      var rememberMe = this.getRememberedShowMemberItem();
	      // This check is added to keep BD flow unaffected by the change in BC flow
	      var display_moi_price = COSTCO.util.isBusinessDelivery() ? signed_in && is_member : signed_in && is_member && is_validated && is_active;
	      if (display_moi_price) {
	        $('.moi,.mapi').show();
	      } else if (signed_in) {
	        $('.mapi').show();
	        $('.moi').hide();
	      } else if (rememberMe) {
	        $('.mapi').hide();
	        $('.moi').show();
	      } else {
	        $('.moi,.mapi').hide();
	        $('.mapi').parent().find('.map-item').removeClass('hide');
	      }
	    },
	
	    /**
	     * If the user is signed in and has a Costco membership number stored,
	     * show the Select Options or Sign in for Price Button
	     * @return {[void]}
	     */
	    display_SelectOrSignInButton: function display_SelectOrSignInButton() {
	      var member_cookie = this.getMemberCookie();
	      $('.product-tile-set').each(function (element, index) {
	        if ($(this).find('.member-only').length > 0) {
	          if (member_cookie.signedIn) {
	            $(this).find('.select-option-button, .see-details-button').removeClass('hide');
	          } else {
	            $(this).find('.sign-in-button').removeClass('hide');
	          }
	        } else if ($(this).find('#mapItem').length > 0 && !member_cookie.signedIn) {
	          $(this).find('.sign-in-button').removeClass('hide');
	        } else {
	          $(this).find('.select-option-button, .see-details-button').removeClass('hide');
	        }
	      });
	    },
	    /**
	     * This is used by inline links to pop the email offers modal. It is
	     * attached to the TopRow_ESpot_4 "Sign Up" link but can be used anywhere
	     * a "get email offers" modal is necessary.
	     * @return {[void]}
	     */
	    get_email_offers: function get_email_offers() {
	      COSTCO.dialog.createExtDialogBox({
	        title: messages.RWD_GET_EMAIL_OFFERS,
	        body: this.tmpl('tmpl_email_offers', {}),
	        primary: messages.EMAIL_BUTTON_TITLE,
	        secondary: messages.JS_DIALOG_CANCEL,
	        primary_event: function primary_event() {
	          !$('#costcoModal p.success').length > 0 ? $('#costcoModal form').submit() : $('#costcoModalBtn2').hide();
	        }
	      });
	    },
	    /**
	     * This function is the entry point for the front-end citi credit card
	     * application process.  The business includes this javascript in an <a onclick/>,
	     * which will initiate the ajax call.  From here, the path can go 2 different ways
	     * 1.  	If the user has authorized users, they are provided with a dialog, allowing
	     * 		them to choose from a list of authorized users, or none at all.
	     * 2.	If the baseUrl is not included an the whitelist, it will show the
	     * 		external link dialog to user, otherwise it will open a new tab to the url.
	     */
	    getBrandFolderVideo: function getBrandFolderVideo(assetKey, folderkey) {
	      var baseUriForBrandfolder = $('#baseUriForBrandfolder' + folderkey).val();
	      var bearerTokenForBrandfolder = $('#bearerTokenForBrandfolder').val();
	      var bfHeaders = {};
	      bfHeaders["Authorization"] = bearerTokenForBrandfolder;
	      fetch(baseUriForBrandfolder + assetKey, {
	        method: "GET",
	        headers: bfHeaders
	      }).then(function (response) {
	        if (response.status >= 200 && response.status <= 299) {
	          return response.json();
	        } else {
	          throw Error(response.statusText);
	        }
	      }).then(function (jsonResponse) {
	        var title = "";
	        try {
	          title = jsonResponse.data[0].attributes.name;
	        } catch (e) {
	          console.log('Title could not be retrieved from BrandFolder');
	        }
	        window.eventBus.publish('popupShow', { asset_key: assetKey, title: title, bfFolderType: folderkey });
	      }).catch(function (error) {
	        console.log(error);
	      });
	    },
	    applyForCostcoCredit: function applyForCostcoCredit(baseUrl, authorizedMemNum) {
	      COSTCO.util.ajaxSend();
	      if (typeof PageAnalyticsInfo !== 'undefined') {
	        var pageType = PageAnalyticsInfo.pageType;
	      }
	      $.ajax({
	        type: 'POST',
	        url: 'https://' + location.hostname + '/ApplyForCostcoCredit',
	        dataType: 'jsonp',
	        data: {
	          'authorizedMemNum': authorizedMemNum,
	          'pageType': pageType
	        },
	        success: function success(parsedDataJson) {
	          // Show dropdown of member numbers to choose
	          if (parsedDataJson.errorCode) {
	            if (parsedDataJson.errorCode == 2510) // session timeout
	              {
	                document.location.href = 'Logoff?URL=ReLogonFormView&storeId=' + wcs.storeId;
	                return;
	              }
	          }
	
	          var data = parsedDataJson.applicationPrepopData;
	          var token = '';
	          var citiRedirectUrl = '';
	          var authorizedMembersJsonArray = [];
	
	          if (data) {
	            token = data.CITI_MEMBERDATA_SIGNED_ENCRYPTED;
	          }
	
	          if (baseUrl && token) {
	            citiRedirectUrl = '' + baseUrl + token;
	          }
	
	          var payloadJson = {
	            'applicationPrepopData': data
	          };
	
	          if (parsedDataJson.authorizedMembers) {
	            authorizedMembersJsonArray = $.parseJSON(parsedDataJson.authorizedMembers);
	          }
	          //TO-DO: hiding authorizedMember selection modal until funitonality is implemented on backend. 
	          // if (authorizedMembersJsonArray != undefined && authorizedMembersJsonArray.length > 0) {
	          //   util.createMemberNumberSelectDialog(baseUrl, payloadJson, authorizedMembersJsonArray);
	          // } else 
	          if (citiRedirectUrl) {
	            util.createCostcoCreditApplyExtPrefillDialog(citiRedirectUrl);
	          } else {
	            util.createCostcoCreditApplyExtPrefillDialog(baseUrl);
	          }
	        },
	        error: function error(x, t, m) {
	          COSTCO.util.LoginTimeout.updateActivity();
	          if (t === 'timeout') {
	            console.log('timout with server');
	          } else {
	            console.log('unexpected error TODO');
	          }
	          console.log('set return codes for caller of this service TODO');
	        },
	        complete: function complete() {
	          COSTCO.util.ajaxComplete();
	        }
	      });
	      return false;
	    },
	    /**
	     * This is the dialog, allowing users to select authorized users for their citi
	     * application.  This function is referenced solely in applyForCostcoCredit().
	     */
	    createMemberNumberSelectDialog: function createMemberNumberSelectDialog(baseUrl, payloadJson, authorizedMembersJsonArray) {
	      var dialogDiv = $(this.tmpl('tmpl_costco_cc_additional_member', {}));
	      dialogDiv.find(':selected').val(payloadJson);
	      var memberSelect = dialogDiv.find('select');
	      for (var i = 0; i < authorizedMembersJsonArray.length; i++) {
	        memberSelect.append($('<option>', {
	          value: {
	            'applicationPrepopData': authorizedMembersJsonArray[i].memberPayload
	          }
	        }).text(authorizedMembersJsonArray[i].name));
	      }
	      COSTCO.dialog.createExtDialogBox({
	        title: messages.JS_DIALOG_AUTHORIZED_USER_TITLE,
	        body: dialogDiv,
	        primary: messages.JS_DIALOG_AUTHORIZED_USER_OK,
	        secondary: messages.JS_DIALOG_CANCEL,
	        primary_event: function primary_event() {
	          var authorizedMemNum = $('#authorized-member-select').val();
	          COSTCO.util.dynamicExternalFormPost(baseUrl, payloadJson);
	          $('.costcoModalBtn1').first().click();
	        }
	      });
	      return false;
	    },
	    createCostcoCreditApplyExtDialog: function createCostcoCreditApplyExtDialog(baseUrl, payloadJson) {
	      var dialogDiv = $(this.tmpl('tmpl_costco_cc_apply_confirm', {}));
	      COSTCO.dialog.createExtDialogBox({
	        title: messages.JS_DIALOG_LEAVING_SITE_TITLE,
	        body: dialogDiv,
	        primary: messages.JS_DIALOG_AUTHORIZED_USER_OK,
	        secondary: messages.JS_DIALOG_CANCEL,
	        primary_event: function primary_event() {
	          COSTCO.util.dynamicExternalFormPost(baseUrl, payloadJson);
	          $('.costcoModalBtn1').first().click();
	        }
	      });
	      return false;
	    },
	    /**
	    * External link dialog for Citi application prefill.
	    */
	    createCostcoCreditApplyExtPrefillDialog: function createCostcoCreditApplyExtPrefillDialog(url) {
	      COSTCO.dialog.createExtDialogBox({
	        title: messages.JS_DIALOG_EXTERNAL_LINK,
	        body: messages.JS_LEAVING_DOMAIN_ALERT_SINGLE_TAG,
	        secondary: messages.JS_DIALOG_CANCEL,
	        primary: messages.JS_DIALOG_EXTERNAL_LINK,
	        primary_event: function primary_event() {
	          document.location.href = url;
	          COSTCO.dialog.close();
	        }
	      });
	    },
	    /**
	     * This shows or hides all citi application links based on certain criteria.
	     */
	    showAllCappLinks: function showAllCappLinks(isShow) {
	      if (isShow == undefined || isShow) {
	        $('.citi_credit_app_link').show();
	      } else {
	        $('.citi_credit_app_link').hide();
	      }
	    },
	    /**
	     * This processes the business cases for when users should not be allowed to apply
	     * for citi credit cards.  Links will be hidden, and other text will be shown instead.
	     * For the case where text is shown instead, the business must set this up via CMC.  Please
	     * reference the run documentation provided.
	     */
	    processCappLogic: function processCappLogic() {
	      var capp_json = util.getCappJson();
	      if (capp_json != null) {
	        if (capp_json.coBrandedCreditMax) {
	          // hide all application links
	          util.showAllCappLinks(false);
	        } else if (capp_json.displayErrorForRenew) {
	          // show message and hide all application link
	          $('#displayErrorForRenew').show();
	          util.showAllCappLinks(false);
	        } else if (capp_json.displayErrorForCancel) {
	          // show message and hide all application links
	          $('#displayErrorForCancel').show();
	          util.showAllCappLinks(false);
	        } else if (capp_json.displayErrorForRenewGSHousehold) {
	          // show message and hide all application links
	          $('#displayErrorForRenewGSHousehold').show();
	          util.showAllCappLinks(false);
	        } else {
	          // show credit app links
	          util.showAllCappLinks(true);
	        }
	      } else {
	        // show credit app links
	        util.showAllCappLinks(true);
	      }
	    },
	    /**
	     * Updates the cookie json with the business logic encapsulated in these
	     * attributes.
	     */
	    updateCappJson: function updateCappJson(data) {
	      var capp_json = {};
	      capp_json.coBrandedCreditMax = typeof data !== 'undefined' ? data.coBrandedCreditMax : MembershipMetaData.payload.caller.coBrandedCreditMax;
	      capp_json.displayErrorForRenew = typeof data !== 'undefined' ? data.displayErrorForRenew : MembershipMetaData.payload.caller.displayErrorForRenew;
	      capp_json.displayErrorForCancel = typeof data !== 'undefined' ? data.displayErrorForCancel : MembershipMetaData.payload.caller.displayErrorForCancel;
	      capp_json.displayErrorForRenewGSHousehold = typeof data !== 'undefined' ? data.displayErrorForRenewGSHousehold : MembershipMetaData.payload.caller.displayErrorForRenewGSHousehold;
	      $.cookie('capp_json', JSON.stringify(capp_json), {
	        expires: 30,
	        path: '/'
	      });
	    },
	    /**
	     * Retrieves citi cookie and converts to json.
	     */
	    getCappJson: function getCappJson() {
	      var capp_json = $.cookie('capp_json');
	      if (capp_json != null) {
	        capp_json = JSON.parse(capp_json);
	      }
	      return capp_json;
	    },
	    /**
	     * Create external post form, to be used in a dialog (if on whitelist)
	     * or incorporated into the external link dialog.  dataJson is converted
	     * into hidden inputs to pass in the form. Form opens to new tab.
	     */
	    dynamicExternalFormPost: function dynamicExternalFormPost(url, dataJson) {
	      var dynamicPostForm = $('<form method=\'POST\' action=\'' + url + '\' target=\'_blank\' enctype=\'multipart/form-data\'></form>');
	      for (var key in dataJson) {
	        if (dataJson.hasOwnProperty(key)) {
	          dynamicPostForm.append($('<input type=\'hidden\' name=\'' + key + '\' value=\'' + dataJson[key] + '\'/>'));
	        }
	      }
	      // Pushing the form into the DOM and then submitting, IE complains if not done.
	      $('body').append($('<div id=\'external_link\' style=\'display:hidden\'/>').append(dynamicPostForm.clone()));
	      $('#external_link form').submit();
	      $('#external_link form').remove();
	    },
	    /**
	     * Ajax spinner for send.
	     */
	    ajaxSend: function ajaxSend() {
	      if ($('#dataGlobalSpinner').length == 0) {
	        var spinner = '<div class="ui-widget-overlay ui-front r1_spinner" id="dataGlobalSpinner"></div>';
	        $('body').append(spinner);
	      } else {
	        $('#dataGlobalSpinner').append('<div/>');
	      }
	    },
	    /**
	     * Ajax spinner for completion.  Multiple ajax spinners could be going, so this
	     * will only take one out with each call.
	     */
	    ajaxComplete: function ajaxComplete() {
	      var spinner = $('#dataGlobalSpinner');
	      if (spinner.length > 0 && spinner.children().length == 0) {
	        spinner.remove();
	      } else {
	        $(spinner.children()[0]).remove();
	      }
	    },
	    /**
	     * Login timeout logic incorporated from legacy js that is referenced.
	     */
	    LoginTimeout: {
	      redirectView: '/LogonForm',
	      lastActivity: '',
	      checkTimeout: function checkTimeout() {
	        if (COSTCO.util.LoginTimeout.lastActivity == '') {
	          return;
	        }
	        var now = new Date().getTime();
	        var diff = now - COSTCO.util.LoginTimeout.lastActivity;
	        if (diff > wcs.loginTimeOut) {
	          window.location.href = COSTCO.util.LoginTimeout.redirectView;
	          throw new Error('Stale browser - redirecting');
	        }
	      },
	      updateActivity: function updateActivity() {
	        COSTCO.util.LoginTimeout.lastActivity = new Date().getTime();
	      }
	    },
	    /**
	     * Get a parsed object from localStorage (if localStorage is available).
	     * @param  {[item]} item - the key to pull from localStorage
	     * @return {[object]} storage_item - the object representing the string
	     *  in local storage (or empty object in the case of the item not existing)
	     */
	    getFromStorage: function getFromStorage(item) {
	      var storage_item = {};
	      if (localStorage) {
	        storage_item = localStorage.getItem(item) ? JSON.parse(localStorage.getItem(item)) : {};
	      }
	      return storage_item;
	    },
	    /**
	     * Set a string/object in localStorage for later use (if localStorage is available)
	     * @param {[string]} name - key to reference the value
	     * @param {[string|object]} item - value to store in localStorage
	     */
	    setInStorage: function setInStorage(name, item) {
	      var item = typeof item === 'string' ? item : JSON.stringify(item);
	      if (localStorage) {
	        localStorage.setItem(name, item);
	      }
	    },
	    /**
	     * Get a parsed object from sessionStorage (if sessionStorage is available).
	     * @param  {[item]} item - the key to pull from sessionStorage
	     * @return {[object]} storage_item - the object representing the string
	     *  in session storage (or empty object in the case of the item not existing)
	     */
	    getFromSession: function getFromSession(item) {
	      var storage_item = {};
	      if (sessionStorage) {
	        storage_item = sessionStorage.getItem(item) ? JSON.parse(sessionStorage.getItem(item)) : {};
	      }
	      return storage_item;
	    },
	    /**
	     * Set a string/object in sessionStorage for later use (if sessionStorage
	     * is available)
	     * @param {[string]} name - key to reference the value
	     * @param {[string|object]} item - value to store in sessionStorage
	     */
	    setInSession: function setInSession(name, item) {
	      var item = typeof item === 'string' ? item : JSON.stringify(item);
	      if (sessionStorage) {
	        sessionStorage.setItem(name, item);
	      }
	    },
	    /**
	     * Remove object from sessionStorage (if sessionStorage is available).
	     * @param  {[name]} name - key for item to be removed from sessionStorage
	     * @return none
	     *
	     */
	    removeFromSession: function removeFromSession(name) {
	      if (sessionStorage) {
	        sessionStorage.removeItem(name);
	      }
	    },
	    /**
	     * Shamelessly stolen from stackoverflow. Get the query string by name
	     * @param  {[type]}
	     * @param  {[type]}
	     * @return {[type]}
	     */
	    getParameterByName: function getParameterByName(name, url) {
	      if (!url) url = window.location.href;
	      name = name.replace(/[\[\]]/g, '\\$&');
	      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
	          results = regex.exec(url);
	      if (!results) return null;
	      if (!results[2]) return '';
	      return decodeURIComponent(results[2].replace(/\+/g, ' '));
	    },
	    /**
	     * Shamelessly stolen from stackoverflow. Adds a single parameter to the URL 
	     * @param  {[type]}
	     * @param  {[type]}
	     * @return {[type]}
	     */
	    insertParamInUrl: function insertParamInUrl(key, value) {
	      key = encodeURIComponent(key);
	      value = encodeURIComponent(value);
	      var kvp = document.location.search.substr(1).split('&');
	      var i = 0;
	      for (; i < kvp.length; i++) {
	        if (kvp[i].startsWith(key + '=')) {
	          var pair = kvp[i].split('=');
	          pair[1] = value;
	          kvp[i] = pair.join('=');
	          break;
	        }
	      }
	      if (i >= kvp.length) {
	        kvp[kvp.length] = [key, value].join('=');
	      }
	      var params = kvp.join('&');
	      return params;
	    },
	    /**
	     * Returns an object representing query string parameters.
	     * @return {[object]} The object represeting query strings
	     *                        &isAwesome=true becomes
	     *                        {"isAwesome":"true"}
	     */
	    get_parameters_as_object: function get_parameters_as_object() {
	      return document.location.search.replace(/(^\?)/, '').split('&').map(function (n) {
	        return n = n.split('='), this[n[0]] = n[1], this;
	      }.bind({}))[0];
	    },
	    all: function all(arr, p) {
	      // from haskell's data.list
	      var test = true;
	      arr.forEach(function (x) {
	        if (!p(x)) {
	          test = false;
	          return;
	        }
	      });
	      return test;
	    },
	    /**
	     * Returns True if at least one item in the array fulfills the condition
	     * @param  {[array]}    arr - the array to test
	     * @param  {[function]} p - the predicate function to test against the array
	     * @return {Boolean}
	     */
	    any: function any(arr, p) {
	      var answer = false;
	      for (var i = 0, len = arr.length; i < len; i++) {
	        if (answer) break;
	        if (p(arr[i])) {
	          answer = true;
	          break;
	        }
	      }
	      return answer;
	    },
	    hasElem: function hasElem(elem, array) {
	      var hasit = false;
	      array.forEach(function (e, i) {
	        if (elem === e) hasit = true;
	        return;
	      });
	      return hasit;
	    },
	    localeSpecificCurrency: function localeSpecificCurrency(v, loc, c) {
	      var n = parseFloat(v);
	      if (isNaN(v)) return v;
	      c = typeof c != 'undefined' ? c : 2;
	      switch (loc) {
	        case 'fr':
	          return this.formatCurrency(n, c, ',', ' ') + ' $';
	        default:
	          return '$' + this.formatCurrency(n, c, '.', ',');
	      }
	    },
	    formatCurrency: function formatCurrency(n, c, d, t) {
	      var c = isNaN(c = Math.abs(c)) ? 2 : c,
	          d = d == undefined ? ',' : d,
	          t = t == undefined ? '.' : t,
	          s = n < 0 ? '-' : '',
	          i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + '',
	          j = (j = i.length) > 3 ? j % 3 : 0;
	      return s + (j ? i.substr(0, j) + t : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : '');
	    },
	    formatMoney: function formatMoney(number, has_symbol) {
	      var number = (Math.round(number * 100) / 100).toString(),
	          dollars = number.split('.')[0],
	          cents = (number.split('.')[1] || '') + '00';
	      dollars = dollars.split('').reverse().join('').replace(/(\d{3}(?!$))/g, '$1,').split('').reverse().join(''), symbol = has_symbol ? '$' : '';
	      var locale = COSTCO.util.getLocale();
	      if (locale == 'fr-CA') {
	        return dollars.split(',').join(' ') + ',' + cents.slice(0, 2) + ' ' + symbol;
	      }
	      return symbol + dollars + '.' + cents.slice(0, 2);
	    },
	    formatPhone: function formatPhone(number) {
	      if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE === true) {
	        return number.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
	      } else {
	        return number.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
	      }
	    },
	    // public method for encoding
	    encode: function encode(input) {
	      var output = '';
	      var chr1 = void 0,
	          chr2 = void 0,
	          chr3 = void 0,
	          enc1 = void 0,
	          enc2 = void 0,
	          enc3 = void 0,
	          enc4 = void 0;
	      var i = 0;
	      input = COSTCO.util._utf8_encode(input);
	      while (i < input.length) {
	        chr1 = input.charCodeAt(i++);
	        chr2 = input.charCodeAt(i++);
	        chr3 = input.charCodeAt(i++);
	        enc1 = chr1 >> 2;
	        enc2 = (chr1 & 3) << 4 | chr2 >> 4;
	        enc3 = (chr2 & 15) << 2 | chr3 >> 6;
	        enc4 = chr3 & 63;
	        if (isNaN(chr2)) {
	          enc3 = enc4 = 64;
	        } else if (isNaN(chr3)) {
	          enc4 = 64;
	        }
	        output = output + this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) + this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4);
	      }
	      return output;
	    },
	    // public method for decoding
	    decode: function decode(input) {
	      var output = '';
	      var chr1 = void 0,
	          chr2 = void 0,
	          chr3 = void 0;
	      var enc1 = void 0,
	          enc2 = void 0,
	          enc3 = void 0,
	          enc4 = void 0;
	      var i = 0;
	      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');
	      while (i < input.length) {
	        enc1 = this._keyStr.indexOf(input.charAt(i++));
	        enc2 = this._keyStr.indexOf(input.charAt(i++));
	        enc3 = this._keyStr.indexOf(input.charAt(i++));
	        enc4 = this._keyStr.indexOf(input.charAt(i++));
	        chr1 = enc1 << 2 | enc2 >> 4;
	        chr2 = (enc2 & 15) << 4 | enc3 >> 2;
	        chr3 = (enc3 & 3) << 6 | enc4;
	        output = output + String.fromCharCode(chr1);
	        if (enc3 != 64) {
	          output = output + String.fromCharCode(chr2);
	        }
	        if (enc4 != 64) {
	          output = output + String.fromCharCode(chr3);
	        }
	      }
	      output = COSTCO.util._utf8_decode(output);
	      return output;
	    },
	    // private method for UTF-8 decoding
	    _utf8_decode: function _utf8_decode(utftext) {
	      var string = '';
	      var i = 0;
	      var c = c1 = c2 = 0;
	      while (i < utftext.length) {
	        c = utftext.charCodeAt(i);
	        if (c < 128) {
	          string += String.fromCharCode(c);
	          i++;
	        } else if (c > 191 && c < 224) {
	          c2 = utftext.charCodeAt(i + 1);
	          string += String.fromCharCode((c & 31) << 6 | c2 & 63);
	          i += 2;
	        } else {
	          c2 = utftext.charCodeAt(i + 1);
	          c3 = utftext.charCodeAt(i + 2);
	          string += String.fromCharCode((c & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
	          i += 3;
	        }
	      }
	      return string;
	    },
	    // private method for UTF-8 encoding
	    _utf8_encode: function _utf8_encode(string) {
	      string = string.replace(/\r\n/g, '\n');
	      var utftext = '';
	      for (var n = 0; n < string.length; n++) {
	        var c = string.charCodeAt(n);
	        if (c < 128) {
	          utftext += String.fromCharCode(c);
	        } else if (c > 127 && c < 2048) {
	          utftext += String.fromCharCode(c >> 6 | 192);
	          utftext += String.fromCharCode(c & 63 | 128);
	        } else {
	          utftext += String.fromCharCode(c >> 12 | 224);
	          utftext += String.fromCharCode(c >> 6 & 63 | 128);
	          utftext += String.fromCharCode(c & 63 | 128);
	        }
	      }
	      return utftext;
	    },
	    /**
	     * Hard coded the locales as our current implementation only supports 3
	     * locales. Also application logic can override the default browser
	     * locale
	     */
	    getLocale: function getLocale() {
	      var langId = this.getLangId();
	      if (langId == -1) return 'en-US';
	      if (langId == -24) return 'en-CA';
	      if (langId == -25) return 'fr-CA';
	      return 'en-US';
	    },
	    isSafari: function isSafari() {
	      var is_chrome = navigator.userAgent.indexOf('Chrome') > -1;
	      var is_safari = navigator.userAgent.indexOf('Safari') > -1;
	      if (is_chrome && is_safari) {
	        is_safari = false;
	      }
	      return is_safari;
	    },
	    /**
	     * Function once ran will copy the dom to nodes as needed - helps to avoid a server "DOM Bomb", but places that load on the client
	     *
	     * Required to define placement and content params
	     *
	     * Options can be overriden as needed to use different classes depending how the responsive content is setup.
	     */
	    responsivePlacement: function responsivePlacement(options) {
	      var opt = {
	        placement: '',
	        content: '',
	        useInnerContent: true,
	        display: 'block',
	        DESKTOP: '.visible-xl-',
	        TABLETLANDSCAPE: '.visible-lg-',
	        TABLETPORTRAIT: '.visible-md-',
	        PHONELANDSCAPE: '.visible-sm-',
	        PHONEPORTRAIT: '.visible-xs-'
	      };
	      $.extend(opt, options);
	      var node = $(opt.placement + opt.content);
	      if (node.length < 1) {
	        console.log('Missing Content for RespnsivePlacement');
	        return;
	      }
	      var content = '';
	      if (opt.useInnerContent) content = node.html();else {
	        content = node;
	      }
	      if ($(opt.placement).find('[itemprop=name]')) {
	        $(opt.placement).find('[itemprop=name]').removeAttr('itemprop');
	      }
	
	      COSTCO.util.responsiveContent(opt.placement, opt.DESKTOP + opt.display, content);
	      COSTCO.util.responsiveContent(opt.placement, opt.TABLETLANDSCAPE + opt.display, content);
	      COSTCO.util.responsiveContent(opt.placement, opt.TABLETPORTRAIT + opt.display, content);
	      COSTCO.util.responsiveContent(opt.placement, opt.PHONELANDSCAPE + opt.display, content);
	      COSTCO.util.responsiveContent(opt.placement, opt.PHONEPORTRAIT + opt.display, content);
	      return;
	    },
	    responsiveContent: function responsiveContent(selector, nodeClass, content) {
	      var node = $(selector + nodeClass);
	      if (node.length <= 0) {
	        return;
	      }
	      if (node.html().trim().length <= 0) {
	        node.append(content);
	      }
	      return;
	    },
	    getQueryStringArray: function getQueryStringArray() {
	      var queryString = [];
	      var a = window.location.search.substr(1).split('&'),
	          b = void 0;
	      for (var i = 0; i < a.length; i++) {
	        b = a[i].split('=');
	        queryString[decodeURIComponent(b[0])] = decodeURIComponent(b[1]);
	      }
	      return queryString;
	    },
	    /**
	     * Taken from Underscore.js (http://underscorejs.org/)
	     * Returns a function, that, as long as it continues to be invoked, will not
	     * be triggered. The function will be called after it stops being called for
	     * N milliseconds. If `immediate` is passed, trigger the function on the
	     * leading edge, instead of the trailing.
	     */
	    debounce: function debounce(func, wait, immediate) {
	      var timeout = void 0;
	      return function () {
	        var context = this,
	            args = arguments;
	        clearTimeout(timeout);
	        timeout = setTimeout(function () {
	          timeout = null;
	          if (!immediate) func.apply(context, args);
	        }, wait);
	        if (immediate && !timeout) func.apply(context, args);
	      };
	    },
	    isElementInViewport: function isElementInViewport(el) {
	      if (el.length <= 0) {
	        return false;
	      }
	      var rect = el[0].getBoundingClientRect();
	      return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) + 600 && /* or $(window).height() */rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */;
	    },
	    onVisibilityChange: function onVisibilityChange(el, callback) {
	      return function () {
	        var visible = COSTCO.util.isElementInViewport(el);
	        if (visible == true) {
	          if (typeof callback == 'function') {
	            callback();
	          }
	        }
	      };
	    },
	    /**
	     * Decode an HTML encoded string. Turns stuff like this
	     * '&lt;p&gt;name&lt;/p&gt;&lt;' and converts it to '<p>name</p>'
	     * @param  {String} encodedHtmlString The html string to decode
	     * @return {String}                   The decoded html string.
	     */
	    get_decoded_html: function get_decoded_html(encodedHtmlString) {
	      var textArea = document.createElement('textarea');
	      textArea.innerHTML = encodedHtmlString;
	      return textArea.value;
	    },
	    /**
	     * Inject an arbitrary number of hidden inputs into a given form. Meant
	     * to be a utility to prevent statically adding key/values to $.ajax.
	     * Just use this function and then serialize the form with $.fn.serialize.
	     * Note that this function will only inject an input into a form if the
	     * named input doesn't already exist.
	     * @param  {String} form   The form selector
	     * @param  {Object} inputs The object representing the key/values to
	     *                         be inserted into the form as inputs
	     *                         {key:'value'}
	     * @return {void}
	     */
	    input_injector: function input_injector(form, inputs) {
	      var html = '';
	      Object.keys(inputs).forEach(function (key) {
	        if ($(form + ' input[name=' + key + ']').length == 0) {
	          html += '<input type=\'hidden\' name=\'' + key + '\' value=\'' + inputs[key] + '\'/>';
	        } else if (key === 'prescriptionId' || key === 'isPharmacy') {
	          $(form + ' input[name=' + key + ']').val(inputs[key]);
	        }
	      });
	      $(form).append(html);
	    },
	    iosModalWhiteSpace: function iosModalWhiteSpace(selectorArray) {
	      // hide the native soft keyboards
	      if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent)) {
	        selectorArray.forEach(function (selector) {
	          var formElements = $(selector + ' input,' + selector + ' select,' + selector + ' textarea');
	          $(formElements).unbind('focus.iosModalWhiteSpace').on('focus.iosModalWhiteSpace', function () {
	            $(selector).css({
	              position: 'absolute'
	            });
	          });
	          $(formElements).unbind('blur.iosModalWhiteSpace').on('blur.iosModalWhiteSpace', function () {
	            $(selector).css({
	              position: 'fixed'
	            });
	            window.scrollTo(0, 0);
	          });
	        });
	      }
	    },
	    /**
	     * This fixes the case where the cursor sits outside of the focused input
	     * on iOS devices. It has the unfortunate side effect of scrolling
	     * to the top of the page when the modal is overlayed.
	     * @return {void}
	     */
	    iosPositionFix: function iosPositionFix() {
	      if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent)) {
	        var style = $('<style>body.modal-open { position: fixed; }</style>');
	        $('html > head').append(style);
	      }
	    },
	    /**
	     * Check if the application is running on the costco mobile app
	     */
	    isRunningOnMobileApp: function isRunningOnMobileApp() {
	      return typeof Android != 'undefined' || typeof webkit != 'undefined';
	      //return true;
	    },
	    /**
	     * This function compares UserAgent header with mobile pattern regex. If mobile browser is not detected with this way,
	     * it checks if screen width is 1024 or less, which is also being treated as a mobile browser.
	     * 
	     * @returns True if mobile browser is detected
	     */
	    isMobile: function isMobile() {
	      var detectedMobileWithRegex = /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune|Nokia|UCWEB/i.test(navigator.userAgent.toLowerCase());
	      var detectedMobileByScreenSize = $(window).width() <= 1024;
	      return detectedMobileWithRegex || detectedMobileByScreenSize;
	    },
	    /**
	     * Generates random UUID number
	     */
	    createUUID: function createUUID() {
	      var dt = new Date().getTime();
	      var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	        var r = (dt + Math.random() * 16) % 16 | 0;
	        dt = Math.floor(dt / 16);
	        return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
	      });
	      return uuid;
	    },
	    /**
	     * Generic ajax wrapper. Set promise handlers inside the options
	     * object. ie options.done: function(){} will be called when the
	     * request is finished. Options object also gets passed back the
	     * the promise functions. Look at the signures below.
	     * @param  {Object} options The object used to pass options.
	     *                          {done: function(){}, hi: 'robert'}
	     * @return {jQuery.Deferred} The deferred object generated by calling
	     *                           $.ajax which can be chained.
	     */
	    ajax: function ajax(options) {
	      var done = void 0;
	      var fail = void 0;
	      var always = void 0;
	      var beforeSend = options.beforeSend || undefined;
	      var complete = options.complete || undefined;
	      options.done ? done = options.done : undefined;
	      options.fail ? fail = options.fail : undefined;
	      options.always ? always = options.always : undefined;
	      // Defaulting adding/removing the "busy" class as a decorator
	      // for beforeSend and complete
	      beforeSend ? options.beforeSend = function (jqXHR, settings) {
	        $('.order-ajax').addClass('ajax-busy');
	        beforeSend(jqXHR, settings);
	      } : options.beforeSend = function (jqXHR, settings) {
	        $('.order-ajax').addClass('ajax-busy');
	      };
	      complete ? options.complete = function (jqXHR, textStatus) {
	        $('.order-ajax, .permanent-ajax-busy').removeClass('ajax-busy');
	        complete(jqXHR, textStatus);
	      } : options.complete = function (jqXHR, textStatus) {
	        if (!options.keepBusy) {
	          $('.order-ajax, .permanent-ajax-busy').removeClass('ajax-busy');
	        }
	      };
	      return $.ajax(options).done(function (data, textStatus, jqXHR) {
	        if (done) done(data, textStatus, jqXHR, options);
	      }).fail(function (jqXHR, textStatus, errorThrown) {
	        if (fail) fail(jqXHR, textStatus, errorThrown, options);
	      }).always(function (data, textStatus, jqXHR) {
	        if (always) always(data, textStatus, jqXHR, options);
	      });
	    },
	    /**
	     * Used by jquery.validate on "validate" function options to scroll to the
	     * first error in the list.
	     * @param  {object} event     The event on the form
	     * @param  {object} validator The validator object associated with the form
	     * @return {void}
	     */
	    invalid_handler: function invalid_handler(event, validator) {
	      if (!validator.numberOfInvalids()) return;
	      var base = $('#costcoModal').hasClass('in') ? '#costcoModal' : 'html, body';
	      base == '#costcoModal' ? $(base).scrollTo(validator.errorList[0].element, 100) : $(base).scrollToElem(validator.errorList[0].element, 100);
	      validator.errorList[0].element.focus();
	    },
	    /**
	     * Check to see if a particular path is part of the checkout flow.
	     * @param  {String}  pathname The path (document.location.pathname)
	     * @return {Boolean}          Is this path part of the checkout flow?
	     */
	    isCheckout: function isCheckout(pathname) {
	      var isCheckout = false;
	      if (pathname == '/CheckoutCartView' || pathname == '/CheckoutCartDisplayView' || pathname == '/CheckoutPaymentView' || pathname == '/CheckoutShippingView' || pathname == '/CheckoutReviewView') {
	        isCheckout = true;
	      }
	      return isCheckout;
	    },
	    triggerClickOnEnterKeyPress: function triggerClickOnEnterKeyPress(inputSelector, clickSelector) {
	      $(inputSelector).unbind('keypress').on('keypress', function (event) {
	        if (event.which == 13) {
	          $(clickSelector).click();
	          return false;
	        }
	      });
	    },
	    /**
	     * Takes a base url and appends query strings to it. Joining the
	     * base and querystring with the appropriate separator '&' or '?'
	     * @param  {string} base           The string to append query strings to
	     *                                 '/order-item-update' or 'www.costco.com'
	     * @param  {object} querystringObj The object representing the querystrings
	     *                                 to append ie '{checkoutPage: 'review'}'
	     * @return {string}                The made url with querystrings attached.
	     */
	    makeUrl: function makeUrl(base, querystringObj) {
	      var sep = base.indexOf('?') > -1 ? '&' : '?';
	      return base + sep + $.param(querystringObj);
	    },
	    /**
	     * Did the ajax response object return any application or system errors?
	     * @param  {object}  response_obj The parsed response object from calling
	     *                                any backend class that resolves to
	     *                                JSONLayout.jsp
	     * @return {Boolean}              Does it have application or system errors?
	     */
	    has_errors: function has_errors(response_obj) {
	      var application = response_obj.error.application;
	      var exception = response_obj.error.exception;
	      return application.length > 0 || exception.length > 0;
	    },
	    messageFormat: function messageFormat(format) {
	      var args = Array.prototype.slice.call(arguments, 1);
	      return format.replace(/{(\d+)}/g, function (match, number) {
	        return typeof args[number] != 'undefined' ? args[number] : match;
	      });
	    },
	    /**
	     * This function restricts membership number inputs to numeric user input.
	     * The input must be of type=text for it to work.
	     * @return {void}
	     */
	    maskMembershipInput: function maskMembershipInput() {
	      $('[name=userField2], [name=membershipNumber], [name=membershipId], [name=membershipNumberToVerify]').mask('#');
	    },
	    addToWishList: function addToWishList(catentryId, fromPage) {
	      window.location.href = COSTCO.util.makeUrl('/AddToWishListView', {
	        catentryId: catentryId,
	        fromPage: fromPage || ''
	      });
	    },
	    isBusinessDelivery: function isBusinessDelivery() {
	      if ($('#isBDAppVar') && $('#isBDAppVar').length > 0) {
	        currentSite = $('#isBDAppVar').val();
	        if (currentSite == 'BD') {
	          return true;
	        }
	      }
	      return false;
	    },
	
	    /**
	     * To initialize global grocery flag. Determine whether grocery product is displayed in the page or not.
	     * @return {Boolean} hasGroceryProducts
	     */
	    hasGroceryProducts: function hasGroceryProducts() {
	      var hasGroceryProducts = false;
	      if ($('#hasGroceryPdts').length > 0) {
	        var globalFlag = $('#hasGroceryPdts').val();
	        if (null != globalFlag && globalFlag == 'true') {
	          hasGroceryProducts = true;
	        }
	      }
	      return hasGroceryProducts;
	    },
	    /**
	     * Determine the default grocery home page url
	     * @return {String} groceryHomepageURL
	     */
	    groceryDefaultHomepage: function groceryDefaultHomepage() {
	      var groceryHomepageURL = '';
	      if ($('#groceryDefaultHomepage').length > 0) {
	        groceryHomepageURL = $('#groceryDefaultHomepage').val();
	      }
	      return groceryHomepageURL;
	    },
	    isCAStore: function isCAStore() {
	      var isCAStore = false;
	      if (null != wcs.storeId && wcs.storeId == '10302') {
	        isCAStore = true;
	      }
	      return isCAStore;
	    },
	    isCABDStore: function isCABDStore() {
	      var isCAStore = false;
	      if (null != wcs.storeId && wcs.storeId == '11303') {
	        isCAStore = true;
	      }
	      return isCAStore;
	    },
	    isUSBDStore: function isUSBDStore() {
	      var isBDStore = false;
	      if (null != wcs.storeId && wcs.storeId == '11301') {
	        isBDStore = true;
	      }
	      return isBDStore;
	    },
	    isBDStore: function isBDStore() {
	      var isBDStore = false;
	      if (null != wcs.storeId && wcs.storeId != '10301' && wcs.storeId != '10302') {
	        isBDStore = true;
	      }
	      return isBDStore;
	    },
	    isUSStore: function isUSStore() {
	      var isUSStore = false;
	      if (null != wcs.storeId && wcs.storeId == '10301') {
	        isUSStore = true;
	      }
	      return isUSStore;
	    },
	    is2DayEligbleRegn: function is2DayEligbleRegn() {
	      var isRegionValid = 'false';
	      if ($.cookie('C_2LOC') != null) {
	        isRegionValid = $.cookie('C_2LOC');
	      }
	      if (isRegionValid != null && COSTCO.util.isCAStore() && isRegionValid == 'false') {
	        return false;
	      }
	      return true;
	    },
	    logToClickTale: function logToClickTale(message, url, lineNumber) {
	      if (typeof window.onerror !== 'function') {
	        console.log('onerror is not a function');
	      }
	      try {
	        if ((typeof message === 'undefined' ? 'undefined' : _typeof(message)) === 'object') {
	          message = JSON.stringify(message);
	        }
	        window.onerror(message, url, lineNumber);
	      } catch (e) {
	        console.log('Unknown error logging to Clicktale');
	      }
	    },
	    getSource: function getSource() {
	      var locale = util.getLocale().slice(3, 5).toUpperCase();
	      var store = util.isBDStore() ? 'BD' : 'BC';
	      return locale + store;
	    },
	    // Begin Business Delivery Client Cookies
	    getBDZipCookie: function getBDZipCookie() {
	      var z = $.cookie('WC_BD_ZIP'),
	          w = $.cookie('WC_BD_WHS'),
	          ec = '',
	          originalZipCode = $.cookie('WC_BD_ZIP_ORIGINAL');
	      if (z == null || z == '""') {
	        z = '';
	      }
	      if (originalZipCode == null || originalZipCode == '""') {
	        originalZipCode = '';
	      }
	      if (w == null || w == '""') {
	        w = '';
	      } else {
	        if (w.indexOf('-') != -1) {
	          //STRY0140687 BD-National Delivery-Check the presence of EC to identify the residential flow.
	          if (w.indexOf('ND') != -1) {
	            var whsArray = w.split('-');
	            if (whsArray.includes('ND')) {
	              ec = 'ND';
	            }
	          }
	          w = w.substring(0, w.indexOf('-'));
	        }
	      }
	      z = z.replace(/\+/g, ' ');
	      originalZipCode = originalZipCode.replace(/\+/g, ' ');
	      return {
	        zipCode: z,
	        warehouseNumber: w,
	        externalCarrier: ec,
	        originalZipCode: originalZipCode
	      };
	    },
	    getMaxOutherHeight: function getMaxOutherHeight(elems) {
	      return Math.max.apply(null, elems.map(function () {
	        return $(this).outerHeight(true);
	      }).get());
	    },
	    isDepotCatalogEnabled: function isDepotCatalogEnabled() {
	      var depotCatalogEnableFlag = $('#depotCatalogEnableFlag').length > 0 && $('#depotCatalogEnableFlag').val() == 'true' ? true : false;
	      return depotCatalogEnableFlag;
	    },
	    isNdEnabled: function isNdEnabled() {
	      if ($('#isNdEnabled').val() == 'true') {
	        return true;
	      } else {
	        return false;
	      }
	    },
	    isEDDEnabled: function isEDDEnabled() {
	      var eddEnabled = true;
	      if (COSTCO.util.checkElementById('#vendorName', 'EDD:CHUBSmallPack') && !COSTCO.util.checkElementById('#eddSmallPackEnabled', 'true')) {
	        eddEnabled = false;
	      }
	      return eddEnabled;
	    },
	
	    isExternalCarrierShipmode: function isExternalCarrierShipmode() {
	      var shipmodeId = '';
	      if (COSTCO.util.isNdEnabled() && ($('input[name="deliveryMethod"]').length > 0 || $('#shipmodeId').length > 0)) {
	        shipmodeId = $('input[name="deliveryMethod"]').length > 0 ? $('input[name="deliveryMethod"]:checked').val() : $('#shipmodeId').val();
	      }
	      if (shipmodeId == '10102' || shipmodeId == '10104') {
	        return true;
	      } else {
	        return false;
	      }
	    },
	
	    isExternalCarrierShipmodeValue: function isExternalCarrierShipmodeValue(shipmodeId) {
	      if (COSTCO.util.isNdEnabled() && shipmodeId.length > 0 && (shipmodeId == '10102' || shipmodeId == '10104')) {
	        return true;
	      } else {
	        return false;
	      }
	    },
	
	    /**
	     * Check if first search suggestion exists and set it to
	     * screen reader announcement div
	     */
	    setFirstSuggestionAnnouncement: function setFirstSuggestionAnnouncement() {
	      if ($('.tt-suggestion').length > 0 && $('#announce-first-suggestion').length > 0 && $('.tt-menu').find('.tt-cursor').length === 0) {
	        var firstSuggestion = $('.tt-suggestion:first').text();
	        $('#announce-first-suggestion').text(firstSuggestion);
	      }
	    },
	
	    /**
	       * Announce first suggestion (if any) after user's inactivity 
	       */
	    announceFirstSuggestion: function announceFirstSuggestion() {
	      if ($('#announce-first-suggestion').length > 0) {
	        $('#announce-first-suggestion').text('');
	      }
	      window.clearTimeout(this.timeout);
	      timeout = window.setTimeout(this.setFirstSuggestionAnnouncement, 2000);
	    },
	    /**
	     * This is to define the constants for the product availablity check
	     */
	    productConstants: {
	      inv_backorderd: 'BACK_ORDER',
	      inv_outOfStock: 'OUT_STOCK',
	      inv_invalidSku: 'INVALID_ITEM',
	      zipcodeAvailCheck_StatusFail: 'FAIL',
	      check_StatusSuccess: 'success',
	      edd_shiprestricted: 'SHIPRESTRICTED',
	      edd_backordered: 'BACKORDERED',
	      edd_presell: 'PRESELL'
	    },
	    /**
	     * Notification object for notification message display.
	     */
	    notification: {
	      /**
	       * Constants for notification display.
	       */
	      type: {
	        SUCCESS: 'SUCCESS',
	        WARNING: 'WARNING',
	        ERROR: 'ERROR'
	      },
	      /**
	       * Displays notification on screen.
	       * @param {string}  notificationType     Type of notification message to display (SUCCESS | WARNING | ERROR)
	       * @param {Array}   notifications        Array of notification messages to be displayed in the notification box
	       * @param {boolean} scrollToNotification Scroll window to notification message
	       * @param {Jquery element}  element           Jquery element for notification display
	       */
	      displayNotification: function displayNotification(notificationType, notifications, scrollToNotification, $element, wrapper) {
	        $element = $element && $($element).length > 0 ? $($element) : $('#notification-message');
	        scrollToNotification = scrollToNotification ? scrollToNotification : false;
	
	        this.clearNotification($element);
	
	        var topNotificationClass = '';
	        var topNotificationInnerHtml = '';
	
	        switch (notificationType) {
	          case this.type.SUCCESS:
	            topNotificationClass = 'success-notification';
	            break;
	          case this.type.WARNING:
	            topNotificationClass = 'warning';
	            break;
	          case this.type.ERROR:
	            topNotificationClass = 'critical-notification';
	            break;
	          default:
	            break;
	        }
	        var elementWrapper = wrapper ? wrapper : 'p';
	        notifications.forEach(function (notification) {
	          if ((typeof notification === 'undefined' ? 'undefined' : _typeof(notification)) === 'object') {
	            for (var errorKey in notification) {
	              topNotificationInnerHtml += '<' + elementWrapper + ' role=\"alert\">' + notification[errorKey] + '</' + elementWrapper + '>';
	            }
	          } else {
	            topNotificationInnerHtml += '<' + elementWrapper + ' role=\"alert\">' + notification + '</' + elementWrapper + '>';
	          }
	        });
	
	        $element.addClass(topNotificationClass);
	
	        topNotificationInnerHtml = COSTCO.util.get_decoded_html(topNotificationInnerHtml);
	        $element.html(topNotificationInnerHtml);
	
	        if (scrollToNotification) {
	          $('body, html').animate({
	            scrollTop: $element.offset().top - 30
	          }, 800);
	        }
	
	        $element.attr('tabindex', -1);
	        $element.focus();
	      },
	      /**
	       * Clears displayed notifications on screen.
	       * @param {Jquery element} Jquery element for notification display.
	       */
	      clearNotification: function clearNotification($element) {
	        $element = $element ? $($element) : $('#notification-message');
	
	        $element.removeClass();
	        $element.html('');
	      }
	    },
	
	    /**
	     * Redirects the pages to generic error/cart on inactive conditions
	     * @param page 
	     * @param orderStatus 
	     */
	    redirectCartOnInactive: function redirectCartOnInactive(page, status) {
	      if ($('#orderStatus').val() !== '' && $('#orderStatus').val() !== undefined) {
	        if ((page === 'SHIPPING' || page === 'payment' || page === 'review') && status === 'INACTIVE') {
	          window.location.href = "/CheckoutCartView";
	        } else if ((page === 'quick-membership' || page === 'quick-membership-renew') && status === 'INACTIVE') {
	          window.location.href = "/GenericError";
	        }
	      }
	    },
	
	    /**
	     * Gets element with back to top link
	     * and (if exists) binds keydown and click event
	     * that moves focus to top of the page
	     * @param backToTopLink
	     */
	    setEventOnBackToTopLink: function setEventOnBackToTopLink(backToTopLinkClass) {
	      var $backToTopLink = $(backToTopLinkClass).find("a").length > 0 ? $(backToTopLinkClass).find("a") : $(backToTopLinkClass);
	      /* ADA STRY0169325 - Back to top functionality */
	      $backToTopLink.attr("href", "#headerskip");
	      $backToTopLink.click(function () {
	        COSTCO.util.scrollToTop();
	      });
	      $backToTopLink.keydown(function (e) {
	        if (e.keyCode === 13) COSTCO.util.scrollToTop();
	      });
	    },
	
	    /**
	     * Function used to add a label with error message accessible only to screen reader
	     * @param element that error label should be attached to
	     */
	    addErrorLabelForAda: function addErrorLabelForAda(element) {
	      if (typeof element !== 'undefined' && element !== null) {
	        var $element = $(element);
	        if ($element.hasClass("error") && !$element.siblings('.sr-only').length) {
	          $element.before("<span for=\"" + $element[0].id + "\" class=\"sr-only\">" + messages.ERROR + "</span>");
	        }
	      }
	    },
	
	    /**
	     * Function used for fetching first global error message on page
	     * @param containerElement - specifies the element in which the global error is searched for
	     * @return first element with global error class
	     */
	    getFirstGlobalErrorOnPage: function getFirstGlobalErrorOnPage(containerElement) {
	      var errorClasses = COSTCO.util.globalErrorElementClasses;
	      //create jquery selector from an array of classes
	      var selector = errorClasses.join(", .");
	      var firstElementWithClass = containerElement.find('.' + selector).html() !== undefined ? containerElement.find('.' + selector).first() : null;
	      var iterationValue = firstElementWithClass;
	      while (iterationValue !== undefined && iterationValue !== null) {
	        firstElementWithClass = iterationValue;
	        iterationValue = COSTCO.util.getFirstGlobalErrorOnPage(firstElementWithClass);
	      }
	      return firstElementWithClass;
	    },
	
	    /**
	     * Function that creates an error label accessible only to screen reader
	     * @param errorMessage that should be appended with screen reader label
	     * @return string containing both the error message and the screen reader only error label
	     */
	    createErrorAdaLabel: function createErrorAdaLabel(errorMessage) {
	      return "<span class='sr-only'>" + messages.ERROR + "</span>" + errorMessage;
	    },
	
	    /**
	     * Function used to remove a label with error message accessible only to screen reader
	     * @param element whose label should be removed
	     */
	    removeErrorLabelForAda: function removeErrorLabelForAda(element) {
	      if (typeof element !== 'undefined' && element !== null) {
	        var $element = $(element);
	        $element.siblings('label').remove(".sr-only");
	        $element.siblings().children('label').remove(".sr-only");
	        $element.parent().siblings('label').remove(".sr-only");
	      }
	    },
	
	    /**
	     * jquery validator 'highlight' method,
	     * with ADA error label added
	     */
	    highlightWithErrorLabel: function highlightWithErrorLabel(element, errorClass, validClass) {
	
	      if (element.type === 'radio') {
	        this.findByName(element.name).addClass(errorClass).removeClass(validClass);
	      } else {
	        $(element).addClass(errorClass).removeClass(validClass);
	        $(element).attr("aria-describedby", this.idOrName(element) + this.settings.idSuffix);
	      }
	      COSTCO.util.addErrorLabelForAda(element);
	    },
	
	    /**
	        * jquery validator 'unhighlight' method,
	        * with ADA error label added
	        */
	    unhighlightWithErrorLabel: function unhighlightWithErrorLabel(element, errorClass, validClass) {
	      if (element.type === 'radio') {
	        this.findByName(element.name).removeClass(errorClass).addClass(validClass);
	      } else {
	        $(element).removeClass(errorClass).addClass(validClass);
	        $(element).removeAttr("aria-describedby");
	      }
	      COSTCO.util.removeErrorLabelForAda(element);
	    },
	
	    /**
	     * Function used to inject message in screen reader placeholder announcement div
	     * @param message to be injected
	     */
	    announceSRMessage: function announceSRMessage(message) {
	      var adaMessageDiv = $('#screen-reader-announcement');
	      if (message !== undefined && message.length !== 0 && message !== "") {
	        adaMessageDiv.empty();
	        adaMessageDiv.html(message);
	
	        //after a 2sec delay, remove the message so SR users don't unneccessarily revisit it when navigating DOM
	        setTimeout(function () {
	          adaMessageDiv.empty();
	        }, 2000);
	      }
	    },
	
	    /**
	     * Calling function onclick by pressing enter key (keyCode = 13)
	     * @param id
	     */
	    clickElementOnEnter: function clickElementOnEnter(elementId) {
	      if (event.keyCode === 13 && $('#' + elementId).length > 0) {
	        $('#' + elementId).click();
	      }
	    },
	
	    /**
	     * Calling function onclick by pressing enter key (keyCode = 13)
	     * or pressing space key (keyCode = 32)
	     * @param id
	     */
	    clickElementOnEnterOrSpace: function clickElementOnEnterOrSpace(elementId) {
	      if ((event.keyCode === 13 || event.keyCode === 32) && $('#' + elementId).length > 0) {
	        //Prevents from window scrolling
	        if (event.keyCode === 32) {
	          event.preventDefault();
	        }
	        //If element is tooltip, do not perfrom action
	        if ($(".span-inline-block").is(":focus")) {
	          return false;
	        }
	        $('#' + elementId).click();
	      }
	    },
	
	    //Workarround for FireFox locked tabbing on radio buttons ALM #22811
	    /**
	     * Calling function onfocus event 
	     * and changing label tabindex attr to -1
	     */
	    changeTabIndex: function changeTabIndex() {
	      var element = $("label[role=radio]");
	      element.each(function () {
	        $(this).attr('tabindex', '-1');
	      });
	    },
	
	    /**
	     * Calling function onblur event making element unfocusable
	     * and changing label tabindex attr back to 0
	     * @param el (date input name)
	     */
	    changeTabIndexOut: function changeTabIndexOut(el) {
	      if (el) {
	        $(el).attr('tabindex', '0');
	      }
	      var element = $("label[role=radio]");
	      element.each(function () {
	        $(this).attr('tabindex', '0');
	      });
	    },
	
	    /**
	     * Calling function onfocus event making date input focusable
	     * @param element (date input name)
	     */
	    setTabIndex: function setTabIndex(el) {
	      var element = $("input[name=" + el + "]");
	      element.attr('tabindex', '0');
	    },
	
	    /**
	     * Calling function onclick by pressing Space key (keyCode = 32) 
	     * referencing element by element's ID
	     * @param elementId
	     */
	    clickElementOnSpaceBtn: function clickElementOnSpaceBtn(elementId) {
	      if (event.keyCode === 32 && $('#' + elementId).length > 0) {
	        //Prevents from window scrolling
	        event.preventDefault();
	        //If element is tooltip, do not perfrom action
	        if ($(".span-inline-block").is(":focus")) {
	          return false;
	        }
	        $('#' + elementId).click();
	      }
	    },
	    /**
	     * Returns all focusable elements inside parent element
	     * @parentElement
	     */
	    returnAllFocusableElements: function returnAllFocusableElements(parentElement) {
	      var focusableElements = parentElement.querySelectorAll('a[href]:not([disabled]), button:not([disabled]),' + 'textarea:not([disabled]),input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]),' + 'input[type="checkbox"]:not([disabled]), select:not([disabled]), *[tabindex="0"], area');
	      return focusableElements;
	    },
	    /**
	     * Returns all visible focusable elements from list of elements
	     * @focusableElements
	     */
	    returnAllFocusableVisibleElements: function returnAllFocusableVisibleElements(focusableElements) {
	      var visibleFocusable = [];
	
	      function findVisibleElements(item, index) {
	        $(item).unbind('keydown');
	        //Does element or its parent has display none
	        if (item.style.display !== "none" && item.offsetParent !== null) {
	          if ($(item).is(':visible')) {
	            visibleFocusable.push(item);
	          }
	        }
	      }
	
	      for (var i = 0; i < focusableElements.length; i++) {
	        findVisibleElements(focusableElements[i]);
	      }
	      return visibleFocusable;
	    },
	    /**
	     * Returns focus to first/last focusable element in modal
	     */
	    setElementFocus: function setElementFocus(firstElement, lastElement, e) {
	      var KEYCODE_TAB = 9;
	      if (e.key === 'Tab' || e.keyCode === KEYCODE_TAB) {
	        if (e.shiftKey && document.activeElement === firstElement) /* shift + tab */{
	            lastElement.focus();
	            e.preventDefault();
	          } else if (!e.shiftKey && document.activeElement === lastElement) {
	          firstElement.focus();
	          e.preventDefault();
	        }
	      }
	    },
	
	    /**
	     * Scrolls page to top
	     */
	    scrollToTop: function scrollToTop() {
	      $('#headerskip').get(0).scrollIntoView(true);
	      $('#headerskip').focus();
	    },
	
	    /**
	     * Focuses on an element without scrolling to it
	     */
	    focusWithoutScroll: function focusWithoutScroll(elem) {
	      var x = window.scrollX;
	      var y = window.scrollY;
	      elem.focus();
	      window.scrollTo(x, y);
	    },
	
	    /**
	     * Sets lisener on first and last
	     * element on modal, and traps focus inside them
	     */
	    bindModalFocusEvents: function bindModalFocusEvents(firstElement, lastElement) {
	      $(firstElement).unbind('keydown').bind('keydown', function (e) {
	        COSTCO.util.setElementFocus(firstElement, lastElement, e);
	      });
	      $(lastElement).unbind('keydown').bind('keydown', function (e) {
	        COSTCO.util.setElementFocus(firstElement, lastElement, e);
	      });
	    },
	    trapFocusInsideModal: function trapFocusInsideModal() {
	      var modalBody = $(".modal-dialog").get(0);
	      if (modalBody != undefined) {
	        var focusableElements = COSTCO.util.returnAllFocusableElements(modalBody);
	        var focusableVisible = COSTCO.util.returnAllFocusableVisibleElements(focusableElements);
	        if (focusableVisible.length > 0) {
	          var firstElement = focusableVisible[0];
	          var lastElement = focusableVisible[focusableVisible.length - 1];
	          COSTCO.util.bindModalFocusEvents(firstElement, lastElement);
	        }
	      }
	    },
	    /**
	     * Showes and hides elemenet based on flag parameter
	     * @param element
	     * @param flag
	     */
	    showHtmlElementByFlag: function showHtmlElementByFlag(element, flag) {
	      if (element == undefined || flag == undefined) {
	        return false;
	      }
	      if (flag === true) {
	        element.removeClass('hide');
	      } else {
	        element.addClass('hide');
	      }
	    },
	    /**
	     * Test if this page is part of new design.
	     * @return true if page is part of new design, false otherwise
	     */
	    isPDPCartCheckoutEnabled: function isPDPCartCheckoutEnabled() {
	      return costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE || costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE || costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE;
	    },
	
	    /**
	     * Method to convert the date input string to Timestamp format
	     */
	    convertDateToTimestamp: function convertDateToTimestamp(dateSring) {
	      var dateTimeParts = dateSring,
	          dateParts = dateTimeParts.split('-'),
	          date;
	      date = new Date(dateParts[0], parseInt(dateParts[1], 10) - 1, dateParts[2], '00', '00');
	      return date.getTime();
	    },
	    globalErrorElementClasses: ['critical-notification', 'error', 'lists-error', 'form-error-text'],
	    base64test: /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{4}|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)$/,
	    _keyStr: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
	    _keyStrExcl: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789',
	    getUrlToLangMap: function getUrlToLangMap() {
	      var urlToLanguageMap = sessionStorage.getItem("urlToLanguageMap");
	      if (urlToLanguageMap == null) {
	        return JSON.parse("{}");
	      } else {
	        return JSON.parse(urlToLanguageMap);
	      }
	    },
	    addUrlToLangMap: function addUrlToLangMap(url, selectedLang) {
	      var urlToLanguageMap = COSTCO.util.getUrlToLangMap();
	      // Checked with business and we will accommodate 50 items in history to 
	      // check for language to reasonably meet most of customers' activities.
	      if (Object.keys(urlToLanguageMap).length >= 50) {
	        var keyToDelete = Object.keys(urlToLanguageMap)[0];
	        delete urlToLanguageMap[keyToDelete];
	      }
	      urlToLanguageMap[url] = selectedLang;
	      sessionStorage.setItem("urlToLanguageMap", JSON.stringify(urlToLanguageMap));
	    },
	    removeUrlFromLangMap: function removeUrlFromLangMap(url) {
	      var urlToLanguageMap = COSTCO.util.getUrlToLangMap();
	      delete urlToLanguageMap[url];
	      sessionStorage.setItem("urlToLanguageMap", JSON.stringify(urlToLanguageMap));
	    },
	    /**
	     * 1. Create a map of url pathname and the language at the time the url was accessed 
	     * 2. During browser history back and forward, if the selectedLanguage and value of the language from the map
	     * 		do not match, then do a hard load of the page
	     */
	    registerLanguageListener: function registerLanguageListener() {
	      // Register event if event function is not already defined
	      if (typeof window.onpageshow !== "function") {
	        window.onpageshow = function (event) {
	          var currentLang = $.cookie(cookies.SELECTED_LANG_COOKIE);
	          var currentUrl = window.location.pathname;
	          // event.persisted is faulty, so use window.performance.navigation.type also
	          if (event.persisted || window.performance && window.performance.navigation.type == 2) {
	            // window.performance.navigation.type = 2 means back or forward
	            var langSettingForCurrentUrl = COSTCO.util.getUrlToLangMap()[currentUrl];
	            if (langSettingForCurrentUrl !== undefined && langSettingForCurrentUrl !== currentLang) {
	              console.log("Doing hard reload since language has changed");
	              COSTCO.util.removeUrlFromLangMap(currentUrl);
	              if (isMobileApp == 'true') {
	                COSTCO.myLocation.reloadWithNewLanguage(currentLang);
	              }
	            }
	          } else {
	            COSTCO.util.addUrlToLangMap(currentUrl, currentLang);
	          }
	        };
	      }
	    },
	    /*
	     * A11Y STRY0166460
	     */
	    closeDropdownWhenOutOfFocus: function closeDropdownWhenOutOfFocus() {
	      $('.list-group-item').find('a').focusin(function () {
	        if (!$(this).parents('.dropdown-container').hasClass('open')) {
	          $('.dropdown-container.open').removeClass('open');
	        }
	      });
	      $('#search-field').focusin(function () {
	        $('.dropdown-container.open').removeClass('open');
	      });
	    },
	
	    /* A screen reader user should only be able to access one search field 
	     * ADA STRY0166458
	     */
	
	    addAriaHiddenToHiddenInput: function addAriaHiddenToHiddenInput() {
	      $("input[type=text].tt-hint").attr("aria-hidden", "true");
	    },
	
	    /** DSR Membership Enquiry - used to open Membership inquiry modal
	     * 
	    */
	    membershipDetailedEnquiry: function membershipDetailedEnquiry() {
	      var modalOptions = {
	        title: messages.RWD_MEMBERSHIP_NUMBER,
	        body: COSTCO.util.tmpl('tmpl_membership_modal'),
	        primary: messages.CLOSE,
	        primary_button_fullspan: false,
	        primary_event: function primary_event() {
	          COSTCO.dialog.close();
	        }
	      };
	      COSTCO.dialog.showAndHideModal(modalOptions);
	    },
	    /**
	        * Method return timeout function for fetch method to call API services
	        */
	    getTimeoutController: function getTimeoutController() {
	      /**
	        * Timeout function
	        * @param {Integer} time (miliseconds)
	        * @param {Promise} promise
	        */
	      var timeout = function timeout(time, promise) {
	        return new Promise(function (resolve, reject) {
	          setTimeout(function () {
	            reject(new Error('API_TIMEOUT'));
	          }, time);
	          promise.then(resolve, reject);
	        });
	      };
	      return timeout;
	    },
	    /**
	        * Method to check if a DOM element is present using its ID and verify the value of the element
	        * return true if the value matches, else false.
	        */
	    checkElementById: function checkElementById(elementId, value) {
	      var elementValueMatch = false;
	      if ($(elementId).length > 0 && $(elementId).val() === value) {
	        elementValueMatch = true;
	      }
	      return elementValueMatch;
	    },
	
	    parseURL: function parseURL(url) {
	      var a = document.createElement('a');
	      a.href = url;
	      return {
	        source: url,
	        protocol: a.protocol.replace(':', ''),
	        host: a.hostname,
	        port: a.port,
	        query: a.search,
	        params: function () {
	          var ret = {},
	              seg = a.search.replace(/^\?/, '').split('&'),
	              len = seg.length,
	              i = 0,
	              s;
	          for (; i < len; i++) {
	            if (!seg[i]) {
	              continue;
	            }
	            s = seg[i].split('=');
	            ret[s[0]] = s[1];
	          }
	          return ret;
	        }(),
	        file: (a.pathname.match(/\/([^\/?#]+)$/i) || [, ''])[1],
	        hash: a.hash.replace('#', ''),
	        path: a.pathname.replace(/^([^\/])/, '/$1'),
	        relative: (a.href.match(/tps?:\/\/[^\/]+(.+)/) || [, ''])[1],
	        segments: a.pathname.replace(/^\//, '').split('/')
	      };
	    },
	
	    getParamVal: function getParamVal(url, key) {
	      var urlMap = COSTCO.util.parseURL(url);
	      return urlMap.params[key];
	    },
	
	    /**
	     * Utility function detect is browser IE11 or older version
	     * return boolean
	     */
	    isIE11OrOlder: function isIE11OrOlder() {
	      var ua = window.navigator.userAgent;
	      var msie = ua.indexOf('MSIE ');
	      if (msie > 0) {
	        // IE 10 or older 
	        return true;
	      }
	      var trident = ua.indexOf('Trident/');
	      if (trident > 0) {
	        // IE 11 
	        return true;
	      }
	      return false;
	    },
	
	    /**
	     * Utility function to check if user is logged in
	     * return boolean
	     */
	    isUserLoggedIn: function isUserLoggedIn() {
	
	      try {
	        $.cookie("hashedUserId").length;
	        return true;
	      } catch (e) {
	        return false;
	      }
	    },
	
	    objectExistsAndNonEmpty: function objectExistsAndNonEmpty(obj) {
	      if (typeof obj == 'undefined') {
	        return false;
	      } else if (obj == null) {
	        return false;
	      } else if (obj == '') {
	        return false;
	      } else {
	        return true;
	      }
	    },
	    filterItems: function filterItems(arr, query) {
	      return arr.filter(function (el) {
	        return el.toLowerCase() != query.toLowerCase();
	      });
	    },
	
	    signoutNextAuth: function signoutNextAuth() {
	      // Fetch CSRF token
	      fetch("/api/auth/csrf", {
	        method: "GET",
	        headers: {
	          "Accept": "*/*",
	          "Cache-Control": "no-cache",
	          "Content-Type": "application/json",
	          "Pragma": "no-cache",
	          "Sec-Fetch-Mode": "cors",
	          "Sec-Fetch-Site": "same-origin",
	          "Credentials": "include"
	        }
	      }).then(function (response) {
	        if (!response.ok) {
	          throw new Error('Failed to fetch CSRF token');
	        }
	        return response.json();
	      }).then(function (data) {
	        var csrfToken = data.csrfToken;
	
	        // Sign out using CSRF token
	        return fetch("/api/auth/signout", {
	          method: "POST",
	          headers: {
	            "Accept": "*/*",
	            "Cache-Control": "no-cache",
	            "Content-Type": "application/x-www-form-urlencoded",
	            "Pragma": "no-cache",
	            "Sec-Fetch-Mode": "cors",
	            "Sec-Fetch-Site": "same-origin",
	            "Credentials": "include"
	          },
	          body: new URLSearchParams({
	            csrfToken: csrfToken,
	            callbackUrl: new URL(window.location.href).origin + "/?ao=yes",
	            json: true
	          })
	        });
	      }).then(function (response) {
	        if (!response.ok) {
	          throw new Error('Failed to sign out');
	        }
	        return response.json();
	      }).then(function (data) {
	        console.log(data.message);
	        // Handle success message as needed
	      }).catch(function (error) {
	        console.error('Error signing out:', error);
	        // Provide user feedback here if needed
	      });
	    },
	    logoutSso: function logoutSso(obj, logOffUrls, isSsoEnabled, isMobileApp) {
	      sessionStorage.removeItem("SelectedPatientIndex");
	      $.cookie('PrescriptionCount', null, { path: '/' });
	      try {
	        console.log("Sign out ");
	        if (typeof Android != 'undefined') {
	          console.log("Android sign out ");
	          Android.onSignOut();
	        } else if (typeof webkit != 'undefined') {
	          console.log("Webkit sign out ");
	          webkit.messageHandlers.onSignOut.postMessage('');
	        }
	        console.log("Sign out finished");
	        if (isSsoEnabled == '0' || isSsoEnabled == null || isSsoEnabled == '' || isSsoEnabled == false || isMobileApp == null || isMobileApp == '' || isMobileApp == 'true') {
	          window.location = window.location.origin + "/Logoff?usrClk=true";
	          return;
	        }
	
	        var logOffAcion = "/security/v1/users/session/ssologoff";
	
	        //New home page support.
	        try {
	          COSTCO.util.signoutNextAuth();
	        } catch (k) {}
	
	        $.cookie('C_GOP', null, { path: '/' });
	        if (logOffUrls == null || logOffUrls == undefined || logOffUrls == "") {
	          window.location = window.location.origin + "/Logoff?usrClk=true";
	          return;
	        }
	
	        logOffUrls = logOffUrls.split(",");
	        logOffUrls = COSTCO.util.filterItems(logOffUrls, window.location.origin);
	
	        if (logOffUrls != null && logOffUrls.length > 0) {
	          var targetUri = '';
	
	          if (costcoStoreFeatures.OCUCO_LOGOUT_ENABLED === true) {
	            targetUri = logOffUrls[0] + logOffAcion + '?' + 'a=' + logOffUrls[1] + logOffAcion + '&b=' + logOffUrls[2] + logOffAcion + '&c=' + logOffUrls[3] + "/Account/Logout";
	          } else {
	            targetUri = logOffUrls[0] + logOffAcion + '?' + 'a=' + logOffUrls[1] + logOffAcion + '&b=' + logOffUrls[2] + logOffAcion;
	          }
	          var logoffWindow = window.open(targetUri, '_blank');
	          setTimeout(function () {
	            logoffWindow.close();
	            window.location = window.location.origin + "/Logoff?usrClk=true";
	          }, 3800); //milliseconds
	        } else {
	          window.location = window.location.origin + "/Logoff?usrClk=true";
	        }
	      } catch (e) {
	        console.log(e);
	        window.location = window.location.origin + "/Logoff?usrClk=true";
	      }
	    },
	
	    /**
	    * This function strips anything that isn't a number
	     * Intended for quantity selector 
	    * @param {[string] inputValue}  
	    * @returns {[number] outputValue}
	    */
	    stripStringOfNonNumberTypes: function stripStringOfNonNumberTypes(inputValue) {
	      var outputValue = inputValue.replace(/[^\d]/g, "");
	      return outputValue;
	    },
	    /**
	     * Checks if the current context is related to a locationControlledInventory product. 
	     */
	    islocationControlledInventoryFlow: function islocationControlledInventoryFlow() {
	      var islocationControlledInventoryFlow = $('#regionalIdentifier').length > 0 && $('#regionalIdentifier').val() == 'true' ? true : false;
	      return islocationControlledInventoryFlow;
	    },
	
	    /**
	     * Checks if the current context is related to a siteControlledInventory product. 
	     */
	    issiteControlledInventoryFlow: function issiteControlledInventoryFlow() {
	      var issiteControlledInventoryFlow = $('#regionalIdentifier').length > 0 && $('#regionalIdentifier').val() == 'false' ? true : false;
	      return issiteControlledInventoryFlow;
	    },
	
	    getFiveDigitPostalCode: function getFiveDigitPostalCode(postalCode) {
	      var zipCode = postalCode;
	      var finalZip = '';
	      var zipCodeWithoutExtraFour = zipCode.split('-');
	      if (zipCodeWithoutExtraFour.length > 1) {
	        finalZip = zipCodeWithoutExtraFour[0];
	      } else {
	        finalZip = zipCode;
	      }
	      return finalZip;
	    },
	
	    formatPhoneNumber: function formatPhoneNumber(number) {
	      var phNumber = number.replace(/\D/g, '');
	      return phNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
	    },
	
	    cancelMemberApplication: function cancelMemberApplication(partNumber) {
	      var appTrackingCookie = $.cookie('APPLICATION_TRACKING_COOKIE');
	      var currentPage = window.location.pathname.substr(1);
	
	      if (document.referrer === "") {
	        window.location.href = '/CheckoutCartView';
	      } else {
	
	        if (appTrackingCookie !== 'null' || 'undefined') {
	          if ($('#isBDAppVar').val() === 'BD' && $.cookie('cartCountCookie') > 1) {
	            path = '/MembershipApplicationView?productPartNumber=' + partNumber + '&fromPage=' + currentPage;
	          } else {
	            path = '/QuickMembershipApplicationView?productPartNumber=' + partNumber + '&fromPage=' + currentPage;
	          }
	          console.log('path: ', path);
	          window.location.href = path;
	          return;
	        }
	        window.location.href = COSTCO.util.scrubSpecialChars(document.referrer);
	      }
	    },
	
	    /** selects the input radio buttons inside the given element
	    * used for all the radio buttons/selection-boxes combined elements */
	    selectRadioBox: function selectRadioBox(element) {
	      $(element).find('input').prop('checked', true);
	    },
	
	    /** used on onblur event of all fields so that the screen reader 
	    * would announce the error when focus moves out of the field */
	    alertScreenReader: function alertScreenReader(element) {
	      if ($(element).attr('aria-invalid') === 'true') {
	        var elementName = $(element).attr('name');
	        var errorElement = $('#' + elementName + 'Error');
	
	        errorElement.removeAttr('role');
	        errorElement.attr('role', 'alert');
	      }
	    },
	
	    ariaSetElementAsValid: function ariaSetElementAsValid(element) {
	      if (element) {
	        element.removeAttr('aria-describedby');
	        element.attr('aria-invalid', 'false');
	      }
	    },
	
	    ariaSetElementAsInvalid: function ariaSetElementAsInvalid(element, describedByElementId) {
	      if (element) {
	        element.attr('aria-describedby', describedByElementId);
	        element.attr('aria-invalid', 'true');
	      }
	    },
	    /**
	     * Gets element with back to top link and (if exists) binds keydown and click event
	     * that moves focus to top of the page. For Gatsby enabled pages # routing is implemented
	     * so we have add event to div rather than adding a new hash to current url
	     *
	     * @param backToTopLink
	     */
	    setEventOnBackToTopLinkGatsby: function setEventOnBackToTopLinkGatsby(backToTopLinkClass) {
	      /* ADA to move focus on skip link click */
	      var $backToTopLink = $(backToTopLinkClass).find("a").length > 0 ? $(backToTopLinkClass).find("a") : $(backToTopLinkClass);
	      //Added for gatsby body focus
	      $backToTopLink.click(function () {
	        $backToTopLink.attr("href", window.location.href);
	        COSTCO.util.scrollToTopGatsby();
	      });
	      $backToTopLink.keydown(function (e) {
	        $backToTopLink.attr("href", window.location.href);
	        if (e.keyCode === 13) COSTCO.util.scrollToTopGatsby();
	      });
	    },
	
	    /**
	    * This function opens and closes accordion that contains drugs list
	    * @param  {String} letter capital letter of drugs
	    * @param  {String} html element that was clicked
	    * @param  {String} hostProtocolURL 
	    * @return {void}
	    */
	    show_drug_list_by_capital_letter: function show_drug_list_by_capital_letter(letter, hostProtocolURL, element) {
	      if ($('#cmpp-drugs-by-letter-accordion-collapse').hasClass('in') && $('#cmpp-drugs-by-letter-accordion-collapse').attr('data-letter') == letter) {
	        $('#cmpp-drugs-by-letter-accordion-collapse').collapse('hide');
	        $(element).children(".cmpp-close").addClass("hidden");
	        $(element).removeClass("cmpp-title-active");
	        $('html, body').animate({ scrollTop: $(element).offset().top }, 800);
	      } else {
	
	        if ($('#cmpp-drugs-by-letter-accordion-collapse').hasClass('in')) {
	
	          $('#cmpp-drugs-by-letter-accordion-collapse').collapse('hide');
	
	          setTimeout(function () {
	            COSTCO.util.drug_list_by_capital(letter, hostProtocolURL, element);
	          }, 700);
	        } else {
	          COSTCO.util.drug_list_by_capital(letter, hostProtocolURL, element);
	        }
	      }
	    },
	    /**
	     * This function handles building the drug list that corresponds
	     * with first letter of drug name.
	     * @param  {String} stateCode used to filter list of all cmpps
	     * @param  {String} html element that was clicked
	     * @param  {String} hostProtocolURL
	     * @return {void}
	     */
	    drug_list_by_capital: function drug_list_by_capital(letter, hostProtocolURL, element) {
	
	      $('#cmpp-drugs-by-letter-accordion-collapse').remove();
	      $('html, body').animate({ scrollTop: $(element).offset().top }, 800);
	
	      $(".panel-group div div div").removeClass("cmpp-title-active");
	      $(".panel-group div div .cmpp-close").addClass("hidden");
	      $(element).addClass("cmpp-title-active");
	      $(element).children(".cmpp-close").removeClass("hidden");
	
	      $(element).parent().after(COSTCO.util.tmpl('tmpl_drugs_by_letter', {
	        letter: letter
	      }));
	      var windowWidth = $(window).width();
	      var colNum = 1;
	      if (windowWidth > 1025) {
	        colNum = 3;
	      } else if (windowWidth > 667) {
	        colNum = 2;
	      };
	      var drugNamesObj = JSON.parse(allDrugNamesMap[0].jsonDrugNameURL);
	      var drugArr = [];
	      for (var el in drugNamesObj) {
	        if (el.substring(0, 1) === letter) {
	          var obj = {
	            drugName: el,
	            drugUrl: drugNamesObj[el]
	          };
	          drugArr.push(obj);
	        }
	      }
	      var numOfItems = drugArr.length;;
	      var numOfRows = Math.ceil(numOfItems / colNum);
	      for (var i = 0; i < numOfRows; i++) {
	        $('#cmpp-drugs-by-letter-accordion-collapse-panel').append(COSTCO.util.tmpl('tmpl_drugs_list_by_capital_letter', {
	          drugLink1: drugArr[i] && hostProtocolURL + drugArr[i].drugUrl,
	          drugLink2: drugArr[i + numOfRows] && hostProtocolURL + drugArr[i + numOfRows].drugUrl,
	          drugLink3: drugArr[i + 2 * numOfRows] && hostProtocolURL + drugArr[i + 2 * numOfRows].drugUrl,
	          drugName1: drugArr[i].drugName && drugArr[i].drugName,
	          drugName2: drugArr[i + numOfRows] && drugArr[i + numOfRows].drugName,
	          drugName3: drugArr[i + 2 * numOfRows] && drugArr[i + 2 * numOfRows].drugName,
	          numOfCol: colNum
	
	        }));
	      }
	      $('#cmpp-drugs-by-letter-accordion-collapse').collapse('show');
	    },
	    /**
	     * Scrolls page to top
	    */
	    scrollToTopGatsby: function scrollToTopGatsby() {
	      document.getElementById("gatsbyIndex").scrollIntoView(true);
	      document.getElementById("gatsbyIndex").focus();
	    },
	
	    /**
	      * Util to give an interactive character count down
	      * @param  {ojbect} label    pass the jquery obj where you want the
	      *                           countdown to reflect
	      * @param  {object} textarea pass a 'text' input
	      *                           (input[type='text'],textarea) to count
	      * @return {void}
	    */
	    character_count: function character_count(label, textarea) {
	      if ($(label).length > 0 && $(textarea).length > 0) {
	        var updateLabelCount = function updateLabelCount(textarea, label) {
	          var count = $(textarea).val().length;
	          $(label).text(max - count);
	        };
	
	        var max = parseInt($(textarea).attr('maxlength'));
	        $(label).text(max - $(textarea).val().length);
	        $(textarea).unbind('keyup').on('keyup', function () {
	          updateLabelCount(this, label);
	        });
	        $(textarea).unbind('change').on('change', function () {
	          updateLabelCount(this, label);
	        });
	      }
	    },
	    getCookieByName: function getCookieByName(name) {
	      var value = '; ' + document.cookie;
	      var parts = value.split('; ' + name + '=');
	      if (parts.length === 2) return parts.pop().split(';').shift();
	    },
	
	    // function for sanitizing data to prevent XSS attacks
	    replaceSpecialChars: function replaceSpecialChars(obj) {
	      var result = new String(obj);
	
	      result = result.replace(/&/g, "&amp;");
	      result = result.replace(/</g, "&lt;");
	      result = result.replace(/>/g, "&gt;");
	      result = result.replace(/'/g, "&#39;");
	      result = result.replace(/"/g, "&quot;");
	      result = result.replace(/\//g, "&#47;");
	      result = result.replace(/\\/g, "&#92;");
	
	      return result;
	    },
	    /**
	     * Async SHA256 encryption
	     * @param {} message text that will be hashed
	     * @param {} callback 
	     */
	    sha256: function sha256(message, callback) {
	      var encoder = new TextEncoder();
	      var data = encoder.encode(message);
	      crypto.subtle.digest('SHA-256', data).then(function (hashBuffer) {
	        var hashArray = Array.from(new Uint8Array(hashBuffer));
	        var hashHex = hashArray.map(function (byte) {
	          return byte.toString(16).padStart(2, '0');
	        }).join('');
	        callback(hashHex);
	      }).catch(function (error) {
	        console.error('Error calculating SHA-256 hash: ', error);
	        callback(null);
	      });
	    },
	    getCookieStartingWith: function getCookieStartingWith(prefix) {
	      var cookies = document.cookie.split(';');
	
	      for (var i = 0; i < cookies.length; i++) {
	        var cookie = cookies[i].trim();
	
	        // Check if the cookie starts with the specified prefix
	        if (cookie.startsWith(prefix)) {
	          // Extract the value of the cookie
	          return cookie.substring(prefix.length + 1);
	        }
	      }
	
	      // Return null if no matching cookie is found
	      return null;
	    },
	
	    /**
	     * Decode JWT and check for validity.  
	     * */
	    checkJWTExpiry: function checkJWTExpiry(JWT) {
	      var expired = true;
	      var JWT_payload = JSON.parse(atob(JWT.split('.')[1]));
	      if (typeof JWT_payload != 'undefined' && JWT_payload != null) {
	        var currentTimeInMiliseconds = Date.now();
	        var validUntil = Number(JWT_payload.created_at) + Number(JWT_payload.expires_in) - 3600000;
	        if (currentTimeInMiliseconds < validUntil) {
	          expired = false;
	        }
	      }
	      return expired;
	    },
	    sentenceToPascalCase: function sentenceToPascalCase(sentence) {
	      return sentence.split(' ').map(function (word) {
	        // Keeps only letters and numbers (including accented/Unicode letters)
	        return (word.match(/[A-Za-zÀ-ÖØ-öø-ÿ0-9]+/g) || []).join('');
	      }).map(function (word) {
	        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
	      }).join(' ');
	    },
	    isElementEmpty: function isElementEmpty(elementValue) {
	      if (typeof elementValue === 'undefined' || elementValue === null || elementValue === '') return true;
	      return false;
	    }
	  };
	  if (typeof window.COSTCO == 'undefined') {
	    window.COSTCO = new Object();
	  }
	  window.COSTCO.util = util;
	
	  return util;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title utility2.js: Global sub-module
	 * @description A collection of functions used application wide, except Home, Browse & Product pages.
	 * Functions that are not needed for Home, Browse & Product pages should live in this file
	 * This module should contain generic utility code. No module specifics.
	 */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	  var util = {
	    POSTAL_CODE_REGEX_US: /^(\d{5}(-\d{4})?$)$/,
	    POSTAL_CODE_REGEX_CA: /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1} \d{1}[A-Za-z]{1}\d{1}$/,
	    ATLEAST_ONE_ALPHABET: /^(?=.*[A-Za-z\u00C0-\u017F]).+/,
	    CC_NAME_FIELD_REGEX: /[^0-9A-Z\.\'\-\&\s\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u2030\u20AC]/i,
	    LAST_NAME_FIELD_REGEX: /[^0-9A-Z\.\'\-\s\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u2030\u20AC]/i,
	    /*
	     * Function used to escape double ticks (ADA)
	     **/
	    encode_html: function encode_html(input) {
	      input = input.replace('"', '&#34');
	      input = input.replace('\'', '&#39');
	      input = input.replace(';', '&#59');
	      return input;
	    },
	    /**
	     * Function used to "extend" the bootstap popover capability to add accesibility features
	     * function add a couple of the ADA needed attributes and a couple of keyboard navigation listener
	     * popover parameters are expected to be defined in the element as normal bootsrap popover
	     */
	    accesible_popover: function accesible_popover(selector) {
	      var popoverElement = $(selector);
	      popoverElement.popover().on('keydown', function (event) {
	        if (event.which == 13) $(this).popover('toggle');
	        if (event.which == 27) $(this).popover('hide');
	      }).on('blur', function () {
	        $(this).popover('hide');
	      }).on('shown.bs.popover', function () {
	        $(this).attr('aria-expanded', 'true');
	      }).on('hidden.bs.popover', function () {
	        $(this).attr('aria-expanded', 'false');
	      });
	    },
	    /**
	     * This function makes images in popover content tabbable for ADA purposes
	     * @param {string} tooltipClass - Tooltip class.
	     * @return {void}
	     */
	    activateKeyboardAccesiblePopover: function activateKeyboardAccesiblePopover(selector) {
	      var popoverElement = $('.' + selector);
	      popoverElement.popover().on('keydown', function (event) {
	        //Enter event keycode
	        if (event.which === 13) {
	          $(this).popover('toggle');
	          //Esc event keycode
	        } else if (event.which === 27) {
	          $(this).popover('hide');
	          //Shift+Tab event keycode
	        } else if (event.shiftKey && event.keyCode === 9) {
	          $(this).popover('hide');
	        }
	      }).on('focus', function () {
	        $(this).popover('toggle');
	        var tooltipElement = $(this);
	        var popoverContentId = $(this).attr('aria-describedby');
	        if (popoverContentId !== undefined && $('#' + popoverContentId).find('img').length !== 0) {
	          $('#' + popoverContentId).find('img').on('blur', function () {
	            tooltipElement.popover('hide');
	          });
	        }
	      }).on('shown.bs.popover', function () {
	        $(this).attr('aria-expanded', 'true');
	      }).on('hidden.bs.popover', function () {
	        $(this).attr('aria-expanded', 'false');
	      });
	      $(':not(.' + selector + ')').on('click', function () {
	        $('.co-help').each(function () {
	          if ($(this).attr('aria-expanded') === 'true') {
	            $(this).popover('hide');
	          }
	        });
	      });
	    },
	    isMinimumScreen: function isMinimumScreen(min) {
	      var width = $(window).width();
	      if (min == 'DESKTOP' && width >= 1025) return true;
	      if (min == 'TABLET-LANDSCAPE' && width >= 769) return true;
	      if (min == 'TABLET-PORTRAIT' && width >= 668) return true;
	      if (min == 'PHONE-LANDSCAPE' && width >= 376) return true;
	      if (min == 'PHONE-PORTRAIT' && width >= 0) return true;
	      return false;
	    },
	    isMaxScreen: function isMaxScreen(min) {
	      var width = $(window).width();
	      if (min == 'DESKTOP' && width < 1024) return true;
	      if (min == 'TABLET-LANDSCAPE' && width < 769) return true;
	      if (min == 'TABLET-PORTRAIT' && width < 668) return true;
	      if (min == 'PHONE-LANDSCAPE' && width < 376) return true;
	      if (min == 'PHONE-PORTRAIT' && width >= 0) return true;
	      return false;
	    },
	    /**
	     * External link dialog for FORMS ONLY.
	     */
	    createExternalLinkDialogForForm: function createExternalLinkDialogForForm(link, form, submitButtonTitle) {
	      var dialogDiv = $('<div id="external_link_dialog">' + $('<div>').append(form.clone()).html() + '<span>' + messages.JS_LEAVING_DOMAIN_ALERT.replace('{0}', this.hostname) + '</span></div>');
	      COSTCO.dialog.createExtDialogBox({
	        title: messages.JS_DIALOG_EXTERNAL_LINK,
	        body: dialogDiv,
	        primary: submitButtonTitle,
	        secondary: messages.JS_DIALOG_CANCEL,
	        primary_event: function primary_event() {
	          $('#external_link_dialog form').submit();
	          $('.costcoModalBtn1').first().click();
	        }
	      });
	      return false;
	    },
	    /**
	     * Return an array with only unique members. unique([1,2,1])
	     * returns [2,1]
	     * @param  {[array]} arr - The array with duplicated members
	     * @return {[array]} out - The array with unique members
	     */
	    unique: function unique(arr) {
	      var seen = {},
	          out = [],
	          len = arr.length,
	          j = 0;
	      for (var i = 0; i < len; i++) {
	        var item = arr[i];
	        if (seen[item] !== 1) {
	          seen[item] = 1;
	          out[j++] = item;
	        }
	      }
	      return out;
	    },
	    /**
	     * Return an array with a string interpolated between
	     * each member i.e. interpolate([1,2],'+') returns [1,"+",2]
	     * @param  {[array]} array - The array to interpolate
	     * @param  {[type]} string - the element to interpolate in the array
	     * @return {[type]} _array - The interpolated array
	     */
	    interpolate: function interpolate(array, _string) {
	      var _array = [];
	      for (var i = 0, len = array.length; i < len; i++) {
	        _array.push(array[i]);
	        if (i != array.length - 1) {
	          _array.push(_string);
	        }
	      }
	      return _array;
	    },
	    // Added for submitting encoded values without special characters
	    encodeExclSpecialChars: function encodeExclSpecialChars(input) {
	      var output = '';
	      var chr1 = void 0,
	          chr2 = void 0,
	          chr3 = void 0,
	          enc1 = void 0,
	          enc2 = void 0,
	          enc3 = void 0,
	          enc4 = void 0;
	      var i = 0;
	      input = COSTCO.util._utf8_encode(input);
	      while (i < input.length) {
	        chr1 = input.charCodeAt(i++);
	        chr2 = input.charCodeAt(i++);
	        chr3 = input.charCodeAt(i++);
	        enc1 = chr1 >> 2;
	        enc2 = (chr1 & 3) << 4 | chr2 >> 4;
	        enc3 = (chr2 & 15) << 2 | chr3 >> 6;
	        enc4 = chr3 & 63;
	        if (isNaN(chr2)) {
	          enc3 = enc4 = 64;
	        } else if (isNaN(chr3)) {
	          enc4 = 64;
	        }
	        output = output + this._keyStrExcl.charAt(enc1) + this._keyStrExcl.charAt(enc2) + this._keyStrExcl.charAt(enc3) + this._keyStrExcl.charAt(enc4);
	      }
	      return output;
	    },
	    // public method for decoding
	    decodeExclSpecialChars: function decodeExclSpecialChars(input) {
	      var output = '';
	      var chr1 = void 0,
	          chr2 = void 0,
	          chr3 = void 0;
	      var enc1 = void 0,
	          enc2 = void 0,
	          enc3 = void 0,
	          enc4 = void 0;
	      var i = 0;
	      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');
	      while (i < input.length) {
	        enc1 = this._keyStrExcl.indexOf(input.charAt(i++));
	        enc2 = this._keyStrExcl.indexOf(input.charAt(i++));
	        enc3 = this._keyStrExcl.indexOf(input.charAt(i++));
	        enc4 = this._keyStrExcl.indexOf(input.charAt(i++));
	        chr1 = enc1 << 2 | enc2 >> 4;
	        chr2 = (enc2 & 15) << 4 | enc3 >> 2;
	        chr3 = (enc3 & 3) << 6 | enc4;
	        output = output + String.fromCharCode(chr1);
	        if (enc3 != 64) {
	          output = output + String.fromCharCode(chr2);
	        }
	        if (enc4 != 64) {
	          output = output + String.fromCharCode(chr3);
	        }
	      }
	      output = COSTCO.util._utf8_decode(output);
	      output = output.replace(/[\u0000-\u0019]+/g, ''); // For removing the non-printable & Invalid JSON characters.
	      return output;
	    },
	    addresses: [],
	    addressLoadState: {
	      shipping: {
	        requested: 0,
	        loaded: 0
	      },
	      billing: {
	        requested: 0,
	        loaded: 0
	      }
	    },
	    resetAddressLoadState: function resetAddressLoadState() {
	      COSTCO.util.addresses = [];
	      COSTCO.util.addressLoadState = {
	        shipping: {
	          requested: 0,
	          loaded: 0
	        },
	        billing: {
	          requested: 0,
	          loaded: 0
	        }
	      };
	    },
	    getAddressBatchPage: function getAddressBatchPage(addressType, filterName, filterOrder, total, processBatch, processPagination) {
	      var start = 1,
	          end = total;;
	      if (addressType == 'S') {
	        addressLoadState = COSTCO.util.addressLoadState.shipping;
	      } else {
	        addressLoadState = COSTCO.util.addressLoadState.billing;
	      }
	      if (addressLoadState.requested == 0) {
	        COSTCO.util.getAddressBatch(addressType, filterName, filterOrder, start, total, processBatch, processPagination);
	      } else {
	        if (total > addressLoadState.requested) {
	          COSTCO.util.getAddressBatch(addressType, filterName, filterOrder, addressLoadState, total + addressLoadState.requested, processBatch, processPagination);
	        } else {
	          if (typeof processBatch === 'function') processBatch(COSTCO.util.addresses);
	          if (typeof processPagination === 'function') processPagination(COSTCO.util.addresses);
	        }
	      }
	    },
	    /* getAddresses
	     * arguments can contain a list of callback functions to be executed on .done.  The last arg is a optional addressType (S || B) that retrieves a filtered list of addresses
	     * */
	    getAddressBatch: function getAddressBatch(addressType, filterName, filterOrder, start, end, processBatch, processPagination) {
	      // request the user's addresses 
	
	      COSTCO.util.ajax({
	        url: '/AjaxCostcoGetAddressCmd?requesttype=ajax',
	        method: 'GET',
	        dataType: 'json',
	        data: {
	          addressType: encodeURIComponent(addressType),
	          filterName: encodeURIComponent(filterName),
	          filterOrder: encodeURIComponent(filterOrder),
	          start: encodeURIComponent(start),
	          end: encodeURIComponent(end)
	        },
	        done: function done(data, textStatus, jqXHR, options) {
	          try {
	            if (addressType == 'S') {
	              COSTCO.util.addressLoadState.shipping.requested += parseInt(end);
	              COSTCO.util.addressLoadState.shipping.loaded += parseInt(data.totalrecords);
	            } else {
	              COSTCO.util.addressLoadState.billing.requested += parseInt(end);
	              COSTCO.util.addressLoadState.billing.loaded += parseInt(data.totalrecords);
	            }
	            if (typeof data.addresses !== 'undefined') {
	              COSTCO.util.mergeAddresses(JSON.parse(data.addresses));
	            }
	          } catch (err) {
	            //
	            console.error(err, 'Parse error');
	          }
	          if (typeof processBatch === 'function') processBatch(data);
	          if (typeof processPagination === 'function') processPagination(data);
	        }
	      });
	    },
	    mergeAddresses: function mergeAddresses(data) {
	      for (var i = 0; i < data.length; i++) {
	        if (data[i].hasOwnProperty('addressId')) {
	          COSTCO.util.renameArray(data[i], COSTCO.util.addressNamingMap);
	        }
	      }
	      COSTCO.util.addresses = COSTCO.util.addresses.concat(data);
	    },
	    /**
	     * Add every unique address from 'addresses' to
	     * COSTCO.util.addresses
	     * @param  {array} addresses [
	     * @return {void}
	     */
	    concatNonDuplicates: function concatNonDuplicates(addresses) {
	      var _this = this;
	
	      addresses.forEach(function (address) {
	        if (!_this.any(_this.addresses, function (x) {
	          return x.id == address.id;
	        })) {
	          _this.addresses.push(address);
	        }
	      });
	    },
	    /*
	     * Address naming is a mess
	     */
	    addressNamingMap: {
	      addressId: 'id',
	      addressTypeId: 'addressType',
	      addressLine1: 'line1',
	      addressLine2: 'line2',
	      firstName: 'first',
	      lastName: 'last',
	      companyName: 'company',
	      primary: 'isPrimary',
	      postalCode: 'zip',
	      middleName: 'mInitial',
	      emailAddress: 'email',
	      fName: 'first',
	      lName: 'last',
	      pNumber: 'phone'
	    },
	    renameArray: function renameArray(data, map) {
	      for (var key in data) {
	        if (data.hasOwnProperty(key) && map.hasOwnProperty(key)) {
	          data[map[key]] = data[key];
	          delete data[key];
	        }
	      }
	    },
	    unbindEvents: function unbindEvents(obj) {
	      Object.keys(obj).forEach(function (key) {
	        $(obj[key]).unbind('click').unbind('blur').unbind('change').unbind('touchstart');
	      });
	    },
	    /**
	     * Function used to notify the native web application that the user has been sucessfully
	     * logged out of the costco website. This is needed as the app relies upon web view
	     */
	    notifyAppLogout: function notifyAppLogout() {
	      console.log('notifying app of logout');
	      try {
	        if (typeof Android != 'undefined') {
	          Android.logoutCostcoApp();
	        } else if (typeof webkit != 'undefined') {
	          webkit.messageHandlers.logoutAction.postMessage('success');
	        }
	      } catch (e) {
	        console.warn(e);
	      }
	    },
	    removeParam: function removeParam(key, sourceURL) {
	      var rtn = sourceURL.split('?')[0],
	          param = void 0,
	          params_arr = [],
	          queryString = sourceURL.indexOf('?') !== -1 ? sourceURL.split('?')[1] : '';
	      if (queryString !== '') {
	        params_arr = queryString.split('&');
	        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
	          param = params_arr[i].split('=')[0];
	          if (param === key) {
	            params_arr.splice(i, 1);
	          }
	        }
	        rtn = rtn + '?' + params_arr.join('&');
	      }
	      return rtn;
	    },
	    /**
	     * Politically incorrect method for turning an array of objects in the form
	     * of [{name:'hi',value:'robert'},{}..] into an equivalent object
	     * '{hi: 'robert', hey: 'robert'}'. $(form).serializeArray() will return
	     * the array of objects we're looking to convert
	     * @param  {Array} arr The array of objects.
	     * @return {Object}    The object equivalent of arr
	     */
	    objectifyArray: function objectifyArray(arr) {
	      var obj = {};
	      arr.forEach(function (arrObj) {
	        obj[arrObj.name] = arrObj.value;
	      });
	      return obj;
	    },
	
	    /**
	     * Utility function for adjusting heights of arbitrary numbner of divs, setting it to the 'tallest' value
	     * For this to happen two things must be the case:
	     * #1 All the DIVs that need to be aligned should have same unique css class applied (convention is costco-align-height-some-arbitrary-name)
	     * #2 call the function with string denoting applied class name, e.g. :
	     *		adjustDivHeights('.costco-align-height-some-arbitrary-name');
	     */
	
	    /* Compare heights of all divs with applied css class and increase the 'smaller' ones to the height of the tallest */
	    adjustDivHeights: function adjustDivHeights(alignClass, defaultHeight) {
	      $arrDivs = $(alignClass);
	      if ($arrDivs != null && $arrDivs.length > 0) {
	        max = 0;
	        $arrDivs.each(function () {
	          max = Math.max(max, parseInt($(this).height()));
	        });
	        if (max == 0 && typeof defaultHeight != 'undefined') {
	          max = defaultHeight;
	        }
	        $arrDivs.each(function () {
	          if ($(this).height() != max) {
	            $(this).height(max);
	          }
	        });
	      }
	    },
	    /**
	     * Capitalize a given string. Takes a string of form "Hi there Robert" and
	     * returns "Hi There Robert".
	     * @param  {String} str The string to capitalize
	     * @return {String}     The capitalized string.
	     */
	    capitalize: function capitalize(str) {
	      return str.split(' ').map(function (x) {
	        return x.charAt().toUpperCase().concat(x.substr(1));
	      }).join(' ');
	    },
	    isUsOrCaZipCode: function isUsOrCaZipCode() {
	      if ($('#B_countryId').length > 0 || $('#countryId').length > 0) {
	        return COSTCO.util.isUSOrCaAddressZip();
	      } else {
	        var storeId = wcs.storeId;
	        switch (storeId) {
	          case '10301':
	            return true;
	          case '10302':
	            return false;
	          case '11301':
	            return true;
	          default:
	            return false;
	        }
	      }
	    },
	    isUSOrCaAddressZip: function isUSOrCaAddressZip() {
	      var selCountry = $('#B_countryId').length > 0 ? $('#B_countryId').val() : $('#countryId').val();
	      selCountry = selCountry + wcs.storeId;
	      switch (selCountry) {
	        case 'US10301':
	          return true;
	        case 'CA10301':
	          return false;
	        case 'US10302':
	          return true;
	        case 'CA10302':
	          return false;
	        case 'US11301':
	          return true;
	        case 'CA11301':
	          return false;
	        case 'US11303':
	          return true;
	        case 'CA11303':
	          return false;
	        default:
	          return 'false';
	      }
	    },
	    getMaxHeight: function getMaxHeight(elems) {
	      return Math.max.apply(null, elems.map(function () {
	        return $(this).height();
	      }).get());
	    },
	    /**
	     * Checks if the current context is related to a grocery product. 
	     */
	    is2DayFlow: function is2DayFlow() {
	      var is2DayFlow = $('#groceryIdentifier').length > 0 && $('#groceryIdentifier').val() == 'true' ? true : false;
	      return is2DayFlow;
	    },
	    isLTLDeliveryServicesEnabled: function isLTLDeliveryServicesEnabled() {
	      var ltlDeliveryServicesEnableFlag = $('#deliveryServicesEnabled').length > 0 && $('#deliveryServicesEnabled').val() == 'true' ? true : false;
	      return ltlDeliveryServicesEnableFlag;
	    },
	
	    /**
	     * dob Validation- Month and date range validation and leap year validation.
	     * @param month 
	     * @param day
	     * @param year 
	     */
	    dateValidation: function dateValidation(month, day, year) {
	      var isDateValid = false;
	      var currentYear = new Date().getFullYear();
	      var beginningYear = currentYear - 100;
	      if (typeof year !== 'undefined' && year !== "" && (year < beginningYear || year > currentYear)) {
	        isDateValid = false;
	      } else if ((month === "04" || month === "06" || month === "09" || month === "11") && day <= 30 && day >= 1) {
	        isDateValid = true;
	      }
	      // check for february 29th
	      else if (month === "02") {
	          var isleap = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
	          if (day >= 1 && (day < 29 || day === "29" && isleap)) {
	            isDateValid = true;
	          }
	        }
	        // Check for month and day range
	        else if (month >= 1 && month <= 12 && day <= 31 && day >= 1) {
	            isDateValid = true;
	          } else {
	            if ((month === "" || typeof month === 'undefined') && (year === "" || typeof year === 'undefined') && (COSTCO.util.isCAStore() || day === "" || typeof day === 'undefined')) {
	              isDateValid = true;
	            }
	          }
	      return isDateValid;
	    },
	    /**
	     * Function used to check if Global error exists on page.
	     * @return {Boolean}
	     */
	    isGlobalErrorOnPage: function isGlobalErrorOnPage() {
	      var isGlobalError = false;
	      var errorClasses = COSTCO.util.globalErrorElementClasses;
	
	      jQuery.each(errorClasses, function (index, value) {
	        $('.' + value).each(function () {
	          if ($(this) !== 'undefined' && $(this).html() !== 'undefined' && $(this).html().trim().lenght > 0 || $(this).children() !== 'undefined' && $(this).children().html() !== undefined && $(this).children().html().trim().length > 0) {
	            var innerContent = $(this).children().html() !== undefined ? $(this).children().html() : $(this).html();
	            if ($(this).length > 0 && innerContent.length > 1) {
	              isGlobalError = true;
	            }
	          }
	        });
	      });
	
	      return isGlobalError;
	    },
	
	    /**
	     * Populates announcement screen reader div on page load
	     */
	    announceSRGlobalErrorMessage: function announceSRGlobalErrorMessage() {
	      if (COSTCO.util.isGlobalErrorOnPage()) {
	        var errorElement = COSTCO.util.getFirstGlobalErrorOnPage($('body'));
	        if (errorElement !== undefined && errorElement !== null && errorElement.text() !== "") {
	          var eMessage = errorElement.text();
	          COSTCO.util.announceSRErrorMessage(eMessage);
	        }
	      }
	    },
	
	    /**
	     * Function used to monitor screen reader announcement div element for changes
	     */
	    resetScreenReaderAnnouncement: function resetScreenReaderAnnouncement() {
	      var targetObject = document.querySelector("#screen-reader-announcement");
	      var observerObject = new MutationObserver(function (mutationRecordsList) {
	        mutationRecordsList.forEach(function (mutation) {
	          if ("attributes" === mutation.type || "childList" === mutation.type || "subtree" === mutation.type) {
	            setTimeout(function () {
	              $(targetObject).empty();
	            }, 2000);
	          }
	        });
	      });
	      if (targetObject !== undefined && targetObject !== null) {
	        observerObject.observe(targetObject, {
	          attributes: true,
	          attributeOldValue: true,
	          childList: true,
	          subtree: true,
	          characterData: true
	        });
	      }
	    },
	
	    /**
	     * Function used to inject error message in screen reader placeholder announcement div
	     * @param error message to be injected
	     */
	
	    announceSRErrorMessage: function announceSRErrorMessage(errorMessage) {
	      try {
	        errorMessage = errorMessage.trim();
	        var htmlContent = $.parseHTML(errorMessage);
	
	        if (htmlContent != null && !htmlContent.filter(function (e) {
	          return e instanceof HTMLElement;
	        }).length) {
	          errorMessage = '<p>' + errorMessage + '</p>';
	        }
	
	        var errorToAnnounce = $(errorMessage).html() !== undefined ? $(errorMessage).html() : errorMessage;
	        COSTCO.util.announceSRMessage(messages.ERROR + ' ' + errorToAnnounce);
	      } catch (error) {
	        console.log("Error occurred while announcing SR message! Error: " + error);
	      }
	    },
	
	    /**
	     * Moves the specified section to keep it in view when user scrolls.
	     * The section only moves if the screen is Tablet Landscape or wider.
	     * @param {string} elementId	ID of html element which is in view when user scrolls
	     * @param {string} topReferenceElementId	ID of element which is initially top-aligned with "sticky element"
	     * @param {string} bottomReferenceElementId ID of an element which presents a bottom limit to a moving "sticky element"
	     */
	    makeElementSticky: function makeElementSticky(elementId, topReferenceElementId, bottomReferenceElementId) {
	
	      var makeElementStickyFunction = function makeElementStickyFunction() {
	
	        var stickyElement = $('#' + elementId);
	        var topReferenceElement = $('#' + topReferenceElementId);
	        var bottomReferenceElement = $('#' + bottomReferenceElementId);
	
	        var bottomReference = bottomReferenceElement.offset().top;
	
	        if (stickyElement.length > 0 && topReferenceElement.length > 0) {
	          var topReference = topReferenceElement.offset().top + topReferenceElement.height();
	
	          var currentTranslateY = parseFloat(stickyElement.css('transform').split(',')[5]) || 0;
	          var translateY = -stickyElement[0].getBoundingClientRect().top + currentTranslateY;
	          var maxDistance = bottomReference - topReference - stickyElement.height();
	
	          if (translateY > maxDistance) {
	            translateY = maxDistance;
	          } else if (translateY < 0) {
	            translateY = 0;
	          }
	
	          stickyElement.css({
	            '-webkit-transform': 'translateY(' + translateY + 'px)',
	            '-moz-transform': 'translateY(' + translateY + 'px)',
	            '-ms-transform': 'translateY(' + translateY + 'px)',
	            '-o-transform': 'translateY(' + translateY + 'px)',
	            'transform': 'translateY(' + translateY + 'px)'
	          });
	        }
	      };
	      $(window).on('scroll wheel DOMMouseScroll mousewheel resize', function (evt) {
	        // remove all transforms if screen is not at least tablet landscape
	        if (COSTCO.util.isMaxScreen('TABLET-LANDSCAPE')) {
	          $('#' + elementId).css({
	            '-webkit-transform': '',
	            '-moz-transform': '',
	            '-ms-transform': '',
	            '-o-transform': '',
	            'transform': ''
	          });
	        } else {
	          makeElementStickyFunction();
	        }
	      });
	    },
	    preventBackButtonForSso: function preventBackButtonForSso(referer) {
	
	      try {
	        setTimeout(function () {
	          history.pushState(null, null, window.location);
	          window.addEventListener('popstate', function (event) {
	            if (referer != null && referer != undefined && referer != '' && (referer.indexOf('signin-qa.costco.com') > -1 || referer.indexOf('signin.costco.com') > -1)) {
	              alert(1);
	              history.pushState(null, null, window.location);
	            }
	          });
	        }, 5000);
	      } catch (e) {
	        console.error(e);
	      }
	    },
	    /**
	     * Method return date in yyyy-dd-mm-dd format
	     */
	    formatCalendarDate: function formatCalendarDate(date, separator) {
	      var d = new Date(date),
	          month = '' + (d.getMonth() + 1),
	          day = '' + d.getDate(),
	          year = d.getFullYear();
	
	      if (month.length < 2) month = '0' + month;
	      if (day.length < 2) day = '0' + day;
	      if (separator === '-') {
	        return [year, month, day].join('-');
	      } else {
	        return [month, day, year.toString().substr(-2)].join('/');
	      }
	    },
	    getAllCalendarAvailableDates: function getAllCalendarAvailableDates(dates) {
	      var availableDates = [];
	      dates.forEach(function (allowed_obj) {
	        if (allowed_obj.date_str) {
	          var date = new Date(allowed_obj.date_obj);
	          var timeZoneCorrectDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
	          // East of GMT
	          if (date.getTimezoneOffset() < 0) {
	            timeZoneCorrectDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
	          }
	          var formattedDate = timeZoneCorrectDate.toJSON().split("T")[0];
	          var availableFormatedDate = formattedDate.split('-')[1] + '/' + formattedDate.split('-')[2] + '/' + formattedDate.split('-')[0];
	          availableDates.push(availableFormatedDate);
	        }
	      });
	      return availableDates;
	    },
	
	    //Controls continue button on Membership Privileges and Conditions page
	    continueAfterTermsAccepted: function continueAfterTermsAccepted() {
	      if ($("#tnc-checkbox").attr("value") == "true") {
	        if ($('#upgradeOnly').val() == "true") {
	          window.location.href = '/QuickMembershipCheckoutCmd?isTandCAccepted=true&upgradeOnly=true';
	        } else {
	          window.location.href = '/QuickMembershipCheckoutCmd?isTandCAccepted=true';
	        }
	      } else {
	
	        $(".membership-tnc-checkbox-main").css({ 'border': '2px solid #D32029', 'margin': '0px' });
	        $("#terms-conditions-error").removeClass("hidden").css('margin-bottom', '20px');
	        $('#tnc-checkbox').focus();
	        $("#tnc-checkbox").attr("aria-describedby", "terms-conditions-error");
	      }
	    },
	
	    //Functionality for accept check box on Membership Privileges and Conditions page 
	    toggleTermsCheckbox: function toggleTermsCheckbox() {
	      if ($("#tnc-checkbox").attr("value") == "false") {
	        $("#tnc-checkbox").removeAttr("aria-describedby");
	        $("#tnc-checkbox").attr("value", "true");
	        $("#tnc-checkbox").attr("checked", "checked");
	        if (!$("#terms-conditions-error").hasClass("hidden")) {
	          $("#terms-conditions-error").addClass("hidden");
	          $(".membership-tnc-checkbox-main").css({ 'border': '1px solid #cccccc', 'margin': '5px 0px 20px 0px' });
	        }
	      } else {
	        $("#tnc-checkbox").attr("value", "false");
	        $("#tnc-checkbox").removeAttr("checked");
	      }
	    },
	
	    // function for sanitizing data to prevent XSS attacks
	    replaceSpecialChars: function replaceSpecialChars(obj) {
	      var result = new String(obj);
	
	      result = result.replace(/&/g, "&amp;");
	      result = result.replace(/</g, "&lt;");
	      result = result.replace(/>/g, "&gt;");
	      result = result.replace(/'/g, "&#39;");
	      result = result.replace(/"/g, "&quot;");
	      result = result.replace(/\//g, "&#47;");
	      result = result.replace(/\\/g, "&#92;");
	
	      return result;
	    },
	
	    scrubSpecialChars: function scrubSpecialChars(obj) {
	      var result = new String(obj);
	      result = result.replace(/[\%\$\`\\\*\<\>\(\)]*/g, '');
	      return result;
	    },
	
	    scrubSpecialCharsFromCompanyName: function scrubSpecialCharsFromCompanyName(obj) {
	      var result = new String(obj);
	      result = result.replace(/[\%\$\`\~\*\<\>]*/g, '');
	      return result;
	    }
	
	  };
	
	  return util;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title membership-helper.js: utility module
	 * @description Helper for membership specific modules
	 * @author kmedz
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(12), __webpack_require__(13), __webpack_require__(14), __webpack_require__(17), __webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = function (membershipData, addressForm, address, addressVerification, accountHelper) {
	  var MembershipHelper = {
	    /**
	     * Initializes the module with the specific membership type, which is
	     * defined in MembershipApplication_PreloadData.jspf
	     * @return {void} [description]
	     */
	    init: function init() {
	      this.membershipType = membershipType;
	
	      if (typeof totalFee !== 'undefined') {
	        this.totalFee = totalFee;
	      }
	      if (typeof membershipFee !== 'undefined') {
	        this.membershipFee = membershipFee;
	      }
	
	      $('#postalcode').val('');
	      $('#businessZipCode').val('');
	    },
	    isQuickMembership: false,
	    /**
	     * When we create an affiliate form we need to populate things like
	     * the date of birth selectors, do the fancy bing zip thing, etc.
	     * @param {jQuery.Element} form - The form containing the inputs we want
	     *                              to modify
	     * @return {void}
	     */
	    formWizBangs: function formWizBangs(form) {
	      // 5.2 Populate the appropriate inputs. Do the fancy masking stuff.
	      // Date of birth inputs
	      this.dobPopulate('#' + form.attr('id'), 100);
	
	      /** Membership DOB month field numeric restriction and appending 0 before 1-9 value */
	      form.find('[name=month],[name=household_month],[name=householdDobMonth],[name=dobmonth],[name=MembershipCrmCallerInfo_dobEditMonth]').on({
	        'focusout': function focusout(event) {
	          MembershipHelper.prependZero(event);
	        }
	      });
	
	      /** Membership DOB day field numeric restriction and appending 0 before 1-9 value */
	      form.find('[name=day],[name=household_day],[name=householdDobDay],[name=dobday],[name=MembershipCrmCallerInfo_dobEditDay]').on({
	        'focusout': function focusout(event) {
	          MembershipHelper.prependZero(event);
	        }
	      });
	
	      /** Membership DOB year field numeric restriction */
	      form.find('[name=year],[name=household_year],[name=householdDobYear],[name=dobyear],[name=MembershipCrmCallerInfo_dobEditYear]').on({});
	
	      var isDeriveCityStateEnabled = costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED && $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === "true";
	      // Populate state select box if the DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED feature is not enabled.
	      if (form.find('.state-select').length) {
	        var stateProvList = this.getStateProvJson();
	        var stateOptions = this.getStateOptions(stateProvList);
	        var $selects = isDeriveCityStateEnabled ? form.find('.state-select') : form.find('.state-select').append(stateOptions);
	        $selects.each(function (i, select) {
	          // If the select has a readonly attribute, disable all options
	          // except the currently selected option.
	          if ($(select).attr('readonly')) {
	            // will return "readonly"
	            $(select).find('option').attr('disabled', 'disabled');
	          }
	        });
	      }
	      // Bing City State autocomplete
	      // Personal information
	      form.find('[name=postalcode]').on('input', function (event) {
	        var value = $(event.currentTarget).val();
	
	        if (value != null && value != '' && value.trim().length > 4) {
	          var region = COSTCO.util.isUsOrCaZipCode();
	          if ($('#isGeocodeService').val() != "true" && value != null && value != "" && value.trim().length > 4) {
	            this.bingCityState(event.currentTarget, '[name=city]', '[name=state]');
	          }
	          if ($('#isGeocodeService').val() === "true" && value != null && value != "" && value.trim().length === value.length) {
	            if (region && COSTCO.util.POSTAL_CODE_REGEX_US.test(value.trim())) {
	              this.geocodeApiCityState(event.currentTarget, '[name=city]', '[name=state]');
	            }
	            if (!region) {
	              if (value.trim().length === 3 && /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1}/.test(value.trim()) || value.trim().length === 7 && COSTCO.util.POSTAL_CODE_REGEX_CA.test(value.trim())) this.geocodeApiCityState(event.currentTarget, '[name=city]', '[name=state]');
	            }
	          }
	        }
	      }.bind(this));
	      // Employee Add On (Acocunt Details)
	      form.find('[name=employeeAddon_zip]').on('input', function (event) {
	        var value = $(event.currentTarget).val();
	        var region = COSTCO.util.isUsOrCaZipCode();
	        if ($('#isGeocodeService').val() != "true" && value != null && value != "" && value.trim().length > 4) {
	          this.bingCityState(event.currentTarget, '[name=employeeAddon_city]', '[name=employeeAddon_state]');
	        }
	        if ($('#isGeocodeService').val() === "true" && value != null && value != "" && value.trim().length === value.length) {
	          if (region && COSTCO.util.POSTAL_CODE_REGEX_US.test(value.trim())) {
	            this.geocodeApiCityState(event.currentTarget, '[name=employeeAddon_city]', '[name=employeeAddon_state]');
	          }
	          if (!region) {
	            if (value.trim().length === 3 && /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1}/.test(value.trim()) || value.trim().length === 7 && COSTCO.util.POSTAL_CODE_REGEX_CA.test(value.trim())) this.geocodeApiCityState(event.currentTarget, '[name=employeeAddon_city]', '[name=employeeAddon_state]');
	          }
	        }
	      }.bind(this));
	      // Business information
	      form.find('[name=businessZipCode]').on('input', function (event) {
	        var value = $(event.currentTarget).val();
	        var region = COSTCO.util.isUsOrCaZipCode();
	        if ($('#isGeocodeService').val() != "true" && value != null && value != "" && value.trim().length > 4) {
	          this.bingCityState(event.currentTarget, '[name=businessCity]', '[name=businessState]');
	        }
	        if ($('#isGeocodeService').val() === "true" && value != null && value != "" && value.trim().length === value.length) {
	          if (region && COSTCO.util.POSTAL_CODE_REGEX_US.test(value.trim())) {
	            this.geocodeApiCityState(event.currentTarget, '[name=businessCity]', '[name=businessState]');
	          }
	          if (!region) {
	            if (value.trim().length === 3 && /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1}/.test(value.trim()) || value.trim().length === 7 && COSTCO.util.POSTAL_CODE_REGEX_CA.test(value.trim())) this.geocodeApiCityState(event.currentTarget, '[name=businessCity]', '[name=businessState]');
	          }
	        }
	      }.bind(this));
	      // Affiliate
	      form.find('[name=zip]').on('input', function (event) {
	        var value = $(event.currentTarget).val();
	        var region = COSTCO.util.isUsOrCaZipCode();
	        if ($('#isGeocodeService').val() != "true" && value != null && value != "" && value.trim().length > 4) {
	          this.bingCityState(event.currentTarget, '[name=city]', '[name=state]');
	        }
	        if ($('#isGeocodeService').val() === "true" && value != null && value != "" && value.trim().length === value.length) {
	          if (region && COSTCO.util.POSTAL_CODE_REGEX_US.test(value.trim())) {
	            this.geocodeApiCityState(event.currentTarget, '[name=city]', '[name=state]');
	          }
	          if (!region) {
	            if (value.trim().length === 3 && /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1}/.test(value.trim()) || value.trim().length === 7 && COSTCO.util.POSTAL_CODE_REGEX_CA.test(value.trim())) this.geocodeApiCityState(event.currentTarget, '[name=city]', '[name=state]');
	          }
	        }
	      }.bind(this));
	      // Account Details - Membership Information
	      form.find('[name=MembershipCrmCallerInfo_zipCode]').on('input', function (event) {
	        var value = $(event.currentTarget).val();
	        var region = COSTCO.util.isUsOrCaZipCode();
	        if ($('#isGeocodeService').val() != "true" && value != null && value != "" && value.trim().length > 4) {
	          this.bingCityState(event.currentTarget, '[name=MembershipCrmCallerInfo_city]', '[name=MembershipCrmCallerInfo_stateDropDown_state]');
	        }
	        if ($('#isGeocodeService').val() === "true" && value != null && value != "" && value.trim().length === value.length) {
	          if (region && COSTCO.util.POSTAL_CODE_REGEX_US.test(value.trim())) {
	            this.geocodeApiCityState(event.currentTarget, '[name=MembershipCrmCallerInfo_city]', '[name=MembershipCrmCallerInfo_stateDropDown_state]');
	          }
	          if (!region) {
	            if (value.trim().length === 3 && /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1}/.test(value.trim()) || value.trim().length === 7 && COSTCO.util.POSTAL_CODE_REGEX_CA.test(value.trim())) this.geocodeApiCityState(event.currentTarget, '[name=MembershipCrmCallerInfo_city]', '[name=MembershipCrmCallerInfo_stateDropDown_state]');
	          }
	        }
	      }.bind(this));
	
	      //Business Details - Business Information
	      form.find('[name=MembershipCrmBusiness_zipCode]').on('input', function (event) {
	        var value = $(event.currentTarget).val();
	        var region = COSTCO.util.isUsOrCaZipCode();
	        if ($('#isGeocodeService').val() != "true" && value != null && value != "" && value.trim().length > 4) {
	          this.bingCityState(event.currentTarget, '[name=MembershipCrmBusiness_city]', '[name=MembershipCrmBusiness_stateDropDown_state]');
	        }
	        if ($('#isGeocodeService').val() === "true" && value != null && value != "" && value.trim().length === value.length) {
	          if (region && COSTCO.util.POSTAL_CODE_REGEX_US.test(value.trim())) {
	            this.geocodeApiCityState(event.currentTarget, '[name=MembershipCrmBusiness_city]', '[name=MembershipCrmBusiness_stateDropDown_state]');
	          }
	          if (!region) {
	            if (value.trim().length === 3 && /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1}/.test(value.trim()) || value.trim().length === 7 && COSTCO.util.POSTAL_CODE_REGEX_CA.test(value.trim())) this.geocodeApiCityState(event.currentTarget, '[name=MembershipCrmBusiness_city]', '[name=MembershipCrmBusiness_stateDropDown_state]');
	          }
	        }
	      }.bind(this));
	
	      // Mask inputs
	      this.maskInput(form);
	    },
	    /**
	     * Determine if we're working with a business membership.
	     * @return {Boolean} Is business membership?
	     */
	    isBusinessMembership: function isBusinessMembership() {
	      return this.membershipType === this.membershipTypes.ADDMEMBER_BUSINESS || this.membershipType === this.membershipTypes.ADDMEMBER_BUSINESS_EXECUTIVE;
	    },
	    /**
	     * Sets some static keys representing membership types.
	     * @type {Object}
	     */
	    membershipTypes: {
	      ADDMEMBER_BUSINESS: 'ADDMEMBER_BUSINESS',
	      ADDMEMBER_BUSINESS_EXECUTIVE: 'ADDMEMBER_BUSINESS_EXECUTIVE',
	      ADDMEMBER_GOLDSTAR: 'ADDMEMBER_GOLDSTAR',
	      ADDMEMBER_GOLDSTAR_EXECUTIVE: 'ADDMEMBER_GOLDSTAR_EXECUTIVE'
	    },
	    /**
	     * The selectors for address fields in personal information
	     * @type {Object}
	     */
	    personalAddressSelectors: {
	      label: '[name=primaryAddress]',
	      line1: '[name=address1]',
	      line2: '[name=address2]',
	      city: '[name=city]',
	      state: '[name=state]',
	      country: '[name=country]',
	      zip: '[name=postalcode]'
	    },
	    /**
	     * The selectors for address fields in business information.
	     * @type {Object}
	     */
	    businessAddressSelectors: {
	      label: '[name=businessAddress]',
	      line1: '[name=businessAddressLine1]',
	      line2: '[name=businessAddressLine2]',
	      city: '[name=businessCity]',
	      state: '[name=businessState]',
	      country: '[name=businessCountry]',
	      zip: '[name=businessZipCode]'
	    },
	    /**
	     * The selectors for address fields in the affiliate modal.
	     * @type {Object}
	     */
	    affiliateAddressSelectors: {
	      label: '[name=affiliateAddress]',
	      line1: '[name=line1]',
	      line2: '[name=line2]',
	      city: '[name=city]',
	      state: '[name=state]',
	      country: '[name=country]',
	      zip: '[name=zip]',
	      fName: '[name=fname]',
	      lName: '[name=lname]'
	    },
	    /**
	     * The selectors for address fields in the Account Details
	     * Membership Information - Primary Information.
	     * @type {Object}
	     */
	    primaryInformationSelectors: {
	      label: '.membership-address-container .title label',
	      line1: '[name=MembershipCrmCallerInfo_addressLine1]',
	      line2: '[name=MembershipCrmCallerInfo_addressLine2]',
	      city: '[name=MembershipCrmCallerInfo_city]',
	      state: '[name=MembershipCrmCallerInfo_stateDropDown_state]',
	      country: '[name=MembershipCrmCallerInfo_stateDropDown_country]',
	      zip: '[name=MembershipCrmCallerInfo_zipCode]',
	      month: '[name=MembershipCrmCallerInfo_dobEditMonth]',
	      day: '[name=MembershipCrmCallerInfo_dobEditDay]',
	      year: '[name=MembershipCrmCallerInfo_dobEditYear]'
	    },
	    /**
	     * The selectors for address fields in the Business Details
	     * Membership Information - Primary Information.
	     * @type {Object}
	     */
	    businessInformationSelectors: {
	      label: '.business-address-container .title label',
	      line1: '[name=MembershipCrmBusiness_addressLine1]',
	      line2: '[name=MembershipCrmBusiness_addressLine2]',
	      city: '[name=MembershipCrmBusiness_city]',
	      state: '[name=MembershipCrmBusiness_stateDropDown_state]',
	      country: '[name=MembershipCrmBusiness_stateDropDown_country]',
	      zip: '[name=MembershipCrmBusiness_zipCode]'
	    },
	    /**
	     * The selectors for address fields in the employee add on section for when
	     * the user is a Employee Primary.
	     * @type {Object}
	     */
	    employeeAddOnSelectors: {
	      label: '.employee-addon > .title span',
	      line1: '[name=employeeAddon_addressLine1]',
	      line2: '[name=employeeAddon_addressLine2]',
	      city: '[name=employeeAddon_city]',
	      state: '[name=employeeAddon_state]',
	      country: '[name=employeeAddon_country]',
	      zip: '[name=employeeAddon_zip]',
	      fName: '[name=employeeAddon_first_name]',
	      lName: '[name=employeeAddon_last_name]'
	    },
	
	    /**
	     * Business specific rules object. Used for clientside validation
	     * @type {Object}
	     */
	    business: {
	      rules: {
	        first_name: { required: true, firstNameValidation: true },
	        lastName: { required: true, lastNameValidation: true },
	        month: {
	          required: $('#dobYearMonthMandatoryFlag').val() === 'true',
	          dob: true,
	          isMinor: true
	        },
	        day: {
	          required: false,
	          dob: true,
	          isMinor: true
	        },
	        year: {
	          required: $('#dobYearMonthMandatoryFlag').val() === 'true',
	          dob: true,
	          isMinor: true
	        },
	        address1: {
	          required: true,
	          valid_address: true,
	          maxlength: 60
	        },
	        address2: {
	          valid_address: true,
	          maxlength: 40
	        },
	        city: {
	          required: true,
	          valid_cityState: true
	        },
	        state: {
	          required: true,
	          valid_cityState: true,
	          notEqual: 'NO_STATE_TYPE_SELECTED',
	          hasvalidationerror: true
	        },
	        postalcode: {
	          required: true,
	          minlength: 5
	        },
	        email: {
	          required: true,
	          singleemail: true,
	          email: false
	        },
	        emailConfirm: {
	          required: true,
	          singleemail: true,
	          equalTo: '#email',
	          email: false
	        },
	        // country : 'required',
	        contactPhoneNumber: {
	          required: true,
	          phone: true
	        },
	        mobilePhoneNumber: {
	          required: false,
	          phone: true,
	          promo: true
	        },
	        // awarenessCode: {required: false, validCode : true},
	        shippingNickname: {
	          copyAddress: true
	        },
	        billingNickname: {
	          copyAddress: true
	        },
	        businessNameEdit: 'required',
	        businessAddressLine1: {
	          required: true,
	          valid_address: true,
	          maxlength: 30
	        },
	        businessAddressLine2: {
	          valid_address: true,
	          maxlength: 30
	        },
	        businessCity: {
	          required: true,
	          valid_cityState: true
	        },
	        businessState: {
	          required: true,
	          valid_cityState: true,
	          notEqual: 'NO_STATE_TYPE_SELECTED',
	          hasvalidationerror: true
	        },
	        // businessCountry : 'required',
	        businessZipCode: {
	          required: true,
	          minlength: 5
	        },
	        businessPhone: {
	          required: true,
	          phone: true
	        },
	        businessEmail: {
	          required: true,
	          singleemail: true,
	          email: false
	        },
	        businessEmailConfirm: {
	          required: true,
	          singleemail: true,
	          email: false,
	          equalTo: '#businessEmail'
	        }
	      },
	
	      messages: function (_messages) {
	        function messages() {
	          return _messages.apply(this, arguments);
	        }
	
	        messages.toString = function () {
	          return _messages.toString();
	        };
	
	        return messages;
	      }(function () {
	        return {
	          month: { required: messages.ERR_INVALID_MONTH_REQUIRED },
	          year: { required: messages.ERR_INVALID_YEAR_REQUIRED },
	          businessNameEdit: messages.ERR_INVALID_BUSINESS_NAME,
	          businessAddressLine1: {
	            required: messages.ERR_INVALID_STREET_REQUIRED,
	            valid_address: messages.ERR_INVALID_ADDRESS,
	            maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH
	          },
	          businessAddressLine2: {
	            valid_address: messages.ERR_INVALID_ADDRESS,
	            maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH
	          },
	          businessCity: { required: messages.ERR_INVALID_CITY_REQUIRED, valid_cityState: messages.ERR_INVALID_CITY_NAME },
	          businessState: { required: wcs.storeId == '10301' ? messages.ERR_INVALID_STATE_NAME : messages.ERR_INVALID_PROVINCE_REQUIRED, valid_cityState: wcs.storeId == '10301' ? messages.ERR_INVALID_STATE_NAME : messages.ERR_INVALID_PROVINCE_REQUIRED },
	          // businessCountry : messages.ERR_INVALID_COUNTRY,
	          businessZipCode: {
	            required: messages.ERR_ENTER_ZIPCODE_NEW,
	            minlength: messages.ERR_VALID_ZIPCODE
	          },
	          businessPhone: messages.ERR_INVALID_PHONE_10_DIGIT,
	          businessEmail: messages.ERR_INVALID_EMAIL_ADDRESS,
	          businessEmailConfirm: {
	            required: messages.ERR_REQUIRED_CONFIRM_EMAIL,
	            equalTo: messages.ERR_CONFIRM_EMAIL_MISMATCH
	          },
	          first_name: { required: messages.ERR_INVALID_FNAME_REQUIRED, firstNameValidation: messages.ERR_INVALID_FNAME },
	          lastName: { required: messages.ERR_INVALID_LNAME_REQUIRED, lastNameValidation: messages.ERR_INVALID_LNAME },
	          address1: {
	            required: messages.ERR_INVALID_STREET_REQUIRED,
	            valid_address: messages.ERR_INVALID_ADDRESS,
	            maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH_FRIENDLY_MESSAGE
	          },
	          address2: {
	            valid_address: messages.ERR_INVALID_ADDRESS,
	            maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH
	          },
	          city: { required: messages.ERR_INVALID_CITY_REQUIRED, valid_cityState: messages.ERR_INVALID_CITY_NAME },
	          state: { required: wcs.storeId == '10301' ? messages.ERR_INVALID_STATE_NAME : messages.ERR_INVALID_PROVINCE_REQUIRED, valid_cityState: wcs.storeId == '10301' ? messages.ERR_INVALID_STATE_NAME : messages.ERR_INVALID_PROVINCE_REQUIRED },
	          postalcode: {
	            required: messages.ERR_ENTER_ZIPCODE_NEW,
	            minlength: messages.ERR_VALID_ZIPCODE
	          },
	          email: messages.ERR_INVALID_EMAIL_ADDRESS,
	          emailConfirm: {
	            required: messages.ERR_REQUIRED_CONFIRM_EMAIL,
	            equalTo: messages.ERR_CONFIRM_EMAIL_MISMATCH
	          },
	          // country : messages.ERR_INVALID_COUNTRY,
	          contactPhoneNumber: messages.ERR_INVALID_PHONE_10_DIGIT,
	          mobilePhoneNumber: messages.ERR_INVALID_PHONE_10_DIGIT,
	          // awarenessCode : messages.ERR_AWARENESS_CODE,
	          shippingNickname: messages.ERR_ENTER_UNIQUE_NICKNAME,
	          billingNickname: messages.ERR_INVALID_SHIPPINGNICKNAME
	        };
	      })
	    },
	    /**
	     * Goldstar specific rules object. Used for clientside validation
	     * @type {Object}
	     */
	    goldstar: {
	      rules: {
	        // primary
	        first_name: { required: true, firstNameValidation: true },
	        // alternate name for affiliate
	        fname: { required: true, firstNameValidation: true },
	        // alternate name for employee addon
	        employeeAddon_first_name: { required: true, firstNameValidation: true },
	        lastName: { required: true, lastNameValidation: true },
	        // alternate name for affiliate
	        lname: { required: true, lastNameValidation: true },
	        // alternamte name for employee addon
	        employeeAddon_last_name: { required: true, lastNameValidation: true },
	        month: {
	          required: $('#dobYearMonthMandatoryFlag').val() === 'true',
	          dob: true,
	          isMinor: true
	        },
	        MembershipCrmCallerInfo_dobEditMonth: {
	          required: false,
	          dob: true
	        },
	        MembershipCrmCallerInfo_dobEditDay: {
	          required: false,
	          dob: true
	        },
	        MembershipCrmCallerInfo_dobEditYear: {
	          required: false,
	          dob: true
	        },
	
	        // alternate name for affiliate
	        dobmonth: {
	          required: $('#dobYearMonthMandatoryFlag').val() === 'true',
	          dob: true,
	          isMinor: true
	        },
	        day: {
	          required: false,
	          dob: true,
	          isMinor: true
	        },
	        // alternate name for affiliate
	        dobday: {
	          required: false,
	          dob: true,
	          isMinor: true
	        },
	        year: {
	          required: $('#dobYearMonthMandatoryFlag').val() === 'true',
	          dob: true,
	          isMinor: true
	        },
	        // alternate name for affiliate
	        dobyear: {
	          required: $('#dobYearMonthMandatoryFlag').val() === 'true',
	          dob: true,
	          isMinor: true
	        },
	        address1: {
	          required: true,
	          valid_address: true,
	          maxlength: 60
	        },
	        address2: {
	          maxlength: 40,
	          valid_address: true
	        },
	        // alternate names for employee addon
	        employeeAddon_addressLine1: {
	          required: true,
	          valid_address: true
	        },
	        employeeAddon_addressLine2: {
	          valid_address: true
	        },
	        employeeAddon_city: {
	          required: true,
	          valid_cityState: true
	        },
	        employeeAddon_state: {
	          required: true,
	          valid_cityState: true,
	          notEqual: 'NO_STATE_TYPE_SELECTED',
	          hasvalidationerror: true
	        },
	        employeeAddon_zip: {
	          required: true,
	          minlength: 5
	        },
	        // alternate name for affiliate
	        line1: {
	          required: true,
	          valid_address: true
	        },
	        line2: {
	          valid_address: true
	        },
	        city: {
	          required: true,
	          valid_cityState: true
	        },
	        state: {
	          required: true,
	          valid_cityState: true,
	          notEqual: 'NO_STATE_TYPE_SELECTED',
	          hasvalidationerror: true
	        },
	        postalcode: {
	          required: true,
	          minlength: 5
	        },
	        // alternate name for affiliate
	        zip: {
	          required: true,
	          minlength: 5
	        },
	        email: {
	          required: true,
	          singleemail: true,
	          email: false,
	          emailEmpty: true
	        },
	        emailConfirm: {
	          required: true,
	          singleemail: true,
	          equalTo: '#email',
	          email: false,
	          emailEmpty: true
	        },
	        // alternate name for employee add on
	        employeeAddon_email: {
	          required: false,
	          singleemail: true
	        },
	        employeeAddOn_email_confirm: {
	          required: false,
	          singleemail: true,
	          equalTo: '#employeeAddon_email'
	        },
	        // country : 'required',
	        contactPhoneNumber: {
	          required: true,
	          phone: true
	        },
	        // alternate name for affiliate
	        cphone: {
	          required: false,
	          phone: true
	        },
	        mobilePhoneNumber: {
	          required: false,
	          phone: true,
	          promo: true
	        },
	        // alternate name for affiliate
	        mphone: {
	          required: false,
	          phone: true,
	          promo: true
	        },
	        // alternate name for employee add on
	        employeeAddon_contact_phone: {
	          required: true,
	          phone: true
	        },
	        employeeAddon_mobile: {
	          required: false,
	          phone: true,
	          promo: true
	        }
	      },
	      messages: function (_messages2) {
	        function messages() {
	          return _messages2.apply(this, arguments);
	        }
	
	        messages.toString = function () {
	          return _messages2.toString();
	        };
	
	        return messages;
	      }(function () {
	        return {
	          first_name: { required: messages.ERR_INVALID_FNAME_REQUIRED, firstNameValidation: messages.ERR_INVALID_FNAME },
	          month: { required: messages.ERR_INVALID_MONTH_REQUIRED },
	          year: { required: messages.ERR_INVALID_YEAR_REQUIRED },
	          dobmonth: { required: messages.ERR_INVALID_MONTH_REQUIRED },
	          householdDobYear: { required: messages.ERR_INVALID_YEAR_REQUIRED },
	          householdDobMonth: { required: messages.ERR_INVALID_MONTH_REQUIRED },
	          dobyear: { required: messages.ERR_INVALID_YEAR_REQUIRED },
	          // alternate for affiliate
	          fname: { required: messages.ERR_INVALID_FNAME_REQUIRED, firstNameValidation: messages.ERR_INVALID_FNAME },
	          // For Account Details
	          householdFname: { required: messages.ERR_INVALID_FNAME_REQUIRED, firstNameValidation: messages.ERR_INVALID_FNAME },
	          // For Employee Add On
	          employeeAddon_first_name: { required: messages.ERR_INVALID_FNAME_REQUIRED, firstNameValidation: messages.ERR_INVALID_FNAME },
	          lastName: { required: messages.ERR_INVALID_LNAME_REQUIRED, lastNameValidation: messages.ERR_INVALID_LNAME },
	          // alternate for affiliate
	          lname: { required: messages.ERR_INVALID_LNAME_REQUIRED, lastNameValidation: messages.ERR_INVALID_LNAME },
	          // For Account Details
	          householdLname: { required: messages.ERR_INVALID_LNAME_REQUIRED, lastNameValidation: messages.ERR_INVALID_LNAME },
	          // For Employee Add On
	          employeeAddon_last_name: { required: messages.ERR_INVALID_LNAME_REQUIRED, lastNameValidation: messages.ERR_INVALID_LNAME },
	          address1: {
	            required: messages.ERR_INVALID_STREET_REQUIRED,
	            valid_address: messages.ERR_INVALID_ADDRESS,
	            maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH_FRIENDLY_MESSAGE
	          },
	          address2: {
	            valid_address: messages.ERR_INVALID_ADDRESS,
	            maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH
	          },
	          // alternate for employee add on
	          employeeAddon_addressLine1: {
	            required: messages.ERR_INVALID_STREET_REQUIRED,
	            valid_address: messages.ERR_INVALID_ADDRESS
	          },
	          employeeAddon_addressLine2: {
	            valid_address: messages.ERR_INVALID_ADDRESS
	          },
	          employeeAddon_city: {
	            required: messages.ERR_INVALID_CITY_REQUIRED,
	            valid_cityState: messages.ERR_INVALID_CITY_NAME
	          },
	          employeeAddon_state: {
	            required: messages.ERR_INVALID_STATE_NAME,
	            valid_cityState: messages.ERR_INVALID_STATE_NAME
	          },
	          employeeAddon_zip: {
	            required: messages.ERR_ENTER_ZIPCODE_NEW,
	            minlength: messages.ERR_VALID_ZIPCODE
	          },
	          // alternate for affiliate
	          line1: {
	            required: messages.ERR_INVALID_STREET_REQUIRED,
	            valid_address: messages.ERR_INVALID_ADDRESS
	          },
	          line2: {
	            valid_address: messages.ERR_INVALID_ADDRESS
	          },
	          city: {
	            required: messages.ERR_INVALID_CITY_REQUIRED,
	            valid_cityState: messages.ERR_INVALID_CITY_NAME
	          },
	          state: {
	            required: wcs.storeId == '10301' ? messages.ERR_INVALID_STATE_NAME : messages.ERR_INVALID_PROVINCE_REQUIRED,
	            valid_cityState: wcs.storeId == '10301' ? messages.ERR_INVALID_STATE_NAME : messages.ERR_INVALID_PROVINCE_REQUIRED
	          },
	          postalcode: {
	            required: messages.ERR_ENTER_ZIPCODE_NEW,
	            minlength: messages.ERR_VALID_ZIPCODE
	          },
	          // alternate for affiliate
	          zip: {
	            required: messages.ERR_ENTER_ZIPCODE_NEW,
	            minlength: messages.ERR_VALID_ZIPCODE
	          },
	          email: messages.ERR_INVALID_EMAIL,
	          emailConfirm: {
	            required: messages.ERR_REQUIRED_CONFIRM_EMAIL,
	            equalTo: messages.ERR_CONFIRM_EMAIL_MISMATCH
	          },
	          equalTo: messages.ERR_CONFIRM_EMAIL_MISMATCH,
	          // alternate for employee add on
	          employeeAddon_email: messages.ERR_INVALID_EMAIL,
	          // country : messages.ERR_INVALID_COUNTRY,
	          contactPhoneNumber: messages.ERR_INVALID_PHONE_10_DIGIT,
	          // alternate for affiliate
	          cphone: messages.ERR_INVALID_PHONE_10_DIGIT,
	          mobilePhoneNumber: messages.ERR_INVALID_PHONE_10_DIGIT,
	          // alternate for affiliate
	          mphone: messages.ERR_INVALID_PHONE_10_DIGIT,
	          // alternate for employee add on
	          employeeAddon_contact_phone: messages.ERR_INVALID_PHONE_10_DIGIT,
	          employeeAddon_mobile: messages.ERR_INVALID_PHONE_10_DIGIT
	        };
	      })
	    },
	    /**
	     * Extend a 'business' or 'goldstar' rules object with household
	     * rules.
	     * @param  {Object} rules The rules object to extend
	     * @param  {boolean} required OPTIONAL make something required
	     * @return {void}
	     */
	    addHouseholdRules: function addHouseholdRules(rules, required, validator_messages) {
	      required = required || false;
	      $.extend(rules, {
	        household_first_name: {
	          required: false,
	          firstNameValidation: true,
	          household_gold: true
	        },
	        // Affiliate alternate
	        householdFname: {
	          required: required || false,
	          firstNameValidation: true,
	          household_gold: required === true ? false : true
	        },
	        household_lastName: {
	          required: false,
	          lastNameValidation: true,
	          household_gold: true
	        },
	        // Affiliate alternate
	        householdLname: {
	          required: required || false,
	          lastNameValidation: true,
	          household_gold: required === true ? false : true
	        },
	        household_month: {
	          required: $('#dobYearMonthMandatoryFlag').val() === 'true',
	          dob: true,
	          isMinor: true
	        },
	        // Affiliate alternate
	        householdDobMonth: {
	          required: $('#dobYearMonthMandatoryFlag').val() === 'true',
	          dob: true,
	          isMinor: true
	        },
	        household_day: {
	          required: false,
	          dob: true,
	          isMinor: true
	        },
	        // Affiliate alternate
	        householdDobDay: {
	          required: false,
	          dob: true,
	          isMinor: true
	        },
	        household_year: {
	          required: $('#dobYearMonthMandatoryFlag').val() === 'true',
	          dob: true,
	          isMinor: true
	        },
	        // Affiliate alternate
	        householdDobYear: {
	          required: $('#dobYearMonthMandatoryFlag').val() === 'true',
	          dob: true,
	          isMinor: true
	        },
	        household_email: {
	          required: false,
	          singleemail: true,
	          household_gold: false,
	          email: false,
	          emailEmpty: true
	        },
	        household_emailConfirm: {
	          required: false,
	          singleemail: true,
	          equalTo: '#household_email',
	          email: false,
	          emailEmpty: true
	        },
	        // Affiliate alternate
	        householdEmail: {
	          required: false,
	          singleemail: true,
	          household_gold: false,
	          email: false,
	          emailEmpty: true
	        },
	        // Affiliate alternate
	        householdEmailConfirm: {
	          required: false,
	          singleemail: true,
	          equalTo: '#household_email_affiliate',
	          email: false,
	          emailEmpty: true
	        },
	        // Alternate for Account Details
	        householdEmailConfirmdetails: {
	          required: false,
	          singleemail: true,
	          equalTo: '#email-details',
	          email: false,
	          emailEmpty: true
	        },
	        household_primaryPhoneNumber: {
	          required: false,
	          phone: true,
	          household_gold: false
	        },
	        // Affiliate alternate
	        householdPrimaryPhoneNumber: {
	          required: false,
	          phone: true,
	          household_gold: false
	        }
	      });
	      $.extend(validator_messages, {
	        household_month: { required: messages.ERR_INVALID_MONTH_REQUIRED },
	        household_year: { required: messages.ERR_INVALID_YEAR_REQUIRED }
	      });
	    },
	    /**
	     * Validation methods for membership specific forms.
	     * @param  {jQuery} form The form we're validating
	     * @return {void}
	     */
	    addValidationMethods: function addValidationMethods(form) {
	      var memberValidationRegex = new RegExp($('#memberValidationRegex').val());
	      var addressValidationRegex = new RegExp($('#addressValidationRegex').val());
	      var cityStateValidationRegex = new RegExp($('#cityStateValidationRegex').val());
	      $.validator.addMethod('notEqual', function (value, element, param) {
	        return this.optional(element) || value != param;
	      }, messages.ERR_INVALID_STATE_NAME);
	      $.validator.addMethod("hasvalidationerror", function (value, element) {
	        return element.getAttribute('hasvalidationerror') == undefined || element.getAttribute('hasvalidationerror') == null || element.getAttribute('hasvalidationerror') == "false";
	      }, messages.ERR_INVALID_STATE);
	      // custom validate mobile phone number when promo notification via text message is selected.
	      $.validator.addMethod('promo', function (value, element, param) {
	        var valid = true;
	        var phone = $.trim(form.find('input[name=mobilePhoneNumber]').val());
	        var promo = $('input[name=receivePromosAndMarketingTxtMsg]').val();
	        if (promo == 'on' && phone.length == 0) {
	          valid = false;
	        }
	        return valid;
	      }, '');
	      // custom validation for date of birth
	      $.validator.addMethod('dob', function (value, element, param) {
	        var valid = true;
	        var month = void 0;
	        var day = void 0;
	        var year = void 0;
	        var monthVal = void 0;
	        var dayVal = void 0;
	        var yearVal = void 0;
	        var errField = void 0;
	        var message = void 0;
	        var dateCondition = false;
	        var idate = void 0;
	        var isFuture = false;
	        var isFutureDate = function isFutureDate(idate) {
	          var today = new Date().getTime();
	          idate = idate.split('/');
	          idate = new Date(idate[2], idate[0] - 1, idate[1]).getTime();
	          return today - idate < 0 ? true : false;
	        };
	        if (element.name == 'month' || element.name == 'day' || element.name == 'year') {
	          month = form.find('[name=month]');
	          day = form.find('[name=day]');
	          year = form.find('[name=year]');
	          errField = '#dob_error';
	        } else if (element.name == 'MembershipCrmCallerInfo_dobEditMonth' || element.name == 'MembershipCrmCallerInfo_dobEditDay' || element.name == 'MembershipCrmCallerInfo_dobEditYear') {
	          month = form.find('[name=MembershipCrmCallerInfo_dobEditMonth]');
	          day = form.find('[name=MembershipCrmCallerInfo_dobEditDay]');
	          year = form.find('[name=MembershipCrmCallerInfo_dobEditYear]');
	          errField = '#MembershipCrmCallerInfo-dob-error';
	        } else if (element.name == 'household_month' || element.name == 'household_day' || element.name == 'household_year') {
	          month = form.find('[name=household_month]');
	          day = form.find('[name=household_day]');
	          year = form.find('[name=household_year]');
	          errField = '#household_dob_error';
	        } else if (element.name == 'dobmonth' || element.name == 'dobday' || element.name == 'dobyear') {
	          month = form.find('[name=dobmonth]');
	          day = form.find('[name=dobday]');
	          year = form.find('[name=dobyear]');
	          errField = '#dob_error_affiliate';
	        } else if (element.name == 'householdDobMonth' || element.name == 'householdDobDay' || element.name == 'householdDobYear') {
	          month = form.find('[name=householdDobMonth]');
	          day = form.find('[name=householdDobDay]');
	          year = form.find('[name=householdDobYear]');
	          errField = element.form.id == 'household-form-details' ? '#household_dob_error_details' : '#household_dob_error_affiliate';
	        }
	
	        var dayIsOptional = $('#dobYearMonthMandatoryFlag').val() === 'true';
	        var isDayElement = element.name === 'day' || element.name == 'household_day' || element.name == 'dobday' || element.name == 'householdDobDay';
	
	        monthVal = month.val();
	        dayVal = day.val();
	        if (dayIsOptional && dayVal == "") {
	          dayVal = "1";
	        }
	        yearVal = year.val();
	
	        if (!dayIsOptional) {
	          if (wcs.storeId == '10301') {
	            dateCondition = monthVal == 'Month' && dayVal == 'Day' && yearVal == 'Year' || monthVal != 'Month' && dayVal != 'Day' && yearVal != 'Year';
	            if (monthVal.length > 0 || dayVal.length > 0 || yearVal.length > 0) {
	              if (monthVal.length == 0 || dayVal.length == 0 || yearVal.length == 0) {
	                dateCondition = false;
	              }
	            }
	          } else if (wcs.storeId == '10302') {
	            dayVal = 1;
	            dateCondition = monthVal == 'Month' && yearVal == 'Year' || monthVal != 'Month' && yearVal != 'Year';
	            if (monthVal.length > 0 || yearVal.length > 0) {
	              if (monthVal.length == 0 || yearVal.length == 0) {
	                dateCondition = false;
	              }
	            }
	          }
	        } else {
	          dateCondition = true;
	        }
	        if (monthVal != 'Month' && dayVal != 'Day' && yearVal != 'Year') {
	          idate = monthVal + '/' + dayVal + '/' + yearVal;
	          if (isFutureDate(idate)) isFuture = true;
	        }
	        if (dateCondition && !isFuture && COSTCO.util.dateValidation(monthVal, dayVal, yearVal)) {
	          $(errField).hide();
	          month.removeClass('error');
	          day.removeClass('error');
	          year.removeClass('error');
	          valid = true;
	        } else {
	          if (dayIsOptional && day.val() === "" && month.val() === "" && year.val() === "" && isDayElement) {
	            valid = true;
	          } else {
	            month.addClass('error');
	            if (!dayIsOptional) {
	              day.addClass('error');
	            } else {
	              if (day.val() !== "") {
	                day.addClass('error');
	              }
	            }
	            year.addClass('error');
	            $(errField).show();
	            $(errField)[0].innerHTML = messages.ERR_ENTER_DOB;
	            valid = false;
	          }
	        }
	        return valid;
	      }, '');
	      // custom validation for checking if the member is over 18
	      $.validator.addMethod('isMinor', function (value, element, param) {
	        var errorField = void 0;
	        var year = void 0;
	        var month = void 0;
	        var day = void 0;
	        var now = new Date();
	        var graymsg = false;
	        var houseHoldForm = false;
	        var employeeAddOn = false;
	
	        if (element.name == 'month' || element.name == 'day' || element.name == 'year') {
	          month = form.find('[name=month]');
	          day = form.find('[name=day]');
	          year = form.find('[name=year]');
	          errorField = '.member-dob-disclaimer';
	          graymsg = true;
	        } else if (element.name == 'household_month' || element.name == 'household_day' || element.name == 'household_year') {
	          month = form.find('[name=household_month]');
	          day = form.find('[name=household_day]');
	          year = form.find('[name=household_year]');
	          errorField = '#is_minor_household';
	          houseHoldForm = true;
	        } else if (element.name == 'householdDobMonth' || element.name == 'householdDobDay' || element.name == 'householdDobYear') {
	          month = form.find('[name=householdDobMonth]');
	          day = form.find('[name=householdDobDay]');
	          year = form.find('[name=householdDobYear]');
	          errorField = element.form.id == 'household-form-details' ? '#is_minor_household' : '.household-dob-disclaimer';
	          graymsg = element.form.id == 'household-form-details' ? false : true;
	          houseHoldForm = true;
	        } else if (element.name == 'dobmonth' || element.name == 'dobday' || element.name == 'dobyear') {
	          month = form.find('[name=dobmonth]');
	          day = form.find('[name=dobday]');
	          year = form.find('[name=dobyear]');
	          errorField = '.member-dob-disclaimer';
	          graymsg = true;
	        }
	
	        var ageYears = now.getFullYear() - year.val();
	        var ageMonths = now.getMonth() - month.val();
	        var ageDays = now.getDate() - day.val();
	        var isValidAge = true;
	        var primaryMinAge = $('#membership_primary_min_age').val();
	        var addOnMinAge = $('#employee-addOn').val();
	
	        var isAgeAllowed = function isAgeAllowed(minAge) {
	          var dayIsOptional = $('#dobYearMonthMandatoryFlag').val() === 'true';
	          var d = day.val();
	          if (dayIsOptional && d == "") {
	            d = "1";
	          }
	          var idate = new Date(year.val(), month.val() - 1, d);
	          var today = new Date();
	          var birthDate = new Date(idate);
	          var age = today.getFullYear() - birthDate.getFullYear();
	          var m = today.getMonth() - birthDate.getMonth();
	          if (m < 0 || m === 0 && today.getDate() < birthDate.getDate()) {
	            age--;
	          }
	          return age >= minAge ? true : false;
	        };
	
	        //household member age dropped from 18 to 16
	        if (!month.val() == "" && !year.val() == "") {
	          if (houseHoldForm) {
	            if (!isAgeAllowed(16)) {
	              isValidAge = false;
	            }
	          } else if (addOnMinAge) {
	            if (!isAgeAllowed(addOnMinAge)) {
	              isValidAge = false;
	            }
	          } else {
	            if (!isAgeAllowed(primaryMinAge)) {
	              isValidAge = false;
	            }
	          }
	        }
	
	        if (!isValidAge) {
	          month.addClass('error');
	          day.addClass('error');
	          year.addClass('error');
	          if (graymsg) {
	            $(errorField).css('color', '#d32029');
	          } else {
	            $(errorField).show();
	            if (houseHoldForm) {
	              $(errorField).innerHTML = messages.ERR_HOUSE_DOB_MINOR;
	            } else {
	              $(errorField).innerHTML = messages.ERR_DOB_MINOR.replace('{0}', primaryMinAge);
	            }
	          }
	          return false;
	        } else {
	          if (graymsg) {
	            $(errorField).css('color', '#707070');
	          } else {
	            month.removeClass('error');
	            day.removeClass('error');
	            year.removeClass('error');
	            $(errorField).hide();
	          }
	          return true;
	        }
	      }, '');
	      $.validator.addMethod('valid_address', function (value, element) {
	        return value !== null && value !== '' ? addressValidationRegex.test(value.trim()) : true;
	      }, '');
	      $.validator.addMethod('valid_cityState', function (value, element) {
	        return value !== null && value !== '' ? cityStateValidationRegex.test(value.trim()) : true;
	      }, '');
	      // custom validation for household_goldstar
	      $.validator.addMethod('household_gold', function (value, element, param) {
	        var fName = void 0;
	        var lName = void 0;
	        var email = void 0;
	        var emailConf = void 0;
	        var phone = void 0;
	        var errorFirst = void 0;
	        var errorLast = void 0;
	        var valid = true;
	        if (element.name == 'household_first_name' || element.name == 'household_lastName' || element.name == 'household_email' || element.name == 'household_primaryPhoneNumber' || element.name == 'household_emailConfirm') {
	          fName = form.find('input[name=household_first_name]').val();
	          lName = form.find('input[name=household_lastName]').val();
	          email = form.find('input[name=household_email]').val();
	          emailConf = form.find('input[name=household_emailConfirm]').val();
	          phone = form.find('input[name=household_primaryPhoneNumber]').val();
	          errorFirst = '#household_first_name_error';
	          errorLast = '#household_last_name_error';
	        } else if (element.name == 'householdFname' || element.name == 'householdLname' || element.name == 'householdEmail' || element.name == 'householdPrimaryPhoneNumber' || element.name == 'householdEmailConfirm') {
	          fName = form.find('input[name=householdFname]').val();
	          lName = form.find('input[name=householdLname]').val();
	          email = form.find('input[name=householdEmail]').val();
	          emailConf = form.find('input[name=householdEmailConfirm]').val();
	          phone = form.find('input[name=householdPrimaryPhoneNumber]').val();
	          errorFirst = '#household_first_name_error_affiliate';
	          errorLast = '#household_last_name_error_affiliate';
	        }
	        $(errorFirst).hide();
	        $(errorLast).hide();
	        if (fName.length == 0 && lName.length == 0 && email.length == 0 && emailConf.length == 0 && phone.length == 0) {
	          $(errorFirst).hide();
	          $(errorLast).hide();
	          valid = true;
	        } else if (fName.length == 0 && lName.length == 0 && (email.length > 0 || phone.length > 0 || emailConf.length > 0)) {
	          $(errorFirst).innerHTML = messages.ERR_INVALID_FNAME_REQUIRED;
	          $(errorLast).innerHTML = messages.ERR_INVALID_LNAME_REQUIRED;
	          $(errorFirst).show();
	          $(errorLast).show();
	          valid = false;
	        } else if (!(fName.length > 0 && lName.length > 0)) {
	          if (fName.length > 0 && lName.length == 0) {
	            $(errorFirst).hide();
	            $(errorLast).innerHTML = messages.ERR_INVALID_LNAME_REQUIRED;
	            $(errorLast).show();
	            if (element.name == 'household_first_name' || element.name == 'householdFname') {
	              valid = true;
	            } else if (element.name == 'household_lastName' || element.name == 'householdLname') {
	              valid = false;
	            }
	          } else if (fName.length == 0 && lName.length > 0) {
	            $(errorLast).hide();
	            $(errorFirst).innerHTML = messages.ERR_INVALID_FNAME_REQUIRED;
	            $(errorFirst).show();
	            if (element.name == 'household_first_name' || element.name == 'householdFname') {
	              valid = false;
	            } else if (element.name == 'household_lastName' || element.name == 'householdLname') {
	              valid = true;
	            }
	          }
	        }
	        return valid;
	      }, '');
	      $.validator.addMethod('copyAddress', function (value, element, param) {
	        var valid = true;
	        var checked = $('input[name=copyMembershipAddressToShippingBilling]').attr('checked');
	        if (checked == 'checked' && ($(element).val() == '' || $('input[name=shippingNickname]').val() == $('input[name=billingNickname]').val())) {
	          valid = false;
	        }
	        return valid;
	      }, '');
	      $.validator.addMethod('phone', function (value, element) {
	        if (value.startsWith("0") || value.startsWith("1")) {
	          return false;
	        }
	        // costco phone numbers are 10 digits with optional .-() and space
	        else return this.optional(element) || /^\(?\d{3}\)?[ -.]?\d{3}[ -.]?\d{4}$/.test(value);
	      }, messages.ERR_INVALID_PHONE_10_DIGIT);
	      // custom validation rule for single email
	      $.validator.addMethod('singleemail', function (value, element) {
	        var flag = true;
	        flag = flag && /^\s*((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?\s*$/.test(value.toLowerCase());
	        return this.optional(element) || flag;
	      }, messages.ERR_INVALID_EMAIL_ADDRESS);
	      $.validator.addMethod('equalTo', function (value, element, param) {
	        var flag = true;
	        flag = flag && value === $(param).val();
	        return this.optional(element) || flag;
	      }, messages.ERR_CONFIRM_EMAIL_MISMATCH);
	      $.validator.addMethod('emailEmpty', function (value, element) {
	        var email = void 0;
	        if (element.name == 'household_emailConfirm') {
	          email = form.find('input[name=household_email]').val();
	        } else if (element.name == 'householdEmailConfirm' || element.name == 'householdEmailConfirmdetails') {
	          email = form.find('input[name=householdEmail]').val();
	        } else if (element.name == 'household_email') {
	          email = form.find('input[name=household_emailConfirm]').val();
	        } else if (element.name == 'householdEmail') {
	          if (form.find('input[name=householdEmailConfirm]').length) {
	            email = form.find('input[name=householdEmailConfirm]').val();
	          } else {
	            email = form.find('input[name=householdEmailConfirmdetails]').val();
	          }
	        } else if (element.name == 'emailConfirm') {
	          if ($(element).attr('id') == 'affiliate-emailConfirm') {
	            email = form.find('input[name=email]').val();
	          } else {
	            return true;
	          }
	        } else if (element.name == 'email') {
	          if ($(element).attr('id') == 'affiliate-email') {
	            email = form.find('input[name=emailConfirm]').val();
	          } else {
	            return true;
	          }
	        }
	        var isOtherFieldEmpty = email == null || email == '';
	        if (!isOtherFieldEmpty && (value == null || value == '')) {
	          return false;
	        } else return true;
	      }, messages.ERR_INVALID_EMAIL_ADDRESS);
	      /** STRY0157080 Require at least ONE alphabet in each of the name fields */
	      $.validator.addMethod("firstNameValidation", function (value, element) {
	        return value !== null && value !== '' ? COSTCO.util.ATLEAST_ONE_ALPHABET.test(value) && memberValidationRegex.test(value.trim()) : true;
	      }, messages.ERR_INVALID_FNAME);
	      $.validator.addMethod("lastNameValidation", function (value, element) {
	        return value !== null && value !== '' ? COSTCO.util.ATLEAST_ONE_ALPHABET.test(value) && memberValidationRegex.test(value.trim()) : true;
	      }, messages.ERR_INVALID_LNAME);
	    },
	    /**
	     * If 'configProduct' exists with the appropriate properties,
	     * prepopulate the inputs. This function uses the data-configproduct
	     * attribute on inputs in the MembershipApplicationTemplates.jsp.
	     * @param {Object} data The data returned from a call to the server
	     *                      for application meta data.
	     * @return {Object} The data passed to the function
	     */
	    prepopulateForm: function prepopulateForm(data) {
	      var configProduct = data.configProduct || this.getConfigProduct();
	      if (configProduct) {
	        var locale = COSTCO.util.getLocale();
	        // Do the populating
	        Object.keys(configProduct).forEach(function (key) {
	          // These keys have to handled specialy because of our Canadian friends.
	          if (key == 'thirdPartyInformationSharing' || key == 'costcoMail' || key == 'costcoEmail') {
	            if (locale == 'en-US' || locale != 'en-US' && key == 'costcoMail') {
	              // The old logic in NewMembershipApplicationHelper.js says
	              // only prepopulate the costcoMail preference if we're in Canada
	              configProduct[key].toLowerCase() == 'yes' ? $('[data-configproduct=' + key + ']').prop('checked', true) : $('[data-configproduct=' + key + ']').prop('checked', false);
	            }
	          } else {
	            $('[data-configproduct=' + key + ']').val(configProduct[key]);
	          }
	        });
	        if (costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED && $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === "true") {
	          COSTCO.MembershipHelper.populateCityStateForDefaultZip(configProduct);
	        }
	      }
	      return data;
	    },
	    /**
	     * Uses the default address zip code obtained from the 'configProduct' (from
	     * the data returned from a call to the server), in order to make a geocodeAPI 
	     * call and populate the city and state fields with the values from the service 
	     * response for the user to choose from (if editing the address)
	     */
	    populateCityStateForDefaultZip: function populateCityStateForDefaultZip(configProduct) {
	
	      if ($('#postalcode')) {
	        var defaultAddrCity = configProduct.city;
	        var defaultAddrState = configProduct.state;
	        var defaultAddrZip = configProduct.zip || configProduct.zipCode;
	        if (defaultAddrZip && defaultAddrCity && defaultAddrState && $('#postalcode').val()) {
	          COSTCO.CAddress.geocodeApiCityState($('#postalcode'), '[name=city]', '[name=state]', defaultAddrCity, defaultAddrState);
	        }
	      }
	
	      if ($('#businessZipCode')) {
	        var defaultCompAddrCity = configProduct.companyCity;
	        var defaultCompAddrState = configProduct.companyState;
	        var defaultCompAddrZip = configProduct.companyZip || configProduct.companyZipCode;
	        if (defaultCompAddrZip && defaultCompAddrCity && defaultCompAddrState && $('#businessZipCode').val()) {
	          COSTCO.CAddress.geocodeApiCityState($('#businessZipCode'), '[name=businessCity]', '[name=businessState]', defaultCompAddrCity, defaultCompAddrState);
	        }
	      }
	    },
	
	    /**
	     * Populates a given element with keys from the obj who's property
	     * names match data-configProduct assigned on inputs of the element.
	     * @param  {jQuery} element The element we want to populate.
	     * @param  {Object} obj  The object who's keys want want to iterate
	     *                       through
	     * @return {jQuery}      Returns the processed element to manipulate further.
	     */
	    populateElement: function populateElement(element, obj) {
	      Object.keys(obj).forEach(function (key) {
	        $(element).find('[data-configproduct=' + key + ']').val(obj[key]);
	      });
	      if (costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED && $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === "true") {
	        COSTCO.MembershipHelper.populateCityStateForDefaultZip(obj);
	      }
	
	      return element;
	    },
	
	    /**
	     * Populate a form using a serilized array ($.fn.serializeArray).
	     * serilizeArray returns an array of objects where each object represents
	     * an input/select/... element who's "name" attribute matches the "name"
	     * property
	     * @param  {jQuery.Object}  form  The form to populate
	     * @param  {Array}          arr   The array of objects to use to populate
	     * @return {void}
	     */
	    populateByName: function populateByName(form, arr) {
	      arr.forEach(function (obj) {
	        $(form).find('[name=' + obj.name + ']').val(obj.value);
	      });
	    },
	
	    /**
	     * Uses the provided affiliate object to build a serialized array of
	     * objects using the form fields from the affiliate template.
	     * @param  {Object} affiliate The object which is the source
	     * @return {Array}            The array of objects
	     */
	    getSerializedAffiliateData: function getSerializedAffiliateData(affiliate) {
	      var $form = $(COSTCO.util.tmpl('tmpl_affiliate', {
	        affiliateHousehold: COSTCO.util.tmpl('tmpl_household_info_affiliate', {})
	      }));
	      // We need to populate the options for dob
	      this.dobPopulate($form, 100);
	      if (costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED && $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === "true") {
	        // We need to populate the form's state drop down
	        if ($form.find('.state-select').length) {
	          var stateProvList = this.getStateProvJson();
	          var stateOptions = this.getStateOptions(stateProvList);
	          $form.find('.state-select').append(stateOptions);
	        }
	      }
	      // Prepopulate the form with existing affiliate data
	      $form = this.populateElement($form, affiliate);
	      // If theres a household attached to affiliate, populate it
	      if (affiliate.houseHold) {
	        $form.find('#affiliate-household').prop('checked', true);
	        $form.find('#affiliate-household').val(true);
	        this.populateElement($form.find('#affiliate-household-container'), affiliate.houseHold);
	      } else {
	        $form.find('#affiliate-household').prop('checked', false);
	        $form.find('#affiliate-household').val(false);
	      }
	      return $form.serializeArray();
	    },
	
	    /**
	     * TRAIL: Refactor - this is not the best way how this function should be
	     * implemented
	     * Populate date of birth selects: month, day, year
	     * Structure of html
	     * <div class="dobPopulate">
	     * <select class="month"/>
	     * <select class="day"/>
	     * <select class="year"/>
	     * </div>
	     * Using this JS - dobPopulate("100") Populates the difference of 100 from
	     * the current year (20XX - 100)
	     * @param  {[type]} template      [description]
	     * @param  {[type]} appConfigYear [description]
	     * @return {void}               [description]
	     */
	    dobPopulate: function dobPopulate(template, appConfigYear) {
	      var elements = $(template).find('.dobPopulate');
	      elements.each(function (index, el) {
	        var currentYear = new Date().getFullYear();
	        var beginningYear = currentYear - parseInt(appConfigYear);
	        var $monthSelect = $(el).find('.month');
	        var $daySelect = $(el).find('.day');
	        var $yearSelect = $(el).find('.year');
	        // Populate year select
	        var _yearSelect = $('<select>');
	        for (var i = currentYear; i >= beginningYear; i--) {
	          _yearSelect.append($('<option></option>').val(i).html(i));
	        }
	        if ($yearSelect.find('option').length <= 1) {
	          $yearSelect.append(_yearSelect.html());
	        }
	        // Populate month select
	        var _monthSelect = $('<select>');
	        for (var _i = 1; _i <= 12; _i++) {
	          _monthSelect.append($('<option></option>').val(_i).html(_i));
	        }
	        if ($monthSelect.find('option').length <= 1) {
	          $monthSelect.append(_monthSelect.html());
	        }
	        // Initialize day select options
	        var _daySelect = $('<select>');
	        for (var _i2 = 1; _i2 <= 31; _i2++) {
	          _daySelect.append($('<option></option>').val(_i2).html(_i2));
	        }
	        if ($daySelect.find('option').length <= 1) {
	          $daySelect.append(_daySelect.html());
	        }
	        // Event handler for changing year and month
	        $yearSelect.change(function () {
	          MembershipHelper.getDaysOfMonth({
	            year: $yearSelect.find('option:selected').val(),
	            month: $monthSelect.find('option:selected').val(),
	            daySelect: $daySelect
	          });
	        });
	        $monthSelect.change(function () {
	          MembershipHelper.getDaysOfMonth({
	            year: $yearSelect.find('option:selected').val(),
	            month: $monthSelect.find('option:selected').val(),
	            daySelect: $daySelect
	          });
	        });
	        $monthSelect.add($daySelect).add($yearSelect).each(function (i, select) {
	          // If the select has a readonly attribute, disable all options
	          // except the currently selected option.
	          if ($(select).attr('readonly')) {
	            // will return "readonly"
	            $(select).find('option').attr('disabled', 'disabled');
	          }
	        });
	      });
	    },
	    /**
	     * Get the days of the month specific to the context year/month
	     * @param  {Object} options The object with year, month and the day <select>
	     * @return {void}
	     */
	    getDaysOfMonth: function getDaysOfMonth(options) {
	      var selected = void 0;
	      var $daySelect = options.daySelect;
	      if (!isNaN(parseInt($daySelect.find('option:selected').val()))) {
	        selected = $daySelect.find('option:selected').val();
	      }
	      if (!isNaN(parseInt(options.year)) && !isNaN(parseInt(options.month))) {
	        // Remove numbered options from day select
	        $daySelect.find('option').each(function (index, element) {
	          if (!isNaN(element.value)) {
	            try {
	              element.remove(); // ie fail
	            } catch (err) {}
	          }
	        });
	        var daysInMonth = new Date(options.year, options.month, 0).getDate();
	        var _daySelect = $('<select>');
	        for (var i = 1; i <= daysInMonth; i++) {
	          _daySelect.append($('<option></option>').val(i).html(i));
	        }
	        $daySelect.append(_daySelect.html());
	        if (typeof selected != 'undefined') {
	          $daySelect.find('option[value="' + selected + '"]').prop('selected', true);
	        }
	      }
	    },
	    /**
	     * Uses Jquery Mask plugin to format input. Use cleanVal() instead of val()
	     * to get unformatted value
	     * @param  {[type]} template [description]
	     * @return {void}          [description]
	     */
	    maskInput: function maskInput(template) {
	      $(template).find('[name=contactPhoneNumber],[name=cphone],[name=MembershipCrmCallerInfo_phone]').unmask().mask('000-000-0000');
	      $(template).find('[name=mobilePhoneNumber],[name=mphone],[name=MembershipCrmCallerInfo_mobile]').unmask().mask('000-000-0000');
	      $(template).find('[name=businessPhone]').unmask().mask('000-000-0000');
	      $(template).find('[name=household_primaryPhoneNumber],[name=householdPrimaryPhoneNumber]').unmask().mask('000-000-0000');
	      $(template).find('[name=month],[name=household_month],[name=householdDobMonth],[name=dobmonth],[name=MembershipCrmCallerInfo_dobEditMonth],[name=day],[name=household_day],[name=householdDobDay],[name=dobday],[name=MembershipCrmCallerInfo_dobEditDay]').unmask().mask('00');
	
	      $(template).find('[name=year],[name=household_year],[name=householdDobYear],[name=dobyear],[name=MembershipCrmCallerInfo_dobEditYear]').unmask().mask('0000');
	      if (addressForm.isUS()) {
	        $(template).find('[name=postalcode],[name=zip],[name=MembershipCrmCallerInfo_zipCode]').unmask().mask('00000-0000');
	        $(template).find('[name=businessZipCode]').unmask().mask('00000-0000');
	        $(template).find('[name=employeeAddon_zip]').unmask().mask('00000-0000');
	      } else {
	        $(template).find('[name=postalcode],[name=zip],[name=MembershipCrmCallerInfo_zipCode]').unmask().mask('S0S 0S0');
	        $(template).find('[name=businessZipCode]').unmask().mask('S0S 0S0');
	        $(template).find('[name=employeeAddon_zip]').unmask().mask('S0S 0S0');
	      }
	    },
	    /**
	     * This function is used showing server side errors returned from
	     * calling various membership related ajax services. If we have an
	     * error, we show it at the top and scroll to it.
	     * @param  {Object} data The membership application meta data
	     * @return {Object}      The membership application meta data
	     */
	    handleErrors: function handleErrors(data) {
	      var hasErrors = data && data.error && data.errorMessages && data.errorMessages.length > 0;
	      var errorHtml = '';
	      var $selectors = $('#server-error, #notification-message');
	      if (data && !data.retainNotification || hasErrors) {
	        $selectors.addClass('hide').children().remove();
	      }
	      if (data && data.status && data.status === 500) {
	        data = {
	          error: true,
	          errorMessages: ['Unexpected Error']
	        };
	      }
	      if (data && data.error && data.errorMessages) {
	        // First clear div#notification-message (needed on Add People Outside Renewal page)
	        COSTCO.util.notification.clearNotification();
	        $selectors.addClass('critical-notification');
	        for (var i = 0, len = data.errorMessages.length; i < len; i++) {
	          if (data.errorMessages[i] === '_ERR_INVALID_SHIP_ADDR') {
	            data.errorMessages[i] = messages.ERR_SHIP_ADDR_SAME_AS_WHS_ADDR;
	            var formId = $('#MemberAddressBookForm');
	            var addressField = '#address1';
	            COSTCO.dialog.sameAddressValidation(formId, addressField);
	          }
	          console.error(data.errorMessages[i]);
	          errorHtml += i === len - 1 ? '<span>' + data.errorMessages[i] + '</span>' : '<p>' + data.errorMessages[i] + '</p>';
	          if (data.errorMessages[0] == 'APPLICATION_ORDER_ITEM_ID_MISSING') {
	            var appType = $('#applicationType').val();
	            // Stale browser
	            if (appType === 'BD') {
	              window.location.href = '/CheckoutCartView';
	              return;
	            }
	          }
	        };
	        $selectors.removeClass('hide').append(errorHtml);
	        $('html, body').scrollToElem($selectors, 100);
	      } else {
	        $selectors.removeClass('critical-notification');
	        // Clear previous error on success (needed on Add People Outside Renewal page)
	        COSTCO.util.notification.clearNotification();
	      }
	      return data;
	    },
	    /**
	     * A wrapper around membershipData. We use this so we dont need to
	     * include membershipData everywhere
	     * @return {Object} The object from sessionStorage representing the
	     *                      configProduct application metadata
	     */
	    getConfigProduct: function getConfigProduct() {
	      return membershipData.getConfigProduct();
	    },
	    /**
	     * A wrapper around membershipData. We use this so we dont need to
	     * include membershipData everywhere
	     * @param  {Object} data The object (represetning the membership application
	     *                       metadata) to set in sessionStorage.
	     * @return {Object}      Returns the same data object passed as an argument
	     *                               (meant to be a chainable action)
	     */
	    setConfigProduct: function setConfigProduct(data) {
	      return membershipData.setConfigProduct(data);
	    },
	    /**
	     * Pull a specific address by label from an array of addresses. For example
	     * 'Primary' in theory return the primary address if it matches the label.
	     * @param  {[type]} addressLabel [description]
	     * @param  {[type]} addressArray [description]
	     * @return {[type]}              [description]
	     */
	    findAddressByLabel: function findAddressByLabel(addressLabel, addressArray) {
	      var address = {};
	      $(addressArray).each(function (index, value) {
	        if (value.label == addressLabel) {
	          address = value;
	          return false;
	        }
	      });
	      return address;
	    },
	    /**
	     * Returns a chainable address verification object. Right now this
	     * is specific to the membership application. Maybe parameterize this
	     * to accept a specific form and selectors.
	     * @param {Object} selectors The object that contains selectors
	     * @return {jQuery.Deferred} Returns a deferred, thenable object.
	     */
	    verifyAddresses: function verifyAddresses(selectors) {
	      var addressObjects = this.buildAddressArray($(selectors.form), {
	        primary: selectors.primary,
	        business: selectors.business
	      });
	      $('.order-ajax').addClass('ajax-busy');
	      return COSTCO.util.ajax({
	        url: '/AjaxAddressVerificationCmd',
	        type: 'POST',
	        dataType: 'json',
	        timeout: 15000,
	        // Turn off glboal event handlers. ajaxComplete and ajaxError are
	        // global events defined in global.js
	        global: false,
	        data: {
	          formdata: encodeURIComponent(JSON.stringify(addressObjects))
	        },
	        always: function always() {
	          $('.permanent-ajax-busy').removeClass('ajax-busy');
	        },
	        complete: function complete() {}
	      });
	    },
	    /**
	     * [description]
	     * @param  {[type]} form [description]
	     * @param  {[type]} obj  [description]
	     * @return {[type]}      [description]
	     */
	    buildAddressArray: function buildAddressArray(form, obj) {
	      var addressObjects = [];
	      var primaryAVSObj = addressVerification.buildRequestElement(form, obj.primary);
	      if (typeof primaryAVSObj.fName == 'undefined' || primaryAVSObj.fName == '') {
	        primaryAVSObj.fName = $("#MemberAddressBookForm input[name='first_name']").val();
	        primaryAVSObj.lName = $("#MemberAddressBookForm input[name='lastName']").val();
	      }
	      addressObjects.push(primaryAVSObj);
	      if (this.isBusinessMembership() && obj.business) {
	        var businessAVSObj = addressVerification.buildRequestElement(form, obj.business);
	        if (typeof businessAVSObj.fName == 'undefined' || businessAVSObj.fName == '') {
	          businessAVSObj.fName = $("#MemberAddressBookForm input[name='first_name']").val();
	          businessAVSObj.lName = $("#MemberAddressBookForm input[name='lastName']").val();
	        }
	        addressObjects.push(businessAVSObj);
	      }
	      $.each(addressObjects, function (index, value) {
	        if (value.id == '') {
	          addressObjects[index].id = index;
	        }
	      });
	      return addressObjects;
	    },
	    /**
	     * This function serves as an intermediary to invoking the verification
	     * modal. It prepares data appropriately and then invokes. If the verification
	     * response has all "no suggestions", we simply invoke the callback on the
	     * entered addresses.
	     * @param  {Object}   addressObj The response from calling
	     *                               /AjaxAddressVerificationCmd. The data
	     *                               structure looks like
	     *                                {Address:[], Validated_Address: []}
	     * @param  {Function} callback   The function which ends up being the
	     *                               primary event on the verification modal.
	     *                               It could submit a form, etc.
	     * @return {void}
	     */
	    invokeMultiAVS: function invokeMultiAVS(addressObj, callback) {
	      $('.order-ajax').removeClass('ajax-busy');
	      if (typeof addressObj !== 'undefined' && addressObj != null && addressObj.Validated_Address != null) {
	        var multiAVSModal = addressVerification.showMultiAddressVerificationModal;
	
	        if (addressVerification.hasAllNoSuggestion(addressObj.Validated_Address)) {
	          // In this case we just want to use the user inputted addresses
	          callback(addressObj.Address);
	          COSTCO.dialog.close();
	        } else if (addressVerification.hasAllSameAsSuggested(addressObj)) {
	          // Prefering the validate_address as it will contain the 4 digits
	          // appended to the zip code.
	          callback(addressObj.Validated_Address);
	          COSTCO.dialog.close();
	        } else {
	          // We have at least one suggested address. We want to show the modal.
	          var validAddresses = MembershipHelper.removeValidAddressFromArray(addressObj);
	          multiAVSModal(validAddresses, callback);
	        }
	      } else {
	        elementObj = $('[name=' + addressObj.errorMessageParam[0] + ']');
	        if (elementObj.length > 0) {
	          elementObj.parent().addClass('error');
	          elementObj.attr('hasvalidationerror', true);
	          $(elementObj).parent().parents("form:first").valid();
	        }
	      }
	    },
	    /**
	     * This function populates a given form. Its meant to replace the values
	     * of each designated field with what the addresses selected after the
	     * verification process. We then can just serialize the form to send to the
	     * backend.
	     * @param  {jQuery} form        The form to populate
	     * @param  {Array} addresses    Array of validated addresses to get address
	     *                              details from it and send with membership
	     *                              application form.
	     * @param  {boolean} isAffiliate Are we populating the affiliate form?
	     * @return {void}
	     */
	    populateAddressData: function populateAddressData(form, addresses, isAffiliate) {
	      var primaryAddress = isAffiliate ? this.findAddressByLabel('Affiliate Address', addresses) : this.findAddressByLabel('Primary Address', addresses);
	      form.find('input[name=address1],input[name=line1]').val(primaryAddress.line1 != null ? primaryAddress.line1.trim() : "");
	      form.find('input[name=address2],input[name=line2]').val(primaryAddress.line2);
	      form.find('input[name=city]').val(primaryAddress.city);
	      form.find('select[name=state]').val(primaryAddress.state);
	      form.find('input[name=postalcode],input[name=zip]').val(primaryAddress.zip);
	      form.find('input[name=country]').val(primaryAddress.country);
	      if (this.isBusinessMembership() && !isAffiliate) {
	        var businessAddress = this.findAddressByLabel('Business Address', addresses);
	        form.find('input[name=businessAddressLine1]').val(businessAddress.line1);
	        form.find('input[name=businessAddressLine2]').val(businessAddress.line2);
	        form.find('input[name=businessCity]').val(businessAddress.city);
	        form.find('select[name=businessState]').val(businessAddress.state);
	        form.find('input[name=businessZipCode]').val(businessAddress.zip);
	        form.find('input[name=businessCountry]').val(businessAddress.country);
	      }
	    },
	    /**
	     * Removes valid addresses and No Suggested addresses from the AVS response array
	     * @param  {Array} addressObj AVS address array
	     * @return {Array} Array of addresses to be validated
	     */
	    removeValidAddressFromArray: function removeValidAddressFromArray(addressObj) {
	      var addressesToVerify = {
	        Address: [],
	        Validated_Address: [],
	        size: 0
	      };
	
	      $.each(addressObj.Validated_Address, function (index, value) {
	        // Ensure each validated address has an `id` attribute
	        if (!value.id) {
	          console.warn('Missing id for validated address at index ' + index + '. Assigning id ' + index + '.');
	          value.id = index.toString(); // Assign the index as the id
	        }
	
	        var entered = addressVerification.findAddressById(value.id, addressObj.Address);
	
	        // Push all validated addresses into the Validated_Address array
	        addressesToVerify.Validated_Address.push(value);
	
	        // Add the corresponding entered address to the Address array
	        if (entered) {
	          addressesToVerify.Address.push(entered);
	        }
	      });
	
	      // Update the size property to reflect the number of validated addresses
	      addressesToVerify.size = addressesToVerify.Validated_Address.length;
	
	      return addressesToVerify;
	    },
	    /**
	     * [description]
	     * @param  {[type]} stateProvList [description]
	     * @return {[type]}               [description]
	     */
	    getStateOptions: function getStateOptions(stateProvList) {
	      return addressForm.getStateOptions(stateProvList);
	    },
	    /**
	     * Make a call to grab the application meta data from
	     * the membershipData module.
	     * @return {jQuery.Promise} The returned promise to chain
	     */
	    getApplicationData: function getApplicationData() {
	      return membershipData.getApplicationData();
	    },
	    /**
	     * Get the membership meta data from the server
	     * @return {jQuery.Promise} The returned promise to chain
	     */
	    getMembershipData: function getMembershipData() {
	      return membershipData.getMembershipData();
	    },
	    /**
	     * [description]
	     * @return {[type]} [description]
	     */
	    getStateProvJson: function getStateProvJson() {
	      return address.getStateProvJson();
	    },
	    /**
	     * [description]
	     * @param  {[type]} x [description]
	     * @param  {[type]} y [description]
	     * @param  {[type]} z [description]
	     * @return {[type]}   [description]
	     */
	    bingCityState: function bingCityState(x, y, z) {
	      return address.bingCityState(x, y, z);
	    },
	    geocodeApiCityState: function geocodeApiCityState(x, y, z) {
	      return address.geocodeApiCityState(x, y, z);
	    },
	    /**
	     * Builds the existing affiliates block. Provide a template and a target
	     * to append the HTML too.
	     * @param  {[type]} template [description]
	     * @param  {[type]} target   [description]
	     * @return {void}
	     */
	    buildExistingAffiliates: function buildExistingAffiliates(template, target) {
	      $('.affiliate-block, .affiliate-clearfix').remove();
	      var affiliateHtml = '';
	
	      this.getAffiliates().forEach(function (affiliate, i) {
	        affiliateHtml += COSTCO.util.tmpl(template, {
	          affiliate: affiliate,
	          // Needed to inject clearfix where ever needed
	          index: i + 1
	        });
	      });
	      $(target).prepend(affiliateHtml);
	    },
	    /**
	     * Gets the array of affiliates attached to the configProduct
	     * @return {Array} The array of objects representing the affiliates
	     */
	    getAffiliates: function getAffiliates() {
	      var affiliates = [];
	      var c = this.getConfigProduct();
	      if (!$.isEmptyObject(c) && c.affilatedMemberships && c.affilatedMemberships.affilatedMember) {
	        affiliates = c.affilatedMemberships.affilatedMember.map(function (affiliate) {
	          // These fields are used by MemberApplicationAffiliateUpdateCmd
	          // Some of them are duplicates of whats already defined
	          // on configProduct.affilatedMemberships.affilatedMember because
	          // theres no standard
	          affiliate.affiliateMembershipNumber = affiliate.membershipNumber || '';
	          affiliate.parentMembershipNumber = c.membershipNumber || '';
	          affiliate.organizationId = c.organizationId || '';
	          affiliate.first = affiliate.firstName || '';
	          affiliate.last = affiliate.lastName || '';
	          affiliate.mi = affiliate.mi || '';
	          return affiliate;
	        });
	      }
	      return affiliates;
	    },
	    /**
	     * Using the AllMembershipInfoDataBean as the source of data, locate the
	     * specific affiliate by number
	     * @param  {Object} data   The AllMembershipInfoDataBean serielized
	     *                         as a JS object
	     * @param  {Number} number The affiliate membership number
	     * @return {Object}        The JS object representing the affiliate from
	     *                             AllMembershipInfoDataBean
	     */
	    getAffiliateFromDataBeanByNumber: function getAffiliateFromDataBeanByNumber(data, number) {
	      var affiliate = undefined;
	      if (data.caller && data.caller.businessInfo && data.caller.businessInfo.affiliates) {
	        var affiliates = data.caller.businessInfo.affiliates;
	        affiliates.forEach(function (aff) {
	          if (aff.cardNumber && aff.cardNumber.value && aff.cardNumber.value == number) {
	            affiliate = aff;
	          }
	        });
	      }
	      return affiliate;
	    },
	
	    /**
	     * Gets the affiliate object from the configProduct if one exists.
	     * @param  {Number} membershipNumber The affiliate membershipNumber
	     * @return {Object}                  The affiliate object
	     */
	    getAffiliateByNumber: function getAffiliateByNumber(membershipNumber) {
	      var affiliate = undefined;
	      this.getAffiliates().forEach(function (aff) {
	        if (membershipNumber == aff.membershipNumber) {
	          affiliate = aff;
	          return;
	        }
	      });
	      return affiliate;
	    },
	
	    /**
	     * Gets the affiliate household from the configProduct if one exists
	     * @param  {Number} membershipNumber The affiliate household membership number
	     * @return {Object}                  The affiliate household object
	     */
	    getAffiliateHouseholdByNumber: function getAffiliateHouseholdByNumber(membershipNumber) {
	      var affHousehold = undefined;
	      this.getAffiliates().forEach(function (aff) {
	        if (aff.houseHold && aff.houseHold.membershipNumber == membershipNumber) {
	          affHousehold = aff.houseHold;
	          return;
	        }
	      });
	      return affHousehold;
	    },
	
	    /**
	     * Gets the affiliate object using the affiliate's household membership number.
	     * @param  {Number} membershipNumber The affiliate household membership number
	     * @return {Object}                  The affiliate object
	     */
	    getAffiliateByHouseholdNumber: function getAffiliateByHouseholdNumber(membershipNumber) {
	      var affiliate = undefined;
	      this.getAffiliates().forEach(function (aff) {
	        if (aff.houseHold && aff.houseHold.membershipNumber == membershipNumber) {
	          affiliate = aff;
	          return;
	        }
	      });
	      return affiliate;
	    },
	
	    /**
	     * Gets the affiliate object using the affiliate's household membership number.
	     * @param  {Object} data   The AllMembershipInfoDataBean serielized
	     *                         as a JS object
	     * @param  {Number} membershipNumber The affiliate household membership number
	     * @return {Object}                  The affiliate object
	     */
	    getAffByHouseholdNumber: function getAffByHouseholdNumber(data, membershipNumber) {
	      var affiliate = undefined;
	      if (data.caller && data.caller.businessInfo && data.caller.businessInfo.affiliates) {
	        var affiliates = data.caller.businessInfo.affiliates;
	        affiliates.forEach(function (aff) {
	          if (aff.household && aff.household.cardNumber && aff.household.cardNumber.value == membershipNumber) {
	            affiliate = aff;
	            return;
	          }
	        });
	      }
	      return affiliate;
	    },
	
	    /**
	     * Takes the request data serialized from the affiliate form template
	     * (tmpl_affiliate) and transforms it to the appropriate namespace for
	     * the MemberAffiliateAddCmd used by renew membership / business
	     * details flows.
	     * @method
	     * @param  {Object} requestData The object representing the form inputs
	     *                              from form#affiliate-form
	     * @return {Object}             The transformed inputs in an object.
	     */
	    transformAffiliateInputNames: function transformAffiliateInputNames(requestData) {
	      var newRequestData = {};
	      var prefix = 'MembershipCrmAddAffiliate_';
	      Object.keys(requestData).forEach(function (key) {
	        switch (key) {
	          case 'fname':
	            newRequestData[prefix + 'firstName'] = requestData[key];
	            break;
	          case 'lname':
	            newRequestData[prefix + 'lastName'] = requestData[key];
	            break;
	          case 'dobday':
	            newRequestData[prefix + 'dobEditDay'] = requestData[key];
	            break;
	          case 'dobmonth':
	            newRequestData[prefix + 'dobEditMonth'] = requestData[key];
	            break;
	          case 'dobyear':
	            newRequestData[prefix + 'dobEditYear'] = requestData[key];
	            break;
	          case 'line1':
	            newRequestData[prefix + 'addressLine1'] = requestData[key];
	            break;
	          case 'line2':
	            newRequestData[prefix + 'addressLine2'] = requestData[key];
	            break;
	          case 'cphone':
	            newRequestData[prefix + 'phone'] = requestData[key];
	            break;
	          case 'mphone':
	            newRequestData[prefix + 'mobile'] = requestData[key];
	            break;
	          case 'householdPrefix':
	            newRequestData[prefix + 'household_prefix'] = requestData[key];
	            break;
	          case 'householdFname':
	            newRequestData[prefix + 'household_firstName'] = requestData[key];
	            break;
	          case 'householdMi':
	            newRequestData[prefix + 'household_mi'] = requestData[key];
	            break;
	          case 'householdLname':
	            newRequestData[prefix + 'household_lastName'] = requestData[key];
	            break;
	          case 'householdSuffix':
	            newRequestData[prefix + 'household_suffix'] = requestData[key];
	            break;
	          case 'householdDobMonth':
	            newRequestData[prefix + 'household_dobEditMonth'] = requestData[key];
	            break;
	          case 'householdDobDay':
	            newRequestData[prefix + 'household_dobEditDay'] = requestData[key];
	            break;
	          case 'householdDobYear':
	            newRequestData[prefix + 'household_dobEditYear'] = requestData[key];
	            break;
	          case 'householdEmail':
	            newRequestData[prefix + 'household_email'] = requestData[key];
	            break;
	          case 'householdPrimaryPhoneNumber':
	            newRequestData[prefix + 'household_phone'] = requestData[key];
	            break;
	          case 'householdCheckbox':
	            newRequestData[prefix + 'includeHousehold'] = requestData[key];
	            break;
	          default:
	            newRequestData['' + prefix + key] = requestData[key];
	        }
	      });
	      return newRequestData;
	    },
	    /**
	     * Similar to above method. Take the old input names and transform them to
	     * what the backend is expecting (for /MemberHouseholdAddCmd)
	     * @param  {Object} requestData The object representing the form inputs
	     *                              from form#affiliate-form
	     * @return {Object}             The transformed inputs in an object.
	     */
	    transformAffiliateHouseholdInputNames: function transformAffiliateHouseholdInputNames(requestData) {
	      var newRequestData = {};
	      Object.keys(requestData).forEach(function (key) {
	        switch (key) {
	          case 'householdPrefix':
	            newRequestData['prefix'] = requestData[key];
	            break;
	          case 'householdFname':
	            newRequestData['first_name'] = requestData[key];
	            break;
	          case 'householdMi':
	            newRequestData['middle_name'] = requestData[key];
	            break;
	          case 'householdLname':
	            newRequestData['last_name'] = requestData[key];
	            break;
	          case 'householdSuffix':
	            newRequestData['suffix'] = requestData[key];
	            break;
	          case 'householdDobMonth':
	            newRequestData['month'] = requestData[key];
	            break;
	          case 'householdDobDay':
	            newRequestData['day'] = requestData[key];
	            break;
	          case 'householdDobYear':
	            newRequestData['year'] = requestData[key];
	            break;
	          case 'householdEmail':
	            newRequestData['email'] = requestData[key];
	            break;
	          case 'householdPrimaryPhoneNumber':
	            newRequestData['contact_phone'] = requestData[key];
	            break;
	          default:
	            newRequestData[key] = requestData[key];
	        }
	      });
	      return newRequestData;
	    },
	    /**
	     * First show the user the affiliates as registered with their
	     * xorderitems.crmmemberinfo (configProduct) on the application page.
	     * If they have 6, we don't allow anymore.
	     * @param  {[type]} data [description]
	     * @return {[type]}      [description]
	     */
	    reflectAffiliates: function reflectAffiliates(data) {
	      // First show the affiliates returned from submission
	      COSTCO.MembershipHelper.buildExistingAffiliates('tmpl_affiliate_block', '#add-person-container');
	      // Hide add person button if we're >= 6 affiliates
	      COSTCO.AffiliateForm.checkAffiliateNumber(data);
	      return data;
	    },
	    /**
	     * Build the affiliate list for renew / account details view using the response
	     * from some crud operation.
	     * @param  {Object} data The JSON object representing the AllMembershipInfoDataBean
	     * @return {Object}      Same as parameter - used for chaining to the next method.
	     */
	    reflectAffiliatesAlternate: function reflectAffiliatesAlternate(data) {
	      if (data && data.caller && data.caller.businessInfo && data.caller.businessInfo.affiliates) {
	        COSTCO.RenewMembership.membershipData = /* COSTCO.AccountDetails.membershipData = */data;
	        var affiliateHtml = '';
	        var affiliates = data.caller.businessInfo.affiliates || [];
	        affiliates.length > 0
	        // Remove the empty class (if it exists), which has a border-top
	        // attribute. The following affiliate blocks have border-tops.
	        ? $('#affiliate-list-container').removeClass('empty') : $('#affiliate-list-container').addClass('empty');
	        affiliates.forEach(function (a) {
	          affiliateHtml += COSTCO.util.tmpl('tmpl_affiliate_row', {
	            affiliateCardNumber: a.cardNumber.value,
	            affiliateFirstName: a.firstName.value,
	            affiliateLastName: a.lastName.value,
	            isNewAffiliate: a.statusReasonDesc && (a.statusReasonDesc.value == 'Created' || a.statusReasonDesc.value == 'Opened'),
	            hasHousehold: a.household && a.household.cardNumber.value,
	            affiliateHouseholdNumber: a.household.cardNumber.value,
	            affiliateHouseholdFirstName: a.household.firstName.value,
	            affiliateHouseholdLastName: a.household.lastName.value
	          });
	        });
	        $('#affiliate-list-container').html(affiliateHtml);
	      }
	      return data;
	    },
	    /**
	     * Build the affiliate list for Add Additional People outside renewal view using
	     * the response from some crud operation.
	     * @param {Object} data The JSON object representing the AllMembershipInfoDataBean.
	     * @return {Object} Same as parameter - used for chaining to the next method.
	     */
	    reflectAffiliatesBussinessOutsideRenewal: function reflectAffiliatesBussinessOutsideRenewal(data) {
	      COSTCO.AddAdditionalPeople.membershipData = /* COSTCO.AccountDetails.membershipData = */data;
	      var newAffiliateHtml = '';
	      var affiliateHtml = '';
	      var affiliates = data.caller.businessInfo.affiliates || [];
	      var newAffiliatesCount = 0;
	      var individualFee = 0;
	      affiliates.forEach(function (a) {
	        if (a.statusReasonDesc && (a.statusReasonDesc.value == 'Created' || a.statusReasonDesc.value == 'Opened')) {
	          newAffiliatesCount++;
	        }
	      });
	      var totalFee = parseFloat(data.caller.addAffiliateAmount);
	      if (newAffiliatesCount > 0) {
	        // Remove the empty class (if it exists), which has a border-top
	        // attribute. The following affiliate blocks have border-tops.
	        $('#new-people-on-my-membership').removeClass('empty');
	        individualFee = totalFee / newAffiliatesCount;
	        // Display info message if there are no errors
	        if (!$('#notification-message').hasClass('critical-notification')) {
	          if (costcoStoreFeatures.GMP_ENABLED) {
	            COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.WARNING, [messages.ACCOUNT_RWD__AddAdditionalPeople_AdditionalPersonCost_InfoText_GMP]);
	          } else {
	            COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.SUCCESS, [messages.ACCOUNT_RWD__AddAdditionalPeople_AdditionalPersonCost_InfoText]);
	          }
	        }
	      } else {
	        $('#new-people-on-my-membership').addClass('empty');
	        // Remove info message if there are no errors
	        if (!$('#notification-message').hasClass('critical-notification')) {
	          COSTCO.util.notification.clearNotification();
	        }
	      }
	      affiliates.forEach(function (a) {
	        if (a.statusReasonDesc && (a.statusReasonDesc.value == 'Created' || a.statusReasonDesc.value == 'Opened')) {
	          newAffiliateHtml += COSTCO.util.tmpl('tmpl_add_new_affiliate_row', {
	            affiliateCardNumber: a.cardNumber.value,
	            affiliateFirstName: a.firstName.value,
	            affiliateLastName: a.lastName.value,
	            isNewAffiliate: true,
	            hasHousehold: a.household && a.household.cardNumber.value,
	            affiliateHouseholdNumber: a.household.cardNumber.value,
	            affiliateHouseholdFirstName: a.household.firstName.value,
	            affiliateHouseholdLastName: a.household.lastName.value,
	            individualFeeJS: individualFee.toFixed(2)
	          });
	        } else {
	          affiliateHtml += COSTCO.util.tmpl('tmpl_affiliate_row', {
	            affiliateCardNumber: a.cardNumber.value,
	            affiliateFirstName: a.firstName.value,
	            affiliateLastName: a.lastName.value,
	            isNewAffiliate: false,
	            hasHousehold: a.household && a.household.cardNumber.value,
	            affiliateHouseholdNumber: a.household.cardNumber.value,
	            affiliateHouseholdFirstName: a.household.firstName.value,
	            affiliateHouseholdLastName: a.household.lastName.value
	          });
	        }
	      });
	      $('#new-people-on-my-membership').html(newAffiliateHtml);
	      $('#affiliate-list-container').html(affiliateHtml);
	      if (totalFee) {
	        $('#total-fee').html('$' + totalFee.toFixed(2));
	      }
	      // In border cases, when newAffiliatesCount changes from 0 to 1, or from 1 to 0,
	      // hide/show appropriate sections to have verbiage in singular/plural, show/hide
	      // total cost, and enable/disable Add to Cart button.
	      if (newAffiliatesCount == 0) {
	        $('#add-a-person-outside-renewal').removeClass('hide');
	        $('#add-another-person-outside-renewal').addClass('hide');
	        $('#total-price-section').addClass('hide');
	        $('#add-to-cart').attr('disabled', 'disabled');
	      } else if (newAffiliatesCount == 1 && $('#add-another-person-outside-renewal').hasClass('hide')) {
	        $('#add-a-person-outside-renewal').addClass('hide');
	        $('#add-another-person-outside-renewal').removeClass('hide');
	        $('#total-price-section').removeClass('hide');
	        $('#add-to-cart').removeAttr('disabled');
	      }
	      // Hide the option to add more affiliates if there are more than six
	      if (affiliates.length >= 6) {
	        $('#add-another-person-outside-renewal').addClass('hide');
	      }
	      return data;
	    },
	    /**
	     * If the response has affiliates, we want the the link to show
	     * "Add Another Person". If we have zero, we want the link to say
	     * "Add a Person".
	     * @param  {Object} data The JSON object representing the AllMembershipInfoDataBean
	     * @return {Object}      Same as parameter - used for chaining to the next method.
	     */
	    addPersonLink: function addPersonLink(data) {
	      if (data && data.caller && data.caller.businessInfo && data.caller.businessInfo.affiliates && data.caller.businessInfo.affiliates.length > 0) {
	        $('#add-another-person-text').removeClass('hide');
	        $('#add-a-person-text').addClass('hide');
	      } else {
	        $('#add-another-person-text').addClass('hide');
	        $('#add-a-person-text').removeClass('hide');
	      }
	      return data;
	    },
	    /**
	     * If we already have 6 newly added affiliates, we don't want to allow the
	     * user to add any more. This function checks that and then hides/disables
	     * the "Add Another Person" link.
	     * @param  {Object} data The JSON object representing the AllMembershipInfoDataBean
	     * @return {Object}      Same as parameter - used for chaining to the next method.
	     */
	    canAddAffiliate: function canAddAffiliate(data) {
	      var counter = 0;
	      if (data && data.caller && data.caller.businessInfo && data.caller.businessInfo.affiliates) {
	        (data.caller.businessInfo.affiliates || []).forEach(function (a) {
	          if (a.statusReasonDesc && (a.statusReasonDesc.value == 'Created' || a.statusReasonDesc.value == 'Opened')) {
	            counter++;
	          }
	        });
	        // Handle hide/show of Add Person/Add Another Person
	        if (COSTCO.MembershipHelper.isQuickMembership) {
	          if (counter == 0) {
	            $('#add-a-person-text').removeClass('hide');
	            $('#add-another-person-text').addClass('hide');
	          } else if (counter > 0 && counter < 6) {
	            $('#add-a-person-text').addClass('hide');
	            $('#add-another-person-text').removeClass('hide');
	          } else {
	            $('#add-a-person-text').addClass('hide');
	            $('#add-another-person-text').addClass('hide');
	          }
	        } else if (counter >= 6) {
	          $('#add-another-person').addClass('hide');
	        } else {
	          $('#add-another-person').removeClass('hide');
	        }
	      }
	      return data;
	    },
	    /**
	     * This takes the renewal price from the AllMembershipInfoDataBean
	     * (caller.renewAmount) and replaces the value of span#renewal-amount
	     * located at MembershipRenewInfo_Business_UI.jspf
	     * @param  {Object} data The JSON object representing the AllMembershipInfoDataBean
	     * @param  {Boolean} isUpgrade
	     * @return {Object}      Same as parameter - used for chaining to the next method.
	     */
	    updateTotalPrice: function updateTotalPrice(data, isUpgrade) {
	      if (data && data.caller && data.caller.renewAmount) {
	        var locale = COSTCO.util.getLocale().substr(0, 2);
	        $('#renewal-amount').text(COSTCO.util.localeSpecificCurrency(isUpgrade ? data.caller.renewAndUpgradeAmount : data.caller.renewAmount, locale));
	      }
	      return data;
	    },
	    /**
	     * In Account Details, when a user has a validated profile with a internal
	     * card (usage = 'Z050') wants to change their email address, we invalidate
	     * them unless they're changing their email that includes the costco domain.
	     * (<username>@costco.com)
	     * @param  {DOMElement} form The form to pull the profile email from
	     * @return {boolean}     Does this profile need to be invalidated?
	     */
	    isInternalInvalidated: function isInternalInvalidated(form) {
	      var email = $(form).find('#update-email').val();
	      return COSTCO.util.getMemberCookie().usage == 'Z050' && !(email.includes('@costco.com') || email.includes('@costco.ca'));
	    },
	    /** Adding zero the left of the input if its lenght is 1 */
	    prependZero: function prependZero(event) {
	      var value = $(event.currentTarget).val();
	      if (value != null && value != '') {
	        if (value.length == 1 && value != '0') {
	          value = '0' + value;
	        }
	        $(event.currentTarget).val(value);
	      }
	    }
	  };
	  if (typeof window.COSTCO == 'undefined') {
	    window.COSTCO = {};
	  }
	  window.COSTCO.MembershipHelper = MembershipHelper;
	  return MembershipHelper;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title membership-data.js: Submodule
	 * @description A submodule that retrieves the users membership data. Used
	 *              for prepopulating forms.
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	  var MembershipData = {
	    /**
	     * Returns a 'thenable' promise  that contains a 'configproduct' from
	     * the database. On the backend this ajax request maps to
	     * MembershipApplicationDataBeanAjax.java. The 'configproduct' is the user's
	     * data and the command builds this object with the following priority:
	     *  1. If CRM data exists for this user, use it
	     *  2. Else if the user has a defaulted billing address, use it.
	     * @return {Object} The promise to be used for further processing. Use it
	     *                      like ...getApplicationData().done(callbackFn(data))
	     */
	    getApplicationData: function getApplicationData() {
	      var configProduct = this.getConfigProduct();
	      var deferred = $.Deferred();
	      var orderItemId = applicationTrackingCookie || $.cookie('APPLICATION_TRACKING_COOKIE');
	      var querystrings = {
	        requesttype: 'ajax',
	        orderItemId: orderItemId || ''
	      };
	      var url = '/AjaxMembershipApplicationMetaDataView?' + $.param(querystrings);
	      // If we have the data already, lets use it instead of making a call.
	      if (!$.isEmptyObject(configProduct) && orderItemId == configProduct.applicationTrackingCookie) {
	        var data = {};
	        data.configProduct = configProduct;
	        return deferred.resolve(data);
	      }
	      COSTCO.util.ajax({
	        url: url,
	        type: 'GET',
	        dataType: 'json',
	        done: function done(data, textStatus, jqXHR, options) {
	          // We'll set this in cache in case we want to use it elsewhere
	          if (data.configProduct) {
	            // If we returned with a configProduct, we cool
	            MembershipData.setConfigProduct(data);
	          } else {
	            // Otherwise, set this to empty and dont track this orderItemsId
	            data.configProduct = {};
	            MembershipData.setConfigProduct(data, true);
	          }
	          if (data.error) {
	            deferred.reject(data, textStatus, jqXHR, options);
	          }
	          deferred.resolve(data, textStatus, jqXHR, options);
	        },
	        fail: function fail(jqXHR, textStatus, errorThrown, options) {
	          deferred.reject(jqXHR, textStatus, errorThrown, options);
	        }
	      });
	      return deferred.promise();
	    },
	    /**
	     * Makes a call to the server to fetch the membership meta data. Stores
	     * it in sessionStorage and returns it with subsequent calls instead of
	     * making additional calls.
	     * @return {jQuery.Deferred} Returns a thenable promise that resolves the
	     *                                   membership meta data.
	     */
	    getMembershipData: function getMembershipData() {
	      var _this = this;
	
	      var membershipData = this._getMembershipData();
	      if (!$.isEmptyObject(membershipData)) {
	        return $.Deferred().resolve(membershipData);
	      }
	      return COSTCO.util.ajax({
	        url: COSTCO.util.makeUrl('/AjaxMembershipMetaDataView', {
	          pseudo: new Date().getTime()
	        }),
	        dataType: 'json'
	      }).then(function (data) {
	        // 	@KMED - COPY HOW WE HANDLE ERRORS FROM MEMBERSHIP APPLICATION
	        // 	<%-- Print Global errors --%>
	        // 	if (MembershipMetaData.payload.errorMessages.length > 0){
	        // 		for (var i = 0; i < MembershipMetaData.payload.errorMessages.length; ++i) {
	        // 			$('#crmMetaDataGlobalError').html(MembershipMetaData.payload.errorMessages[i]);
	        // 		}
	        // 		$('#crmMetaDataGlobalError').show();
	        // 		$('html, body').animate({ scrollTop: $('#crmMetaDataGlobalError') });
	        // 	}else{
	        // 		$('#crmMetaDataGlobalError').hide();
	        // 	}
	        // 	if(data.caller.usageRole != '01'){
	        // 		$('#digitalConnection').remove();
	        // 		$('#mailConnection').remove();
	        // 	}
	        //
	        //  @KMED - WE NEED TO DECOUPLE CITI STUFF. NEED TO FIGURE OUT
	        //  WHATS HAPPENING HERE
	        // 	COSTCO.util.updateCappJson();
	        // 	COSTCO.util.processCappLogic();
	        //
	        // 	@KMED - HERE WE SET AND RETURN
	        return _this.setMembershipData(data);
	      });
	    },
	    /**
	     * Sets the membership meta data in session storage.
	     * @param  {Object} data The membership meta data to set
	     * @return {Object}      Returns the membership meta data for chainable
	     *                               processing.
	     */
	    setMembershipData: function setMembershipData(data) {
	      var u = COSTCO.util;
	      if (data) {
	        u.setInSession('membershipData', data);
	      }
	      return data;
	    },
	    /**
	     * Private method used by "getMembershipData" to return the membership
	     * meta data.
	     * @return {[type]} [description]
	     */
	    _getMembershipData: function _getMembershipData() {
	      return COSTCO.util.getFromSession('membershipData');
	    },
	    /**
	     * If configProduct exists as part of the response, store it. Return
	     * the data for further processing. applicationTrackingCookie = orderItemsId
	     * @param  {Object} data        The application meta data
	     * @param  {Boolean} notTracking The flag to say 'dont use this orderItemsId'.
	     *                               If not included, will add property
	     *                               applicationTrackingCookie
	     * @return {Object}             The application meta data
	     */
	    setConfigProduct: function setConfigProduct(data, notTracking) {
	      var u = COSTCO.util;
	      if (data && data.configProduct) {
	        if (!notTracking) {
	          data.configProduct.applicationTrackingCookie = applicationTrackingCookie;
	        }
	        u.setInSession('configProduct', data.configProduct);
	      }
	      return data;
	    },
	    /**
	     * Gets the configProduct from the session storage
	     * @return {Object} The object representing the configProduct
	     */
	    getConfigProduct: function getConfigProduct() {
	      return COSTCO.util.getFromSession('configProduct');
	    }
	  };
	  if (typeof window.COSTCO === 'undefined') {
	    window.COSTCO = {};
	  }
	  window.COSTCO.MembershipData = MembershipData;
	  return MembershipData;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * @title addressForm.js: Feature level module
	 * @description Address utility module
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(14), __webpack_require__(17), __webpack_require__(15)], __WEBPACK_AMD_DEFINE_RESULT__ = function (address, addressVerification, preauthchargesmodal) {
		var CAddressForm = {
			addressVal: address,
			validationRulesApplied: false,
			// Set of rules used only for address validation
			// This method should be ran once with initialization
			validationRules: function validationRules() {
	
				if (!CAddressForm.validationRulesApplied) {
	
					$.validator.setDefaults({ ignore: ".ignoreHide" });
					$.validator.addMethod("companyrequiredcheck", function (value, element) {
						if ($('#isBDAppVar').val() == 'BD') {
							return value != "";
						} else {
							return true;
						}
					}, messages.ERR_INVALID_COMPANY);
					$.validator.addMethod("pobox", function (value, element) {
						if ($('#isBDAppVar').val() == 'BD') {
							var addressBookBool = typeof element.form.addressType[0] !== 'undefined' ? element.form.addressType[0].value == 'S' ? true : false : false;
							var poRegex = /^[^a-z]*(((num(ber)?|#) *\d+)|((box|bin|b)[-. \/\\]? *(num(ber)?|#)? *\d+)|((.*[^a-z])?p[ \.]? ?(o|0)[-. \/\\]? *-?((box|bin)|b|(num(ber)?|#)?\d+)([^a-z]|$))|(p(ost)? *(o(ff(ice)?)?)? *((box|bin)|b)? *(num(ber)?|#)? *\d+)|(p *-?\/?(o)? *-?box([^a-z]|$))|post office box)/i;
							var poCheck = element.form.addressType.value == 'S' || addressBookBool ? !poRegex.test(value) : true;
							return this.optional(element) || poCheck;
						} else {
							return true;
						}
					}, messages.ERR_INVALID_POBOX);
					$.validator.addMethod("notEqual", function (value, element, param) {
						return this.optional(element) || value != param;
					}, messages.ERR_INVALID_STATE);
					$.validator.addMethod("countryspecificpostalcodePassCountrySelectorModal", function (value, element) {
						var form = element.form;
						var country = $(form).find('[name=country]');
						if (country.val() === undefined) {
							return !COSTCO.CAddressForm.isUS({ input: element }) ? this.optional(element) || COSTCO.util.POSTAL_CODE_REGEX_CA.test($.trim(value)) : this.optional(element) || COSTCO.util.POSTAL_CODE_REGEX_US.test($.trim(value));
						}
						return country.val() != 'US' ? this.optional(element) || COSTCO.util.POSTAL_CODE_REGEX_CA.test($.trim(value)) : this.optional(element) || COSTCO.util.POSTAL_CODE_REGEX_US.test($.trim(value));
					}, messages.ERR_ENTER_ZIPCODE);
					$.validator.addMethod("hasvalidationerror", function (value, element) {
						return element.getAttribute('hasvalidationerror') == undefined || element.getAttribute('hasvalidationerror') == null || element.getAttribute('hasvalidationerror') == "false";
					}, messages.ERR_INVALID_STATE);
					$.validator.addMethod("validateAdditionalTerritories", function (value, element, param) {
						var form = element.form;
						var stateCode = $(form).find('[name=state]').val();
						var additionalBillingStatesCode = CAddressForm.getAdditionalBillingStates();
						if (wcs.isPharmacy === "true") {
							if (!additionalBillingStatesCode.includes(stateCode)) {
								return true;
							} else {
								return false;
							}
						}
						if (param == 'S') {
							if (!additionalBillingStatesCode.includes(stateCode)) {
								return true;
							} else {
								return false;
							}
						} else {
							return true;
						}
					}, messages.ERR_INVALID_STATE);
					$.validator.addMethod("validateCity", function (value, element) {
						var cityValidationRegex = new RegExp($('#cityValidationRegex').val());
						return value !== null && value !== '' ? cityValidationRegex.test(value.trim()) : true;
					}, messages.ERR_INVALID_CITY_NAME);
					$.validator.addMethod("email", function (value, element) {
						return (/^[_a-zA-Z0-9-+]+(\.[_a-zA-Z0-9-+]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,10})$/.test(value.toLowerCase())
						);
					}, messages.JS_VALID_EMAIL);
					$.validator.addMethod("phone", function (value, element) {
						if (value.startsWith("0") || value.startsWith("1")) {
							return false;
						}
						//Method phone is already used for Patient Insurance phone, when there is an address creation this overrides the old bind
						try {
							if (element && element.id === "insurancePhone") {
								return this.optional(element) || /\(?([0-9]{3})\)\s([0-9]{3})\2?([-]?)([0-9]{4})/.test(value);
							}
						} catch (e) {
							console.log(e);
							return true; //if element is empty , no validation required
						}
						return this.optional(element) || /^\(?\d{3}\)?[ -.]?\d{3}[ -.]?\d{4}$/.test(value);
					}, messages.ERR_INVALID_PHONE1);
					$.validator.addMethod("contactPhone", function (value, element) {
						if (value.startsWith("0") || value.startsWith("1")) {
							return false;
						}
						return this.optional(element) || /^\(?\d{3}\)?[ -.]?\d{3}[ -.]?\d{4}$/.test(value);
					}, messages.ERR_INVALID_PHONE1);
					/** STRY0157080 Require at least ONE alphabet in each of the name fields */
					$.validator.addMethod("firstNameValidation", function (value, element) {
						return COSTCO.util.ATLEAST_ONE_ALPHABET.test(value);
					}, messages.ERR_INVALID_FNAME);
					$.validator.addMethod("lastNameValidation", function (value, element) {
						return COSTCO.util.ATLEAST_ONE_ALPHABET.test(value);
					}, messages.ERR_INVALID_LNAME);
					/** SFSTRY0039312 Implement special characters restrictions for Company name as First and Last Name fields */
					$.validator.addMethod("companyNameValidation", function (value, element) {
						if ($('#isBDAppVar').val() == 'BD' && element.form.addressType.value != 'B') {
							return COSTCO.util.ATLEAST_ONE_ALPHABET.test(value);
						} else {
							return true;
						}
					}, messages.ERR_INVALID_COMPANY);
					CAddressForm.validationRulesApplied = true;
				}
			},
	
			/**
	   * Uses Jquery Mask plugin to format input. Use cleanVal() instead of val() to get unformatted value
	   */
			maskInput: function maskInput(template) {
				$(template).find('[name=phone]').unmask().mask('000-000-0000');
				$(template).find('#contactPhNo').unmask().mask('000-000-0000');
				$(template).find('#contactPhNo-inline').unmask().mask('000-000-0000');
				$(template).find('.phoneNumber').unmask().mask('000-000-0000');
	
				if (COSTCO.CAddressForm.isUS({ form: template })) {
					$(template).find('[name=postal]').unmask().mask('00000-0000');
				} else {
					$(template).find('[name=postal]').unmask().mask('S0S 0S0');
				}
			},
			/**
	   * Determine if the form or input is should be interpretted as US.
	   * In the case of a form, we look at the select[name=country]. In the case
	   * of a input, we use the data-country attribute to get the value of
	   * a designated select[name=country] which will have the US/CA value,
	   * otherwise we check the lang ID as a last resort.
	   * @param {object} elementsObj - OPTIONAL - Object with the structure
	   * of {form: formElement, input: inputElement}. Pass inputElement must 
	   * contain a data-attribute that maps to the country select to pull the value.
	   */
			isUS: function isUS(elementsObj) {
				var $form = elementsObj && elementsObj.form ? $(elementsObj.form) : COSTCO.CAddressForm.getForm();
				var $input = elementsObj && elementsObj.input ? $(elementsObj.input) : $('');
				var country = 'US';
	
				if ($input.data('country')) {
					// If passed an input, it needs to have a data-country attribute
					// that maps to the country select we want to interogate if we're
					// US or not.
					var countrySelectId = $input.data('country');
					country = $(countrySelectId).val();
				} else if ($form.find('[name=country]').val()) {
					// Interrogates the form to see if we have a select[name=country] 
					// to determine if US
					country = $form.find('[name=country]').val();
				} else {
					// Last resort is to use the lang ID
					if (COSTCO.util.getLangId() != -1) {
						country = 'CA';
					}
				}
	
				return country == 'US';
			},
	
			createAddressForm: function createAddressForm(obj) {
				var data;
				if (typeof obj === 'number') {
					var addressJson = address.getAddressJson(obj)[0];
					if (addressJson.length == 0) return '';
					data = addressJson[0];
				} else {
					data = obj;
				}
	
				return COSTCO.util.tmpl('tmpl_address_form', obj);
			},
			/**
	   * 
	   * Function used to setup the data and parameter to open the
	   * Address Form modal.
	   * 
	   * Param
	   * 	type		- 1 character denoting S for Shipping B for Billing
	   *  obj			- can be either address id or the address json object
	   *  orderItemId - order item id that we are trying to edit the address for
	   *  multiAddress	- whether or not the order is multiShipping address
	   * 
	   */
			editAddress: function editAddress(type, obj, orderItemId, multiAddress) {
				var data;
				if (typeof obj === 'number') {
					var addressJson = address.getAddressJson(obj, null, type)[0];
					data = addressJson;
				} else {
					data = obj;
				}
	
				if (data == null) {
					data = window['ajaxAddressObject_' + obj];
				}
	
				if (typeof addressOptions === 'undefined') {
					addressOptions = {};
				}
	
				if (typeof addressOptions.url === 'undefined') {
					addressOptions.url = '/AjaxAddressAddCmd';
				}
				//need to add mode parameter if url is AjaxManageAddressCmd and doesn't have mode parameter already
				else if (addressOptions.url.indexOf('AjaxManageAddressCmd') > -1 && addressOptions.url.indexOf('mode') < 0) {
						addressOptions.url = COSTCO.util.makeUrl(addressOptions.url, { mode: 'UPDATE' });
					}
	
				if (multiAddress) {
					addressOptions.orderItemId = orderItemId;
					addressOptions.multiAddress = multiAddress;
				}
				//National delivery UX change to remove Terms and Condition Modal in Address book for BD US
				if ($('#isBDAppVar').val() == 'BD' && type == 'S' && !COSTCO.util.isNdEnabled()) {
					CAddressForm.showBusinessDeliveryQuestionnaireModal(type, data, 'edit', addressOptions);
				} else {
					CAddressForm.openAddressAddModal(type, data, 'edit', addressOptions);
				}
			},
	
			editAddress_v2: function editAddress_v2(type, obj, orderItemId, multiAddress) {
				var data;
				if (typeof obj === 'number') {
					var addressJson = address.getAddressJson(obj, null, type)[0];
					data = addressJson;
				} else {
					data = obj;
				}
	
				if (data == null) {
					data = window['ajaxAddressObject_' + obj];
				}
	
				if (typeof addressOptions === 'undefined') {
					addressOptions = {};
				}
	
				if (typeof addressOptions.url === 'undefined') {
					addressOptions.url = '/AjaxAddressAddCmd';
				}
				//need to add mode parameter if url is AjaxManageAddressCmd and doesn't have mode parameter already
				else if (addressOptions.url.indexOf('AjaxManageAddressCmd') > -1 && addressOptions.url.indexOf('mode') < 0) {
						addressOptions.url = COSTCO.util.makeUrl(addressOptions.url, { mode: 'UPDATE' });
					}
	
				if (multiAddress) {
					addressOptions.orderItemId = orderItemId;
					addressOptions.multiAddress = multiAddress;
				}
	
				if ($('#isBDAppVar').val() == 'BD' && type == 'S') {
					CAddressForm.showBusinessDeliveryQuestionnaireModal_v2(type, data, 'edit', addressOptions);
				} else {
					CAddressForm.openAddressAddModal_v2(type, data, 'edit', addressOptions);
				}
			},
			/**
	   * Opens an edit address modal directly on the page (without first opening choose address modal).
	   * 
	   * This is because regularly the address batch retrieve is being invoked on the choose address modal opening
	   */
			directEditAddress: function directEditAddress(type, addressId, orderItemId, multiAddress) {
				if (typeof COSTCO.util == 'undefined' || COSTCO.util.addresses.length == 0) {
					COSTCO.util.getAddressBatchPage(type, 'FIRSTNAME', 'ASC', '96', function (data) {
						CAddressForm.editAddress(type, addressId, orderItemId, multiAddress);
					});
				} else {
					CAddressForm.editAddress(type, addressId, orderItemId, multiAddress);
				}
			},
	
			createNewAddress: function createNewAddress(type, orderItemId, multiAddress) {
	
				if (typeof addressOptions === 'undefined') {
					addressOptions = {};
				}
				if (typeof orderItemId !== 'undefined' && orderItemId > 0) {
					addressOptions.orderItemId = orderItemId;
				}
				if (typeof addressOptions.url === 'undefined') {
					addressOptions.url = '/AjaxAddressAddCmd';
				}
				//need to add mode parameter if url is AjaxManageAddressCmd and doesn't have mode parameter already
				else if (addressOptions.url.indexOf('AjaxManageAddressCmd') > -1 && addressOptions.url.indexOf('mode') < 0) {
						addressOptions.url = COSTCO.util.makeUrl(addressOptions.url, { mode: 'ADD' });
					}
				//National delivery UX change to remove Terms and Condition Modal in Address book for BD US
				if ($('#isBDAppVar').val() == 'BD' && type == 'S' && !COSTCO.util.isNdEnabled()) {
					CAddressForm.showBusinessDeliveryQuestionnaireModal(type, undefined, 'add', addressOptions);
				} else {
					CAddressForm.openAddressAddModal(type, undefined, 'add', addressOptions);
				}
			},
	
			createNewAddress_v2: function createNewAddress_v2(type, orderItemId, multiAddress) {
	
				if (typeof addressOptions === 'undefined') {
					addressOptions = {};
				}
				if (typeof orderItemId !== 'undefined' && orderItemId > 0) {
					addressOptions.orderItemId = orderItemId;
				}
				if (typeof addressOptions.url === 'undefined') {
					addressOptions.url = '/AjaxAddressAddCmd';
				}
				//need to add mode parameter if url is AjaxManageAddressCmd and doesn't have mode parameter already
				else if (addressOptions.url.indexOf('AjaxManageAddressCmd') > -1 && addressOptions.url.indexOf('mode') < 0) {
						addressOptions.url = COSTCO.util.makeUrl(addressOptions.url, { mode: 'ADD' });
					}
	
				if ($('#isBDAppVar').val() == 'BD' && type == 'S') {
					CAddressForm.showBusinessDeliveryQuestionnaireModal_v2(type, undefined, 'add', addressOptions);
				} else {
					CAddressForm.openAddressAddModal_v2(type, undefined, 'add', addressOptions);
				}
			},
	
			createInline: function createInline(selector, type, checkoutPage, multi) {
	
				var html = COSTCO.CAddressForm.createHtml(type, undefined, 'add', 'inline', checkoutPage, multi);
	
				$(selector).html(html);
	
				COSTCO.util.getAddressBatchPage(type, 'FIRSTNAME', 'ASC', '96', function (data) {
	
					if (data.totalRecords > 0) {
						COSTCO.CAddressForm.createChooseLink(selector, type);
					} else {
						$(selector).find('#select-saved').addClass('hide');
					}
				});
			},
	
			createInline_v2: function createInline_v2(selector, type, checkoutPage, multi, smsNotificationData) {
				var html;
				if (typeof smsNotificationData !== 'undefined') {
					html = COSTCO.CAddressForm.createHtml_v2(type, undefined, 'add', 'inline', checkoutPage, multi, null, smsNotificationData);
				} else {
					html = COSTCO.CAddressForm.createHtml_v2(type, undefined, 'add', 'inline', checkoutPage, multi);
				}
	
				$(selector).html(html);
	
				COSTCO.util.getAddressBatchPage(type, 'FIRSTNAME', 'ASC', '96', function (data) {
	
					if (data.totalRecords > 0) {
						COSTCO.CAddressForm.createChooseLink(selector, type);
					} else {
						$(selector).find('#select-saved').addClass('hide');
					}
				});
	
				var isPreventSameAddressEnabled = $('input[name="isPreventSameAddressEnabled"]');
	
				if (isPreventSameAddressEnabled.length > 0 && isPreventSameAddressEnabled.val()) {
					$('body').unbind("costco.address.error").bind("costco.address.error", function (event, error) {
						if (typeof error != 'undefined') {
							if (error == '_ERR_INVALID_SHIP_ADDR') {
								COSTCO.CAddress.closeModal();
								$('#notification-message').html(messages.ERR_SHIP_ADDR_SAME_AS_WHS_ADDR).addClass('critical-notification');
								var formId = $('#address-modal-inline');
								var addressField = '#S_address1Id';
								COSTCO.dialog.sameAddressValidation(formId, addressField);
							}
						}
					});
				}
			},
	
			createChooseLink: function createChooseLink(selector, type) {
	
				var chooseLink = "<a href=\"javascript:void(0)\" onclick=\"COSTCO.CAddressSelectionDialog.showAddressSelectionDialog(null,'{0}');return false;\">{1}</a>";
	
				var html = COSTCO.util.messageFormat(chooseLink, type, addressInputLabels.choosesaved);
	
				$(selector).find('#select-saved div').html(html);
			},
	
			insertSmsNotificationAgreement: function insertSmsNotificationAgreement(orderId, orderSmsPhone) {
	
				var check = orderSmsPhone.length > 0 ? 'checked' : '';
				if (orderSmsPhone.length == 10) {
					// Insert '-' to avoid onchange event fired on tab and other keys which don't change input field value. 
					var formatted = orderSmsPhone.substr(0, 3) + '-' + orderSmsPhone.substr(3, 3) + '-' + orderSmsPhone.substr(6, 4);
					orderSmsPhone = formatted;
				}
				var hide = orderSmsPhone.length > 0 ? '' : 'hidden';
				var data = {
					orderId: orderId,
					smsPhone: orderSmsPhone,
					check: check,
					hide: hide
				};
				var template = COSTCO.util.tmpl('tmpl_sms_notification_agreement_block', data);
				$('.smsNotificationBlock').html(template);
			},
	
			insertSmsNotificationAgreement_v2: function insertSmsNotificationAgreement_v2(arg, smsPhoneNumber, updateAction, checkCheckbox) {
				var check = smsPhoneNumber.length > 0 ? 'checked' : '';
				if (smsPhoneNumber.length == 10) {
					// Insert '-' to avoid onchange event fired on tab and other keys which don't change input field value. 
					var formatted = smsPhoneNumber.substr(0, 3) + '-' + smsPhoneNumber.substr(3, 3) + '-' + orderSmsPhone.substr(6, 4);
					smsPhoneNumber = formatted;
				}
				var hide = smsPhoneNumber.length > 0 ? '' : 'hidden';
				var data = {
					arg: arg,
					smsPhoneNumber: smsPhoneNumber,
					updateAction: updateAction,
					checkCheckbox: checkCheckbox,
					hide: hide
				};
				var template = COSTCO.util.tmpl('tmpl_sms_notification_agreement_block_v2', data);
				$('.smsNotificationBlock').html(template);
			},
	
			createHtml: function createHtml(type, addressObj, mode, modaltypeOverride, checkoutPage, multi, error) {
	
				var isDeriveCityStateEnabled = costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED && $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === "true";
	
				var stateProvList = address.getStateProvJson();
				COSTCO.CAddressForm.addressVal = stateProvList;
				var stateOptions = CAddressForm.getStateOptions(stateProvList, type, addressObj);
				var countryOptions = CAddressForm.getCountryOptions(type);
	
				var data = addressInputLabels;
	
				var headerLabels = address.getHeaderLabels(type, mode);
	
				data.primaryMessage = headerLabels.primaryMessage;
				var modaltype = 'modal';
				if (typeof modaltypeOverride !== 'undefined') {
					modaltype = modaltypeOverride;
				}
	
				var template = COSTCO.util.tmpl('tmpl_address_form_' + modaltype, data);
				template = $(template);
	
				if (!isDeriveCityStateEnabled) {
					template.find('.stateprov-select').append(stateOptions);
				}
	
				template.find('.country-select').append(countryOptions).change(function () {
	
					var country = $(this).val();
					var stateOptions = CAddressForm.getStateOptions(stateProvList, type, { country: country });
					if (!isDeriveCityStateEnabled) {
						template.find('.stateprov-select').empty().append(stateOptions);
					}
					updateCountryLabels(country);
					CAddressForm.maskInput(template);
				});
	
				if (typeof error != 'undefined') {
					if (error == '_ERR_INVALID_SHIP_ADDR') {
						template.append('<input type="hidden" name="invalid-ship-addr" value="true" />');
					} else {
						template.find('.error').html(error);
					}
				}
	
				var updateCountryLabels = function updateCountryLabels(country) {
					if (country == 'US') {
						template.find('label[for="postalId"]').html(data.uspostallabel);
						template.find('label[for="stateId"]').html(data.usstatelabel);
					} else {
						template.find('label[for="postalId"]').html(data.capostallabel);
						template.find('label[for="stateId"]').html(data.castatelabel);
					}
				};
	
				if (addressObj) {
					updateCountryLabels(addressObj.country);
				}
	
				template.find('[name=postal]').on('input', { modaltype: modaltype }, function (event) {
					var value = $(this).val();
					var region = COSTCO.util.isUsOrCaZipCode();
					if ($('#isGeocodeService').val() != "true" && value != null && value != "" && value.trim().length > 4) {
						COSTCO.CAddress.bingCityState(this, '[name=city]', '[name=state]');
						if (checkoutPage == 'shipping' && event.data.modaltype == 'inline') {
							if ($('#isBDAppVar').val() != 'BD') {
								COSTCO.ScheduledDeliverable.handleZipCodeChange(value);
							}
						}
					}
					if ($('#isGeocodeService').val() === "true" && value != null && value != "" && value.trim().length === value.length) {
						if (region && COSTCO.util.POSTAL_CODE_REGEX_US.test(value.trim())) {
							COSTCO.CAddress.geocodeApiCityState(this, '[name=city]', '[name=state]');
						}
						if (!region) {
							if (value.trim().length === 3 && /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1}/.test(value.trim()) || value.trim().length === 7 && COSTCO.util.POSTAL_CODE_REGEX_CA.test(value.trim())) COSTCO.CAddress.geocodeApiCityState(this, '[name=city]', '[name=state]');
						}
						if (checkoutPage == 'shipping' && event.data.modaltype == 'inline') {
							if ($('#isBDAppVar').val() != 'BD') {
								COSTCO.ScheduledDeliverable.handleZipCodeChange(value);
							}
						}
					}
				});
	
				if (type == 'B') {
					template.find('#country-row').removeClass('hide');
				}
				if (mode == 'add') {
					template.find('[name=email]').val($('#defaultEmail').val());
				}
				if (type == 'S') {
					template.find('#delIntsr-row').removeClass('hide');
					template.find('#contactName').removeClass('ignoreHide');
					template.find('#contactPhNo').removeClass('ignoreHide');
				}
	
				if (mode == 'edit') {
					template.find('.address-checkboxes').hide();
					if (addressObj.isPrimary == '1' && type == 'S') {
						template.find(".defaultWarning").removeClass('hide');
					} else {
						template.find(".defaultWarning").addClass('hide');
					}
				}
	
				/*
	    * Show the default shipping warning
	    */
	
				var updateWarning = function updateWarning(modaltype) {
	
					if (template.find('#set-default-' + modaltype).prop('checked')) {
						template.find(".defaultWarning").removeClass('hide');
					} else {
						template.find(".defaultWarning").addClass('hide');
					}
				};
	
				if (mode == 'add') {
					if (type == 'S') {
	
						/* Below click binding function was added to the set-default checkbox to toggle setAsDefaultShippingAddress hidden field 
	      * on the page. This hidden field has to change based on the checkbox status so that page submit reads the right value to
	      * set on IsPrimary field of address record. */
						template.find('#set-default-' + modaltype).bind("click", function () {
							if ($('#set-default-' + modaltype).is(':checked')) {
								$('#NewAddressSingleShippingForm input[name=setAsDefaultShippingAddress]').val('true');
							} else {
								$('#NewAddressSingleShippingForm input[name=setAsDefaultShippingAddress]').val('false');
							}
						});
	
						template.find('#set-default-' + modaltype).click(function () {
							updateWarning(modaltype);
						});
					}
	
					var detectedCheckoutPage = typeof checkoutPage !== 'undefined' ? checkoutPage : window.checkoutPage;
	
					if (detectedCheckoutPage === 'shipping' || detectedCheckoutPage === 'multi-shipping' || detectedCheckoutPage === 'payment') {
						template.find('#set-default-' + modaltype).prop('checked', modaltype === 'inline');
					} else if (detectedCheckoutPage === 'review' || detectedCheckoutPage === 'live-tickets') {
						template.find('#set-default-' + modaltype).prop('checked', false);
					}
					updateWarning(modaltype);
				}
	
				template.find('#set-default-' + modaltype).click(function () {
					if ($(this).prop('checked')) {
						template.find('#save-address-' + modaltype).prop('checked', true);
					}
					if (checkoutPage == 'shipping') {
						updateWarning(modaltype);
					}
				});
	
				template.find('#save-address-' + modaltype).click(function () {
					if (!$(this).prop('checked')) {
						$('#set-default-' + modaltype).prop('checked', false);
					}
					if (checkoutPage == 'shipping') {
						updateWarning(modaltype);
					}
				});
	
				if (typeof addressObj !== 'undefined') {
					CAddressForm.populateAddressModal(template, addressObj, modaltype);
				} else {
					template.find('[name=addressType]').val(type);
				}
	
				if ((checkoutPage === 'payment' || checkoutPage === 'review' || checkoutPage === 'live-tickets') && type == 'B' && modaltype == 'inline') {
					template.find('#address-same-as-ship').removeClass('hide');
				}
	
				if (type == 'B') {
					template.find(".defaultWarning").addClass('hide');
				}
	
				CAddressForm.maskInput(template);
	
				return template;
			},
			// returns id of matching template element, or null
			findTemplateId_v2: function findTemplateId_v2(type, templateName, modalType) {
				var result = null;
				modalType = modalType == null || modalType == undefined || modalType == '' ? '' : '_' + modalType;
				var template = $('#tmpl_' + type + '_' + templateName + modalType + '_v2');
				if (template.length == 0) {
					// look for template with the "_gift" suffix
					template = $('#tmpl_' + type + '_' + templateName + modalType + '_gift_v2');
				}
				if (template.length == 0) {
					var orderItemInputs = $('input[name^="orderItem_"]');
					for (var i = 0; i < orderItemInputs.length && template.length == 0; i++) {
						var orderItemId = orderItemInputs.get(i).value;
						// look for template with the orderItemId
						template = $('#tmpl_' + type + '_' + templateName + modalType + ('_' + orderItemId) + '_v2');
						if (template.length == 0) {
							// look for template with the orderItemId and the "_gift" suffix
							template = $('#tmpl_' + type + '_' + templateName + modalType + ('_' + orderItemId) + '_gift_v2');
						}
					}
				}
				if (template.length == 1) {
					result = template.attr('id');
				}
				return result;
			},
	
			createHtml_v2: function createHtml_v2(type, addressObj, mode, modaltypeOverride, checkoutPage, multi, error, smsNotificationData) {
	
				var stateProvList = address.getStateProvJson();
	
				var isDeriveCityStateEnabled = costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED && $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === "true";
	
				var stateOptions = CAddressForm.getStateOptions(stateProvList, type, addressObj);
				var countryOptions = CAddressForm.getCountryOptions(type);
	
				var addrType = typeof addressObj == 'undefined' ? type : addressObj.addressType;
	
				var data = addressInputLabels;
				if (typeof smsNotificationData !== 'undefined') {
					data.smsNotificationData = smsNotificationData;
					data.showSMSNotificationCheckbox = true;
				} else {
					data.smsNotificationData = {};
					data.showSMSNotificationCheckbox = false;
				}
				var headerLabels = address.getHeaderLabels(type, mode);
	
				data.primaryMessage = headerLabels.primaryMessage;
	
				var modaltype = 'modal';
				if (typeof modaltypeOverride !== 'undefined') {
					modaltype = modaltypeOverride;
				}
	
				var templateId = CAddressForm.findTemplateId_v2(type, 'address_form', modaltype);
				var template = COSTCO.util.tmpl(templateId, data);
	
				template = $(template);
				if (!data.showSMSNotificationCheckbox) {
					template.find('#smsNotificationCheckBox').remove();
				}
	
				if (!isDeriveCityStateEnabled) {
					template.find('.stateprov-select').append(stateOptions);
				}
	
				template.find('.country-select').append(countryOptions).change(function () {
	
					var country = $(this).val();
					var stateOptions = CAddressForm.getStateOptions(stateProvList, type, { country: country });
					if (!isDeriveCityStateEnabled) {
						template.find('.stateprov-select').empty().append(stateOptions);
					}
					template.find('#city-state').addClass('hide');
					template.find('input[id=' + addrType + '_postalId]').val('');
					template.find('label[for=' + addrType + '_postalId]').removeClass('active');
					updateCountryLabels(country);
					CAddressForm.maskInput(template);
				});
	
				if (typeof error != 'undefined') {
					if (error == '_ERR_INVALID_SHIP_ADDR') {
						template.append('<input type="hidden" name="invalid-ship-addr" value="true" />');
						template.find('.error').html(messages.ERR_SHIP_ADDR_SAME_AS_WHS_ADDR).addClass('critical-notification cds-u-space-mb-md');
					} else {
						template.find('.error').html(error);
					}
				}
	
				var updateCountryLabels = function updateCountryLabels(country) {
					if (country == 'US') {
						template.find('label[for="' + addrType + '_postalId"]').html(data.uspostallabel);
						template.find('label[for="' + addrType + '_stateId"]').html(data.usstatelabel);
						template.find('label[id="zip-info-text"]').html(data.usZipInfoText);
					} else {
						template.find('label[for="' + addrType + '_postalId"]').html(data.capostallabel);
						template.find('label[for="' + addrType + '_stateId"]').html(data.castatelabel);
						template.find('label[id="zip-info-text"]').html(data.caZipInfoText);
					}
				};
	
				if (addressObj) {
					updateCountryLabels(addressObj.country);
				}
	
				template.find('[name=postal]').on('input', { modaltype: modaltype }, function (event) {
					var value = $(this).val();
					var region = COSTCO.util.isUsOrCaZipCode();
					if ($('#isGeocodeService').val() != "true" && value != null && value != "" && value.trim().length > 4) {
						COSTCO.CAddress.bingCityState(this, '[name=city]', '[name=state]');
						if (checkoutPage == 'shipping' && event.data.modaltype == 'inline') {
							if ($('#isBDAppVar').val() != 'BD') {
								COSTCO.ScheduledDeliverable.handleZipCodeChange(value);
							}
						}
					}
					if ($('#isGeocodeService').val() === "true" && value != null && value != "" && value.trim().length === value.length) {
						if (region && COSTCO.util.POSTAL_CODE_REGEX_US.test(value.trim())) {
							COSTCO.CAddress.geocodeApiCityState(this, '[name=city]', '[name=state]');
						}
						if (!region) {
							if (value.trim().length === 3 && /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1}/.test(value.trim()) || value.trim().length === 7 && COSTCO.util.POSTAL_CODE_REGEX_CA.test(value.trim())) {
								COSTCO.CAddress.geocodeApiCityState(this, '[name=city]', '[name=state]');
							}
						}
						if (checkoutPage == 'shipping' && event.data.modaltype == 'inline') {
							if ($('#isBDAppVar').val() != 'BD') {
								COSTCO.ScheduledDeliverable.handleZipCodeChange(value);
							}
						}
					}
				});
				if (type == 'B') {
					template.find('#country-row').removeClass('hide');
				}
				if (mode == 'add') {
					template.find('[name=email]').val($('#defaultEmail').val());
				}
				if (type == 'S') {
					template.find('#delIntsr-row').removeClass('hide');
					template.find('#contactName').removeClass('ignoreHide');
					template.find('#contactPhNo').removeClass('ignoreHide');
					$('#contact-information-phone').css('padding-left', '0');
				}
	
				if (mode == 'edit') {
					if (addressObj.addressType !== 'T') {
						template.find('#save-to-address-book').hide();
					}
					if (addressObj.isPrimary == '1') {
						template.find('#set-default-address').hide();
					}
					if (addressObj.isPrimary == '1' && type === 'S') {
						template.find(".defaultWarning").show();
					} else {
						template.find(".defaultWarning").hide();
					}
					if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE === true) {
						if (template.find('#save-to-address-book').is(':hidden') === true && template.find('#set-default-address').is(':hidden') === true) {
							template.find('.checkbox-separator').addClass('hide');
						}
					}
				}
	
				/*
	    * Show the default shipping warning
	    */
	
				var updateWarning = function updateWarning(modaltype) {
	
					if (template.find('#set-default-' + modaltype).prop('checked')) {
						template.find(".defaultWarning").removeClass('hide');
					} else {
						template.find(".defaultWarning").addClass('hide');
					}
				};
	
				if (mode == 'add') {
					if (type == 'S') {
	
						/* Below click binding function was added to the set-default checkbox to toggle setAsDefaultShippingAddress hidden field 
	      * on the page. This hidden field has to change based on the checkbox status so that page submit reads the right value to
	      * set on IsPrimary field of address record. */
						template.find('#set-default-' + modaltype).bind("click", function () {
							if ($('#set-default-' + modaltype).is(':checked')) {
								$('#NewAddressSingleShippingForm input[name=setAsDefaultShippingAddress]').val('true');
							} else {
								$('#NewAddressSingleShippingForm input[name=setAsDefaultShippingAddress]').val('false');
							}
						});
	
						template.find('#set-default-' + modaltype).click(function () {
							updateWarning(modaltype);
						});
					}
	
					var detectedCheckoutPage = typeof checkoutPage !== 'undefined' ? checkoutPage : window.checkoutPage;
	
					if (detectedCheckoutPage === 'multi-shipping') {
						template.find('#set-default-' + modaltype).prop('checked', modaltype === 'inline');
					} else if (detectedCheckoutPage === 'review') {
						template.find('#set-default-' + modaltype).prop('checked', false);
					}
					updateWarning(modaltype);
				}
	
				template.find('#set-default-' + modaltype).click(function () {
					if ($(this).prop('checked')) {
						template.find('#save-address-' + modaltype).prop('checked', true);
						$('#set-default-' + modaltype).prop('value', true);
						$('.defaultWarning.kb-OOS-banner').show();
					} else {
						$('#set-default-' + modaltype).prop('value', false);
						$('.defaultWarning.kb-OOS-banner').hide();
					}
				});
	
				template.find('#save-address-' + modaltype).click(function () {
					if (!$(this).prop('checked')) {
						$('#set-default-' + modaltype).prop('checked', false);
						$('.defaultWarning.kb-OOS-banner').hide();
					}
					if (checkoutPage == 'shipping') {
						updateWarning(modaltype);
					}
				});
	
				if (typeof addressObj !== 'undefined') {
					CAddressForm.populateAddressModal_v2(template, addressObj, modaltype);
				} else {
					template.find('[name=addressType]').val(type);
				}
	
				if (type === 'B' && modaltype === 'inline') {
					template.find('#address-same-as-ship').removeClass('hide');
				}
	
				if (type == 'B') {
					template.find(".defaultWarning").addClass('hide');
				}
	
				CAddressForm.maskInput(template);
	
				//SFSTRY0015679 make company name mandatory in USBD for Local Business Delivery
				var isLocalBusinessDelivery = typeof shipModeLocalND !== 'undefined' && ($("input[name='deliveryMethod']:checked").val() == shipModeLocalND || $("input[name='deliveryMethod']:checked").val() == shipModeLocal);
				if ($('#isBDAppVar').val() === 'BD') {
					//SFSTRY0020930 - check if xapp flag for company name mandate is enabled
					var isCompanyMandateEnabled = $("#isCompanyMandateEnabled").val();
					if (wcs.storeId === '11303' || wcs.storeId === '11301' && isLocalBusinessDelivery && isCompanyMandateEnabled === "true") {
						$(template).find('[name=company]').parent().parent().removeClass('hide');
						$(template).find('#showCompanyField').parent().addClass('hide');
					}
				}
	
				return template;
			},
	
			populateAddressModal: function populateAddressModal(template, addressObject, modaltype) {
	
				template.find('[name=addressId]').val(addressObject['id']);
				template.find('#firstId').val(addressObject['first']);
				template.find('#lastId').val(addressObject['last']);
				var companyName = COSTCO.util.get_decoded_html(addressObject['company']);
				if (companyName != undefined && companyName != "undefined" && companyName != "") {
					template.find('#companyId').val(companyName);
				} else {
					template.find('#companyId').val("");
				}
				template.find('[name=country]').val(addressObject['country']);
				template.find('[name=address1]').val(addressObject['line1']);
				template.find('[name=address2]').val(addressObject['line2']);
				template.find('[name=postal]').val(addressObject['zip']);
	
				if (costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED && $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === "true") {
					var editAddrCity = addressObject['city'];
					var editAddrState = addressObject['state'];
					var postalField = template.find('[name=postal]');
					COSTCO.CAddress.geocodeApiCityState(postalField, '[name=city]', '[name=state]', editAddrCity, editAddrState);
				} else {
					template.find('[name=city]').val(addressObject['city']);
					template.find('[name=state]').val(addressObject['state']);
					template.find('#city-state').removeClass('hide');
				}
	
				if (addressObject['phone'] != undefined && addressObject['phone'] != "") {
					if ($('#isBDAppVar').val() == 'BD') {
						template.find('#phoneId').val(addressObject['phone'].split(/EXT.|x/g)[0]);
						var extension = addressObject['phone'].split(/EXT.|x/g)[1];
						if (extension) {
							template.find('[name=ext1]').val(extension.trim());
						}
					} else {
						template.find('#phoneId').val(addressObject['phone'].split('x')[0]);
						template.find('[name=ext1]').val(addressObject['phone'].split('x')[1]);
					}
				} else {
					template.find('#phoneId').val(addressObject['phone']);
					template.find('[name=ext1]').val(addressObject['phone']);
				}
				template.find('[name=nickname]').val(addressObject['nickname']);
				template.find('[name=email]').val(addressObject['email']);
				template.find('[name=addressType]').val(addressObject.addressType);
				template.find('[name=addressId]').val(addressObject.id);
				if (addressObject['deliveryInstructions']) {
					var deliveryInst = COSTCO.util.get_decoded_html(addressObject['deliveryInstructions']);
				} else if (addressObject['deliveryInst']) {
					var deliveryInst = COSTCO.util.get_decoded_html(addressObject['deliveryInst']);
				}
				template.find('[name=deliveryInstructions]').val(deliveryInst);
				template.find('[name=contactName]').val(addressObject['contactName']);
				template.find('[name=contactPhone]').val(addressObject['contactPhNo']);
	
				if (addressObject.addressType != 'T') {
					template.find('#save-address-' + modaltype).prop('checked', true);
				}
	
				if (addressObject.isPrimary == '1') {
					template.find('#set-default-' + modaltype).prop('checked', true);
				}
	
				if (addressObject.isPrimary === '1' && addressObject.addressType === 'S' && typeof checkoutPage !== 'undefined' && checkoutPage === 'shipping') {
					template.find('.defaultWarning').removeClass('hide');
				}
				$(template).find('#phoneId').unmask().mask('000-000-0000');
			},
	
			populateAddressModal_v2: function populateAddressModal_v2(template, addressObject, modaltype) {
	
				template.find('[name=addressId]').val(addressObject['id']);
	
				template.find('[name=firstModal]').val(addressObject['first']);
				template.find('label[for="' + addressObject.addressType + '_firstId"]').addClass('active');
	
				template.find('[name=lastModal]').val(addressObject['last']);
				template.find('label[for="' + addressObject.addressType + '_lastId"]').addClass('active');
	
				var companyName = COSTCO.util.get_decoded_html(addressObject['company']);
				if (companyName !== undefined && companyName !== "undefined" && companyName !== "") {
					template.find('#' + addressObject.addressType + '_companyId').val(companyName);
					template.find('label[for="' + addressObject.addressType + '_companyId"]').addClass('active');
					COSTCO.CAddressForm.showInputFiled(template.find('#showCompanyField'));
				} else {
					template.find('#' + addressObject.addressType + '_companyId').val('');
				}
				template.find('[name=country]').val(addressObject['country']);
				template.find('label[for="' + addressObject.addressType + '_countryId"]').addClass('active');
	
				template.find('[name=address1]').val(addressObject['line1']);
				template.find('label[for="' + addressObject.addressType + '_address1Id"]').addClass('active');
	
				if (addressObject['line2'] !== undefined && addressObject['line2'] !== "undefined" && addressObject['line2'] !== "") {
					template.find('[name=address2]').val(addressObject['line2']);
					template.find('label[for="' + addressObject.addressType + '_address2Id"]').addClass('active');
					COSTCO.CAddressForm.showInputFiled(template.find('#showAptField'));
				} else {
					template.find('[name=address2]').val('');
				}
	
				template.find('[name=postal]').val(addressObject['zip']);
				template.find('label[for="' + addressObject.addressType + '_postalId"]').addClass('active');
	
				if (costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED && $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === "true") {
					var editAddrCity = addressObject['city'];
					var editAddrState = addressObject['state'];
					var postalField = template.find('[name=postal]');
					COSTCO.CAddress.geocodeApiCityState(postalField, '[name=city]', '[name=state]', editAddrCity, editAddrState);
				} else {
					template.find('[name=city]').val(addressObject['city']);
					template.find('[name=state]').val(addressObject['state']);
				}
	
				template.find('label[for="' + addressObject.addressType + '_cityId"]').addClass('active');
				template.find('label[for="' + addressObject.addressType + '_stateId"]').addClass('active');
	
				template.find('#city-state').removeClass('hide');
	
				if (addressObject['phone'] != undefined && addressObject['phone'] != "") {
					if ($('#isBDAppVar').val() == 'BD') {
						template.find('[name=phone]').val(addressObject['phone'].split(/EXT.|x/g)[0]);
						template.find('label[for="' + addressObject.addressType + '_phoneId"]').addClass('active');
						var extension = addressObject['phone'].split(/EXT.|x/g)[1];
						if (extension) {
							template.find('[name=ext1]').val(extension.trim());
							template.find('label[for="ext1"]').addClass('active');
						}
					} else {
						template.find('[name=phone]').val(addressObject['phone'].split('x')[0]);
						template.find('label[for="' + addressObject.addressType + '_phoneId"]').addClass('active');
						template.find('[name=ext1]').val(addressObject['phone'].split('x')[1]);
					}
				} else {
					template.find('[name=phone]').val(addressObject['phone']);
					template.find('[name=ext1]').val(addressObject['phone']);
				}
				template.find('[name=nickname]').val(addressObject['nickname']);
	
				template.find('[name=email]').val(addressObject['email']);
				template.find('label[for="' + addressObject.addressType + '_emailId"]').addClass('active');
	
				template.find('[name=addressType]').val(addressObject.addressType);
				template.find('[name=addressId]').val(addressObject.id);
				template.find('[name=deliveryInstructions]').val(addressObject['deliveryInstructions']);
				if (addressObject['deliveryInstructions'] != undefined && addressObject['deliveryInstructions'].length > 0) {
					template.find('label[for=deliveryInstructions-modal]').addClass('active');
				}
				template.find('[name=contactName]').val(addressObject['contactName']);
				if (addressObject['contactName'] != undefined && addressObject['contactName'].length > 0) {
					template.find('label[for=contactName]').addClass('active');
				}
				template.find('[name=contactPhone]').val(addressObject['contactPhNo']);
				if (addressObject['contactPhNo'] != undefined && addressObject['contactPhNo'].length > 0) {
					template.find('label[for=contactPhNo]').addClass('active');
				}
	
				if (addressObject.addressType != 'T') {
					template.find('#save-address-' + modaltype).prop('checked', true);
				}
	
				if (addressObject.isPrimary == '1') {
					template.find('#set-default-' + modaltype).prop('checked', true);
				}
	
				if (addressObject.isPrimary === '1' && addressObject.addressType === 'S' && typeof checkoutPage !== 'undefined' && checkoutPage === 'shipping') {
					template.find('.defaultWarning').removeClass('hide');
				}
	
				if (addressObject === '') {
					COSTCO.CAddressForm.restoreLabelsAndHiddenFieldsForEmptyAddressObject(template);
				}
				template.find('#' + addressObject.addressType + '_phoneId').unmask().mask('000-000-0000');
	
				if (template.find('#phoneId').length > 0) {
					$(template).find('#phoneId').unmask().mask('000-000-0000');
				}
			},
	
			restoreLabelsAndHiddenFieldsForEmptyAddressObject: function restoreLabelsAndHiddenFieldsForEmptyAddressObject(template) {
				template.find('#city-state').addClass('hide');
				template.find('label').each(function () {
					if ($(this).hasClass("active")) {
						$(this).removeClass("active");
					}
				});
				COSTCO.CAddressForm.hideInputFiled(template.find('#showAptField'));
				COSTCO.CAddressForm.hideInputFiled(template.find('#showCompanyField'));
			},
	
			/**
	   * function that populates address form with given address
	   * @param input
	   * 			input address form that needs to be populated
	   * @param addressId
	   * 			address that will be populated in address form
	   * @param modaltype
	   * 			param that determines if form is modal or inline
	   */
			populateAddressFormWithAddressData: function populateAddressFormWithAddressData(input, addressId, modaltype) {
	
				var data = '';
				if (input.checked && addressId !== '') {
					data = window['ajaxAddressObject_' + addressId];
					delete data['id'];
					delete data['nickname'];
					if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE === false) {
						data.isPrimary = '1';
					}
				}
	
				if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE === true) {
					// Add right prefix for address form input ids
					data.addressType = $(input).get(0).name === "same-as-billing" ? 'S' : 'B';
					CAddressForm.populateAddressModal_v2($(input.form), data, modaltype);
				} else {
					CAddressForm.populateAddressModal($(input.form), data, modaltype);
				}
			},
			addressNotServicedModal: function addressNotServicedModal(verifiedAddress, cancelFn, submitFn, message) {
				// Workaround for undefined verifiedAddress 
				var addressObject = {
					addressNotServicedMsg1: messages.ERR_MODAL_ADDRESS_NOT_SERVICED,
					firstName: '',
					lastName: '',
					address1: '',
					city: '',
					state: '',
					zip: '',
					addressNotServicedMsg2: messages.MODAL_ADDRESS_NOT_SERVICED
				};
				if (typeof verifiedAddress !== 'undefined') {
					addressObject = {
						addressNotServicedMsg1: messages.ERR_MODAL_ADDRESS_NOT_SERVICED,
						firstName: verifiedAddress.first,
						lastName: verifiedAddress.last,
						address1: verifiedAddress.line1,
						city: verifiedAddress.city,
						state: verifiedAddress.state,
						zip: verifiedAddress.zip,
						addressNotServicedMsg2: messages.MODAL_ADDRESS_NOT_SERVICED
					};
				}
				if (COSTCO.util.isNdEnabled()) {
					var modalAddressNotServicedForResidentialMessage = costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE === true ? messages.MODAL_ADDRESS_NOT_SERVICED_FOR_RESIDENTIAL_v2 : messages.MODAL_ADDRESS_NOT_SERVICED_FOR_RESIDENTIAL;
					if (message != null && message == "residentialNotServiced") {
						addressObject.addressNotServicedMsg1 = messages.ERR_MODAL_ADDRESS_NOT_SERVICED_FOR_RESIDENTIAL;
						addressObject.addressNotServicedMsg2 = modalAddressNotServicedForResidentialMessage;
					} else {
						addressObject.addressNotServicedMsg1 = messages.ERR_MODAL_ADDRESS_NOT_SERVICED_CART_MERGE;
						addressObject.addressNotServicedMsg2 = messages.MODAL_ADDRESS_NOT_SERVICED_CART_MERGE;
					}
					addressObject.address2 = verifiedAddress.line2;
				}
				var template = COSTCO.util.tmpl('tmpl_address_not_serviced_modal', addressObject);
				address.baseModal('S', 'addrnotserviced', {
					title: messages.MODAL_ADDRESS_NOT_SERVICED_TITLE,
					body: template,
					primary: messages.ADDRESS_NOT_SERVICED_SHOP,
					secondary: messages.JS_DIALOG_CANCEL,
					primary_event: function primary_event() {
						if (submitFn) {
							submitFn();
						} else {
							COSTCO.dialog.close();
						}
					},
					secondary_event: function secondary_event() {
						if (cancelFn) {
							cancelFn();
						} else {
							COSTCO.dialog.close();
						}
					}
				});
			},
	
			openAddressAddModal: function openAddressAddModal(type, addressObj, mode, addressOptions) {
				var openAddress = function openAddress(error) {
					var htmlBody = CAddressForm.createHtml(type, addressObj, mode, undefined, undefined, undefined, error);
					// if it is edit mode, trigger jQuery validation immediately
					if (mode == "edit") {
						CAddressForm.validate(type, htmlBody);
					}
					var validateAddressTypeModal = [];
					if (addressObj != undefined) {
						validateAddressTypeModal[0] = addressObj.line1;
						validateAddressTypeModal[1] = addressObj.zip;
						validateAddressTypeModal[2] = addressObj.city;
						if (addressObj.userAddressType != 'U') {
							validateAddressTypeModal[3] = addressObj.userAddressType;
						}
					}
					addressOptions.validateParams = validateAddressTypeModal;
					address.baseModal(type, mode, {
						body: htmlBody,
						primary_event: function primary_event() {
							if (CAddressForm.validate(type)) {
								var addressEnteredForCheck = $('#addressEnteredForCheck');
								var address1 = $('FORM[id="address-modal-modal"]').find("#address1Id").val();
								if (!addressEnteredForCheck.length) {
									addressEnteredForCheck = $('<INPUT TYPE="hidden" ID="addressEnteredForCheck" />').appendTo(document.body);
								}
								addressEnteredForCheck.val(address1);
								CAddressForm.submit(type, false, addressOptions);
							}
						},
						onshown: function onshown() {
							if (addressOptions.setAsDefaultAddress) {
								$('#set-default').val('true').attr('checked', true);
							} else {
								$('#set-default').val('false').attr('checked', false);
							}
							var invalidShipAddr = $('input[name=invalid-ship-addr]');
							if (invalidShipAddr.length > 0 && invalidShipAddr.val() === 'true') {
								var formId = $('#address-modal-modal');
								var addressField = '#address1Id';
								COSTCO.dialog.sameAddressValidation(formId, addressField);
							}
						}
					});
				};
				openAddress(undefined);
	
				$('body').unbind("costco.address.error").bind("costco.address.error", function (event, error) {
					openAddress(error);
				});
			},
	
			openAddressAddModal_v2: function openAddressAddModal_v2(type, addressObj, mode, addressOptions) {
				var openAddress = function openAddress(error) {
					var htmlBody = CAddressForm.createHtml_v2(type, addressObj, mode, undefined, undefined, undefined, error);
					if (mode == "edit") {
						CAddressForm.validate(type, htmlBody);
					}
					address.baseModal(type, mode, {
						body: htmlBody,
						primary_event: function primary_event() {
	
							if (CAddressForm.validate(type)) {
								CAddressForm.submit(type, false, addressOptions);
							}
						},
						onshown: function onshown() {
							if ($('input[name=invalid-ship-addr]').length > 0 && $('input[name=invalid-ship-addr]').val() === 'true') {
								var formId = $('#address-modal-modal');
								var addressField = '#S_address1Id';
								COSTCO.dialog.sameAddressValidation(formId, addressField);
							}
						}
					});
				};
				openAddress(undefined);
	
				$('body').unbind("costco.address.error").bind("costco.address.error", function (event, error) {
					openAddress(error);
				});
			},
	
			/**This function checks if the address line has reached max length, and if that is the case shows friendly message
	   * 
	   * Param 
	   * data:	data from children's element 
	   */
			validateAddressLineLength: function validateAddressLineLength(data) {
				var maxLength = 30;
				var errorElement = document.getElementById("address-error-message-" + data.id);
				if (data.value.length === maxLength) {
					//check if errorElement has error class
					if ($(errorElement).hasClass("hide")) {
						$(errorElement).removeClass("hide");
					}
				} else {
					$(errorElement).addClass("hide");
				}
			},
			submit: function submit(type, preventHtmlReload, addressOptions) {
				var addressArray = CAddressForm.buildAddressArray(type);
	
				if (typeof addressOptions === 'undefined') {
					addressOptions = {};
				}
				if ($('#isBDAppVar').val() == 'BD' && type == 'S') {
					var page = $('div#address').data('page') || '';
	
					if (!COSTCO.CAddressForm.isFormCompleted('S') && !(page === 'Home,MyAccount,AccountAddressBook') && !COSTCO.util.isNdEnabled()) {
						CAddressForm.showBDQuestionnaireModalForInlineForm(type, preventHtmlReload, addressOptions, addressArray);
					} else {
						addressOptions.successCallback = CAddressForm.addressVerifiedCallback;
						addressVerification.addressVerification(addressArray, type, preventHtmlReload, addressOptions);
					}
				} else {
					// BEGIN
					// NOTE: Below code is introduced with following commit/fix:
					// Grocery- Defect Fix 9968 Change-Id: Ifdb9bcbc501a5abc9c95733eeffe5140cd7ac55b
					//
					// We probably do not need it any more.
					// If encountering issues, please contact developer
					// 
					// if(typeof orderItemId != 'undefined'){
					// 	if(typeof(orderItemId) == 'number'){
	
					// 		addressOptions.orderItemId=orderItemId;
					// 	}
					// 	else{
					//  	addressOptions.orderItemId=orderItemId.orderItemId;
	
					// 	}
					// }
					// else{
					// 	addressOptions.orderItemId='';
					// }
					// END
					addressOptions.successCallback = CAddressForm.addressVerifiedCallback;
	
					addressVerification.addressVerification(addressArray, type, preventHtmlReload, addressOptions);
				}
			},
			/**
	   * Callback function for address form, on completed address verification service call
	   * @param {}
	   */
			addressVerifiedCallback: function addressVerifiedCallback(addressObj, type, preventajaxhtml, addressOptions) {
	
				if (typeof addressObj !== 'undefined' && addressObj != null && addressObj.Validated_Address != undefined && addressObj.Validated_Address != null) {
					if (addressObj.errorMessage != null && addressObj.errorMessage.length > 0) {
						$('.address-text-error').text(addressObj.errorMessage);
					} else if (addressObj.Validated_Address[0].result == 'ADDRESS_SUGGESTION_AVAILABLE' || addressObj.Validated_Address[0].result == 'ADDRESS_WRONG_NO_SUGGESTION' || addressObj.Validated_Address[0].result == 'ADDRESS_CORRECT_NO_SUGGESTION') {
						var additionalBillingStates = CAddressForm.getAdditionalBillingStates();
						if (addressObj.Validated_Address[0].result == 'ADDRESS_SUGGESTION_AVAILABLE' && additionalBillingStates.includes(addressObj.Validated_Address[0].state) && type == 'S') {
							// SFSTRY0038578: Do not suggest address from unsupported territories for shipping address
							addressObj.Validated_Address[0].result = 'ADDRESS_WRONG_NO_SUGGESTION';
						}
						if (addressVerification.isSuggestedSameAsEntered(addressObj)) {
							var validatedAddress = addressVerification.extractValidatedAddress(addressObj, type);
							COSTCO.CAddressVerification.entered = validatedAddress;
							addressVerification.useAddress(preventajaxhtml, addressOptions);
							//address.addEditAddress(validatedAddress, preventajaxhtml, addressOptions);
						} else {
							addressVerification.showAddressVerificationModal(addressObj, preventajaxhtml, addressOptions);
						}
					} else if (addressObj.Validated_Address[0].result == 'ADDRESS_SERVICE_UNAVAILABLE') {
						var validatedAddress = addressObj.Validated_Address[0];
						address.addEditAddress(validatedAddress, preventajaxhtml, addressOptions);
					} else {
						var validatedAddress = addressVerification.extractValidatedAddress(addressObj, type);
						address.addEditAddress(validatedAddress, preventajaxhtml, addressOptions);
					}
				} else {
					if (addressObj.errorMessageParam != null && addressObj.errorMessageParam.length > 0) {
						elementObj = $('[name=' + addressObj.errorMessageParam[0] + ']');
	
						if (elementObj.length > 0) {
	
							elementObj.parent().addClass('error');
							elementObj.attr('hasvalidationerror', true);
							elementObj.attr('firstNameValidation', true);
							elementObj.attr('lastNameValidation', true);
							COSTCO.CAddressForm.getForm().valid();
						}
					} else if (addressObj.errorMessage != null && addressObj.errorMessage.length > 0) {
						if ($('#address-modal-inline').length > 0) {
							COSTCO.CAddress.closeModal();
						}
						$('.address-text-error').text(addressObj.errorMessage);
					}
				}
			},
	
			getAdditionalBillingStates: function getAdditionalBillingStates() {
				var states = [];
				var territories = $('#additional_Billling_Territories').val();
				if (territories !== null && territories !== undefined && territories !== "") {
					var codeAndDisplayNameOfTerritories = territories.split('|');
					if (codeAndDisplayNameOfTerritories.length !== 0) {
						$.each(codeAndDisplayNameOfTerritories, function (index, codeAndDisplayName) {
							var code = codeAndDisplayName.split(':')[0];
							if (code !== null && code !== undefined && code !== "") {
								var displayName = codeAndDisplayName.split(':')[1];
								if (displayName !== null && displayName !== undefined && displayName !== "") {
									var state = { code: code, displayName: displayName };
									states.push(state);
								}
							}
						});
						return states.map(function (state) {
							return state.code;
						});
					}
				}
				return states;
			},
	
			getStateOptions: function getStateOptions(stateProvList, type, address) {
				var locale = 'en-US';
				locale = COSTCO.util.getLocale();
	
				var defaultCountry = locale.split('-')[1];
				var additionalBillingStatesCode = CAddressForm.getAdditionalBillingStates();
	
				$('#state').on('change', function () {
					CAddressForm.hideCheckboxForAdditionalTerritories(this.value, additionalBillingStatesCode);
				});
	
				if (type == 'S') {
					var _states = CAddressForm.getStates(stateProvList, defaultCountry);
					var filterOutStates = [].concat(_toConsumableArray(additionalBillingStatesCode), ['VI']);
					var filteredStates = _states.filter(function (state) {
						return !filterOutStates.includes(state.code);
					});
					return CAddressForm.getStateProvDropDown(filteredStates);
				} else {
					var states = '';
					if (typeof address !== 'undefined' && typeof address.country !== 'undefined') {
						states = CAddressForm.getStates(stateProvList, address.country);
					} else {
						states = CAddressForm.getStates(stateProvList, defaultCountry);
					}
					if (wcs.isPharmacy === "true") {
						var _filteredStates = states.filter(function (state) {
							return !additionalBillingStatesCode.includes(state.code);
						});
						return CAddressForm.getStateProvDropDown(_filteredStates);
					}
					return CAddressForm.getStateProvDropDown(states);
				}
	
				return '';
			},
			hideCheckboxForAdditionalTerritories: function hideCheckboxForAdditionalTerritories(enteredCode, additionalBilllingStatesCodes) {
				if (additionalBilllingStatesCodes !== null && additionalBilllingStatesCodes !== undefined) {
					if (additionalBilllingStatesCodes.length !== 0) {
						if ($.inArray(enteredCode, additionalBilllingStatesCodes) !== -1) {
							$('#set-default').prop('checked', false);
							$('.save-address-in-book').prop('checked', false);
							$('.defaultWarning').addClass('hide');
							$('#default-address-checkbox').addClass('hide');
							$("#add-to-address-book-checkbox").addClass('hide');
						} else {
							$('.save-address-in-book').prop('checked', true);
							$('#default-address-checkbox').removeClass('hide');
							$('#add-to-address-book-checkbox').removeClass('hide');
						}
					}
				}
			},
	
			getCountryOptions: function getCountryOptions(type) {
	
				if (type == 'S') {
					return CAddressForm.getCountryDropDown(shippingCountries);
				} else {
					return CAddressForm.getCountryDropDown(billingCountries);
				}
	
				return '';
			},
	
			getStates: function getStates(stateProvList, country) {
	
				for (var i = 0; i < stateProvList.length; i++) {
					var stateProvCountry = stateProvList[i].code;
					if (stateProvCountry == country) {
						return stateProvList[i].states;
					}
				}
			},
	
			getStateProvDropDown: function getStateProvDropDown(states) {
	
				html = '';
				for (var i = 0; i < states.length; i++) {
					html += '<option value="' + states[i].code + '">' + states[i].displayName + '</option>';
				}
				return html;
			},
	
			getCityDropDown: function getCityDropDown(cities) {
	
				html = '';
				for (var i = 0; i < cities.length; i++) {
					html += '<option value="' + cities[i] + '">' + cities[i] + '</option>';
				}
				return html;
			},
	
			getCountryDropDown: function getCountryDropDown(countriesList) {
	
				html = '';
	
				var langId = COSTCO.util.getLangId();
				if (langId == -1) {
					countries.sort(function (a, b) {
						return a.code < b.code ? 1 : -1;
					});
				}
	
				for (var k = 0; k < countries.length; k++) {
	
					if (countriesList.indexOf(countries[k].code) >= 0) {
						html += '<option value="' + countries[k].code + '">' + countries[k].displayName + '</option>';
					}
				}
				return html;
			},
	
			getForm: function getForm() {
	
				var forms = $('.address-form');
	
				if (forms.length > 1) {
					return $('#address-modal-modal');
				} else {
					return forms;
				}
			},
	
			validate: function validate(type, formToValidate, isEditDefaultShippingAddress) {
	
				CAddressForm.validationRules();
	
				function getAddressLine1MaxCharLength() {
					var addressLine1MaxChar = 30;
					if ($('#isBDAppVar').val() == 'BD') {
						addressLine1MaxChar = 35;
					}
					return addressLine1MaxChar;
				}
	
				function getFirstLastNameRule() {
					var firstLastNameMaxChar = 40;
					var firstLastNameRule = {
						required: true
					};
					if ($('#isBDAppVar').val() == 'BD') {
						firstLastNameRule.maxlength = firstLastNameMaxChar;
					}
					return firstLastNameRule.required;
				}
	
				function isCompanyRequired() {
					if ($('#isBDAppVar').val() == 'BD') {
						//SFSTRY0020930 - check if xapp flag for company name mandate is enabled
						var isCompanyMandateEnabled = $("#isCompanyMandateEnabled").val();
						var isLocalDelivery = typeof shipModeLocalND !== 'undefined' && ($("input[name='deliveryMethod']:checked").val() == shipModeLocalND || $("input[name='deliveryMethod']:checked").val() == shipModeLocal);
						var modalTitle = $('#costcoModalTitle').text();
						window.digitalDataEvents = window.digitalDataEvents || [];
						if (type == 'S') {
							//SFSTRY0015679 - Company name mandated for Local business delivery.
							if (shippingCountries[0] == "US") {
								if (isCompanyMandateEnabled === "true" && isLocalDelivery) {
									if (typeof modalTitle != 'undefined' && modalTitle != null && $("#S_companyId").val() == '') {
										if (modalTitle.toLocaleLowerCase() === 'add new address') {
											digitalDataEvents.push({ uimsg: "Add New Address Modal | Enter your company name" });
										}
										if (modalTitle.toLocaleLowerCase() === 'edit delivery address') {
											digitalDataEvents.push({ uimsg: "Edit Address Modal | Enter your company name" });
										}
									}
									return true;
								}
								return false;
							} else {
								return true;
							}
						}
						if (type == 'B') {
							if (shippingCountries[0] == "US" && isCompanyMandateEnabled === "true" && isLocalDelivery) {
								if (typeof modalTitle != 'undefined' && modalTitle != null && $("#B_companyId").val() == '') {
									if (modalTitle.toLocaleLowerCase() === 'add new address') {
										digitalDataEvents.push({ uimsg: "Add New Address Modal | Enter your company name" });
									}
									if (modalTitle.toLocaleLowerCase() === 'edit billing address') {
										digitalDataEvents.push({ uimsg: "Edit Address Modal | Enter your company name" });
									}
								}
								return true;
							}
							return false;
						}
					}
					// Was always false before change related to STRY0144246
					return false;
				}
				//Tries to reach the form. First attempt form parameter, second attempt throw COSTCO.CAddressForm.getForm. 
				//And if the form is not undefined, do validation
				var form = void 0;
				if (formToValidate != undefined) {
					form = formToValidate;
				}
				if (form == undefined && COSTCO.CAddressForm.getForm().length != 0) {
					form = COSTCO.CAddressForm.getForm();
				}
				if (form != undefined) {
					if (!isEditDefaultShippingAddress) {
						form.validate({
							rules: {
								firstModal: { required: getFirstLastNameRule(), firstNameValidation: true },
								lastModal: { required: getFirstLastNameRule(), lastNameValidation: true },
								country: "required",
								address1: { required: true, maxlength: getAddressLine1MaxCharLength, pobox: true },
								address2: { maxlength: 30, pobox: true },
								//company : {maxlength: 40, companyrequiredcheck: true},
								company: { required: isCompanyRequired(), maxlength: 40, companyNameValidation: true },
								postal: { required: true, countryspecificpostalcodePassCountrySelectorModal: true },
								city: { required: true, validateCity: true },
								state: { required: true, notEqual: "NO_STATE_TYPE_SELECTED", hasvalidationerror: true, validateAdditionalTerritories: type },
								phone: { required: true, phone: true },
								email: { required: true, email: true, maxlength: 254 },
								deliveryInstructions: { required: false },
								contactName: "required",
								contactPhone: "phone",
								ext1: "digits"
							},
							messages: {
								firstModal: { required: messages.ERR_INVALID_FIRSTNAME, firstNameValidation: messages.ERR_INVALID_FNAME },
								lastModal: { required: messages.ERR_INVALID_LASTNAME, lastNameValidation: messages.ERR_INVALID_LNAME },
								country: messages.ERR_INVALID_COUNTRY,
								address1: { required: messages.ERR_INVALID_STREETADDRESS, maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH_FRIENDLY_MESSAGE, pobox: messages.ERR_INVALID_POBOX },
								address2: { maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH, pobox: messages.ERR_INVALID_POBOX },
								company: { maxlength: messages.ERR_INVALID_COMPANY_NAME_LENGTH, required: messages.ERR_COMPANY_REQUIRED, companyrequiredcheck: messages.ERR_INVALID_COMPANY, companyNameValidation: messages.ERR_INVALID_COMPANY },
								postal: messages.ERR_ENTER_ZIPCODE,
								city: { required: messages.ERR_INVALID_CITY, validateCity: messages.ERR_INVALID_CITY_NAME },
								state: messages.ERR_INVALID_STATE,
								phone: { required: messages.ERR_INVALID_PHONE1, phone: messages.ERR_INVALID_PHONE1 },
								email: { required: messages.ERR_REQUIRED_EMAIL_MY, email: messages.ERR_INVALID_EMAIL, maxlength: messages.ERR_INVALID_EMAIL },
								contactName: messages.ERR_INVALID_CONTACT_NAME,
								contactPhone: messages.ERR_INVALID_PHONE1,
								ext1: messages.ERR_INVALID_EXTN_NUMBER
							},
							invalidHandler: COSTCO.util.invalid_handler,
							highlight: COSTCO.util.highlightWithErrorLabel,
							unhighlight: COSTCO.util.unhighlightWithErrorLabel,
							errorPlacement: function errorPlacement(error, element) {
								if (element.attr("name") == "state") {
									element.parent().addClass('error');
									error.insertAfter($('[name=state]').parent());
								} else if (element.attr("name") == "country") {
									element.parent().addClass('error');
									error.insertAfter($('[name=country]').parent());
								} else {
									error.insertAfter(element);
								}
							}
						}).form();
					} else {
						// validation rules and messages for edit default shipping address
						form.validate({
							rules: {
								firstModal: { required: getFirstLastNameRule(), firstNameValidation: true },
								lastModal: { required: getFirstLastNameRule(), lastNameValidation: true },
								country: "required",
								address1: { required: true, maxlength: getAddressLine1MaxCharLength, pobox: true },
								address2: { maxlength: 30, pobox: true },
								//company : {maxlength: 40, companyrequiredcheck: true},
								company: { required: isCompanyRequired(), maxlength: 40, companyNameValidation: true },
								postal: { required: true, countryspecificpostalcodePassCountrySelectorModal: true },
								city: { required: true, validateCity: true },
								state: { required: true, notEqual: "NO_STATE_TYPE_SELECTED", hasvalidationerror: true, validateAdditionalTerritories: type },
								phone: { required: true, phone: true },
								email: { required: true, email: true, maxlength: 254 },
								deliveryInstructions: { required: false },
								contactName: "required",
								contactPhone: "phone",
								ext1: "digits"
							},
							messages: {
								firstModal: { required: messages.ERR_INVALID_FIRSTNAME, firstNameValidation: messages.ERR_INVALID_FNAME },
								lastModal: { required: messages.ERR_INVALID_LASTNAME, lastNameValidation: messages.ERR_INVALID_LNAME },
								country: messages.ERR_INVALID_COUNTRY,
								address1: { required: messages.ERR_INVALID_STREETADDRESS, maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH_FRIENDLY_MESSAGE, pobox: messages.ERR_INVALID_POBOX },
								address2: { maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH, pobox: messages.ERR_INVALID_POBOX },
								company: { maxlength: messages.ERR_INVALID_COMPANY_NAME_LENGTH, required: messages.ERR_INVALID_COMPANY, companyrequiredcheck: messages.ERR_INVALID_COMPANY, companyNameValidation: messages.ERR_INVALID_COMPANY },
								postal: messages.ERR_ENTER_ZIPCODE,
								city: { required: messages.ERR_INVALID_CITY, validateCity: messages.ERR_INVALID_CITY_NAME },
								state: messages.ERR_INVALID_STATE,
								phone: { required: messages.ERR_INVALID_PHONE2, phone: messages.ERR_INVALID_PHONE2 },
								email: { required: messages.ERR_EMAIL_ADDRESS_REQUIRED, email: messages.ERR_INVALID_EMAIL, maxlength: messages.ERR_INVALID_EMAIL },
								contactName: messages.ERR_INVALID_CONTACT_NAME,
								contactPhone: messages.ERR_INVALID_PHONE1,
								ext1: messages.ERR_INVALID_EXTN_NUMBER
							},
							invalidHandler: COSTCO.util.invalid_handler,
							highlight: COSTCO.util.highlightWithErrorLabel,
							unhighlight: COSTCO.util.unhighlightWithErrorLabel,
							errorPlacement: function errorPlacement(error, element) {
								if (element.attr("name") == "state") {
									element.parent().addClass('error');
									error.insertAfter($('[name=state]').parent());
								} else if (element.attr("name") == "country") {
									element.parent().addClass('error');
									error.insertAfter($('[name=country]').parent());
								} else {
									error.insertAfter(element);
								}
							}
						}).form();
					}
	
					var selectsValid = true;
	
					form.find('.style-select > select').each(function () {
						$(this).unbind('change').change(function () {
							if ($(this).val() === "NO_STATE_TYPE_SELECTED") {
								selectsValid = false;
								$(this).parent().addClass('error');
							} else {
								$(this).parent().removeClass('error');
								if ($(this).attr('hasvalidationerror') != undefined && $(this).attr('hasvalidationerror') != null) {
									$(this).attr('hasvalidationerror', false);
								}
							}
						});
					});
	
					form.find('.style-select > select').change();
	
					return form.valid() && selectsValid;
				}
			},
	
			/*
	   * Build Address Array from a query selector
	   */
			buildAddressArray: function buildAddressArray(type) {
				var addressObject = {};
				var addressArray = [];
				var _baseAddr = COSTCO.CAddressForm.getForm();
				var addressPrefix = '';
	
				if (_baseAddr.length > 0 && _baseAddr[0].id == 'quick-renew-address-form') {
					if (type == "S" || type == 'S') addressPrefix = 'shipping_';else addressPrefix = 'billing_';
				}
	
				addressObject['id'] = _baseAddr.find('[name=' + addressPrefix + 'addressId]').val();
				addressObject['fName'] = _baseAddr.find('[name=' + addressPrefix + 'firstModal]').val();
				addressObject['lName'] = _baseAddr.find('[name=' + addressPrefix + 'lastModal]').val();
				addressObject['company'] = _baseAddr.find('[name=' + addressPrefix + 'company]').val();
				addressObject['country'] = _baseAddr.find('[name=' + addressPrefix + 'country]').val();
				addressObject['line1'] = _baseAddr.find('[name=' + addressPrefix + 'address1]').val();
				addressObject['line2'] = _baseAddr.find('[name=' + addressPrefix + 'address2]').val();
				addressObject['zip'] = _baseAddr.find('[name=' + addressPrefix + 'postal]').val();
				addressObject['city'] = _baseAddr.find('[name=' + addressPrefix + 'city]').val();
				addressObject['state'] = _baseAddr.find('[name=' + addressPrefix + 'state]').val();
				addressObject['pNumber'] = _baseAddr.find('[name=' + addressPrefix + 'phone]').unmask().val();
				addressObject['ext1'] = _baseAddr.find('[name=' + addressPrefix + 'ext1]').val();
				addressObject['nickname'] = _baseAddr.find('[name=' + addressPrefix + 'nickname]').val();
				addressObject['email'] = _baseAddr.find('[name=' + addressPrefix + 'email]').val();
				addressObject['mInitial'] = _baseAddr.find('[name=mInitial]').val();
				addressObject['saveAddress'] = address.getSaveAddress(addressObject['id'], _baseAddr.find('[name=' + addressPrefix + 'save-address]:checked').length > 0);
				addressObject['setDefault'] = address.getDefaultAddress(addressObject['id'], _baseAddr.find('[name=' + addressPrefix + 'set-default]:checked').length > 0);
				addressObject['addressType'] = address.getAddressType(addressObject['id'], type);
				addressObject['addressType2'] = address.getAddressType(addressObject['id'], type);
				addressObject['deliveryInst'] = _baseAddr.find('[name=' + addressPrefix + 'deliveryInstructions]').val();
				addressObject['contactName'] = _baseAddr.find('[name=' + addressPrefix + 'contactName]').val();
				if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE === true) {
					addressObject['contactPhNo'] = _baseAddr.find('[name=' + addressPrefix + 'contactPhone]').length > 0 ? _baseAddr.find('[name=' + addressPrefix + 'contactPhone]').cleanVal() : _baseAddr.find('[name=' + addressPrefix + 'contactPhone]').val();
				} else {
					addressObject['contactPhNo'] = _baseAddr.find('[name=' + addressPrefix + 'contactPhone]').val();
				}
				addressObject['smsPhone'] = $('#receiveSMS').is(':checked') ? _baseAddr.find('#' + addressPrefix + 'smsPhoneId').cleanVal() : "";
	
				if (addressObject.addressType == '') {
					addressObject.addressType = type;
				}
	
				addressArray.push(addressObject);
				return addressArray;
			},
	
			populateCityState: function populateCityState(form, city, state, cityQuery, stateQuery) {
	
				var form = $(form);
	
				var cityQueryNameValue = cityQuery.match(/\[name=(.*?)\]/)[1];
				var cityFieldType = COSTCO.CAddressForm.getCityFieldType(form, cityQueryNameValue);
				if (form.find('select' + cityQuery).length) {
					COSTCO.CAddressForm.setCorrectCityField(form, cityQueryNameValue, cityFieldType);
				}
	
				form.find(cityQuery).val(city);
				form.find(stateQuery).val(state);
				form.find(cityQuery).focusout().change();
				form.find(stateQuery).focusout().change();
				//STRY0148134 checkout redesign - show city state inputs
				form.find('#' + cityFieldType + 'city-state').removeClass('hide');
			},
	
			matchCityOption: function matchCityOption(citySelect, editAddrCity) {
	
				var options = citySelect.find('option');
				var matchingValue = null;
				var normalizedEditAddrCity = editAddrCity.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
	
				options.each(function () {
					var optionValue = $(this).val();
					var normalizedOptionValue = optionValue.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
					if (normalizedOptionValue == normalizedEditAddrCity) {
						matchingValue = optionValue;
						return false;
					}
				});
	
				return matchingValue;
			},
	
			/* ALM52674 - This method is used for the modal to display the correct city field type
	   * depending on the geo location service response - if the service is down, 
	   * a text input field is used, while if the service call is successful, a 
	   * select field with valid city options for the given zip/postal code is displayed
	  */
			setCorrectCityField: function setCorrectCityField(form, cityQueryNameValue, cityFieldType) {
	
				var alternativeCityQueryNameValue = cityFieldType + 'city2';
	
				//correctCityField is the city field that should be displayed, instead of the incorrectCityField
				var correctCityField = '[name=' + alternativeCityQueryNameValue + ']';
				var incorrectCityField = '[name=' + cityQueryNameValue + ']';
	
				/*whatever city field is displayed, it should have the idForCurrentCityField and nameForCurrentCityField
	   values as the 'id', and 'name' attribute values, while the alternative field (not displayed) should have
	   idForAltCityField and nameForAltCityField as 'id' and 'name'*/
	
				var idForCurrentCityField = form.find('[name=' + cityQueryNameValue + ']').attr('id');
				var idForAltCityField = form.find('[name=' + alternativeCityQueryNameValue + ']').attr('id');
	
				var nameForCurrentCityField = cityQueryNameValue;
				var nameForAltCityField = alternativeCityQueryNameValue;
	
				var parentDivId = cityFieldType + 'city-state';
	
				var incorrParentDiv = form.find(incorrectCityField).parent();
				while (incorrParentDiv.attr('id') !== parentDivId) {
					incorrParentDiv.addClass('hide');
					incorrParentDiv = incorrParentDiv.parent();
				}
				form.find(incorrectCityField).removeAttr('id required aria-required');
	
				var corrParentDiv = form.find(correctCityField).parent();
				while (corrParentDiv.attr('id') !== parentDivId) {
					corrParentDiv.removeClass('hide');
					corrParentDiv = corrParentDiv.parent();
				}
				form.find(correctCityField).attr('id', idForCurrentCityField);
				form.find('#' + idForCurrentCityField).removeAttr('name required aria-required');
				form.find('#' + idForCurrentCityField).attr({
					'required': 'true',
					'aria-required': 'true'
				});
	
				form.find(incorrectCityField).attr('id', idForAltCityField);
				form.find('#' + idForAltCityField).attr('name', nameForAltCityField);
	
				form.find('#' + idForCurrentCityField).attr('name', nameForCurrentCityField);
	
				CAddressForm.moveMissplacedElements(form, idForAltCityField, idForCurrentCityField);
			},
	
			moveMissplacedElements: function moveMissplacedElements(form, idForAltCityField, idForCurrentCityField) {
				var altParentDiv = form.find('#' + idForAltCityField).parent();
				var currElements = altParentDiv.find('[for=' + idForCurrentCityField + ']');
				if (currElements.length) {
					form.find('#' + idForCurrentCityField).parent().append(currElements);
				}
				return currElements;
			},
	
			/* SFSTRY0028209 - The address modal City and State fields will be displayed/populated
	   *  based on the geo location service response 
	  */
			populateCityStateForZipPostalCode: function populateCityStateForZipPostalCode(form, cityList, stateList, cityQuery, stateQuery, editAddrCity, editAddrState) {
	
				var form = $(form);
	
				var editAddrCityOptionMatch = undefined;
				var cityQueryNameValue = cityQuery.match(/\[name=(.*?)\]/)[1];
				var cityFieldType = COSTCO.CAddressForm.getCityFieldType(form, cityQueryNameValue);
	
				if (cityList.length && stateList.length) {
	
					if (form.find(cityQuery).attr('type') == "text") {
						COSTCO.CAddressForm.setCorrectCityField(form, cityQueryNameValue, cityFieldType);
					}
					var cityOptions = CAddressForm.getCityDropDown(cityList);
	
					var stateOptions = CAddressForm.getStateProvDropDown(stateList);
					form.find(cityQuery).empty().append(cityOptions);
					form.find(stateQuery).empty().append(stateOptions);
	
					if (editAddrCity != undefined) {
						editAddrCityOptionMatch = COSTCO.CAddressForm.matchCityOption(form.find(cityQuery), editAddrCity);
					}
				} else {
					var stateProvList = address.getStateProvJson();
					var stateOptions = CAddressForm.getStateOptions(stateProvList);
					form.find(stateQuery).empty().append(stateOptions);
					form.find(cityQuery).empty();
					var alternativeCityQuery = '[name=' + cityFieldType + 'city2]';
					if (form.find(alternativeCityQuery).length > 0 && form.find(alternativeCityQuery).attr('type') == "text") {
						COSTCO.CAddressForm.setCorrectCityField(form, cityQueryNameValue, cityFieldType);
					} else {
						form.find(cityQuery).val('');
					}
				}
	
				if (editAddrState != undefined && editAddrCity != undefined) {
					var editAddrSavedCity = editAddrCityOptionMatch ? editAddrCityOptionMatch : editAddrCity;
					form.find(cityQuery).val(editAddrSavedCity);
					form.find(stateQuery).val(editAddrState);
				}
	
				form.find(cityQuery).focusout().change();
				form.find(stateQuery).focusout().change();
				//STRY0148134 checkout redesing - show city state inputs
				//form.find('#city-state').removeClass('hide');
	
				form.find('#' + cityFieldType + 'city-state').removeClass('hide');
			},
	
			/**
	   * Gets the City field form type 
	   */
			getCityFieldType: function getCityFieldType(form, cityQueryNameValue) {
				var fieldType = '';
				if (cityQueryNameValue.indexOf('business') !== -1) {
					fieldType = 'business_';
				} else if (cityQueryNameValue.indexOf('shipping') !== -1) {
					fieldType = 'shipping_';
				} else if (cityQueryNameValue.indexOf('billing') !== -1) {
					fieldType = 'billing_';
				} else if (cityQueryNameValue.indexOf('affiliate') !== -1 || form.attr('id').indexOf('affiliate') !== -1) {
					fieldType = 'affiliate_';
				}
	
				return fieldType;
			},
	
			/**
	   * Gets shipping address id from html address display block
	   */
			getShippingId: function getShippingId() {
				if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE === true && !COSTCO.MembershipHelper.isQuickMembership) {
					return $('#shipping .address-display').data('addressid');
				} else {
					return $('.address-display').data('addressid');
				}
			},
	
			/**
	   * Gets billing address id from html address display block
	   */
			getBillingId: function getBillingId() {
				if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE === true && !COSTCO.MembershipHelper.isQuickMembership) {
					return $('#billing .address-display').data('addressid');
				} else {
					return $('.address-display').data('addressid');
				}
			},
	
			/**
	   * Checks if address form has been completed. For give address type if address block with address id is found on page,
	   * it is considered that address form is completed.
	   */
			isFormCompleted: function isFormCompleted(type) {
				if (type === 'S') {
					return this.getShippingId() != null;
				} else {
					return this.getBillingId() != null;
				}
			},
			initiatePopovers: function initiatePopovers() {
				var helper = "#deliveryInstructionsPopover";
	
				var popOverSettings = {
					trigger: 'focus',
					placement: 'top',
					html: true,
					selector: helper,
					content: function content() {
						return $(helper).data().popupcontent;
					}
				};
				$('body').popover(popOverSettings);
			},
			showBusinessDeliveryQuestionnaireModal: function showBusinessDeliveryQuestionnaireModal(type, data, action, addressOptions) {
				address.baseModal(type, 'bdquestionnaire', {
					title: messages.BD_QUESTIONNAIRE_TITLE,
					body: COSTCO.util.tmpl('tmpl_bd_questionnaire_modal'),
					primary: messages.RWD_BD_QUESTIONNAIRE_AGREE,
					secondary: messages.JS_DIALOG_CANCEL,
					primary_event: function primary_event() {
						if (action == 'edit') {
							CAddressForm.openAddressAddModal(type, data, 'edit', addressOptions);
						} else {
							CAddressForm.openAddressAddModal(type, data, 'add', addressOptions);
						}
					}
				});
			},
			showBusinessDeliveryQuestionnaireModal_v2: function showBusinessDeliveryQuestionnaireModal_v2(type, data, action, addressOptions) {
				address.baseModal(type, 'bdquestionnaire', {
					title: messages.BD_QUESTIONNAIRE_TITLE,
					body: COSTCO.util.tmpl('tmpl_bd_questionnaire_modal'),
					primary: messages.RWD_BD_QUESTIONNAIRE_AGREE,
					secondary: messages.JS_DIALOG_CANCEL,
					primary_event: function primary_event() {
						if (action == 'edit') {
							CAddressForm.openAddressAddModal_v2(type, data, 'edit', addressOptions);
						} else {
							CAddressForm.openAddressAddModal_v2(type, data, 'add', addressOptions);
						}
					}
				});
			},
			showBDQuestionnaireModalForInlineForm: function showBDQuestionnaireModalForInlineForm(type, preventHtmlReload, addressOptions, addressArray) {
				COSTCO.dialog.createExtDialogBox({
					title: messages.BD_QUESTIONNAIRE_TITLE,
					body: COSTCO.util.tmpl('tmpl_bd_questionnaire_modal'),
					primary: messages.RWD_BD_QUESTIONNAIRE_AGREE,
					secondary: messages.JS_DIALOG_CANCEL,
					primary_event: function primary_event() {
						CAddressForm.agreeFromBDQuestionnaireModal(type, preventHtmlReload, addressOptions, addressArray);
					}
				});
			},
			agreeFromBDQuestionnaireModal: function agreeFromBDQuestionnaireModal(type, preventHtmlReload, addressOptions, addressArray) {
				addressOptions.successCallback = CAddressForm.addressVerifiedCallback;
				addressVerification.addressVerification(addressArray, type, preventHtmlReload, addressOptions);
			},
			//hides the link, shows input field
			showInputFiled: function showInputFiled(input) {
				var selectedElementParent = $(input).parent();
				selectedElementParent.siblings().removeClass('hide');
				selectedElementParent.siblings().find('input').focus();
				selectedElementParent.siblings().find('input').select();
				//timout set so that NVDA can focus the input field
				setTimeout(function () {
					selectedElementParent.addClass('hide');
				}, 120);
			},
	
			hideInputFiled: function hideInputFiled(input) {
				$(input).parent().siblings().addClass('hide');
				$(input).parent().removeClass('hide');
			},
	
			/**
	   * This function is used to trigger character counting functionality
	   */
			countTextareaCharacters: function countTextareaCharacters(element) {
				var additionalParam = $(element).data('param-type') !== undefined ? $(element).data('param-type') : null;
				$('body').trigger('count.delivery.inst.characters', additionalParam);
			},
	
			/**
	   * This function finds the textArea and character label and calls the character counting functionality
	   * @param {the expand element for the delivery instructions area} expandLink 
	   */
			countTextareaCharactersAddressBook: function countTextareaCharactersAddressBook(expandLink) {
				var textArea = $(expandLink).parent().siblings().find('textarea');
				var countLabel = textArea.siblings().find('#delivery-message-count');
				COSTCO.util.character_count(countLabel, textArea);
			},
	
			/**
	  * This function is used to open edit block for Delivery Information
	  */
			showDeliveryInstructionsBlock: function showDeliveryInstructionsBlock(paramType) {
				$('#delivery-instructions-text').addClass('hide');
				$('#edit-delivery-instructions-text').removeClass('hide');
				var textAreaId = 'deliveryInstructions' + (paramType ? '-' + paramType : '');
				var textArea = $('#edit-delivery-instructions-text textarea[id=' + textAreaId + ']');
				textArea.attr('tabindex', 0);
				textArea.focus();
				textArea.select();
			},
			/**
	  * This function is used to open edit block for Contact Information
	  */
			showContactInformationBlock: function showContactInformationBlock() {
				$('#contact-information-text').addClass('hide');
				$('#edit-contact-information-text').removeClass('hide');
				if ($('input[id=contactPhNo-inline]').val() !== "") {
					$('label[for=contactPhNo-inline]').addClass('active');
				}
				if ($('input[id=contactName-inline]').val() !== "") {
					$('label[for=contactName-inline]').addClass('active');
				}
				$('#contactPhNo-inline').unmask().mask('000-000-0000');
			},
			/**
	  * This function is used for updating different contact information for specific addressId
	  * depending on xAddressInfoType (delivery instructions, contact name, contact phone etc.)
	  */
			updateXAddressInformation: function updateXAddressInformation(inputElement, addressId) {
				var xAddressInfoType = $(inputElement).data('xaddress-info-type');
				var inputValue = $(inputElement).val();
				var preventHtmlResponse = false;
				var nextElement = event.relatedTarget;
				if (nextElement !== null) {
					if (nextElement.name === "contactPhone" || nextElement.name === "contactName") {
						preventHtmlResponse = true;
					}
				}
				var data = [{
					name: "addressId",
					value: addressId || ""
				}, {
					name: "xAddressInfoType",
					value: xAddressInfoType || ""
				}, {
					name: "inputValue",
					value: inputValue || ""
				}, {
					name: "preventHtmlResponse",
					value: preventHtmlResponse
				}];
	
				COSTCO.AjaxModular.ajax_update_state({
					url: 'AjaxXAddressUpdateCmd',
					method: 'POST',
					dataType: 'json',
					data: data,
					scrollToError: false,
					done: function done(data, textStatus, jqXHR, options) {
						COSTCO.AjaxModular.ajax_update_default_done(data, textStatus, jqXHR, options);
						for (var i = 0; i < COSTCO.util.addresses.length; i++) {
							if (COSTCO.util.addresses[i] !== undefined && COSTCO.util.addresses[i]["addressType"] === 'S') {
								COSTCO.util.addresses[i][xAddressInfoType] = inputValue;
							}
						}
					},
					always: function always() {
						if (COSTCO.CreditCard !== undefined) {
							COSTCO.CreditCard.initComplete = false;
						}
						if (COSTCO.util.isBusinessDelivery()) {
							COSTCO.Header.miniShopCartRefresh();
							COSTCO.preauthchargesmodal.init();
						}
					}
				});
			},
			validateContactInformation: function validateContactInformation() {
				if ($.validator.methods.contactInformationPhone === undefined) {
					$.validator.addMethod("contactInformationPhone", function (value, element) {
						if (value.startsWith("0") || value.startsWith("1")) {
							return false;
						}
						return this.optional(element) || /^\(?\d{3}\)?[ -.]?\d{3}[ -.]?\d{4}$/.test(value);
					}, messages.ERR_INVALID_PHONE1);
				}
				var form = $('#contact-information-form');
				form.validate({
					rules: {
						contactName: { required: true, maxlength: 40 },
						contactPhone: { contactInformationPhone: true }
					},
					messages: {
						contactName: messages.ERR_INVALID_CONTACT_NAME,
						contactPhone: messages.ERR_INVALID_PHONE1
					},
					invalidHandler: COSTCO.util.invalid_handler,
					highlight: COSTCO.util.highlightWithErrorLabel,
					unhighlight: COSTCO.util.unhighlightWithErrorLabel,
					errorPlacement: function errorPlacement(error, element) {
						error.insertAfter(element);
					}
				});
	
				return form.valid();
			},
			updateContactInformation: function updateContactInformation(inputElement, addressId) {
				if (COSTCO.CAddressForm.validateContactInformation()) {
					CAddressForm.updateXAddressInformation(inputElement, addressId);
				}
			},
	
			toggleSmsBlock: function toggleSmsBlock() {
				if ($('#receiveSMS').is(':checked')) {
					$('.smsPhoneBlock').removeClass('hidden');
				} else {
					$('.smsPhoneBlock').addClass('hidden');
				}
			},
			/*
	   * QuestionnaireModal for BD National Delivery version 2
	   */
			showNationalDeliveryQuestionnaireModal: function showNationalDeliveryQuestionnaireModal(verifiedAddress, preventhtmlajax, addressOptions, message, userSelection) {
				var deliveryMethod;
				if ($('input[name="deliveryMethod"]').length > 0) {
					deliveryMethod = $("input[name='deliveryMethod']:checked").val();
				} else if ($('#shipmodeId').length > 0) {
					deliveryMethod = parseFloat($('#shipmodeId').val());
				}
				var delObj = {
					espotContent: deliveryMethod
				};
				var template = COSTCO.util.tmpl('tmpl_bd_questionnaire_modal', delObj);
				address.baseModal('S', 'bdquestionnaire', {
					title: messages.BD_QUESTIONNAIRE_TITLE,
					body: template,
					primary: messages.RWD_BD_QUESTIONNAIRE_AGREE,
					secondary: messages.JS_DIALOG_CANCEL,
					primary_event: function primary_event() {
						verifiedAddress.userAddressType = userSelection;
						address.addEditAddress(verifiedAddress, preventhtmlajax, addressOptions, message);
					}
				});
			},
			/*
	   * QuestionnaireModal for BD National Delivery
	   */
			showNationalDeliveryQuestionnaireModal_v2: function showNationalDeliveryQuestionnaireModal_v2(form, data, params, verifiedAddress) {
				var deliveryMethod;
				if ($('input[name="deliveryMethod"]').length > 0) {
					deliveryMethod = $("input[name='deliveryMethod']:checked").val();
				} else if ($('#shipmodeId').length > 0) {
					deliveryMethod = parseFloat($('#shipmodeId').val());
				}
				var delObj = {
					espotContent: deliveryMethod
				};
				var template = COSTCO.util.tmpl('tmpl_bd_questionnaire_modal', delObj);
				address.baseModal('S', 'bdquestionnaire', {
					title: messages.BD_QUESTIONNAIRE_TITLE,
					body: template,
					primary: messages.RWD_BD_QUESTIONNAIRE_AGREE,
					secondary: messages.JS_DIALOG_CANCEL,
					primary_event: function primary_event() {
						if (typeof checkoutPage !== 'undefined') {
							if (checkoutPage == 'review' || checkoutPage == 'shipping') {
								isCheckoutFlow = true;
							}
						}
						if (isCheckoutFlow && !verifiedAddress) {
							COSTCO.zipCodeModal.buttonClickChange(data.SetDeliveryZip, form, params, data);
						} else if (isCheckoutFlow && !data.WarehouseChange && data.StatusMessage == data.ZipStatusMessageList[7]) {
							COSTCO.zipCodeModal.buttonClickChange(data.SetDeliveryZip, form, params, data, verifiedAddress);
						} else {
							COSTCO.zipCodeModal.changeZip_buttonClickChange(data, params, form, verifiedAddress);
						}
					}
				});
			},
			/**
	   * Reads 'Form End' when focus gets out of form
	   * @param formElement - form
	   */
			makeFormAdaCompatible: function makeFormAdaCompatible(formElement) {
				if (formElement == undefined) {
					return false;
				}
				//Adds event on all focusable elements of form
				formElement.find('a, input, select').each(function () {
					$(this).blur(function () {
						setTimeout(function () {
							//timeout is needed to wait for setting focus on next element
							if (!$.contains(formElement.get(0), document.activeElement)) {
								COSTCO.util.announceSRMessage(messages.FORM_END);
							}
						}, 30);
					});
				});
			},
	
			//Adds analytics for save/cancel/remove address buttons on the address form. 
			updateAddressModal: function updateAddressModal() {
				var modalTitle = document.getElementById('costcoModalTitle');
				var modalBtn1 = document.getElementById('costcoModalBtn1');
				var modalBtn2 = document.getElementById('costcoModalBtn2');
	
				if (typeof modalTitle != 'undefined' && modalTitle != null) {
					var text = modalTitle.innerText;
				}
	
				if (typeof modalBtn1 != 'undefined' && modalBtn1 != null) {
					$('#costcoModalBtn1').attr("data-bi-tc", "ui:My Account | Address Book | Cancel Address");
				}
				if (typeof modalBtn2 != 'undefined' && modalBtn2 != null) {
	
					if (text.toLocaleLowerCase() === 'edit shipping address' || text.toLocaleLowerCase() === 'add new address') {
						$('#costcoModalBtn2').attr("data-bi-tc", "ui:My Account | Address Book | Save Address");
					}
	
					if (text.toLocaleLowerCase() === 'remove address') {
						$('#costcoModalBtn2').attr("data-bi-tc", "ui:My Account | Address Book | Remove Address");
					}
				}
			}
		};
	
		if (typeof window.COSTCO === "undefined") {
			window.COSTCO = new Object();
		}
		window.COSTCO.CAddressForm = CAddressForm;
		return CAddressForm;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title address.js: Feature level module
	 * @description Module associated with address handling
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(15)], __WEBPACK_AMD_DEFINE_RESULT__ = function (preauthchargesmodal) {
	  var CAddress = {
	    stateprov: '',
	    addressTools: {
	      applyAddressToOrder: "false",
	      applyAddressToOrderItems: "false",
	      addressType: '',
	      cachedAddressId: '',
	      errorContainer: ''
	    },
	    urlDelete: 'AjaxAddressAddCmd?mode=DELETE&addressId=',
	    form: '',
	    initialize: function initialize(isReloaded) {
	      COSTCO.util.getInitialAddressBatch();
	    },
	    // Hierarchy Setup for Modals -> Mode -> Type
	    getHeaderLabels: function getHeaderLabels(type, mode) {
	      var typeLabel, modeLabel;
	      if (typeof mode !== 'undefined') {
	        modeLabel = addressLabels[mode];
	      }
	      if (typeof type !== 'undefined') {
	        if (type.trim() == 'S') {
	          typeLabel = $.extend({}, addressLabels.shipping);
	          if (typeof modeLabel.shipping !== 'undefined') {
	            typeLabel = $.extend(typeLabel, modeLabel.shipping);
	          }
	        } else {
	          typeLabel = $.extend({}, addressLabels.billing);
	          if (typeof modeLabel.billing !== 'undefined') {
	            typeLabel = $.extend(typeLabel, modeLabel.billing);
	          }
	        }
	      }
	      //added empty object as the first argument so that addressHeaderLabels stays in its original state
	      return $.extend({}, addressHeaderLabels, modeLabel, typeLabel);
	    },
	    previousOptions: [],
	    previousMode: [],
	    previousType: [],
	    pushModal: function pushModal(type, mode, options) {
	      COSTCO.CAddress.previousOptions.push(options);
	      COSTCO.CAddress.previousMode.push(mode);
	      COSTCO.CAddress.previousType.push(type);
	    },
	    resetQueue: function resetQueue() {
	      COSTCO.CAddress.previousOptions = [];
	      COSTCO.CAddress.previousMode = [];
	      COSTCO.CAddress.previousType = [];
	    },
	    closeModal: function closeModal() {
	      COSTCO.CAddress.resetQueue();
	      COSTCO.dialog.closeAndUnbind();
	    },
	    baseModal: function baseModal(type, mode, options, poppin) {
	      if (COSTCO.CAddress.previousOptions.length > 0 && typeof options.secondary_event === 'undefined') {
	        var s_options = COSTCO.CAddress.previousOptions.pop();
	        var s_mode = COSTCO.CAddress.previousMode.pop();
	        var s_type = COSTCO.CAddress.previousType.pop();
	        options.secondary_event = options.close = options.afterclose = function () {
	          COSTCO.CAddress.baseModal(s_type, s_mode, s_options, true);
	        };
	      }
	      var labels = CAddress.getHeaderLabels(type, mode);
	      var addressOptions = {
	        title: labels.modalTitle,
	        primary: labels.primaryButton,
	        secondary: messages.JS_DIALOG_CANCEL,
	        secondary_event: function secondary_event() {
	          COSTCO.CAddress.closeModal();
	        },
	        close: function close() {
	          $('.order-ajax').removeClass('ajax-busy');
	          COSTCO.CAddress.closeModal();
	        },
	        afterclose: function afterclose(e) {
	          COSTCO.CAddress.closeModal();
	        }
	      };
	      options = $.extend(addressOptions, options);
	      if (typeof poppin === 'undefined') {
	        COSTCO.CAddress.pushModal(type, mode, options);
	      } else {
	        COSTCO.CAddress.resetQueue();
	        COSTCO.CAddress.pushModal(type, mode, options);
	      }
	
	      COSTCO.dialog.showAndHideModal(options);
	    },
	    urlAddUpdate: function urlAddUpdate(addressOptions) {
	      if (typeof $('#calendarServiceResponse').val() !== 'undefined') {
	        document.getElementById("calendarServiceResponse").value = "";
	      }
	
	      var url = '';
	      if (typeof addressOptions === 'undefined') {
	        url = '/AjaxAddressAddCmd';
	      } else {
	        url = addressOptions.url ? addressOptions.url : '/AjaxAddressAddCmd';
	      }
	      var orderItemId = '';
	      var multiAddress = '';
	      var addressIdsToUpdate = [];
	
	      if (typeof checkoutPage !== 'undefined' && typeof addressOptions !== 'undefined') {
	        if (!COSTCO.util.isBusinessDelivery()) {
	          orderItemId = addressOptions.orderItemId;
	        }
	        if (checkoutPage === 'multi-shipping') {
	          multiAddress = 'true';
	          var cartCount = $.cookie('cartCountCookie');
	          for (i = 0; i < cartCount; i++) {
	            addressIdsToUpdate[i] = $('#addressId_' + (i + 1)).val();
	          }
	          var addressIdsToUpdateString = encodeURIComponent(JSON.stringify(addressIdsToUpdate));
	        } else if (checkoutPage === 'shipping') {
	          multiAddress = 'false';
	        }
	      }
	
	      var queryObject = {
	        addressType: CAddress.addressTools.addressType,
	        applyAddressToOrder: CAddress.addressTools.applyAddressToOrder,
	        applyAddressToOrderItems: CAddress.addressTools.applyAddressToOrderItems,
	        orderItemId: orderItemId,
	        multiAddress: multiAddress,
	        modular: 'true',
	        requesttype: 'ajax',
	        addressIdsToUpdate: addressIdsToUpdateString
	      };
	
	      return COSTCO.util.makeUrl(url, queryObject);
	    },
	
	    urlAdd: function urlAdd(addressOptions) {
	      if (typeof $('#calendarServiceResponse').val() !== 'undefined') {
	        document.getElementById("calendarServiceResponse").value = "";
	      }
	      var url = '';
	      if (typeof addressOptions === 'undefined') {
	        url = '/AjaxAddressAddCmd';
	      } else {
	        url = addressOptions.url ? addressOptions.url : '/AjaxAddressAddCmd';
	      }
	      var orderItemId = '';
	      var multiAddress = '';
	      var addressIdsToUpdate = [];
	
	      if (typeof checkoutPage !== 'undefined' && typeof addressOptions !== 'undefined') {
	        if (!COSTCO.util.isBusinessDelivery()) {
	          orderItemId = addressOptions.orderItemId;
	        }
	        if (checkoutPage === 'multi-shipping') {
	          multiAddress = 'true';
	          var cartCount = $.cookie('cartCountCookie');
	          for (i = 0; i < cartCount; i++) {
	            addressIdsToUpdate[i] = $('#addressId_' + (i + 1)).val();
	          }
	          var addressIdsToUpdateString = encodeURIComponent(JSON.stringify(addressIdsToUpdate));
	          CAddress.addressTools.applyAddressToOrderItems = false;
	        } else if (checkoutPage === 'shipping') {
	          multiAddress = 'false';
	        }
	      }
	      var queryObject = {
	        addressType: CAddress.addressTools.addressType,
	        applyAddressToOrder: CAddress.addressTools.applyAddressToOrder,
	        applyAddressToOrderItems: CAddress.addressTools.applyAddressToOrderItems,
	        orderItemId: orderItemId,
	        multiAddress: multiAddress,
	        modular: 'true',
	        requesttype: 'ajax',
	        addressIdsToUpdate: addressIdsToUpdateString,
	        preventHtmlReload: costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE && $((CAddress.addressTools.addressType === 'S' ? '#shipping' : '#billing') + ' #address-modal-inline').length > 0
	      };
	
	      return COSTCO.util.makeUrl(url, queryObject);
	    },
	    urlChoose: function urlChoose(orderItemId) {
	      return '/AjaxAddressAddCmd?mode=CHOOSE&addressType=' + CAddress.addressTools.addressType + '&applyAddressToOrder=' + CAddress.addressTools.applyAddressToOrder + '&applyAddressToOrderItems=' + CAddress.addressTools.applyAddressToOrderItems + '&orderItemId=' + orderItemId + '&modular=true&requesttype=ajax';
	    },
	    applyAddressToWhat: function applyAddressToWhat(type) {
	      // stateful change of addressTools url params
	      if (type === 'B') {
	        CAddress.addressTools.addressType = 'B';
	        CAddress.addressTools.applyAddressToOrder = 'true';
	        CAddress.addressTools.applyAddressToOrderItems = 'false';
	      } else if (type === 'S') {
	        CAddress.addressTools.addressType = 'S';
	        CAddress.addressTools.applyAddressToOrder = 'false';
	        CAddress.addressTools.applyAddressToOrderItems = 'true';
	      } else {
	        CAddress.addressTools.addressType = 'T';
	        CAddress.addressTools.applyAddressToOrder = 'false';
	        CAddress.addressTools.applyAddressToOrderItems = 'false';
	      }
	    },
	    chooseAddress: function chooseAddress(oldAddyId, newAddyId, orderItemId) {
	      var oldAddy = CAddress.getAddressElement(oldAddyId, '', true);
	      var newAddy = CAddress.getAddressElement(newAddyId, '', true);
	      var oldZipcode;
	      var orderHasEddItems = $('#orderHasEddItems').val();
	      if (newAddy.addressType === 'S' && undefined !== orderHasEddItems) {
	        if (orderHasEddItems === 'true') {
	          oldZipcode = $.cookie("invCheckPostalCode");
	          if (typeof sessionStorage !== "undefined" && null !== oldZipcode) {
	            sessionStorage.setItem('oldZipcode', oldZipcode);
	          }
	          $.cookie("invCheckPostalCode", newAddy.zip.toUpperCase());
	          $.cookie("invCheckStateCode", newAddy.state);
	          $.cookie("invCheckCity", newAddy.city);
	        }
	      }
	
	      //update WAREHOUSEDELIVERY_WHS cookie when changing shipping address
	      if (!COSTCO.util.isBusinessDelivery($('#isBDAppVar').val()) && typeof oldZipcode !== 'undefined' && typeof newAddy.zip !== 'undefined') {
	        if (oldZipcode.toUpperCase() != newAddy.zip.toUpperCase()) {
	          CAddress.updateWarehouseCookie(newAddy.zip.toUpperCase());
	        }
	      }
	
	      if (!oldAddy) {
	        oldAddy = newAddy;
	      }
	      oldAddy['newAddressId'] = newAddy.id;
	      CAddress.applyAddressToWhat(oldAddy.addressType);
	      var labels = CAddress.getHeaderLabels(oldAddy['addressType'], 'choose');
	      var inputContainer = '#address_change_' + newAddyId;
	      if (orderItemId) {
	        inputContainer = '#address_change_' + newAddyId + '_' + orderItemId;
	      }
	
	      var callChooseAddress = function callChooseAddress() {
	
	        COSTCO.Checkout.ajax_update_state({
	          url: CAddress.urlChoose(orderItemId),
	          method: "POST",
	          dataType: 'json',
	          data: {
	            'authToken': COSTCO.Checkout.getAuthToken(),
	            'oldZipcode': oldZipcode,
	            formdata: encodeURIComponent(JSON.stringify(oldAddy))
	          },
	          replaceKey: {
	            original: 'address-block',
	            replace: labels.replaceKey
	          },
	          done: function done(data, textStatus, jqXHR, options) {
	            if (checkoutPage === 'review' && costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE && typeof COSTCO.CreditCard !== 'undefined') {
	              COSTCO.CreditCard.initComplete = false;
	            }
	            COSTCO.Checkout.ajax_update_default_done(data, textStatus, jqXHR, options);
	          },
	          ajax_update_post_done: function ajax_update_post_done() {
	            if (typeof checkoutPage != 'undefined') {
	              apiAlreadyCalled = undefined;
	              COSTCO.OrderItems.init();
	
	              if (checkoutPage == 'review') {
	                COSTCO.CreditCard.initComplete = false;
	                COSTCO.CreditCard.init();
	                if (COSTCO.util.isBusinessDelivery()) {
	                  COSTCO.Header.miniShopCartRefresh();
	                }
	              }
	            }
	            if (COSTCO.util.isBusinessDelivery() && newAddy.addressType == 'B') {
	              COSTCO.dialog.close();
	            }
	            $('body').trigger('costco.address.selected', newAddy);
	          },
	          ajax_handle_errors: function ajax_handle_errors(response_obj) {
	
	            var $errorContainer = $('#header-error-container');
	
	            var application = response_obj.error.application || [];
	            var exception = response_obj.error.exception || [];
	            var error_html = '';
	            if (exception.length > 0) {
	              error_html += '<p>An unexpected error has occured</p>';
	            }
	            application.forEach(function (error_message) {
	              error_html += '<p>' + error_message.replace(/''/g, '\'') + '</p>';
	            });
	
	            if (response_obj.error.redirect && error_html && error_html.indexOf(messages.ERR_INVALID_DUALCART_MSG) > -1) {
	              document.location.href = '/' + response_obj.error.redirect;
	              return;
	            }
	
	            var warning_data = response_obj.payload.data[0] || [];
	            var warning_status = warning_data["warning"] || [];
	            if (warning_status.length > 0) {
	              var warning_message = warning_data["message"];
	              error_html += '<p>' + warning_message + '</p>';
	            }
	
	            if (error_html == '' || error_html.length == 0) {
	              $('body').trigger('costco.ajax.content.update.sucess', response_obj);
	
	              if ($errorContainer.length > 0) {
	                $errorContainer.children().remove();
	                $errorContainer.removeClass('critical-notification');
	              }
	            } else {
	              if ($errorContainer.length > 0) {
	                $errorContainer.children().remove();
	                $errorContainer.addClass('critical-notification');
	                $errorContainer.append(error_html);
	              }
	
	              if (COSTCO.util.has_errors(response_obj)) {
	                $('body').trigger('costco.ajax.content.update.error', response_obj);
	              }
	            }
	          },
	          always: function always() {
	            COSTCO.Checkout.ajax_update_default_always(inputContainer);
	            COSTCO.preauthchargesmodal.init();
	          },
	          inputContainer: inputContainer,
	          scrollToError: false
	        });
	      };
	
	      if (newAddy.addressType === 'S' && (COSTCO.util.isBusinessDelivery($('#isBDAppVar').val()) || checkoutPage != 'shipping' && checkoutPage != 'review')) {
	        var submitZipCodeForValidation = function submitZipCodeForValidation() {
	          var submitParams = [orderItemId];
	          var form = $('#formshipping');
	          var callBack = COSTCO.CAddress.addressValidateSuccessOnChooseAddress;
	          if (checkoutPage == 'review') {
	            form = $('#formreview');
	          }
	          form.find("input[name=zipCodeFormDeliveryZipCode]").val(newAddy.zip);
	          COSTCO.zipCodeModal.submitZipCodeForValidation(form, callBack, null, submitParams, oldAddy, newAddy);
	        };
	
	        var serviceToUpdateCookies = $('#isGeocodeService').val() != "true" ? COSTCO.util.callBingAndUpdateCookies : COSTCO.util.callGeocodeAPIAndUpdateCookies;
	        serviceToUpdateCookies(newAddy.zip).then(function () {
	          if (COSTCO.util.isBusinessDelivery($('#isBDAppVar').val()) && typeof checkoutPage != 'undefined' && (checkoutPage || checkoutPage === 'review' || checkoutPage === 'shipping')) {
	            submitZipCodeForValidation();
	          } else {
	            callChooseAddress();
	          }
	        }, function () {
	          //Allow the flow for CABD here, as we allow all codes if FSA is right, and delivery not segmented
	          if (COSTCO.util.isBusinessDelivery() && COSTCO.util.isCABDStore() && typeof checkoutPage != 'undefined' && (checkoutPage || checkoutPage === 'review' || checkoutPage === 'shipping')) {
	            submitZipCodeForValidation();
	          }
	        });
	      } else {
	        callChooseAddress();
	      }
	    },
	    addressSetZipSuccess: function addressSetZipSuccess(data, params, form, newAddy) {
	      if (data.errorMessage) {
	        $('#addressFormInlineButton').removeAttr('disabled');
	        COSTCO.CAddressForm.addressNotServicedModal(newAddy, undefined, function () {
	          window.location.replace('http://' + $('#desktopHostName').val());
	        });
	      } else {
	        //AJAX CALL to Merge Contract
	        $.ajax({
	          url: '/CheckoutCartView',
	          type: 'POST',
	          data: { skipCartRedirect: true
	          },
	          dataType: 'html',
	          success: function success(data, textStatus, xhr) {
	            if (typeof checkoutPage != 'undefined') {
	              COSTCO.OrderItems.order_prepare();
	
	              // USBD only: force re-init of COSTCO.CreditCard when changing to delivery address ZIP on Place Order
	              if (COSTCO.util.isBusinessDelivery() && COSTCO.util.isUSBDStore() && checkoutPage == 'review' && typeof COSTCO.CreditCard !== 'undefined') {
	                COSTCO.CreditCard.initComplete = false;
	              }
	            } else {
	              window.location.reload();
	            }
	          },
	          error: function error(xhr, textStatus, errorThrown) {
	            if (typeof checkoutPage != 'undefined') {
	              COSTCO.OrderItems.order_prepare();
	            } else {
	              window.location.reload();
	            }
	          }
	        });
	      }
	    },
	    /**
	     * Choose new address.
	     * @return {void}
	     */
	    callChooseAddressNew: function callChooseAddressNew(orderItemId, oldAddy, newAddy, data) {
	      var labels = CAddress.getHeaderLabels(oldAddy['addressType'], 'choose');
	      var inputContainer = '#address_change_' + newAddy.id;
	      if (orderItemId) {
	        inputContainer = '#address_change_' + newAddy.id + '_' + orderItemId;
	      }
	
	      var options = {
	        url: CAddress.urlChoose(orderItemId),
	        method: "POST",
	        dataType: 'json',
	        data: {
	          'authToken': COSTCO.Checkout.getAuthToken(),
	          formdata: encodeURIComponent(JSON.stringify(oldAddy)),
	          userSelectionDeliveryMethod: data && data.userSelectionDeliveryMethod ? data.userSelectionDeliveryMethod : ''
	        },
	        replaceKey: {
	          original: 'address-block',
	          replace: labels.replaceKey
	        },
	        done: function done(data, textStatus, jqXHR, options) {
	          if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE && typeof COSTCO.CreditCard !== 'undefined') {
	            COSTCO.CreditCard.initComplete = false;
	          }
	          // BD only: Update WC_BD_LOC cookie if ZIP is also changed on address change
	          if (COSTCO.util.isBusinessDelivery() && options.changeZip) {
	            if ($('#isGeocodeService').val() != "true") {
	              COSTCO.util.callBingAndUpdateBDLocationCookie($.cookie('WC_BD_ZIP'));
	            } else {
	              COSTCO.util.callGeocodeApiAndUpdateBDLocationCookie($.cookie('WC_BD_ZIP'));
	            }
	          }
	          COSTCO.Checkout.ajax_update_default_done(data, textStatus, jqXHR, options);
	        },
	        ajax_update_post_done: function ajax_update_post_done(data) {
	          /* Default function body, extracted so it can be combined with promises. */
	          function postDone(data) {
	            COSTCO.CAddress.closeModal();
	            COSTCO.CAddress.bindEvents();
	            COSTCO.OrderItems.init();
	
	            if (checkoutPage === 'review') {
	              COSTCO.CreditCard.initComplete = false;
	              COSTCO.CreditCard.init();
	              if (COSTCO.util.isBusinessDelivery()) {
	                COSTCO.Header.miniShopCartRefresh();
	              }
	            }
	            if (COSTCO.util.isBusinessDelivery() && COSTCO.util.isUSBDStore() && $('#residential-address-notification').length) {
	              $('#residential-address-notification').remove();
	            }
	          }
	          if (typeof checkoutPage != 'undefined') {
	            // STRY0183851: BD only - in case of mismatch with Accertify.jspf cookie data, ajax-refresh Payment section
	            if (COSTCO.util.isBusinessDelivery() && checkoutPage != 'cart' && $('input#whs-cookie-accertify').length && COSTCO.util.getBDZipCookie().warehouseNumber != $('input#whs-cookie-accertify').val()) {
	              COSTCO.Checkout.ajaxRefreshAllCheckoutSections().then(function () {
	                postDone(data);
	              });
	            } else {
	              postDone(data);
	            }
	          }
	        },
	
	        always: function always() {
	          COSTCO.Checkout.ajax_update_default_always(inputContainer);
	          COSTCO.preauthchargesmodal.init();
	        },
	        inputContainer: inputContainer,
	        scrollToError: false,
	        changeZip: oldAddy.zip != newAddy.zip
	      };
	      COSTCO.Checkout.ajax_update_state(options);
	    },
	    addressValidateSuccessOnChooseAddress: function addressValidateSuccessOnChooseAddress(data, params, form, chosenAddress, oldAddy) {
	      $('#addressFormInlineButton').removeAttr('disabled');
	      $('#changeDeliveryText1').hide();$('#changeDeliveryText2').hide();$('#changeDeliveryText3').hide();$('#changeDeliveryText4').hide();$('#locationZipError').hide();
	      var userDeliveryMethod = '';
	      var isUserCurrentOrderItemsAvailable = $('#isUserCurrentOrderItemsAvailable').val();
	      //Set address type
	      if (COSTCO.util.isNdEnabled()) {
	        userDeliveryMethod = $('form#CheckoutReviewForm input[name=orderShipmodeId]').val() == '10101' ? 'Local' : 'Nationwide';
	        if (data.WarehouseChange && !data.ShowAddressTypePopup) {
	          userDeliveryMethod = 'Nationwide';
	        }
	        if (data.WarehouseChange && data.IsInBDTruckZoneOnly) {
	          userDeliveryMethod = 'Local';
	        }
	        if (data.WarehouseChange && data.IsStorePickupOnly) {
	          userDeliveryMethod = 'Store-Pick-Up';
	        }
	        data.userSelectionDeliveryMethod = userDeliveryMethod;
	      }
	      if (data.ResidentialStatusMessage == "ERR_INVALID_RESIDENTIAL_WAREHOUSE" && userDeliveryMethod == 'Nationwide') {
	        COSTCO.CAddressForm.addressNotServicedModal(chosenAddress, undefined, function () {
	          window.location.replace('http://' + $('#desktopHostName').val());
	        }, "residentialNotServiced");
	      } else if (data.BargeOrderZip == true) {
	        if (oldAddy == null) {
	          COSTCO.CAddress.callAddressAddNew(params[2], params[3], chosenAddress, params[4]);
	        } else {
	          COSTCO.CAddress.callChooseAddressNew(params[2], oldAddy, chosenAddress);
	        }
	      } else if ((data != undefined && data.ExternalCarrierChange && userDeliveryMethod == 'Nationwide' || data != undefined && data.WarehouseChange && userDeliveryMethod == 'Local') && isUserCurrentOrderItemsAvailable) {
	        COSTCO.CAddress.launchModalOnAddrChange(data, params, form, undefined, userDeliveryMethod, oldAddy, chosenAddress);
	      } else {
	        if (data.StatusMessage == data.ZipStatusMessageList[4] && isUserCurrentOrderItemsAvailable) {
	          COSTCO.ziphelper.setLocationCookie(data.Set_C_LOC_Cookie);
	          COSTCO.CAddress.launchModalOnAddrChange(data, params, form, undefined, userDeliveryMethod, oldAddy, chosenAddress);
	        } else {
	          if (data.StatusMessage == data.ZipStatusMessageList[2] || data.StatusMessage == data.ZipStatusMessageList[0] || data.StatusMessage == data.ZipStatusMessageList[4] || data.StatusMessage == data.ZipStatusMessageList[7]) {
	            if (data.StatusMessage == data.ZipStatusMessageList[7] && COSTCO.CAddress.isZipOrDeliveryMethodChange(data, userDeliveryMethod)) {
	              COSTCO.CAddress.launchModalOnAddrChange(data, params, form, undefined, userDeliveryMethod, oldAddy, chosenAddress);
	            } else {
	              if (oldAddy == null) {
	                COSTCO.CAddress.callAddressAddNew(params[2], params[3], chosenAddress, params[4], data);
	              } else {
	                COSTCO.CAddress.callChooseAddressNew(params[2], oldAddy, chosenAddress, data);
	              }
	            }
	          } else {
	            COSTCO.CAddressForm.addressNotServicedModal(chosenAddress, undefined, function () {
	              window.location.replace('http://' + $('#desktopHostName').val());
	            });
	          }
	        }
	      }
	    },
	    launchModalOnAddrChange: function launchModalOnAddrChange(data, params, form, verifiedAddress, userDeliveryMethod, oldAddy, newAddy) {
	
	      var fromZipCodeToDisplay = data.bdZipCookieOriginal;
	      if (fromZipCodeToDisplay == null || fromZipCodeToDisplay == "undefined" || fromZipCodeToDisplay == "") {
	        fromZipCodeToDisplay = data.CurrentDeliveryZip;
	      }
	
	      var popupMsg = "";
	      var isCheckoutFlow = false;
	      if (typeof checkoutPage !== 'undefined') {
	        if (checkoutPage == 'review' || checkoutPage == 'shipping') {
	          isCheckoutFlow = true;
	        }
	      }
	      if (!COSTCO.util.isNdEnabled()) {
	        // ND disabled flow
	        popupMsg = COSTCO.util.isUSBDStore() ? messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT_ND_OFF_USBD : messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT_ND_OFF;
	        popupMsg = popupMsg.replace(/\{0\}/g, fromZipCodeToDisplay);
	        popupMsg = popupMsg.replace(/\{1\}/g, data.SetDeliveryZip);
	      } else if (data.RegisteredUser) {
	        // ND enabled flow
	        if (data.InactiveZipMessage.length > 0) {
	          popupMsg = data.InactiveZipMessage;
	        } else if (data.NewWarehouseAlert.length > 0) {
	          popupMsg = data.NewWarehouseAlert;
	        } else if (!isCheckoutFlow && (data.ExternalCarrierChange || data.WarehouseChange) || isCheckoutFlow && data.ExternalCarrierChange && userDeliveryMethod == 'Nationwide' || data.WarehouseChange && userDeliveryMethod == 'Local') {
	          var errorMessage2;
	          if (data.SetDeliveryZip == data.CurrentDeliveryZip) {
	            errorMessage2 = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT9;
	          } else {
	            errorMessage2 = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT8;
	          }
	          errorMessage2 = errorMessage2.replace(/\{0\}/g, fromZipCodeToDisplay);
	          errorMessage2 = errorMessage2.replace(/\{1\}/g, data.SetDeliveryZip);
	          popupMsg = errorMessage2;
	        } else {
	          var errorMessage3;
	          if (data.SetDeliveryZip == data.CurrentDeliveryZip) {
	            errorMessage3 = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT9;
	          } else {
	            errorMessage3 = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT8;
	          }
	          errorMessage3 = errorMessage3.replace(/\{0\}/g, fromZipCodeToDisplay);
	          errorMessage3 = errorMessage3.replace(/\{1\}/g, data.SetDeliveryZip);
	          popupMsg = errorMessage3;
	        }
	      } else {
	        var errorMessage1;
	        if (data.SetDeliveryZip == data.CurrentDeliveryZip) {
	          errorMessage1 = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT9;
	        } else {
	          errorMessage1 = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT8;
	        }
	        errorMessage1 = errorMessage1.replace(/\{0\}/g, fromZipCodeToDisplay);
	        errorMessage1 = errorMessage1.replace(/\{1\}/g, data.SetDeliveryZip);
	        popupMsg = errorMessage1;
	      }
	
	      if (data.StatusMessage == data.ZipStatusMessageList[5]) {
	        COSTCO.zipCodeModal.dialogAlert(popupMsg, form);
	      } else if (data.StatusMessage == data.ZipStatusMessageList[4] || data.StatusMessage == data.ZipStatusMessageList[7] && userDeliveryMethod && !(data.ExternalCarrierChange && userDeliveryMethod == 'Nationwide' || data.WarehouseChange && userDeliveryMethod == 'Local')) {
	        COSTCO.CAddress.changeZipDialogOnAddrChange(data, params, popupMsg, form, verifiedAddress, userDeliveryMethod, oldAddy, newAddy);
	      } else {
	        if (COSTCO.util.isNdEnabled()) {
	          COSTCO.CAddress.dialogOnAddrChange(data.SetDeliveryZip, params, popupMsg, form, data, userDeliveryMethod, oldAddy, newAddy);
	        } else {
	          COSTCO.CAddress.dialogOnAddrChange(data.SetDeliveryZip, params, popupMsg, form, null, null, oldAddy, newAddy);
	        }
	      }
	    },
	    changeZipDialogOnAddrChange: function changeZipDialogOnAddrChange(data, params, popupMsg, form, verifiedAddress, userAddressType, oldAddy, newAddy) {
	      var primaryButton = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_ZIP_CODE_BUTTON;
	      var titleMsg = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_HEADER;
	      var messageQues = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_QUESTION1;
	      COSTCO.dialog.createExtDialogBox({
	        title: titleMsg,
	        body: COSTCO.util.tmpl('tmpl_change_delivery_zipcode', {
	          messageTxt: popupMsg,
	          msgQuestion: messageQues }),
	        primary: primaryButton,
	        secondary: messages.ZIPCODE_SELECTOR_CANCEL_BUTTON,
	        primary_event: function primary_event() {
	          if (data != null && data.ShowAddressTypePopup && data.redirectURL[0] == "SetDeliveryZip") {
	            if (data.ResidentialStatusMessage == "ERR_INVALID_RESIDENTIAL_WAREHOUSE") {
	              $(form).find("#WC_BusinessDeliveryBrowseForm_FormInput_userSelectedDeliveryMethod").val('Local');
	              COSTCO.zipCodeModal.submitZipCode(form);
	            } else {
	              COSTCO.zipCodeModal.viewAddressTypeModal(form, data, params);
	            }
	          } else if (COSTCO.util.isNdEnabled() && data && (data.StatusMessage == data.ZipStatusMessageList[4] || data.StatusMessage == data.ZipStatusMessageList[7]) && data.ShowDeliveryMethodPopup) {
	            COSTCO.CAddressVerification.viewDeliveryMethodModal(form, data, params, oldAddy, newAddy);
	          } else {
	            if (oldAddy == null) {
	              //add address flow
	              COSTCO.CAddress.callAddressAddNew(params[2], params[3], newAddy, params[4]);
	            } else {
	              COSTCO.CAddress.callChooseAddressNew(params[2], oldAddy, newAddy);
	            }
	          }
	        }
	      });
	      $('.close').removeClass("hidden");
	    },
	    dialogOnAddrChange: function dialogOnAddrChange(currentZip, optParams, popupMsg, form, data, userDeliveryMethod, oldAddy, newAddy) {
	      var primaryButton = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_ZIP_CODE_BUTTON;
	      var titleMsg = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_HEADER;
	      var messageQues = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_QUESTION1;
	      COSTCO.dialog.createExtDialogBox({
	        title: titleMsg,
	        body: COSTCO.util.tmpl('tmpl_change_delivery_zipcode', {
	          messageTxt: popupMsg,
	          msgQuestion: messageQues }),
	        primary: primaryButton,
	        secondary: messages.ZIPCODE_SELECTOR_CANCEL_BUTTON,
	        primary_event: function primary_event() {
	          if (COSTCO.util.isNdEnabled() && data && data.StatusMessage == data.ZipStatusMessageList[7] && data.ShowDeliveryMethodPopup) {
	            COSTCO.CAddressVerification.viewDeliveryMethodModal(form, data, optParams, oldAddy, newAddy);
	          } else {
	            if (oldAddy == null) {
	              //add address flow
	              COSTCO.CAddress.callAddressAddNew(optParams[2], optParams[3], newAddy, optParams[4], data);
	            } else {
	              COSTCO.CAddress.callChooseAddressNew(optParams[2], oldAddy, newAddy, data);
	            }
	          }
	        }
	      });
	    },
	    /**
	     * Add new address.
	     * @return {void}
	     */
	    callAddressAddNew: function callAddressAddNew(addressType, addressOptions, verifiedAddress, preventajaxhtml, data) {
	
	      CAddress.applyAddressToWhat(addressType);
	      if (checkoutPage == 'review' || checkoutPage == 'shipping') {
	        isCheckoutFlow = true;
	      }
	      if (COSTCO.util.isBusinessDelivery($('#isBDAppVar').val()) && !isCheckoutFlow) {
	        CAddress.addressTools.applyAddressToOrderItems = 'false';
	      }
	      var labels = CAddress.getHeaderLabels(addressType, 'add');
	      var options = {
	        url: verifiedAddress.id !== "" ? CAddress.urlAddUpdate(addressOptions) : CAddress.urlAdd(addressOptions),
	        method: "POST",
	        dataType: 'json',
	        data: {
	          'authToken': COSTCO.Checkout.getAuthToken(),
	          formdata: encodeURIComponent(JSON.stringify(verifiedAddress)),
	          userSelectionDeliveryMethod: data && data.userSelectionDeliveryMethod ? data.userSelectionDeliveryMethod : ''
	        },
	        replaceKey: {
	          original: 'address-block',
	          replace: labels.replaceKey
	        },
	        done: function done(data, textStatus, jqXHR, options) {
	          if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE && COSTCO.CreditCard !== undefined) {
	            COSTCO.CreditCard.initComplete = false;
	          }
	          if (!data.errorMessage) {
	            COSTCO.Checkout.ajax_update_default_done(data, textStatus, jqXHR, options);
	          } else {
	            var parentNode = document.getElementById("costcoModalText");
	            if (parentNode !== null) {
	              var newDiv = document.createElement("div");
	              newDiv.innerHTML = data.errorMessage;
	              newDiv.className = 'error';
	              parentNode.prepend(newDiv);
	            }
	          }
	        },
	        ajax_update_post_done: function ajax_update_post_done(data) {
	          /* Default function body, extracted so it can be combined with promises. */
	          function postDone(data) {
	            var application = data.error.application;
	            if (application.length === 0) {
	              COSTCO.util.resetAddressLoadState();
	              COSTCO.CAddress.closeModal();
	              $('body').trigger("costco.address.added", data.payload.data[1]);
	            } else {
	              $('body').trigger("costco.address.error", application);
	            }
	            CAddress.bindEvents();
	            if (addressOptions.addressBookReinit) {
	              COSTCO.CAddressBook.init();
	            }
	            if (checkoutPage) {
	              COSTCO.OrderItems.init();
	
	              if (checkoutPage === 'review') {
	                COSTCO.CreditCard.initComplete = false;
	                COSTCO.CreditCard.init();
	                if (COSTCO.util.isBusinessDelivery()) {
	                  COSTCO.Header.miniShopCartRefresh();
	                  COSTCO.preauthchargesmodal.init();
	                }
	              }
	              if (COSTCO.util.isBusinessDelivery() && COSTCO.util.isUSBDStore() && $('#residential-address-notification').length) {
	                $('#residential-address-notification').remove();
	              }
	            }
	          }
	          // STRY0183851: BD only - in case of mismatch with Accertify.jspf cookie data, ajax-refresh Payment section
	          if (typeof checkoutPage != 'undefined' && checkoutPage != 'cart' && COSTCO.util.isBusinessDelivery() && $('input#whs-cookie-accertify').length && COSTCO.util.getBDZipCookie().warehouseNumber != $('input#whs-cookie-accertify').val()) {
	            COSTCO.Checkout.ajaxRefreshAllCheckoutSections().then(function () {
	              postDone(data);
	            });
	          } else {
	            postDone(data);
	          }
	        }
	      };
	      if (preventajaxhtml) {
	        options.ajax_replace_content = function () {};
	      }
	      COSTCO.Checkout.ajax_update_state(options);
	    },
	    addressValidateSuccess: function addressValidateSuccess(data, params, form, verifiedAddress) {
	      $('#addressFormInlineButton').removeAttr('disabled');
	      $('#changeDeliveryText1').hide();$('#changeDeliveryText2').hide();$('#changeDeliveryText3').hide();$('#changeDeliveryText4').hide();$('#locationZipError').hide();
	      var userDeliveryMethod = '';
	      var isUserCurrentOrderItemsAvailable = $('#isUserCurrentOrderItemsAvailable').val();
	      if (COSTCO.util.isNdEnabled()) {
	        userDeliveryMethod = $('form#CheckoutReviewForm input[name=orderShipmodeId]').val() == '10101' ? 'Local' : 'Nationwide';
	        if (!data.ShowDeliveryMethodPopup && !data.ShowAddressTypePopup) {
	          userDeliveryMethod = 'Nationwide';
	        }
	        if (!data.ShowDeliveryMethodPopup && data.IsInBDTruckZoneOnly) {
	          userDeliveryMethod = 'Local';
	        }
	        if (!data.ShowDeliveryMethodPopup && data.IsStorePickupOnly) {
	          userDeliveryMethod = 'Store-Pick-Up';
	        }
	      }
	      if (data.ResidentialStatusMessage == "ERR_INVALID_RESIDENTIAL_WAREHOUSE" && userDeliveryMethod == 'Nationwide') {
	        COSTCO.CAddressForm.addressNotServicedModal(verifiedAddress, undefined, function () {
	          window.location.replace('http://' + $('#desktopHostName').val());
	        }, "residentialNotServiced");
	      } else if (data.BargeOrderZip == true) {
	        COSTCO.CAddress.submitAddress(data, params, form, verifiedAddress);
	        $('body').bind('costco.address.added', function (event, address) {
	          $('#NewAddressSingleShippingForm input[name="addressId"]').val(address.addressId);
	          $('#NewAddressSingleShippingForm').submit();
	        });
	      } else {
	        if (data.StatusMessage == data.ZipStatusMessageList[4] && isUserCurrentOrderItemsAvailable) {
	          COSTCO.ziphelper.setLocationCookie(data.Set_C_LOC_Cookie);
	          COSTCO.zipCodeModal.launchModal(data, params, form, verifiedAddress);
	        } else {
	          if (data.StatusMessage == data.ZipStatusMessageList[2] || data.StatusMessage == data.ZipStatusMessageList[0] || data.StatusMessage == data.ZipStatusMessageList[4] || data.StatusMessage == data.ZipStatusMessageList[7]) {
	            if (data.StatusMessage == data.ZipStatusMessageList[7] && COSTCO.CAddress.isZipOrDeliveryMethodChange(data)) {
	              COSTCO.zipCodeModal.launchModal(data, params, form, verifiedAddress);
	            } else {
	              if (COSTCO.util.isNdEnabled() && (data.StatusMessage == data.ZipStatusMessageList[4] || data.StatusMessage == data.ZipStatusMessageList[7]) && userDeliveryMethod == 'Local') {
	                COSTCO.CAddressForm.showNationalDeliveryQuestionnaireModal_v2(form, data, params, verifiedAddress);
	              } else {
	                data.userSelectionDeliveryMethod = userDeliveryMethod;
	                COSTCO.CAddress.submitAddress(data, params, form, verifiedAddress);
	                $('body').bind('costco.address.added', function (event, address) {
	                  $('#NewAddressSingleShippingForm input[name="addressId"]').val(address.addressId);
	                  $('#NewAddressSingleShippingForm').submit();
	                });
	              }
	            }
	          } else {
	            COSTCO.CAddressForm.addressNotServicedModal(verifiedAddress, undefined, function () {
	              window.location.replace('http://' + $('#desktopHostName').val());
	            });
	          }
	        }
	      }
	    },
	    submitAddress: function submitAddress(data, params, form, verifiedAddress) {
	      if (data != null && data.BargeOrderZip == false) {
	        COSTCO.ziphelper.setZipCookie(data.SetDeliveryZip);
	        COSTCO.ziphelper.setLocationCookie(data.Set_C_LOC_Cookie);
	        $('#header-delivery-zip').find('#bdzip').text(data.SetDeliveryZip);
	      }
	      var addressType = '';
	      if (verifiedAddress.addressType == null) {
	        addressType = verifiedAddress.addressType2.trim();
	      } else {
	        addressType = verifiedAddress.addressType.trim();
	      }
	      CAddress.applyAddressToWhat(addressType);
	      var labels = CAddress.getHeaderLabels(addressType, 'add');
	      var options = {
	        url: verifiedAddress.id != "" ? CAddress.urlAddUpdate() : CAddress.urlAdd(),
	        method: "POST",
	        dataType: 'json',
	        data: {
	          'authToken': COSTCO.Checkout.getAuthToken(),
	          formdata: encodeURIComponent(JSON.stringify(verifiedAddress)),
	          userSelectionDeliveryMethod: data && data.userSelectionDeliveryMethod ? data.userSelectionDeliveryMethod : ''
	        },
	        replaceKey: {
	          original: 'address-block',
	          replace: labels.replaceKey
	        },
	        done: function done(data, textStatus, jqXHR, options) {
	          if (!data.errorMessage) {
	            COSTCO.Checkout.ajax_update_default_done(data, textStatus, jqXHR, options);
	          } else {
	            var parentNode = document.getElementById("costcoModalText");
	            if (parentNode != null) {
	              var newDiv = document.createElement("div");
	              newDiv.innerHTML = data.errorMessage;
	              newDiv.className = 'error';
	              parentNode.prepend(newDiv);
	            }
	          }
	        },
	        ajax_update_post_done: function ajax_update_post_done(data) {
	          var application = data.error.application;
	          if (application.length == 0) {
	            COSTCO.util.resetAddressLoadState();
	            COSTCO.CAddress.closeModal();
	            $('body').trigger("costco.address.added", data.payload.data[1]);
	          } else {
	            $('body').trigger("costco.address.error", application);
	          }
	          CAddress.bindEvents();
	          if (typeof checkoutPage != 'undefined' && checkoutPage) {
	            COSTCO.OrderItems.init();
	            if (checkoutPage == 'review' && !costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE) {
	              COSTCO.CAddress.initializeCreditCardModule();
	            } else if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE && $('#shipping #address-modal-inline').length === 0) {
	              COSTCO.CAddress.initializeCreditCardModule();
	            }
	          }
	        }
	      };
	      COSTCO.Checkout.ajax_update_state(options);
	    },
	    initializeCreditCardModule: function initializeCreditCardModule() {
	      COSTCO.CreditCard.initComplete = false;
	      COSTCO.CreditCard.init();
	    },
	    addressValidateSuccessOnPlaceOrder: function addressValidateSuccessOnPlaceOrder(data, params, form, chosenAddress) {
	      $('#addressFormInlineButton').removeAttr('disabled');
	      $('#changeDeliveryText1').hide();$('#changeDeliveryText2').hide();$('#changeDeliveryText3').hide();$('#changeDeliveryText4').hide();$('#locationZipError').hide();
	      var userDeliveryMethod = '';
	      var isUserCurrentOrderItemsAvailable = $('#isUserCurrentOrderItemsAvailable').val();
	      //Set address type
	      if (COSTCO.util.isNdEnabled()) {
	        userDeliveryMethod = $('form#CheckoutReviewForm input[name=orderShipmodeId]').val() == '10101' ? 'Local' : 'Nationwide';
	        if (data.WarehouseChange && !data.ShowAddressTypePopup) {
	          userDeliveryMethod = 'Nationwide';
	        }
	        if (data.WarehouseChange && data.IsInBDTruckZoneOnly) {
	          userDeliveryMethod = 'Local';
	        }
	        if (data.WarehouseChange && data.IsStorePickupOnly) {
	          userDeliveryMethod = 'Store-Pick-Up';
	        }
	        data.userSelectionDeliveryMethod = userDeliveryMethod;
	      }
	      if (data.ResidentialStatusMessage == "ERR_INVALID_RESIDENTIAL_WAREHOUSE" && userDeliveryMethod == 'Nationwide') {
	        COSTCO.CAddressForm.addressNotServicedModal(chosenAddress, undefined, function () {
	          window.location.replace('http://' + $('#desktopHostName').val());
	        }, "residentialNotServiced");
	      } else if (data.BargeOrderZip == true) {
	        COSTCO.OrderSummary.placeOrder();
	      } else if ((data != undefined && data.ExternalCarrierChange && userDeliveryMethod == 'Nationwide' || data != undefined && data.WarehouseChange && userDeliveryMethod == 'Local') && isUserCurrentOrderItemsAvailable) {
	        COSTCO.zipCodeModal.launchModal(data, params[2] ? [params[2]] : params, form, undefined, userDeliveryMethod);
	      } else {
	        if (data.StatusMessage == data.ZipStatusMessageList[4] && isUserCurrentOrderItemsAvailable) {
	          COSTCO.ziphelper.setLocationCookie(data.Set_C_LOC_Cookie);
	          COSTCO.zipCodeModal.launchModal(data, params, form, undefined, userDeliveryMethod);
	        } else {
	          if (data.StatusMessage == data.ZipStatusMessageList[0] || data.StatusMessage == data.ZipStatusMessageList[4] || data.StatusMessage == data.ZipStatusMessageList[7]) {
	            if (data.StatusMessage == data.ZipStatusMessageList[7] && COSTCO.CAddress.isZipOrDeliveryMethodChange(data, userDeliveryMethod)) {
	              COSTCO.zipCodeModal.launchModal(data, params, form, undefined, userDeliveryMethod);
	            } else {
	              COSTCO.ziphelper.setZipCookie(data.SetDeliveryZip);
	              COSTCO.ziphelper.setLocationCookie(data.Set_C_LOC_Cookie);
	              $('#header-delivery-zip').find('#bdzip').text(data.SetDeliveryZip);
	              COSTCO.OrderSummary.placeOrder();
	            }
	          } else if (data.StatusMessage == data.ZipStatusMessageList[2]) {
	            COSTCO.OrderSummary.placeOrder();
	          } else if (data.StatusMessage == data.ZipStatusMessageList[5] && data.NewWarehouseAlert.length > 0) {
	            COSTCO.zipCodeModal.launchModal(data, params[2] ? [params[2]] : params, form);
	          } else {
	            COSTCO.CAddressForm.addressNotServicedModal(chosenAddress, undefined, function () {
	              window.location.replace('http://' + $('#desktopHostName').val());
	            });
	          }
	        }
	      }
	    },
	    addressValidateSuccessOnSubmitShipping: function addressValidateSuccessOnSubmitShipping(data, params, form, chosenAddress) {
	      $('#addressFormInlineButton').removeAttr('disabled');
	      $('#changeDeliveryText1').hide();$('#changeDeliveryText2').hide();$('#changeDeliveryText3').hide();$('#changeDeliveryText4').hide();$('#locationZipError').hide();
	      var userDeliveryMethod = '';
	      var isUserCurrentOrderItemsAvailable = $('#isUserCurrentOrderItemsAvailable').val();
	      //Set address type
	      if (COSTCO.util.isNdEnabled()) {
	        userDeliveryMethod = $('form#CheckoutReviewForm input[name=orderShipmodeId]').val() == '10101' ? 'Local' : 'Nationwide';
	        if (data.WarehouseChange && !data.ShowAddressTypePopup) {
	          userDeliveryMethod = 'Nationwide';
	        }
	        if (data.WarehouseChange && data.IsInBDTruckZoneOnly) {
	          userDeliveryMethod = 'Local';
	        }
	        if (data.WarehouseChange && data.IsStorePickupOnly) {
	          userDeliveryMethod = 'Store-Pick-Up';
	        }
	        data.userSelectionDeliveryMethod = userDeliveryMethod;
	      }
	      if (data.ResidentialStatusMessage == "ERR_INVALID_RESIDENTIAL_WAREHOUSE" && userDeliveryMethod == 'Nationwide') {
	        COSTCO.CAddressForm.addressNotServicedModal(chosenAddress, undefined, function () {
	          window.location.replace('http://' + $('#desktopHostName').val());
	        }, "residentialNotServiced");
	      } else if (data.BargeOrderZip == true) {
	        $('#NewAddressSingleShippingForm input[name="addressId"]').val(chosenAddress.id);
	        $('#NewAddressSingleShippingForm').submit();
	      } else if ((data != undefined && data.ExternalCarrierChange && userDeliveryMethod == 'Nationwide' || data != undefined && data.WarehouseChange && userDeliveryMethod == 'Local') && isUserCurrentOrderItemsAvailable) {
	        COSTCO.zipCodeModal.launchModal(data, params[2] ? [params[2]] : params, form, undefined, userDeliveryMethod);
	      } else {
	        if (data.StatusMessage == data.ZipStatusMessageList[4] && isUserCurrentOrderItemsAvailable) {
	          COSTCO.ziphelper.setLocationCookie(data.Set_C_LOC_Cookie);
	          COSTCO.zipCodeModal.launchModal(data, params, form, undefined, userDeliveryMethod);
	        } else {
	          if (data.StatusMessage == data.ZipStatusMessageList[0] || data.StatusMessage == data.ZipStatusMessageList[4] || data.StatusMessage == data.ZipStatusMessageList[7]) {
	            if (data.StatusMessage == data.ZipStatusMessageList[7] && COSTCO.CAddress.isZipOrDeliveryMethodChange(data, userDeliveryMethod)) {
	              COSTCO.zipCodeModal.launchModal(data, params, form, undefined, userDeliveryMethod);
	            } else {
	              COSTCO.ziphelper.setZipCookie(data.SetDeliveryZip);
	              COSTCO.ziphelper.setLocationCookie(data.Set_C_LOC_Cookie);
	              $('#header-delivery-zip').find('#bdzip').text(data.SetDeliveryZip);
	              $('#NewAddressSingleShippingForm input[name="addressId"]').val(chosenAddress.id);
	              $('#NewAddressSingleShippingForm input[name="orderShipmodeId"]').val($('form#CheckoutReviewForm input[name=orderShipmodeId]').val());
	              $('#NewAddressSingleShippingForm').submit();
	            }
	          } else if (data.StatusMessage == data.ZipStatusMessageList[2]) {
	            $('#NewAddressSingleShippingForm input[name="addressId"]').val(chosenAddress.id);
	            $('#NewAddressSingleShippingForm').submit();
	          } else if (data.StatusMessage == data.ZipStatusMessageList[5] && data.NewWarehouseAlert.length > 0) {
	            COSTCO.zipCodeModal.launchModal(data, params[2] ? [params[2]] : params, form);
	          } else {
	            COSTCO.CAddressForm.addressNotServicedModal(chosenAddress, undefined, function () {
	              window.location.replace('http://' + $('#desktopHostName').val());
	            });
	          }
	        }
	      }
	    },
	    addEditAddress: function addEditAddress(verifiedAddress, preventajaxhtml, addressOptions, message) {
	
	      if (COSTCO.util.isBusinessDelivery($('#isBDAppVar').val()) && !COSTCO.CAddressForm.isFormCompleted('S') && verifiedAddress.addressType != 'B' && checkoutPage) {
	        if (checkoutPage === 'shipping') {
	          //COSTCO.CAddress.submitAddress(null, verifiedAddress.id, $('#formshipping'), verifiedAddress);
	          $('#formshipping').find('[name=zipCodeFormDeliveryZipCode]').val(verifiedAddress.zip);
	          COSTCO.zipCodeModal.submitZipCodeForValidation($('#formshipping'), COSTCO.CAddress.addressValidateSuccess, COSTCO.CAddress.addressSetZipSuccess, verifiedAddress.id, undefined, verifiedAddress);
	        } else if (checkoutPage === 'review') {
	          $('#formreview').find('[name=zipCodeFormDeliveryZipCode]').val(verifiedAddress.zip);
	          COSTCO.zipCodeModal.submitZipCodeForValidation($('#formreview'), COSTCO.CAddress.addressValidateSuccess, COSTCO.CAddress.addressSetZipSuccess, verifiedAddress.id, undefined, verifiedAddress);
	        }
	      } else {
	        var callAddressAdd = function callAddressAdd(addressType) {
	          CAddress.applyAddressToWhat(addressType);
	          if (COSTCO.util.isBusinessDelivery($('#isBDAppVar').val())) {
	            CAddress.addressTools.applyAddressToOrderItems = 'false';
	          }
	          var labels = CAddress.getHeaderLabels(addressType, 'add');
	          var oldZipcode;
	          var orderHasEddItems = $('#orderHasEddItems').val();
	          if (!addressOptions.addressBookReinit && verifiedAddress.addressType === 'S' && undefined !== orderHasEddItems) {
	            if (orderHasEddItems === 'true') {
	              oldZipcode = $.cookie("invCheckPostalCode");
	              if (typeof sessionStorage !== "undefined" && null !== oldZipcode) {
	                sessionStorage.setItem('oldZipcode', oldZipcode);
	              }
	              $.cookie("invCheckPostalCode", verifiedAddress.zip.toUpperCase());
	              $.cookie("invCheckStateCode", verifiedAddress.state);
	              $.cookie("invCheckCity", verifiedAddress.city);
	            }
	
	            //update WAREHOUSEDELIVERY_WHS cookie
	            if (!COSTCO.util.isBusinessDelivery($('#isBDAppVar').val()) && typeof verifiedAddress.zip !== 'undefined') {
	              CAddress.updateWarehouseCookie(verifiedAddress.zip.toUpperCase());
	            }
	          }
	          var options = {
	            url: verifiedAddress.id !== "" ? CAddress.urlAddUpdate(addressOptions) : CAddress.urlAdd(addressOptions),
	            method: "POST",
	            dataType: 'json',
	            data: { 'authToken': COSTCO.Checkout.getAuthToken(), 'oldZipcode': oldZipcode, formdata: encodeURIComponent(JSON.stringify(verifiedAddress)) },
	
	            replaceKey: {
	              original: 'address-block',
	              replace: labels.replaceKey
	            },
	            done: function done(data, textStatus, jqXHR, options) {
	              if (!data.errorMessage) {
	                if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE && typeof COSTCO.CreditCard !== 'undefined') {
	                  COSTCO.CreditCard.initComplete = false;
	                }
	                COSTCO.Checkout.ajax_update_default_done(data, textStatus, jqXHR, options);
	              } else {
	                var parentNode = document.getElementById("costcoModalText");
	                if (parentNode !== null) {
	                  var newDiv = document.createElement("div");
	                  //BD ALM-3463 fix repetitive error msg
	                  if (COSTCO.util.isBusinessDelivery($('#isBDAppVar').val())) {
	                    var errorDiv = document.getElementById("addressValidationError");
	                    if (errorDiv !== null) {
	                      errorDiv.remove();
	                    }
	                    newDiv.id = 'addressValidationError';
	                  }
	                  newDiv.innerHTML = data.errorMessage;
	                  newDiv.className = 'error';
	                  parentNode.prepend(newDiv);
	                }
	              }
	            },
	            ajax_update_post_done: function ajax_update_post_done(data) {
	              var application = data.error.application;
	              if (application.length === 0) {
	                COSTCO.util.resetAddressLoadState();
	                COSTCO.CAddress.closeModal();
	                $('body').trigger("costco.address.added", data.payload.data[1]);
	              } else {
	                $('body').trigger("costco.address.error", application);
	              }
	              CAddress.bindEvents();
	              if (addressOptions.addressBookReinit) {
	                COSTCO.CAddressBook.init();
	              }
	              if (typeof checkoutPage !== 'undefined' && checkoutPage) {
	                apiAlreadyCalled = undefined;
	                COSTCO.OrderItems.init();
	
	                if (checkoutPage === 'review') {
	                  COSTCO.CreditCard.initComplete = false;
	                  COSTCO.CreditCard.init();
	                  if (COSTCO.util.isBusinessDelivery()) {
	                    COSTCO.Header.miniShopCartRefresh();
	                  }
	                }
	              }
	            },
	            always: function always() {
	              COSTCO.preauthchargesmodal.init();
	            }
	          };
	          if (preventajaxhtml) {
	            options.ajax_replace_content = function () {};
	          }
	          COSTCO.Checkout.ajax_update_state(options);
	        };
	
	        var addressType = '';
	        if (verifiedAddress.addressType === null) {
	          addressType = verifiedAddress.addressType2 !== null ? verifiedAddress.addressType2.trim() : '';
	        } else {
	          addressType = verifiedAddress.addressType.trim();
	          var uniquePageSelector = '';
	          if (typeof checkoutPage !== 'undefined' && checkoutPage) {
	            if (checkoutPage === 'multi-shipping') {
	              uniquePageSelector = '#single-page-checkout-multi-address';
	            } else {
	              uniquePageSelector = '#shipping';
	            }
	          } else {
	            uniquePageSelector = '#shippingTab';
	          }
	          $(uniquePageSelector).find('input[id="addressEnteredForCheck"]').remove();
	          $(uniquePageSelector).append('<input type="hidden" id="addressEnteredForCheck" value="' + verifiedAddress.line1 + '"/>');
	        }
	        // Prevent code breaking if checkoutPage is undefined to fix STRY0158367-Use-
	        // address-functionality-does-notrespond-from-the-address-validation-modal
	        var checkoutPageName = typeof checkoutPage === 'undefined' ? false : checkoutPage;
	
	        if (addressType === 'S' && !addressOptions.addressBookReinit && (COSTCO.util.isBusinessDelivery($('#isBDAppVar').val()) || checkoutPageName != 'shipping' && checkoutPageName != 'review')) {
	          var submitZipCodeForValidation = function submitZipCodeForValidation() {
	            var submitParams = [addressType, addressOptions, preventajaxhtml];
	            var form = $('#formshipping');
	            var callBack = COSTCO.CAddress.addressValidateSuccessOnChooseAddress;
	            if (checkoutPage == 'review') {
	              form = $('#formreview');
	            }
	            form.find("input[name=zipCodeFormDeliveryZipCode]").val(verifiedAddress.zip);
	            COSTCO.zipCodeModal.submitZipCodeForValidation(form, callBack, null, submitParams, null, verifiedAddress);
	          };
	          var serviceToUpdateCookies = $('#isGeocodeService').val() != "true" ? COSTCO.util.callBingAndUpdateCookies : COSTCO.util.callGeocodeAPIAndUpdateCookies;
	          serviceToUpdateCookies(verifiedAddress.zip).then(function () {
	            if (COSTCO.util.isBusinessDelivery($('#isBDAppVar').val()) && typeof checkoutPage != 'undefined' && (checkoutPage || checkoutPage === 'review' || checkoutPage === 'shipping') && message != 'editAddressType') {
	              submitZipCodeForValidation();
	            } else {
	              callAddressAdd(addressType);
	            }
	          }, function () {
	            //Allow the flow for CABD here, as we allow all codes if FSA is right, and delivery not segmented
	            if (COSTCO.util.isBusinessDelivery() && COSTCO.util.isCABDStore() && typeof checkoutPage != 'undefined' && (checkoutPage || checkoutPage === 'review' || checkoutPage === 'shipping') && message != 'editAddressType') {
	              submitZipCodeForValidation();
	            }
	          });
	        } else {
	          callAddressAdd(addressType);
	        }
	      }
	    },
	    getAddressType: function getAddressType(addressId, type) {
	      var string = '';
	      for (var i = 0; i < COSTCO.util.addresses.length; i++) {
	        if (COSTCO.util.addresses[i].id == addressId) {
	          string = COSTCO.util.addresses[i].addressType.toUpperCase();
	          break;
	        }
	      }
	      if (string == '' && typeof type !== 'undefined') {
	        string = type;
	      }
	      return string;
	    },
	    getAddressElement: function getAddressElement(addyId, prop, wholeObj) {
	      for (var i = 0; i < COSTCO.util.addresses.length; i++) {
	        // return specific obj
	        if (wholeObj == true) {
	          if (COSTCO.util.addresses[i].id == addyId) {
	            return COSTCO.util.addresses[i];
	          }
	        } else if (COSTCO.util.addresses[i].id == addyId) {
	          // return specific property
	          return COSTCO.util.addresses[i][prop];
	        }
	      }
	    },
	    getSaveAddress: function getSaveAddress(addressId, isChecked) {
	      return addressId != '' ? CAddress.getAddressElement(addressId, 'addressType') == 'T' ? 'off' : 'on' : isChecked ? 'on' : 'off';
	    },
	    getDefaultAddress: function getDefaultAddress(addressId, isChecked) {
	      if (isChecked) return 'on';
	      return 'off';
	    },
	    isEmptyAddressType: function isEmptyAddressType(type, addyObj) {
	      for (obj in addyObj) {
	        if (addyObj[obj].addressType === type) return false;
	      }
	      return true;
	    },
	    handleServerError: function handleServerError(msg) {
	      // put msg and show associated modal
	      $(CAddress.addressTools.errorContainer).text(msg).show();
	      if ($('.address-edit[addressid=' + CAddress.addressTools.cachedAddressId + ']').length > 0) {
	        $('.address-edit[addressid=' + CAddress.addressTools.cachedAddressId + ']').click();
	      } else if (CAddress.addressTools.errorContainer == '#address-form .text-error') {
	        $('#address-form-modal').costcoModal('showPartial full-page');
	      }
	      $('div').scrollTop($(CAddress.addressTools.errorContainer).offset().top - $('div').offset().top + $('div').scrollTop());
	    },
	    /**
	     * If the user changes their address for grocery items, associate the
	     * new address with all of the grocery items. Where 'this' is the select
	     * DOM element. Called inline on MultiShippingItemAddress.jsp.
	     * @return {void}
	     */
	    groceryItemAddress: function groceryItemAddress() {
	      var selectedGroceryAddress = $(this).val();
	      var $groceryAddresses = $('.grocery-address [name^=addressId_]');
	      $groceryAddresses.val(selectedGroceryAddress);
	    },
	    //-End-Grocery changes
	    getAddressJson: function getAddressJson(addressId, startAddress, type) {
	      if (typeof addressId == 'undefined') {
	        return COSTCO.util.addresses;
	      }
	
	      if (typeof COSTCO.util == 'undefined' || COSTCO.util.addresses.length == 0) {
	        return [];
	      }
	      var returnArray = [];
	      if (isNaN(addressId)) {
	        for (var i = 0; i < COSTCO.util.addresses.length; i++) {
	          if (COSTCO.util.addresses[i].addressType.trim() == addressId) {
	            returnArray.push(COSTCO.util.addresses[i]);
	          }
	        }
	      } else {
	        for (var i = 0; i < COSTCO.util.addresses.length; i++) {
	          if (COSTCO.util.addresses[i].id == addressId) {
	            returnArray.push(COSTCO.util.addresses[i]);
	          }
	        }
	      }
	      if (typeof startAddress !== 'undefined') {
	        var foundIndex = 0;
	        for (var i = 0; i < returnArray.length; i++) {
	          if (returnArray[i].id == startAddress) {
	            foundIndex = i;
	          }
	        }
	        if (foundIndex > 0) {
	          var arrayElement = returnArray.splice(foundIndex, 1)[0];
	          returnArray.unshift(arrayElement);
	        }
	      }
	      // Need to trim address types
	      for (var i = 0; i < returnArray.length; i++) {
	        returnArray[i].addressType = returnArray[i].addressType.trim();
	      }
	      return returnArray;
	    },
	    getStateProvJson: function getStateProvJson(callback) {
	      return countries;
	    },
	    /**
	     * Function used to populate city and state in the responsive address form
	     * Function is tied to the postal code element
	     * 
	     * Params
	     * 		element -> jquery query that contain the postalCode input value
	     * 		cityQuery -> jquery query that locate the input for city
	     * 		stateQuery -> jquery query that locate the input for state
	     * 
	     */
	    bingCityState: function bingCityState(element, cityQuery, stateQuery) {
	      var query = $(element).val();
	
	      var updateFormElements = function updateFormElements(data) {
	        var province = null;
	        var country = null;
	        try {
	          //Check out if country is Puerto Rico specific
	          country = data.resourceSets[0].resources[0].address.countryRegionIso2;
	          if (country != undefined && country === 'PR') {
	            province = data.resourceSets[0].resources[0].address.countryRegionIso2;
	            country = 'US';
	          } else {
	            province = data.resourceSets[0].resources[0].address.adminDistrict;
	          }
	        } catch (e) {
	          province = "";
	        }
	        var city = null;
	        try {
	          city = data.resourceSets[0].resources[0].address.locality;
	        } catch (e) {
	          city = "";
	        }
	
	        if (COSTCO.CAddressForm !== undefined) {
	          COSTCO.CAddressForm.populateCityState(element.form, city, province, cityQuery, stateQuery);
	          //COSTCO.CAddressForm.validate();
	        }
	      };
	      COSTCO.util.callBing(query, updateFormElements);
	    },
	    /**
	        * Function used to populate city and state in the responsive address form
	        * Function is tied to the postal code element
	        * 
	        * Params
	        * 		element -> jquery query that contain the postalCode input value
	        * 		cityQuery -> jquery query that locate the input for city
	        * 		stateQuery -> jquery query that locate the input for state
	        * 
	        */
	    geocodeApiCityState: function geocodeApiCityState(element, cityQuery, stateQuery, editAddrCity, editAddrState) {
	
	      var query = $(element).val();
	
	      var updateFormElements = function updateFormElements(data) {
	        var province = null;
	        var country = null;
	        var city = null;
	        try {
	          city = data[0].city;
	          province = data[0].stateProvinceAbbreviation;
	          if (province == null) {
	            province = data[0].stateProvince;
	          }
	          country = data[0].country;
	        } catch (e) {
	          console.error('Error: ' + e.message);
	        }
	
	        if (COSTCO.CAddressForm !== undefined) {
	          COSTCO.CAddressForm.populateCityState(element.form, city, province, cityQuery, stateQuery);
	        }
	      };
	
	      var updateFormElementsFromZipPostalCode = function updateFormElementsFromZipPostalCode(data) {
	        var provinceList = [];
	        var countryList = [];
	        var cityList = [];
	        try {
	          for (var i = 0; i < data.length; i++) {
	            if (data[i].city != undefined && !cityList.find(function (city) {
	              return city === data[i].city;
	            })) {
	              cityList.push(data[i].city);
	            }
	
	            var existingProv = provinceList.find(function (prov) {
	              return prov.code === data[i].stateProvinceAbbreviation;
	            });
	            if (data[i].stateProvinceAbbreviation != undefined && !existingProv) {
	              var prov = new Object();
	              prov.code = data[i].stateProvinceAbbreviation;
	              prov.displayName = data[i].stateProvince != null ? data[i].stateProvince : data[i].stateProvinceAbbreviation;
	              provinceList.push(prov);
	            }
	
	            if (data[i].country != undefined && !countryList.find(function (country) {
	              return country === data[i].country;
	            })) {
	              countryList.push(data[i].country);
	            }
	          }
	        } catch (e) {
	          console.error('Error: ' + e.message);
	        }
	
	        if (COSTCO.CAddressForm !== undefined) {
	          var form = undefined;
	          if ($(element).form) {
	            form = $(element).form;
	          } else if ($(element).prevObject) {
	            form = $(element).prevObject;
	          } else if ($(element).closest('form')) {
	            form = $(element).closest('form');
	          }
	          if (form != undefined) {
	            COSTCO.CAddressForm.populateCityStateForZipPostalCode(form, cityList, provinceList, cityQuery, stateQuery, editAddrCity, editAddrState);
	            // COSTCO.CAddressForm.validate();
	          }
	        }
	      };
	
	      var geocodeCallback = costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED && $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === "true" ? updateFormElementsFromZipPostalCode : updateFormElements;
	
	      COSTCO.util.callGeocodeAPI(query, geocodeCallback);
	    },
	
	    bindEvents: function bindEvents() {
	      if (typeof checkoutPage !== "undefined" && checkoutPage === 'multi-shipping') {
	        $('.addressid-selection').unbind('change').change(function () {
	          var selectedOption = $(this).find(':selected');
	          var name = selectedOption.attr('name');
	          if (typeof name !== 'undefined' && name === 'add-new-address-option') {
	            COSTCO.CAddressForm.createNewAddress('S', selectedOption.attr('orderitem-id'), true);
	          }
	        });
	        if ($('#addressId_1 option').length == 1) {
	          $('.addressid-selection').unbind('click').click(function () {
	            var selectedOption = $(this).find(':selected');
	            var name = selectedOption.attr('name');
	            if (typeof name !== 'undefined' && name === 'add-new-address-option') {
	              COSTCO.CAddressForm.createNewAddress('S', selectedOption.attr('orderitem-id'), true);
	            }
	          });
	        }
	      }
	      COSTCO.CAddressForm.initiatePopovers();
	    },
	    /**
	    * Changes the cookie and appends/removes EC as per condition
	    * 
	    */
	    isZipOrDeliveryMethodChange: function isZipOrDeliveryMethodChange(data, userSelection) {
	      var isChanged = false;
	      currentCookie = $.cookie('WC_BD_WHS');
	      if (COSTCO.util.isNdEnabled() && data && userSelection) {
	        if ((userSelection == "Nationwide" || !data.ShowAddressTypePopup) && currentCookie.search("-ND") == -1) {
	          isChanged = true;
	        } else if (userSelection == "Local" && currentCookie.search("-ND") != -1 && data.ShowAddressTypePopup) {
	          isChanged = true;
	        }
	      }
	      if (data && data.CurrentDeliveryZip != data.SetDeliveryZip) {
	        isChanged = true;
	      }
	      return isChanged;
	    },
	    /**
	     * The method sets all the required field so as to save the user selected address type to DB
	     * and calls function to show the Address Type popup
	    */
	    addUserSelectionFromDelivery: function addUserSelectionFromDelivery(obj) {
	
	      var addressJson = COSTCO.CAddress.getAddressJson(obj)[0];
	      var addresstype = addressJson.userAddressType;
	      if (document.querySelector('input[name="nd-radio-group-input"]:checked') != null) {
	        addresstype = document.querySelector('input[name="nd-radio-group-input"]:checked').value;
	      }
	      COSTCO.CAddressVerification.entered = addressJson;
	      COSTCO.CAddressVerification.entered.addressType = "S";
	      COSTCO.CAddressVerification.entered.saveAddress = "on";
	      COSTCO.CAddressVerification.entered.setDefault = "on";
	      COSTCO.CAddressVerification.entered.addressType2 = "S";
	      COSTCO.CAddressVerification.entered.userAddressType = addresstype;
	      COSTCO.CAddressVerification.entered.userAddrTypeUpdate = "Y";
	      COSTCO.CAddressVerification.viewAddressTypeModal(undefined, {}, 'editAddressType');
	    },
	    //update WAREHOUSEDELIVERY_WHS cookie
	    updateWarehouseCookie: function updateWarehouseCookie(zipcode) {
	
	      var parsedCookie = JSON.parse($.cookie('WAREHOUSEDELIVERY_WHS'));
	      var responseJson;
	      var distCenterServiceUrl = $('#distributionCentersUrl').val() + '?destinationPostalCode=' + zipcode.toUpperCase();
	      var headers = {
	        'costco.env': $('#distributionCentersEnv').val(),
	        'costco.service': 'restInventory',
	        'client-identifier': $('#distributionCentersClientId').val()
	      };
	
	      try {
	        $.ajax({
	          url: distCenterServiceUrl,
	          type: 'GET',
	          headers: headers,
	          dataType: 'json',
	          async: false,
	          success: function success(data) {
	            responseJson = data;
	            parsedCookie.distributionCenters = responseJson.distributionCenters;
	            parsedCookie.groceryCenters = responseJson.groceryCenters;
	            $.cookie('WAREHOUSEDELIVERY_WHS', JSON.stringify(parsedCookie));
	          },
	          error: function error(data) {
	            responseJson = data;
	            console.log("Error in updateWarehouseCookie: " + JSON.stringify(responseJson));
	          }
	        });
	      } catch (e) {
	        console.error("Error in updateWarehouseCookie: " + e);
	      }
	    }
	  };
	  if (typeof window.COSTCO === "undefined") {
	    window.COSTCO = new Object();
	  }
	  window.COSTCO.CAddress = CAddress;
	  return CAddress;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title preauthchargesmodal.js: Sub-module for Global pages
	 * @description This module is used to display the preauthcharges modal
	 * @dependency 
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(16)], __WEBPACK_AMD_DEFINE_RESULT__ = function (dialog) {
	
		var preauthchargesmodal = {
	
			init: function init() {
				this.attachExternalClass();
			},
	
			attachExternalClass: function attachExternalClass() {
				$('.preauthcharges-text').unbind().on('click', this.bind_external);
			},
	
			bind_external: function bind_external(event) {
				var callerElement = event.target;
				COSTCO.dialog.returnFocusOnCallerElement(callerElement);
				preauthchargesmodal.createDialogBox(this.href);
				event.preventDefault();
			},
	
			createDialogBox: function createDialogBox(url) {
				dialog.createExtDialogBox({
					title: messages.CHECKOUT_PREAUTH_MSG,
					body: COSTCO.util.tmpl('tmpl_preauthcharges_modal', {}),
					primary: messages.CLOSE
				});
			}
	
		};
	
		if (typeof window.COSTCO === "undefined") {
			window.COSTCO = new Object();
		}
	
		window.COSTCO.preauthchargesmodal = preauthchargesmodal;
	
		return preauthchargesmodal;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title costcodialog.js: Sub-module for Global pages
	 * @description This module is used to creating Modal
	 * @dependency
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	  var dialog = {
	    dialogSettings: null,
	    triggerEvent: null,
	    /**
	     * Create a BS style modal that is customizable
	     * @param  {Object} settings Object with following properties:
	     * - title : string appears in the header portion of the modal
	     * - body : HTML/string that represents the body of the modal
	     * - primary : primary action button name.
	     * - secondary : secondary action button name.z
	     * - primary_event : OPTIONAL custom event to attach to primary button
	     * - url : OPTIONAL url for external link. Used if a primary_event is not provided.
	     * @return {void}
	     */
	    createExtDialogBox: function createExtDialogBox(settings) {
	      // show onetimepopup?
	      if (settings.oneTimePopup && this.isPresentInLocalStorage(settings.url)) {
	        window.open(settings.url);
	        return;
	      }
	      dialog.showAndHideModal(settings);
	    },
	
	    modalObserver: {
	      state: {
	        STARTED: 'STARTED',
	        STOPPED: 'STOPPED'
	      },
	      observer: null,
	      modalObserverState: '',
	      elementCausedModal: undefined,
	      elementCausedSecondModalId: undefined,
	      showingSecondModal: undefined
	    },
	
	    /**
	     * Function used to watch for changes of costco modal
	    */
	    returnFocusOnCallerElement: function returnFocusOnCallerElement(activeElement) {
	      if (dialog.modalObserver.modalObserverState != dialog.modalObserver.state.STARTED) {
	        dialog.modalObserver.modalObserverState = dialog.modalObserver.state.STARTED;
	        if (activeElement !== undefined) {
	          dialog.modalObserver.elementCausedModal = activeElement;
	        }
	        var targetObject = COSTCO.dialog.getModal();
	        if (targetObject.length > 0) {
	          targetObject = targetObject[0];
	          var observerObject = new MutationObserver(function mutationObjectCallback(mutationRecordsList) {
	            mutationRecordsList.forEach(function (mutation) {
	              var eventOnClick = false;
	              if (event !== undefined) {
	                eventOnClick = event.target.onclick ? true : false;
	              }
	              //On modal close
	              if (mutation.target.className === "modal fade" && !dialog.modalObserver.elementCausedSecondModalId && !eventOnClick) {
	                $(dialog.modalObserver.elementCausedModal).focus();
	                dialog.modalObserver.elementCausedModal = undefined;
	                COSTCO.dialog.stopModalObserver();
	              } else if (mutation.target.className === "modal fade" && dialog.modalObserver.elementCausedSecondModalId && !eventOnClick) {
	                dialog.modalObserver.showingSecondModal = undefined;
	              } else if (mutation.target.className === "modal fade" && dialog.modalObserver.elementCausedModal && eventOnClick) {
	                COSTCO.dialog.addParentElementForModalObserver(event.target);
	              }
	            });
	          });
	          // Register the target node to observe and specify which DOM changes to watch
	          observerObject.observe(targetObject, {
	            attributes: true,
	            attributeFilter: ["class"]
	          });
	          if (observerObject) {
	            this.modalObserver.observer = observerObject;
	          }
	        }
	      }
	    },
	
	    addParentElementForModalObserver: function addParentElementForModalObserver(activeElement) {
	      dialog.modalObserver.elementCausedSecondModalId = activeElement.id;
	      dialog.modalObserver.showingSecondModal = true;
	    },
	
	    removeParentElementForModalObserver: function removeParentElementForModalObserver(activeElement) {
	      if ($('#' + dialog.modalObserver.elementCausedSecondModalId).get(0)) {
	        $('#' + dialog.modalObserver.elementCausedSecondModalId).get(0).focus();
	        $(document).keyup(function (e) {
	          if (e.key === "Escape") {
	            $(dialog.modalObserver.elementCausedModal).focus();
	            dialog.modalObserver.elementCausedModal = undefined;
	            COSTCO.dialog.stopModalObserver();
	          }
	        });
	      }
	
	      dialog.modalObserver.elementCausedSecondModalId = undefined;
	    },
	
	    stopModalObserver: function stopModalObserver() {
	
	      dialog.modalObserver.modalObserverState = dialog.modalObserver.state.STOPPED;
	
	      this.modalObserver.observer.disconnect();
	    },
	
	    /**
	     * Get the Modal for instances where you need to bind certain events
	     * @return {jQuery.Object} The costcoModal jquery object
	     */
	    getModal: function getModal() {
	      return $('#costcoModal');
	    },
	    /**
	     * [description]
	     * @return {[type]} [description]
	     */
	    isVisible: function isVisible() {
	      if ($('#costcoModal').css('display') == 'none') {
	        return false;
	      } else {
	        return $('#costcoModal').is(':visible');
	      }
	    },
	    /**
	     * [description]
	     * @param  {[type]} settings [description]
	     * @return {void}          [description]
	     */
	    showAndHideModal: function showAndHideModal(settings) {
	      dialog.captureDataBeforeShowingModal(settings);
	      if (COSTCO.dialog.isVisible()) {
	        $('#costcoModal').on('hidden.bs.modal', function () {
	          // Load up a new modal...
	          COSTCO.dialog.showModal(settings);
	        });
	        $('#costcoModal').modal('hide');
	      } else {
	        this.showModal(settings);
	      }
	    },
	    /**
	     * [description]
	     * @param  {[type]} settings [description]
	     * @return {void}          [description]
	     */
	    showModal: function showModal(settings) {
	      dialog.captureDataBeforeShowingModal(settings);
	      //modification for ReturnDialogMOdal.jsp
	      if (settings.url) {
	        $('#select-page').addClass('hidden');
	        $('#add-edit-page').removeClass('hidden');
	      }
	      if (settings.hideCloseButton) {
	        $('.close').addClass('hidden');
	      }
	      //end modification for ReturnDialogMOdal.jsp
	      if (settings.dialogclasses) {
	        $('.modal-dialog').addClass(settings.dialogclasses);
	      }
	      if (settings.hideHeader) {
	        $('.modal-header').hide();
	      } else {
	        $('.modal-header').show();
	        $('#costcoModalTitle').text(settings.title);
	        var modaltitle = settings.title;
	        if (modaltitle == 'Edit Address') {
	          $(".modal-header").find(":button").removeAttr("data-bi-tc");
	          $(".modal-header").find(":button").attr("data-bi-tc", "ui:Edit Shipping Address | X Close");
	          $("#costcoModalBtn2").removeAttr("data-bi-tc");
	          $("#costcoModalBtn2").attr("data-bi-tc", "ui:Edit Shipping Address | Save Address");
	          $(".costcoModalBtn1.btn.btn-tertiary.btn-block").removeAttr("data-bi-tc");
	          $(".costcoModalBtn1.btn.btn-tertiary.btn-block").attr("data-bi-tc", "ui:Edit Shipping Address | Cancel");
	        }
	        if (modaltitle == 'Add New Address') {
	          $(".modal-header").find(":button").removeAttr("data-bi-tc");
	          $(".modal-header").find(":button").attr("data-bi-tc", "ui:Add New Address Modal | X Close");
	          $("#costcoModalBtn2").removeAttr("data-bi-tc");
	          $("#costcoModalBtn2").attr("data-bi-tc", "ui:Add New Address Modal | Save Address");
	          $("#costcoModalBtn1").removeAttr("data-bi-tc");
	          $("#costcoModalBtn1").attr("data-bi-tc", "ui:Add New Address | Cancel");
	          $(".costcoModalBtn1.btn.btn-tertiary.btn-block").removeAttr("data-bi-tc");
	          $(".costcoModalBtn1.btn.btn-tertiary.btn-block").attr("data-bi-tc", "ui:Add New Address Modal | Cancel");
	        }
	        if (modaltitle == 'Select Address') {
	          $(".modal-header").find(":button").removeAttr("data-bi-tc");
	          $(".modal-header").find(":button").attr("data-bi-tc", "ui:Select Address Modal | X Close");
	          $(".costcoModalBtn1.btn.btn-tertiary.btn-block").removeAttr("data-bi-tc");
	          $(".costcoModalBtn1.btn.btn-tertiary.btn-block").attr("data-bi-tc", "ui:Select Address Modal | Cancel");
	        }
	        if (modaltitle == 'Change Pick Up Address') {
	          $(".modal-header").find(":button").removeAttr("data-bi-tc");
	          $(".costcoModalBtn1.btn.btn-tertiary.btn-block").removeAttr("data-bi-tc");
	        }
	        if (modaltitle == 'Edit Delivery Address' || modaltitle == 'Edit Billing Address') {
	          $(".modal-header").find(":button").removeAttr("data-bi-tc");
	          $(".modal-header").find(":button").attr("data-bi-tc", "ui:Edit Address | Close Button");
	          $("#costcoModalBtn2").removeAttr("data-bi-tc");
	          $("#costcoModalBtn2").attr("data-bi-tc", "ui:Edit Address | Save Address");
	          $("#costcoModalBtn1").removeAttr("data-bi-tc");
	          $("#costcoModalBtn1").attr("data-bi-tc", "ui:Edit Address | Cancel");
	        }
	        if (settings.close) {
	          $('.close').unbind().on('click', function () {
	            settings.close();
	          });
	        }
	      }
	      // if there is a modal Label specified in the setting used it
	      // otherwise we will use the modal title
	      if (settings.modalLabel) {
	        $('#costcoModal').attr('aria-label', settings.modalLabel);
	        $('#costcoModal').removeAttr('aria-labelledby');
	      } else {
	        if (!settings.hideHeader && settings.title) {
	          $('#costcoModal').attr('aria-labelledby', 'costcoModalTitle');
	          $('#costcoModal').removeAttr('aria-label');
	        }
	      }
	
	      $('#costcoModalText').html(settings.body);
	      if (settings.replaceFooter) {
	        $('#costcoModal .modal-footer').html(settings.replaceFooter);
	      }
	      if (settings.showVerifyMeModal || settings.primary && (settings.primary_event || settings.url)) {
	        $('#costcoModalBtn2').text(settings.primary).show();
	        $('#costcoModalBtn2').removeAttr('automation-id');
	        $('#costcoModalBtn2').attr('automation-id', settings.primary.replace(/[^a-zA-Z0-9]/g, '').toLowerCase() + "_button");
	        if (settings.primary_button_style !== undefined && settings.primary_button_style.includes('rounded')) {
	          $('#costcoModalBtn2').addClass('primary-button-v2');
	        }
	        //since primary button is visible, make the secondary button half the row again
	        if (settings.secondary != undefined || settings.setHalfButtons) {
	          $('.costcoModalBtn1').parent('.col-md-12').removeClass('col-md-12').addClass('col-md-6');
	          $('#costcoModalBtn2').parent('.col-md-12').removeClass('col-md-12').addClass('col-md-6');
	          $('.costcoModalBtn1').parent('.col-lg-12').removeClass('col-lg-12').addClass('col-lg-6');
	          $('#costcoModalBtn2').parent('.col-lg-12').removeClass('col-lg-12').addClass('col-lg-6');
	        } else {
	          $('#costcoModalBtn2').parent('.col-md-6').removeClass('col-md-6').addClass('col-md-12');
	          $('#costcoModalBtn2').parent('.col-lg-6').removeClass('col-lg-6').addClass('col-lg-12');
	        }
	        if (settings.showVerifyMeModal) {
	          $('#costcoModalBtn2').html(settings.showVerifyMeModalText);
	          $('#costcoModalBtn2').addClass('verify-me-button');
	          $('#costcoModalBtn2').removeClass('primary-button-v2');
	          $('#costcoModalBtn2').removeClass('btn-primary');
	          $('#costcoModalBtn2').addClass('no-padding');
	        } else {
	          $('#costcoModalBtn2').removeClass('verify-me-button');
	        }
	      } else {
	        $('#costcoModalBtn2').hide();
	        //since primary event button is hidden, make the secondary button span the whole row
	        $('.costcoModalBtn1').parent('.col-md-6').removeClass('col-md-6').addClass('col-md-12');
	        $('.costcoModalBtn1').parent('.col-lg-6').removeClass('col-lg-6').addClass('col-lg-12');
	      }
	      if (settings.secondary_button_style !== undefined && settings.secondary_button_style.includes('rounded')) {
	        $('.costcoModalBtn1').addClass('secondary-button-v2');
	      } else if (settings.secondary_button_style !== undefined && settings.secondary_button_style.includes('tertiary')) {
	        $('.costcoModalBtn1').addClass('tertiary-alternative-button-v2');
	        $('.costcoModalBtn1').removeClass('btn-tertiary secondary-button-v2');
	      }
	
	      if (settings.hideFooter) {
	        $('.modal-footer').hide();
	      } else {
	        $('.modal-footer').show();
	      }
	      if (settings.primaryDisabled) {
	        $('#costcoModalBtn2').addClass('btn-disabled');
	      } else {
	        $('#costcoModalBtn2').removeClass('btn-disabled');
	      }
	      if (settings.secondary) {
	        $('.costcoModalBtn1').text(settings.secondary).show();
	      } else {
	        $('.costcoModalBtn1').hide();
	      }
	      if (settings.close) {
	        $('.close').unbind().on('click', function () {
	          //modification for ReturnDialogMOdal.jsp
	          if (settings.url == undefined) {
	            $('#select-page').removeClass('hidden');
	            $('#add-edit-page').addClass('hidden');
	          }
	          //end modification for ReturnDialogMOdal.jsp
	
	          settings.close();
	        });
	      }
	
	      if (settings.footerText) {
	        $('#costcoModalFooterText').html(settings.footerText);
	        $('#costcoModalFooterText').removeClass('hide');
	      } else {
	        $('#costcoModalFooterText').addClass('hide');
	      }
	      // Hides the default modal footer and shows the alternate modal footer
	      if (settings.footerText2) {
	        $('#costcoModalFooterText2').html(settings.footerText2);
	        $('#costcoModalFooterText2').removeClass('hide');
	      } else {
	        $('#costcoModalFooterText2').addClass('hide');
	      }
	
	      $('#commercial-indicator, #residental-indicator').unbind().on('keydown keypress', function (event) {
	        if (event.which === 32) {
	          $(this).click();
	        } else if (event.which === 38 || event.which === 40) {
	          //cursors up and down
	          var $controlIndicators = $(this).closest('.control-group').find('.control__indicator');
	          var total = $controlIndicators.length;
	          var index = $controlIndicators.index(this);
	          if (event.which == 38) {
	            //cursor up
	            index = index == 0 ? total - 1 : index - 1;
	          } else if (event.which == 40) {
	            //cursor down
	            index = (index + 1) % total;
	          }
	          $controlIndicators[index].click();
	        }
	      });
	
	      $('#commercial-indicator, #residental-indicator').unbind('click').on('click', function (event) {
	        if ($(event.target).hasClass('control__indicator')) {
	          var passiveElement = $(event.target).attr('id') === "commercial-indicator" ? $('#residental-indicator') : $('#commercial-indicator');
	          COSTCO.dialog.setRadioButtonsAttributes($(event.target), passiveElement);
	        }
	        $(event.target).find('input').click();
	      });
	
	      $('#costcoModalBtn2').unbind().on('click', function () {
	        if (COSTCO.timeoutModal && COSTCO.timeoutModal.state === COSTCO.timeoutModal.TIMEDOUT) {
	          var url = "ReLogonFormView?URL=" + window.location.pathname;
	          document.location.href = url;
	        }
	        if (settings.primary_event) {
	          if (settings.primary == 'View List' || settings.primary == 'Voir la liste') {
	            COSTCO.Global.updateSelectedMenuItem('Lists.label');
	          }
	          settings.primary_event();
	        } else {
	          $('#costcoModal').modal('hide');
	          if (settings.url) {
	            window.open(settings.url);
	
	            // check for onetimepopup and add to local storage
	            if (settings.oneTimePopup) {
	              COSTCO.util.setInStorage(settings.url, {
	                'url': settings.url
	              });
	            }
	          }
	        }
	      });
	      $('.costcoModalBtn1').unbind().on('click', function () {
	        //modification for ReturnDialogMOdal.jsp
	        if (settings.url == undefined) {
	          $('#select-page').removeClass('hidden');
	          $('#add-edit-page').addClass('hidden');
	        }
	        //end modification for ReturnDialogMOdal.jsp
	
	        if (settings.secondary_event) {
	          settings.secondary_event();
	        } else {
	          $('#costcoModal').modal('hide');
	        }
	      });
	      if (settings.popover) {
	        $('#costcoModal').find('[data-toggle="popover"]').popover();
	      }
	      this.bindEvents(settings);
	      $('#costcoModal').modal({
	        backdrop: settings.preventClose ? 'static' : true,
	        keyboard: settings.preventClose ? false : true,
	        show: true
	      });
	      //Handle page load by opening in new tab
	      $('#costcoModal').show();
	      $('#costcoModal').css('display', 'block');
	    },
	
	    sameAddressValidation: function sameAddressValidation(formSelector, fieldSelector) {
	      var addressEnteredForCheck = $('#addressEnteredForCheck').val();
	      $(fieldSelector).val(addressEnteredForCheck);
	      $(fieldSelector).focus();
	      var forms = $(fieldSelector).parents('FORM');
	      var addressEnteredForCheck2 = $('#addressEnteredForCheck2');
	      if (forms.length && addressEnteredForCheck2.length) {
	        var form = $(forms[0]);
	        var address2 = addressEnteredForCheck2.val();
	        var city = $('#addressEnteredForCheckCity').val();
	        var state = $('#addressEnteredForCheckState').val();
	        var postalCode = $('#addressEnteredForCheckPostalCode').val();
	        var formFields = form.find('INPUT[type="text"]');
	        for (var i = 0; i < formFields.length; i++) {
	          var field = formFields[i];
	          if (/address2/.test(field.name)) {
	            field.value = address2;
	          } else if (/city/.test(field.name)) {
	            field.value = city;
	          } else if (/.*(zip|postal).*/.test(field.name)) {
	            field.value = postalCode;
	          }
	        }
	        formFields = form.find('SELECT');
	        for (var i = 0; i < formFields.length; i++) {
	          var field = formFields[i];
	          if (/.*(province|state).*/.test(field.name)) {
	            field.value = state;
	          }
	        }
	      }
	      $.validator.addMethod("sameAddressValidationRule", function (inputValue) {
	        return addressEnteredForCheck === inputValue ? false : true;
	      }, messages.ERR_SHIP_ADDR_SAME_AS_WHS_ADDR_FIELD_VALIDATION);
	
	      $(formSelector).validate().resetForm();
	      $(formSelector).validate();
	      $(fieldSelector).rules('add', 'sameAddressValidationRule');
	      $(fieldSelector).valid();
	    },
	
	    /**
	     * Updates the modal title, body, buttons, bindings etc without closing the modal
	     * @param  {Object} settings @see COSTCO.dialog.createExtDialogBox()
	     */
	    updateModal: function updateModal(settings) {
	      dialog.showModal(settings);
	    },
	    /**
	     * [description]
	     * @return {void} [description]
	     */
	    close: function close() {
	      $('#costcoModal').modal('hide');
	      dialog.returnFocusOnPreviousElement();
	    },
	    /**
	     * [description]
	     * @return {void} [description]
	     */
	    closeAndUnbind: function closeAndUnbind() {
	      $('#costcoModal').unbind('shown.bs.modal');
	      $('#costcoModal').unbind('hidden.bs.modal');
	      $('#costcoModal').unbind('hide.bs.modal');
	      this.close();
	    },
	    /**
	     * Binds the "hidden/shown" events (ie modal is closed/opened) with some
	     * clear/show actions. Additionally you can pass a function as part
	     * of your settings object to execute custom thangs.
	     * @param  {Object} settings  The settings object that contains
	     *                            the event handlers used for various
	     *                            modal actions.
	     * @return {void}
	     */
	    bindEvents: function bindEvents(settings) {
	      $('#costcoModal').unbind('shown.bs.modal').on('shown.bs.modal', function (e) {
	        // This event is fired when the modal has been made visible to the user
	        // (will wait for CSS transitions to complete). If caused by a click,
	        // the clicked element is available as the relatedTarget property of
	        // the event.
	        if (settings.onshown) settings.onshown(e);
	        if (dialog.modalObserver.elementCausedSecondModalId && !e.target.onclick && !dialog.modalObserver.showingSecondModal) {
	          COSTCO.dialog.removeParentElementForModalObserver();
	        };
	        COSTCO.util.trapFocusInsideModal();
	      });
	      $('#costcoModal').unbind('hidden.bs.modal').on('hidden.bs.modal', function (e) {
	        if (typeof settings.dialogclasses != 'undefined') {
	          $('.modal-dialog').removeClass(settings.dialogclasses);
	        }
	        // clear and show. Execute fn if it exists
	        if (settings.onclose) settings.onclose(e);
	        $('#costcoModalTitle').empty().show();
	        if ($('#react-video-holder').length && $('#videoViewer-popup').length) $('#react-video-holder').append($('#videoViewer-popup'));
	        $('#costcoModalText').empty().show();
	        $('.costcoModalBtn1').empty().show();
	        $('#costcoModalBtn2').empty().show();
	
	        if (settings.afterclose) settings.afterclose(e);
	      });
	      $('#costcoModal').unbind('show.bs.modal').on('show.bs.modal', function (e) {
	        if (settings.onshow) settings.onshow(e);
	      });
	      $('#costcoModal').unbind('hide.bs.modal').on('hide.bs.modal', function (e) {
	        // This event is fired when the modal is going to close.
	        if (settings.onhide) settings.onhide(e);
	      });
	    },
	    /**
	     * [description]
	     * @param  {[type]} hostname [description]
	     * @return {boolean}
	     */
	    isPresentInLocalStorage: function isPresentInLocalStorage(hostname) {
	      if (JSON.stringify(COSTCO.util.getFromStorage(hostname)).indexOf(hostname) > 0) {
	        return true;
	      } else {
	        return false;
	      }
	    },
	    /**
	     * Holds previous options object used to instantiate a modal with.
	     * This is the modal stack used by modalStack function.
	     * @type {Array}
	     */
	    modalStackPreviousOptions: [],
	    /**
	     * Create a sequential stack of modals by calling this function
	     * successively.
	     *  ex.
	     *    1. COSTCO.dialog.modalStack({title:'hi', body:'robert'})
	     *      -> Invoke a hi-robert modal, pushes options to stack.
	     *    2. COSTCO.dialog.modalStack({title:'hi', body:'kurt'})
	     *      -> Closes the hi-robert modal and invokes/pushes the hi-kurt
	     *         modal to stack.
	     *    3. (Escape key, Exit Arrow, or blur)
	     *      -> Pops the currently invoked modal from the stack and
	     *         closes it. Invokes the previous modal from the stack
	     *         until the stack b gone or we call this function again.
	     * @param  {Object} options The settings object for the modal.
	     * @return {void}
	     */
	    modalStack: function modalStack(options) {
	      var stack = this.modalStackPreviousOptions;
	      options.index = stack.length + 1;
	      stack.push(options);
	      options.afterclose = function () {
	        var stack = dialog.modalStackPreviousOptions;
	        if (stack.length === this.index && stack.length !== 1) {
	          // we need to go backward
	          dialog.showAndHideModal(stack[this.index - 2]);
	          COSTCO.dialog.modalStackPreviousOptions.pop();
	        } else if (stack.length > this.index) {
	          dialog.showAndHideModal(stack[this.index]);
	        } else {
	          COSTCO.dialog.clearStack();
	        }
	      }.bind(options);
	      if (stack.length === 1) {
	        this.showAndHideModal(options);
	      } else {
	        this.close();
	      }
	    },
	
	    /**
	     * set radio buttons attributes
	     */
	    setRadioButtonsAttributes: function setRadioButtonsAttributes(activeElement, passiveElement) {
	      activeElement.addClass('active').attr('aria-checked', true).find('div').removeClass('hide');
	      passiveElement.removeClass('active').attr('aria-checked', false).find('input').removeAttr('checked');
	      passiveElement.find('div').addClass('hide');
	    },
	
	    /**
	     * Clears the modal stack.
	     * @return {void} [description]
	     */
	    clearStack: function clearStack() {
	      this.modalStackPreviousOptions = [];
	    },
	    /*
	     * Listener for opening/closing modals 
	     * to help with returning focus to original 
	     * element or input 
	     */
	    initializeReturnFocusListener: function initializeReturnFocusListener() {
	      $(document).on('hidden.bs.modal', '#costcoModal', function (e) {
	        dialog.returnFocusOnPreviousElement();
	      });
	      $(document).on('shown.bs.modal', '#costcoModal', function (e) {
	        dialog.returnFocusOnInput();
	      });
	    },
	    /*
	     * This function utilizes the triggerEvent variable
	     * to return focus on elements 
	     */
	    returnFocusOnPreviousElement: function returnFocusOnPreviousElement() {
	      var previousElement = null;
	      if (dialog.triggerEvent != null) {
	        previousElement = dialog.triggerEvent.srcElement;
	      } else if (dialog.triggerEvent == null && COSTCO.timeoutModal != null && COSTCO.timeoutModal.lastActiveElement != null) {
	        previousElement = COSTCO.timeoutModal.lastActiveElement;
	      } else {
	        previousElement = $('body');
	      }
	      $(previousElement).focus();
	    },
	
	    /*
	     * This function's use case is to return 
	     * focus to the element within a modal
	     */
	    returnFocusOnInput: function returnFocusOnInput() {
	      var previousElement = null;
	      if (COSTCO.timeoutModal != null && COSTCO.timeoutModal.lastActiveElement != null && dialog.dialogSettings.title !== messages.TIMEOUT_MODAL_HEADER) {
	        previousElement = COSTCO.timeoutModal.lastActiveElement;
	        COSTCO.timeoutModal.lastActiveElement = null;
	      }
	      $(previousElement).focus();
	    },
	
	    /*
	     * This function captures 
	     */
	    triggerEventUtil: function triggerEventUtil() {
	      if (window.event !== undefined) {
	        if (dialog.getSettings() != null && dialog.getSettings().title === messages.BD_QUESTIONNAIRE_TITLE) {
	          return;
	        } else if (dialog.getSettings() != null && dialog.getSettings().title === messages.TIMEOUT_MODAL_HEADER) {
	          return;
	        } else {
	          dialog.triggerEvent = window.event;
	        }
	      }
	    },
	    /*
	     * returns the current dialog's settings
	     */
	    getSettings: function getSettings() {
	      return dialog.dialogSettings;
	    },
	    /*
	     * Captures data upon opening a modal
	     * to grab the event and copy settings
	     */
	    captureDataBeforeShowingModal: function captureDataBeforeShowingModal(settings) {
	      dialog.triggerEventUtil();
	      dialog.dialogSettings = settings;
	    }
	
	  }; // end costcoDialog object
	  // Expose costcoDialog to the global scope.
	  if (typeof window.COSTCO === 'undefined') {
	    window.COSTCO = {};
	  }
	  window.COSTCO.dialog = dialog;
	  return dialog;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title addressVerification.js: Feature level module
	 * @description Address verification module
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(14), __webpack_require__(18)], __WEBPACK_AMD_DEFINE_RESULT__ = function (address, addressDisplay) {
	  var CAddressVerification = {
	    entered: '',
	    suggested: '',
	    buildAddressVerificationModal: function buildAddressVerificationModal(entered, suggested, result) {
	      var verificationModal = $($('#tmpl_address_verification').html());
	      // Need to create a temp object for extending through jQuery
	      var tempEntered = JSON.parse(JSON.stringify(entered));
	      var extendedSuggest = $.extend(tempEntered, suggested);
	      if (result === 'ADDRESS_WRONG_NO_SUGGESTION') {
	        var enteredHtml = addressDisplay.createAddressVerificationDisplay(entered, 'tmpl_address_display_verification');
	        $(verificationModal).find('#entered-address .address').append(enteredHtml);
	        $(verificationModal).find('#entered-address input').attr('tabindex', '-1');
	        $(verificationModal).find('[role="radio"]').attr("aria-labelledby", "orderAddrVerfication_" + entered.id);
	        $(verificationModal).find('#suggested-address').hide();
	        $(verificationModal).find('#no-match').show();
	        $(verificationModal).find('#address-verify-warningInfo-header').hide();
	        $(verificationModal).find('#address-verify-warningInfo-header-no-match').show();
	        COSTCO.CAddressVerification.entered = entered;
	      } else {
	        var _enteredHtml = addressDisplay.createAddressVerificationDisplay(entered, 'tmpl_address_display_verification');
	        $(verificationModal).find('#entered-address .address').append(_enteredHtml);
	        $(verificationModal).find('#entered-address input').attr('tabindex', '-1');
	        $(verificationModal).find('[role="radio"]').attr("aria-labelledby", "orderAddrVerfication_" + entered.id);
	        var suggestedHtml = addressDisplay.createAddressVerificationDisplay(extendedSuggest, 'tmpl_address_display_verification');
	        $(verificationModal).find('#suggested-address .address').append(suggestedHtml);
	        $(verificationModal).find('#suggested-address input').attr('checked', 'true');
	        $(verificationModal).find('#suggested-address input').parent().attr('aria-checked', 'true');
	        $(verificationModal).find('#suggested-address input').attr('tabindex', '-1');
	        if (COSTCO.util.isBusinessDelivery() && COSTCO.util.isUSBDStore()) {
	          if (!COSTCO.util.isNdEnabled() && "N" == suggested.isCommercial) {
	            $(verificationModal).find('#address-modal-notification').text(messages.MODAL_ADDRESS_RESIDENTIAL_WARNING);
	          }
	        }
	        COSTCO.CAddressVerification.entered = entered;
	        COSTCO.CAddressVerification.suggested = extendedSuggest;
	      }
	      return verificationModal;
	    },
	    showAddressVerificationModal: function showAddressVerificationModal(addressObj, preventhtmlajax, addressOptions) {
	      var suggested = addressObj.Validated_Address[0];
	      var entered = addressObj.Address[0];
	      var result = suggested.result;
	      var modalBody = CAddressVerification.buildAddressVerificationModal(entered, suggested, result);
	      var primaryDisabled = result === 'ADDRESS_WRONG_NO_SUGGESTION';
	      $('.order-ajax').removeClass('ajax-busy');
	      if (typeof addressOptions.primaryEventCallback === 'undefined') {
	        addressOptions.primaryEventCallback = CAddressVerification.useAddressCallback;
	      }
	      if (addressOptions.isModalStack) {
	        var labels = address.getHeaderLabels('S', 'verify');
	        COSTCO.dialog.modalStack({
	          title: labels.modalTitle,
	          body: modalBody,
	          primary_event: function primary_event() {
	            addressOptions.primaryEventCallback(preventhtmlajax, addressOptions);
	          },
	          primaryDisabled: primaryDisabled,
	          primary: labels.primaryButton,
	          secondary: messages.JS_DIALOG_CANCEL
	        });
	      } else {
	        address.baseModal(addressOptions.successCallback.arguments[1], 'verify', {
	          body: modalBody,
	          primary_event: function primary_event() {
	            addressOptions.primaryEventCallback(preventhtmlajax, addressOptions);
	          },
	          primaryDisabled: primaryDisabled
	        });
	      }
	    },
	    buildMultiAddressVerificationModal: function buildMultiAddressVerificationModal(addressObj) {
	      var verificationModal = $($('#tmpl_multi_address_verification').html());
	
	      // Iterate through each address in the Address array
	      $.each(addressObj.Address, function (index, entered) {
	        // Add the total number of addresses for display purposes
	        entered.numOfAddresses = addressObj.Address.length;
	
	        // Find the matching validated address, if any
	        var suggested = CAddressVerification.matchValidatedAddress(entered.id, addressObj.Validated_Address);
	
	        var verificationLineBlockHtml = '';
	
	        if (suggested && !suggested.result.includes('NO_SUGGESTION')) {
	          // Handle cases where a valid suggestion exists
	          var tempEntered = JSON.parse(JSON.stringify(entered));
	          var extendedSuggest = $.extend(tempEntered, suggested);
	
	          var enteredHtml = addressDisplay.createAddressVerificationDisplay(entered, 'tmpl_multi_address_verification_display_addr_element');
	
	          verificationLineBlockHtml = $(COSTCO.util.tmpl('tmpl_multi_address_verification_line_block', entered));
	          $(verificationLineBlockHtml).find('.entered-address .address').append(enteredHtml);
	
	          var suggestedHtml = addressDisplay.createAddressVerificationDisplay(extendedSuggest, 'tmpl_multi_address_verification_display_addr_element');
	          $(verificationLineBlockHtml).find('.suggested-address .address').append(suggestedHtml);
	          $(verificationLineBlockHtml).find('.suggested-address input').attr('checked', 'checked');
	        } else {
	          // Handle cases where the result is 'NO_SUGGESTION' or no validated address is found
	          console.warn('No valid suggestion found for address ID: ' + entered.id + '. Using entered address values.');
	
	          var _enteredHtml2 = addressDisplay.createAddressVerificationDisplay(entered, 'tmpl_multi_address_verification_display_addr_element');
	
	          verificationLineBlockHtml = $(COSTCO.util.tmpl('tmpl_multi_address_verification_line_block', entered));
	          $(verificationLineBlockHtml).find('.entered-address .address').append(_enteredHtml2);
	          $(verificationLineBlockHtml).find('.entered-address input').attr('tabindex', '-1');
	          $(verificationLineBlockHtml).find('.entered-address input').attr('checked', 'checked');
	          $(verificationLineBlockHtml).find('.suggested-address input').hide();
	          $(verificationLineBlockHtml).find('.no-match').show();
	        }
	
	        // Append the verification block to the modal
	        $(verificationModal).find('#address-verify-form').append(verificationLineBlockHtml);
	      });
	
	      return verificationModal;
	    },
	    showMultiAddressVerificationModal: function showMultiAddressVerificationModal(addressObj, callback) {
	      var modalBody = CAddressVerification.buildMultiAddressVerificationModal(addressObj);
	      COSTCO.dialog.modalStack({
	        title: addressLabels.verify.modalTitle,
	        body: modalBody,
	        primary: addressLabels.verify.primaryButton,
	        secondary: messages.JS_DIALOG_CANCEL,
	        primary_event: function primary_event() {
	          $('.permanent-ajax-busy').addClass('ajax-busy');
	          // create final address array and pass it to callback
	          var selectedInputs = $(modalBody).find('input[name^=verify]:checked');
	          var finalAddressArray = [];
	          $.each(selectedInputs, function (index, value) {
	            var action = $(value).val();
	            var addressId = $(value).attr('data-id');
	            if (action === 'suggested') {
	              finalAddressArray.push(CAddressVerification.findAddressById(addressId, addressObj.Validated_Address));
	            } else {
	              finalAddressArray.push(CAddressVerification.findAddressById(addressId, addressObj.Address));
	            }
	          });
	          COSTCO.dialog.clearStack();
	          COSTCO.dialog.close();
	          if (callback) callback(finalAddressArray);
	          // addressOptions.primaryEventCallback(preventhtmlajax, addressOptions, finalAddressArray);
	        }
	      });
	    },
	    /**
	     * Callback function for addressForm, used for primaryEventCallback
	     * @param  {[type]} preventhtmlajax [description]
	     * @param  {[type]} addressOptions  [description]
	     * @return {void}                 [description]
	     */
	    useAddressCallback: function useAddressCallback(preventhtmlajax, addressOptions) {
	      COSTCO.CAddressVerification.useAddress(preventhtmlajax, addressOptions);
	    },
	    setAddressEnteredForCheck: function setAddressEnteredForCheck(address) {
	      var parentEl = document.body;
	      var address1 = $('#addressEnteredForCheck');
	      if (address1.length) {
	        parentEl = address1.parent().get(0);
	      } else {
	        address1 = $('<INPUT TYPE="hidden" ID="addressEnteredForCheck" />').appendTo(parentEl);
	      }
	      var address2 = $('#addressEnteredForCheck2');
	      if (!address2.length) {
	        address2 = $('<INPUT TYPE="hidden" ID="addressEnteredForCheck2" />').appendTo(parentEl);
	      }
	      var city = $('#addressEnteredForCheckCity');
	      if (!city.length) {
	        city = $('<INPUT TYPE="hidden" ID="addressEnteredForCheckCity" />').appendTo(parentEl);
	      }
	      var state = $('#addressEnteredForCheckState');
	      if (!state.length) {
	        state = $('<INPUT TYPE="hidden" ID="addressEnteredForCheckState" />').appendTo(parentEl);
	      }
	      var postalCode = $('#addressEnteredForCheckPostalCode');
	      if (!postalCode.length) {
	        postalCode = $('<INPUT TYPE="hidden" ID="addressEnteredForCheckPostalCode" />').appendTo(parentEl);
	      }
	      address1.val(address.line1);
	      address2.val(address.line2);
	      city.val(address.city);
	      state.val(address.state);
	      postalCode.val(address.zip);
	    },
	    useAddress: function useAddress(preventhtmlajax, addressOptions, action) {
	      var verifiedAddress;
	      var message = action;
	      if ($('input[name=verify]:checked').val() != undefined) {
	        action = $('input[name=verify]:checked').val();
	      }
	      window.digitalDataEvents = window.digitalDataEvents || [];
	      if (action == 'suggested') {
	        verifiedAddress = COSTCO.CAddressVerification.suggested;
	        digitalDataEvents.push({ ui: "Address Verification Modal | Use Address |  Suggested  Address" });
	      } else {
	        verifiedAddress = COSTCO.CAddressVerification.entered;
	        digitalDataEvents.push({ ui: "Address Verification Modal | Use Address | Entered Address" });
	        // SFSTRY0039755 - Limit zip code editing to US only
	        if (COSTCO.util.isUSStore()) {
	          // SFSTRY0034758 - Use 9 digit zip code if AddressDoctor suggestion matches address
	          if (COSTCO.CAddressVerification.suggested !== 'undefined' && COSTCO.CAddressVerification.suggested !== '') {
	            if (COSTCO.CAddressVerification.suggested.zip.substring(0, 5) === COSTCO.CAddressVerification.entered.zip.substring(0, 5)) {
	              verifiedAddress.zip = COSTCO.CAddressVerification.suggested.zip;
	            }
	          }
	        }
	        //Save suggested isCommercial(RDI) flag if available, even if user selects entered address:
	        if ($('input[name=verify]:checked').val() != undefined) {
	          verifiedAddress.isCommercial = COSTCO.CAddressVerification.suggested.isCommercial;
	        }
	      }
	      COSTCO.CAddressVerification.suggested = '';
	      COSTCO.CAddressVerification.setAddressEnteredForCheck(verifiedAddress);
	      address.addEditAddress(verifiedAddress, preventhtmlajax, addressOptions, message);
	    },
	    handleRadioButtonClick: function handleRadioButtonClick(element) {
	      var passiveElementParent = $(element).parent().attr('id') === "suggested-address" ? $('#entered-address') : $('#suggested-address');
	      COSTCO.CAddressVerification.setRadioAttributes($(element), passiveElementParent);
	      $('#costcoModalBtn2').removeClass('btn-disabled');
	    },
	    addressVerification: function addressVerification(addressArray, type, preventajaxhtml, addressOptions) {
	      $('.order-ajax').addClass('ajax-busy');
	      var _dataType = 'json';
	      var _data = {};
	      _data['formdata'] = encodeURIComponent(JSON.stringify(addressArray));
	      $.ajax({
	        url: '/AjaxAddressVerificationCmd',
	        type: 'POST',
	        dataType: _dataType,
	        data: _data,
	        timeout: 15000
	      }).done(function (addressObj) {
	        addressOptions.successCallback(addressObj, type, preventajaxhtml, addressOptions);
	      }).fail(function (addressObj) {
	        // Timeout or error sets verifiedAddress to inputted array
	        // Error Calling Verification Service
	        console.log('Verification Address : ' + JSON.stringify(addressObj));
	      }).always(function () {
	        $('.order-ajax').removeClass('ajax-busy');
	      });
	    },
	    extractValidatedAddress: function extractValidatedAddress(addressObj, type) {
	      console.log('Extracting Validated Address : ' + JSON.stringify(addressObj));
	      var suggested = addressObj.Validated_Address[0];
	      var entered = addressObj.Address[0];
	      suggested.fName = entered.fName;
	      suggested.lName = entered.lName;
	      suggested.company = entered.company;
	      suggested.pNumber = entered.pNumber;
	      suggested.ext1 = entered.ext1;
	      suggested.nickname = entered.nickname;
	      suggested.saveAddress = entered.saveAddress;
	      suggested.setDefault = entered.setDefault;
	      suggested.addressType = type;
	      suggested.addressType2 = entered.addressType2;
	      suggested.mInitial = entered.mInitial;
	      suggested.email = entered.email;
	      suggested.deliveryInst = entered.deliveryInst;
	      suggested.contactName = entered.contactName;
	      suggested.contactPhNo = entered.contactPhNo;
	      return suggested;
	    },
	    isSuggestedSameAsEntered: function isSuggestedSameAsEntered(addressObj) {
	      // web service down or service reports address suggestion for correctly entered address
	      var suggested = addressObj && addressObj.Validated_Address && addressObj.Validated_Address[0] || {};
	      var entered = addressObj && addressObj.Address && addressObj.Address[0] || {};
	
	      // If service signals a "no suggestion" case or missing result, treat as not same
	      if (!suggested.result || suggested.result === 'ADDRESS_WRONG_NO_SUGGESTION') {
	        return false;
	      }
	
	      var norm = function norm(n) {
	        return (n || '').toString().trim().toUpperCase();
	      }; //Converts any value (including undefined/null) into a trimmed, uppercase string.
	      var zip5 = function zip5(z) {
	        return (z || '').toString().substring(0, 5);
	      }; //Safely returns the first five characters of a ZIP/postal code.
	
	      var isSameAddress = norm(suggested.line1) === norm(entered.line1) && norm(suggested.line2) === norm(entered.line2) && norm(suggested.city) === norm(entered.city) && (suggested.state || '') === (entered.state || '') && zip5(suggested.zip) === zip5(entered.zip) && (suggested.country || '') === (entered.country || '');
	
	      return isSameAddress;
	    },
	    /**
	     * Builds one element of the AVS request object array
	     * @param  {Object} form jquery form object which contains fields of address to be verified
	     * @param  {Object} selectors JSON object containing selectors that should be used in the form to get data from form to build request
	     * @return {Object} One element of the array to be passed to AVS service
	     */
	    buildRequestElement: function buildRequestElement(form, selectors) {
	      var addressObject = {
	        id: $(form).find(selectors.id).val() ? $(form).find(selectors.id).val() : '',
	        label: $(form).find(selectors.label).val() || $(form).find(selectors.label).text(),
	        line1: $(form).find(selectors.line1).val(),
	        line2: $(form).find(selectors.line2).val(),
	        line3: $(form).find(selectors.line3).val(),
	        city: $(form).find(selectors.city).val(),
	        state: $(form).find(selectors.state).val(),
	        country: $(form).find(selectors.country).val(),
	        zip: $(form).find(selectors.zip).val(),
	        fName: $(form).find(selectors.fName).length > 0 ? $(form).find(selectors.fName).val() : '',
	        lName: $(form).find(selectors.lName).length > 0 ? $(form).find(selectors.lName).val() : ''
	      };
	      return addressObject;
	    },
	    /**
	     * Match validated address with entered address by label.
	     * @param {String} label Label of the entered address
	     * @param {Array} validatedAddresses Array or validated addresses returned by AVS
	     * @return matched address by label
	     */
	    matchValidatedAddress: function matchValidatedAddress(id, validatedAddresses) {
	      if (!validatedAddresses || !validatedAddresses.length) return null;
	
	      // strict id match first
	      var match = validatedAddresses.find(function (v) {
	        return String(v.id || '') === String(id || '');
	      });
	      if (match) return match;
	
	      // fallback: if id is blank or numeric, use index
	      var idx = id === '' || id == null ? 0 : Number(id);
	      if (!Number.isNaN(idx) && validatedAddresses[idx]) {
	        return validatedAddresses[idx];
	      }
	      return null;
	    },
	    /**
	     * Iterate through input address array and match address by id param.
	     * @param {String} id id of the address to be matched
	     * @param {Array} addresses Array of addresses in which we need to find one by id
	     * @return {Object} Matched address
	     */
	    findAddressById: function findAddressById(id, addresses) {
	      var matchedAddress = {};
	      $.each(addresses, function (index, value) {
	        if (value.id == id) {
	          matchedAddress = addresses[index];
	          return false;
	        }
	      });
	      return matchedAddress;
	    },
	    /**
	     * Takes an array of verified addresses and determines if any of them
	     * have returned with a result of 'NO_SUGGESTION'.
	     * @param  {Array} addresses The array of addresses to check.
	     * @return {boolean}
	     */
	    hasAnyNoSuggestion: function hasAnyNoSuggestion(addresses) {
	      return COSTCO.util.any(addresses, function (address) {
	        return address.result.includes('NO_SUGGESTION');
	      });
	    },
	    /**
	     * Takes an array of verified addresses and determines if all of them have
	     * returned with a result of 'NO_SUGGESTION'.
	     * @param  {Array} addresses The array of addresses to check.
	     * @return {boolean}
	     */
	    hasAllNoSuggestion: function hasAllNoSuggestion(addresses) {
	      return COSTCO.util.all(addresses, function (address) {
	        return address.result.includes('NO_SUGGESTION');
	      });
	    },
	    /**
	     * Takes an address object returned from the address verification service
	     * and determines if all of the entered addresses match all of the suggested
	     * addresses.
	     * @param  {Object} addressObj The address object returned from AV
	     * @return {boolean}           Are all entered == suggested?
	     */
	    hasAllSameAsSuggested: function hasAllSameAsSuggested(addressObj) {
	      var result = true;
	      for (var i = 0; i < addressObj.Address.length; i++) {
	        // To reuse isSuggestedSameAsEntered, need this data structure.
	        // This assumes we always have 1:1 entered:validated in the addressObj
	        var tempObj = {
	          Address: [addressObj.Address[i]],
	          // ensure we have the matching validated address
	          Validated_Address: [this.findAddressById(addressObj.Address[i].id, addressObj.Validated_Address)]
	        };
	        if (this.isSuggestedSameAsEntered(tempObj)) {
	          continue;
	        } else {
	          result = false;
	          break;
	        }
	      }
	      return result;
	    },
	    /**
	     * Displays the new Adress Type modal so that the user sets the address type (if in BD Truck zone)
	     * @param  {String}    form - submitted form element
	    */
	    viewAddressTypeModal: function viewAddressTypeModal(preventhtmlajax, addressOptions, message, data) {
	      COSTCO.dialog.createExtDialogBox({
	        title: messages.DELIVERY_OPTIONS,
	        body: COSTCO.util.tmpl('tmpl_delivery_address_modal'),
	        primary: messages.SET_DELIVERY_METHOD,
	        popover: true,
	        dialogclasses: 'nd-delivery-method-dialog',
	        onshow: function onshow() {
	          $('#delivery_address_modal_form').append($('#nd-zipcode-method-modal-body #nd-zipcode-method-fieldset'));
	          $('#nd-zipcode-method-modal-body #nd-zipcode-method-fieldset').remove();
	          //			$('.nd-delivery-method-dialog #costcoModalBtn2').attr("data-bi-tc", "ui:Browse | Choose Delivery Method | Set Delivery Method")
	        },
	        onclose: function onclose() {
	          //			$(document).unbind('click', COSTCO.zipCodeModal.showErrorOnClickOutsideModal);
	          $('#nd-zipcode-method-modal-body').append($('#delivery_address_modal_form #nd-zipcode-method-fieldset'));
	          $('#delivery_address_modal_form #nd-zipcode-method-fieldset').remove();
	        },
	        primary_event: function primary_event() {
	          if (document.querySelector('input[name="nd-radio-group-input"]:checked') == null) {
	            $('.addresstype-setup-notification').removeClass("hidden");
	            $('.addresstype-setup-notification').find("div").html(messages.ERR_DELIVERY_METHOD_NOT_SELECTED);
	          } else {
	            if (message == "suggested") {
	              COSTCO.CAddressVerification.suggested.showAddressTypePopup = false;
	            } else if (data != undefined) {
	              data.showAddressTypePopup = false;
	            } else {
	              COSTCO.CAddressVerification.entered.showAddressTypePopup = false;
	            }
	            COSTCO.CAddressVerification.useAddress(preventhtmlajax, addressOptions, message);
	          }
	        }
	      });
	      $('.close').addClass("hidden");
	    },
	    validateShowAddressTypeModal: function validateShowAddressTypeModal(verifiedAddress, addressOptions) {
	      return verifiedAddress.showAddressTypePopup == "true" && (addressOptions.addressBookReinit == undefined || addressOptions.addressBookReinit == false) && verifiedAddress.addressType == 'S' && (addressOptions.validateParams == undefined || addressOptions.validateParams != undefined && (verifiedAddress.line1 != addressOptions.validateParams[0] || verifiedAddress.zip != addressOptions.validateParams[1] || verifiedAddress.city != addressOptions.validateParams[2]));
	    },
	    handleRadioButtonEnterKey: function handleRadioButtonEnterKey(element) {
	      if (event.keyCode === 13) {
	        $(element).parent().siblings().find('input').get(0).removeAttribute('checked');
	        $(element).parent().siblings().find('div:first').get(0).removeAttribute('aria-checked');
	        $(element).children().get(0).setAttribute('checked', 'true');
	        $(element).get(0).setAttribute('aria-checked', 'true');
	        $('#costcoModalBtn2').removeClass('btn-disabled');
	      }
	    },
	    handleRadioButtonSpaceKey: function handleRadioButtonSpaceKey(element) {
	      if (event.keyCode === 32) {
	        element.click();
	        $('#costcoModalBtn2').removeClass('btn-disabled');
	      }
	    },
	
	    setRadioAttributes: function setRadioAttributes(activeElement, passiveElementParent) {
	      var passiveInput = passiveElementParent.find('input').get(0);
	      if (typeof passiveInput !== 'undefined') {
	        passiveInput.removeAttribute('checked');
	      }
	
	      var passiveLabel = passiveElementParent.find('label').get(0);
	      if (typeof passiveLabel !== 'undefined') {
	        passiveLabel.removeAttribute('aria-checked');
	      }
	
	      // set attr checked on input
	      var activeInput = activeElement.find('input').get(0);
	      if (typeof activeInput !== 'undefined') {
	        activeInput.setAttribute('checked', 'true');
	      }
	
	      // set attr aria-checked on label
	      var activeElem = activeElement.get(0);
	      if (typeof activeElem !== 'undefined') {
	        activeElem.setAttribute('aria-checked', 'true');
	      }
	    },
	    /**
	    * Displays the new Delivery Method modal so that the user sets the delivery method
	    * @param  {String}    form - submitted form element
	    */
	    viewDeliveryMethodModal: function viewDeliveryMethodModal(form, data, params, oldAddy, newAddy) {
	      var showQuestionnaireModal = false;
	      COSTCO.dialog.createExtDialogBox({
	        title: messages.DELIVERY_OPTIONS,
	        body: COSTCO.util.tmpl('tmpl_delivery_address_modal'),
	        primary: messages.SET_DELIVERY_METHOD,
	        popover: true,
	        dialogclasses: 'nd-delivery-method-dialog',
	        onshow: function onshow() {
	          $('#delivery_address_modal_form').append($('#nd-zipcode-method-modal-body #nd-zipcode-method-fieldset'));
	          $('#nd-zipcode-method-modal-body #nd-zipcode-method-fieldset').remove();
	          $('.nd-delivery-method-dialog #costcoModalBtn2').attr("data-bi-tc", "ui:Checkout | Choose Delivery Method | Set Delivery Method");
	          $('.addresstype-setup-notification').addClass("hidden");
	          $('.addresstype-setup-notification').find("div").html('');
	
	          if (data.isBDTruckZoneEnabledForWareHouse === true) {
	            $("#nd-local-delivery-modal-section").removeClass("hidden");
	          } else {
	            $("#nd-local-delivery-modal-section").addClass("hidden");
	          }
	
	          if (data.isNationalDeliveryEnabledForWareHouse === true) {
	            $("#nd-nationwide-delivery-modal-section").removeClass("hidden");
	          } else {
	            $("#nd-nationwide-delivery-modal-section").addClass("hidden");
	          }
	
	          if (data.isStorePickupEnabledForWareHouse === true) {
	            $("#store-pickup-modal-section").removeClass("hidden");
	          } else {
	            $("#store-pickup-modal-section").addClass("hidden");
	          }
	
	          $('#nd-local-delivery-radio-button').focus();
	        },
	        onclose: function onclose() {
	          $(document).unbind('click', COSTCO.zipCodeModal.showErrorOnClickOutsideModal);
	          if ($('#nd-zipcode-method-modal-body').children('fieldset').length == 0) {
	            $('#nd-zipcode-method-modal-body').append($('#delivery_address_modal_form #nd-zipcode-method-fieldset'));
	          }
	          $('#delivery_address_modal_form #nd-zipcode-method-fieldset').remove();
	        },
	        primary_event: function primary_event() {
	          if (document.querySelector('input[name="nd-radio-group-input"]:checked') == null) {
	            $('.addresstype-setup-notification').removeClass("hidden");
	            $('.addresstype-setup-notification').find("div").html(messages.ERR_DELIVERY_METHOD_NOT_SELECTED);
	
	            var isFocusSet = false;
	            if (data.isBDTruckZoneEnabledForWareHouse === true) {
	              $('#nd-local-delivery-radio-button').focus();
	              isFocusSet = true;
	            }
	
	            if (data.isNationalDeliveryEnabledForWareHouse === true && isFocusSet == false) {
	              $('#nd-nationwide-delivery-radio-button').focus();
	              isFocusSet = true;
	            }
	
	            if (data.isStorePickupEnabledForWareHouse === true && isFocusSet == false) {
	              $('#store-pickup-radio-button').focus();
	            }
	          } else {
	            var deliveryMehod;
	            if ($('input[name="deliveryMethod"]').length > 0) {
	              deliveryMethod = $("input[name='deliveryMethod']:checked").val();
	            }
	            var selectedDeliveryMethod = 'Local';
	            if (document.querySelector('input[name="nd-radio-group-input"]:checked') != null) {
	              var uiSelectedDeliveryMethod = document.querySelector('input[name="nd-radio-group-input"]:checked').value;
	              switch (uiSelectedDeliveryMethod) {
	                case "C":
	                  selectedDeliveryMethod = "Local";
	                  break;
	                case "R":
	                  selectedDeliveryMethod = "Nationwide";
	                  break;
	                case "P":
	                  selectedDeliveryMethod = "Store-Pick-Up";
	                  break;
	              }
	              $(form).find("#WC_BusinessDeliveryBrowseForm_FormInput_userSelectedDeliveryMethod").val(selectedDeliveryMethod);
	            }
	            window.digitalDataEvents = window.digitalDataEvents || [];
	            if (selectedDeliveryMethod === 'Local') {
	              digitalDataEvents.push({
	                browseDeliveryMethod: "Local Business Delivery"
	              });
	            } else if (selectedDeliveryMethod === 'Nationwide') {
	              digitalDataEvents.push({
	                browseDeliveryMethod: "Nationwide Delivery"
	              });
	            }
	            data.userSelectionDeliveryMethod = selectedDeliveryMethod;
	            if (oldAddy == null) {
	              //add address flow
	              COSTCO.CAddress.callAddressAddNew(params[2], params[3], newAddy, params[4], data);
	            } else {
	              COSTCO.CAddress.callChooseAddressNew(params[2], oldAddy, newAddy, data);
	            }
	          }
	          var espot = $('#delivery_address_modal_form #nd-zipcode-method-fieldset').clone();
	          $('#nd-zipcode-method-modal-body').html(espot);
	        }
	      });
	      $('.close').addClass("hidden");
	    }
	
	  };
	  if (typeof window.COSTCO === 'undefined') {
	    window.COSTCO = {};
	  }
	  window.COSTCO.CAddressVerification = CAddressVerification;
	  return CAddressVerification;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title checkout_helper.js: Feature level module
	 * @description Utility module associated with checkout
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(14)], __WEBPACK_AMD_DEFINE_RESULT__ = function (address) {
	  var CAddressDisplay = {
	    createAddressDisplay: function createAddressDisplay(obj, type) {
	      var data = CAddressDisplay.buildAddressJson(obj);
	      if (obj.phone) {
	        obj.phone = COSTCO.util.formatPhone(obj.phone);
	      }
	
	      return COSTCO.util.tmpl('tmpl_address_display', obj);
	    },
	    createAddressVerificationDisplay: function createAddressVerificationDisplay(obj, template) {
	      var data = CAddressDisplay.buildAddressJson(obj);
	      if (template == null || template == '' || typeof template === 'undefined') {
	        //set default template if template is not passed in the argument
	        template = 'tmpl_address_display_verification';
	      }
	      return COSTCO.util.tmpl(template, obj);
	    },
	    buildAddressJson: function buildAddressJson(obj) {
	      var data;
	      if (typeof obj === 'number') {
	        var addressJson = address.getAddressJson(obj)[0];
	        if (addressJson.length == 0) return '';
	        data = addressJson[0];
	      } else {
	        data = obj;
	      }
	      return data;
	    }
	  };
	  if (typeof window.COSTCO === "undefined") {
	    window.COSTCO = new Object();
	  }
	  window.COSTCO.CAddressDisplay = CAddressDisplay;
	  return CAddressDisplay;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title member-verification.js: Sub-module of Account feature
	 * @description This module provides membership verification functionality.
	 * @dependency utility.js, costcodialog.js
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	  var MemberVerification = {
	
	    init: function init() {
	      this.validationRules();
	      this.maskDateInput();
	    },
	
	    membershipNumber: null,
	
	    getForm: function getForm() {
	      return $('#MemberVerificationForm');
	    },
	
	    validateNumberForm: function validateNumberForm() {
	      MemberVerification.getForm().validate({
	        rules: {
	          membershipNumberToVerify: {
	            required: true,
	            membershipNumber: true
	          }
	        },
	        messages: {
	          membershipNumberToVerify: {
	            required: messages.ERR_INVALID_MEMBERSHIP_NO,
	            membershipNumber: messages.ERR_INVALID_MEMBERSHIP_NO
	          }
	        },
	        invalidHandler: function invalidHandler(event, validator) {
	          var errors = validator.numberOfInvalids();
	          if (errors) {
	            window.digitalDataEvents = window.digitalDataEvents || [];
	            digitalDataEvents.push({ uimsg: "Member Verification Flow | Enter Valid Membership Number Error" });
	          }
	        }
	      });
	
	      return MemberVerification.getForm().valid();
	    },
	
	    maskDateInput: function maskDateInput() {
	      $('#employeeStartDate').mask('00/00', {
	        placeholder: 'MM/YY'
	      });
	    },
	
	    validateZipCodeForm: function validateZipCodeForm() {
	      var form = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : COSTCO.MemberVerification.getForm();
	
	      form.validate({
	        rules: {
	          questionLastName: {
	            required: true
	          },
	          questionZip: {
	            'required': true,
	            'postalcode': true
	          }
	        },
	        messages: {
	          questionLastName: messages.ERR_INVALID_LASTNAME,
	          questionZip: messages.ERR_ENTER_ZIPCODE
	        },
	        invalidHandler: function invalidHandler(event, validator) {
	          var errors = validator.numberOfInvalids();
	          if (errors) {
	            for (var i = 0; i < errors; i++) {
	              COSTCO.MemberVerification.fireAnalyticsEventLastNameOrZipCodeError(validator.errorList[i].element);
	            }
	          }
	        }
	      });
	
	      return form.valid();
	    },
	
	    fireAnalyticsEventLastNameOrZipCodeError: function fireAnalyticsEventLastNameOrZipCodeError(element) {
	      var test = $(element).is("input[name='questionLastName']");
	      if (test) {
	        digitalDataEvents.push({ uimsg: "Member Verification Flow | Enter Your Last Name Error" });
	      } else {
	        digitalDataEvents.push({ uimsg: "Member Verification Flow | Enter a Valid Zip Code Error" });
	      }
	    },
	
	    validationRules: function validationRules() {
	      $.validator.addMethod('membershipNumber', function (value, element) {
	        // costco pins are 12 digits
	        return this.optional(element) || /^\d{12,16}$/.test(value);
	      }, messages.MEMBERVERIFICATION_MEMBERSHIP__InvalidMembershipNumber);
	
	      $.validator.addMethod('postalcode', function (value, element) {
	        return this.optional(element) || /^(\d{5}(-\d{4})?$)|(^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1} \d{1}[A-Za-z]{1}\d{1})$/.test($.trim(value));
	      }, messages.ERR_ENTER_ZIPCODE);
	    },
	    /**
	     * Submits request for membership verification steps
	     * @param  {String} urlWithParams Service URL with query string parameters appended
	     * @return {jQuery.Deferred}      The deferred object
	     */
	    submitRequest: function submitRequest(urlWithParams) {
	      return COSTCO.util.ajax({
	        type: 'POST',
	        url: urlWithParams,
	        dataType: 'json'
	      })
	      // This returns a chainable promise.
	      .then(function (data) {
	        if (data && data.CRM_ERROR_FRAMEWORK) {
	          var errorTmpl = isDmcPage ? 'tmpl_membership_dmc_verify_err_service_error' : 'tmpl_membership_verify_err_service_error';
	          var errorTmplData = {
	            membershipNumber: MemberVerification.membershipNumber
	          };
	
	          switch (data.CRM_ERROR_FRAMEWORK) {
	
	            case 'ERROR_EXCEEDED_MAX_AUTH_ATTEMPTS':
	              if (isDmcPage) {
	                errorTmpl = 'tmpl_membership_dmc_verify_err_max_retries_reached';
	              } else {
	                errorTmpl = 'tmpl_membership_verify_err_max_retries_reached';
	              }
	              break;
	
	            case 'ERROR_ONLINE_VERIFY_US':
	              errorTmpl = 'tmpl_membership_verify_err_service_error_us';
	              break;
	
	            case 'ERROR_PRESCREEN_ATTEMPT_FAILED':
	              switch (data.CRM_MEMBER_TYPE) {
	                case 'E':
	                  errorTmpl = 'tmpl_membership_verify_err_employee_membership';
	                  break;
	
	                case 'T':
	                  errorTmpl = 'tmpl_membership_verify_err_trial_membership';
	                  break;
	
	                case 'X':
	                  errorTmpl = 'tmpl_membership_verify_err_inactive_membership';
	                  break;
	
	                default:
	                  errorTmpl = 'tmpl_membership_verify_err_try_again';
	              }
	
	          }
	
	          MemberVerification.doAnalytics(errorTmpl);
	
	          return $.Deferred().reject(errorTmpl, errorTmplData);
	        }
	
	        return $.Deferred().resolve(data);
	      }).fail(function (errorTmpl, errorTmplData) {
	        if (errorTmpl) {
	          MemberVerification.displayErrorInModal(errorTmpl, errorTmplData);
	        }
	      });
	    },
	
	    doAnalytics: function doAnalytics(errorTmpl) {
	      window.digitalDataEvents = window.digitalDataEvents || [];
	      switch (errorTmpl) {
	        case 'tmpl_membership_verify_err_service_error':
	          digitalDataEvents.push({ ui: "Member Verification Flow | Not Able to Verify Error" });
	          break;
	        case 'tmpl_membership_verify_err_try_again':
	          digitalDataEvents.push({ ui: "My Account | Membership | Verify Membership | No Match" });
	          break;
	        case 'tmpl_membership_verify_err_max_retries_reached':
	          digitalDataEvents.push({ uimsg: "Member Verification Flow | Exceeded Number of Attempts Error" });
	          break;
	        case 'tmpl_membership_verify_err_service_error_us':
	          digitalDataEvents.push({ uimsg: "My Account | Membership | Verify Membership | Unsuccessful" });
	          break;
	      }
	    },
	    /**
	     * Invalidates session on backend for membership verification process
	     */
	    invalidateSession: function invalidateSession() {
	      var url = MemberVerification.makeVerificationUrl({
	        membershipNumber: MemberVerification.membershipNumber,
	        invalidSession: true
	      });
	
	      MemberVerification.submitRequest(url);
	    },
	    /**
	     * Makes URL with string params for membership account verification services
	     * @param  {Object} params  JSON obj with params to be put in URL as a query string e.g. {membershipNumber: 4444333322221111, invalidSession: true}
	     * @return {String}         URL for membership account verification services with query string paramaters
	     *                          e.g. /AjaxMembershipAccountVerificationCmd?membershipNumber=4444333322221111&invalidSession=true
	     */
	    makeVerificationUrl: function makeVerificationUrl(params) {
	      return COSTCO.util.makeUrl('/AjaxMembershipAccountVerificationCmd', params);
	    },
	    /**
	     * Opens membership verification dialog
	     * @param  {number} membershipNum Membership number
	     */
	    openMembershipVerificationDialog: function openMembershipVerificationDialog(membershipNum) {
	      MemberVerification.membershipNumber = membershipNum;
	
	      window.digitalDataEvents = window.digitalDataEvents || [];
	      digitalDataEvents.push({ uimsg: "navName:DMC | Verify Your Membership | Verify Now" });
	
	      var doNotCloseModalFlag = false;
	      isDmcPage = typeof isDmcPage !== "undefined" && isDmcPage === "true";
	      if (isDmcPage) {
	        doNotCloseModalFlag = true;
	        $('#costcoModalBtn2').parent().removeClass().addClass('col-xs-12 col-sm-12 col-md-12 col-lg-12');
	      }
	
	      var settings = {
	        dialogclasses: 'verify-membership-dialog',
	        title: messages.MEMBERVERIFICATION_MEMBERSHIP__ValidateMembership_LabelText,
	        body: COSTCO.util.tmpl('tmpl_membership_verify_number', {
	          membershipNumber: MemberVerification.membershipNumber
	        }),
	        footerText: isDmcPage ? COSTCO.util.tmpl('tmpl_membership_verify_buy_membership') : '',
	        preventClose: doNotCloseModalFlag,
	        primary: messages.MEMBERVERIFICATION_MEMBERSHIP__Continue_ButtonText,
	        secondary: !isDmcPage ? messages.MEMBERVERIFICATION_MEMBERSHIP__Cancel_ButtonText : '',
	        primary_event: function primary_event() {
	
	          if (MemberVerification.validateNumberForm()) {
	            MemberVerification.membershipNumber = parseInt($('#membershipNumberToVerify').val());
	
	            var url = MemberVerification.makeVerificationUrl({
	              membershipNumber: MemberVerification.membershipNumber
	            });
	
	            MemberVerification.submitRequest(url).then(function (data) {
	              if (isDmcPage) {
	                $('#costcoModalBtn2').parent().removeClass().addClass('col-xs-12 col-md-6');
	              }
	              if (data.CRM_AUTH_QUESTION && data.CRM_AUTH_QUESTION.answers && data.CRM_AUTH_QUESTION.answers.length > 0) {
	                MemberVerification.showQuestionsStep(data);
	              } else {
	                MemberVerification.showPrescreen(data);
	              }
	            });
	          } else {
	            window.digitalDataEvents = window.digitalDataEvents || [];
	            digitalDataEvents.push({ uimsg: "Member Verification Flow | Enter Valid Membership Number Error" });
	          }
	        },
	        secondary_event: function secondary_event() {
	          if (isDmcPage) {
	            MemberVerification.proceedeToDMCCheck('verification', false);
	          } else {
	            COSTCO.dialog.close();
	          }
	        },
	        close: function close() {
	          if (isDmcPage) {
	            MemberVerification.proceedeToDMCCheck('verification', false);
	          } else {
	            COSTCO.dialog.close();
	          }
	        },
	        onshown: function onshown() {
	          COSTCO.util.maskMembershipInput();
	        }
	      };
	
	      COSTCO.dialog.createExtDialogBox(settings);
	    },
	    /**
	     * Shows prescreen (last name / zip code form)
	     * @param  {Object} data Data response returned from server
	     */
	    showPrescreen: function showPrescreen(data) {
	      COSTCO.dialog.updateModal({
	        title: messages.MEMBERVERIFICATION_MEMBERSHIP__ValidateMembership_LabelText,
	        body: COSTCO.util.tmpl('tmpl_membership_verify_prescreen', {}),
	        primary: messages.MEMBERVERIFICATION_MEMBERSHIP__Continue_ButtonText,
	        secondary: messages.MEMBERVERIFICATION_MEMBERSHIP__Cancel_ButtonText,
	        primary_event: function primary_event() {
	          if (MemberVerification.validateZipCodeForm()) {
	            var url = MemberVerification.makeVerificationUrl({
	              lastName: $('#questionLastName').val(),
	              zipCode: $('#questionZip').val()
	            });
	
	            MemberVerification.submitRequest(url).then(MemberVerification.showQuestionsStep);
	          }
	        },
	        secondary_event: function secondary_event() {
	          if (isDmcPage) {
	            MemberVerification.proceedeToDMCCheck('verification', false);
	          } else {
	            COSTCO.dialog.close();
	            MemberVerification.invalidateSession();
	          }
	        },
	        close: function close() {
	          if (isDmcPage) {
	            MemberVerification.proceedeToDMCCheck('verification', false);
	          } else {
	            COSTCO.dialog.close();
	            MemberVerification.invalidateSession();
	          }
	        },
	        onshown: function onshown() {
	          COSTCO.util.maskMembershipInput();
	        }
	      });
	    },
	
	    /**
	     * Updates modal with questions to select. If there is another question returned from backend, call it self again to display new question.
	     * @param  {Object} data Response data from previous step
	     */
	    showQuestionsStep: function showQuestionsStep(data) {
	      var questionsBodyTmpl = '';
	
	      if (data.CRM_AUTH_QUESTION) {
	        questionsBodyTmpl = $(COSTCO.util.tmpl('tmpl_membership_verify_questions', {
	          membershipNumber: MemberVerification.membershipNumber,
	          verificationQuestion: data.CRM_AUTH_QUESTION.question
	        }));
	
	        var questionsTmpl = questionsBodyTmpl.find('#verification-questions');
	
	        if (questionsTmpl.length) {
	          $.each(data.CRM_AUTH_QUESTION.answers, function (index, value) {
	            questionsTmpl.append(COSTCO.util.tmpl('tmpl_membership_verify_question_item', {
	              answerId: index,
	              verificationAnswer: value
	            }));
	          });
	        }
	      }
	
	      COSTCO.dialog.updateModal({
	        title: messages.MEMBERVERIFICATION_MEMBERSHIP__ValidateMembership_LabelText,
	        body: questionsBodyTmpl,
	        primary: messages.MEMBERVERIFICATION_MEMBERSHIP__Continue_ButtonText,
	        secondary: messages.MEMBERVERIFICATION_MEMBERSHIP__Cancel_ButtonText,
	        primary_event: function primary_event() {
	          var selectedAnswer = $('input[name=CRManswer]:checked').val();
	
	          var url = MemberVerification.makeVerificationUrl({
	            answerNumber: selectedAnswer
	          });
	
	          var loadingTmpl = 'tmpl_membership_questions_loading';
	          if (data.CRM_AUTH_LAST_STEP) {
	            loadingTmpl = 'tmpl_membership_verify_loading';
	          }
	
	          COSTCO.dialog.updateModal({
	            title: messages.MEMBERVERIFICATION_MEMBERSHIP__ValidateMembership_LabelText,
	            body: COSTCO.util.tmpl(loadingTmpl, {}),
	            onshown: function onshown() {
	              COSTCO.util.maskMembershipInput();
	            }
	          });
	
	          MemberVerification.submitRequest(url).then(function (data) {
	            if (data.CRM_AUTH_QUESTION && data.CRM_AUTH_QUESTION.answers && data.CRM_AUTH_QUESTION.answers.length > 0) {
	              MemberVerification.showQuestionsStep(data);
	            } else if (data.CRM_AUTH_PASSED == true) {
	              MemberVerification.showSuccessStep();
	            } else {
	              MemberVerification.displayErrorInModal(isDmcPage ? 'tmpl_membership_dmc_verify_err_service_error' : 'tmpl_membership_verify_err_service_error');
	            }
	          });
	        },
	        secondary_event: function secondary_event() {
	          if (isDmcPage) {
	            MemberVerification.proceedeToDMCCheck('verification', false);
	          } else {
	            COSTCO.dialog.close();
	            MemberVerification.invalidateSession();
	          }
	        },
	        close: function close() {
	          if (isDmcPage) {
	            MemberVerification.proceedeToDMCCheck('verification', false);
	          } else {
	            COSTCO.dialog.close();
	            MemberVerification.invalidateSession();
	          }
	        },
	        onshown: function onshown() {
	          COSTCO.util.maskMembershipInput();
	        }
	      });
	    },
	    /**
	     * Transfer request to DMC handler
	     */
	    proceedeToDMCCheck: function proceedeToDMCCheck(action, actionSuccessful) {
	
	      COSTCO.dialog.close();
	      var command = "/DMCCheck";
	
	      var queryStart = "?";
	      var queryConcat = "&";
	      var queryAction = "action=" + action;
	      var queryDeviceId = "deviceId=" + deviceId;
	      var queryVerified = "verified=" + actionSuccessful;
	      var queryRenewalCanceled = "renewCanceled=" + actionSuccessful;
	      var queryString = queryStart + queryAction + queryConcat + queryDeviceId + queryConcat;
	
	      if (action == 'renewal') queryString += queryRenewalCanceled;else queryString += queryVerified;
	
	      var newURL = window.location.protocol + "//" + window.location.host + command + queryString;
	      window.location.replace(newURL);
	    },
	    /**
	     * Update modal with succcess text
	     */
	    showSuccessStep: function showSuccessStep() {
	      window.digitalDataEvents = window.digitalDataEvents || [];
	      digitalDataEvents.push({ uimsg: "My Account | Membership | Verify Membership | Success" });
	      COSTCO.dialog.updateModal({
	        title: messages.MEMBERVERIFICATION_MEMBERSHIP__ValidateMembership_LabelText,
	        body: COSTCO.util.tmpl('tmpl_membership_verify_success', {}),
	        primary: messages.MEMBERVERIFICATION_MEMBERSHIP__Continue_ButtonText,
	        primary_event: function primary_event() {
	          if (isDmcPage) {
	            MemberVerification.proceedeToDMCCheck('verification', true);
	          } else {
	            COSTCO.dialog.close();
	            location.reload();
	          }
	        },
	        close: function close() {
	          if (isDmcPage) {
	            MemberVerification.proceedeToDMCCheck('verification', true);
	          } else {
	            COSTCO.dialog.close();
	            location.reload();
	          }
	        },
	        onshown: function onshown() {
	          COSTCO.util.maskMembershipInput();
	        }
	      });
	    },
	    /**
	     * Update modal with error text from prepared template.
	     * @param  {string} errorTemplate   Template id
	     * @param  {Object} data            Data used to populate in template
	     */
	    displayErrorInModal: function displayErrorInModal(errorTemplate, data) {
	      COSTCO.dialog.updateModal({
	        title: messages.MEMBERVERIFICATION_MEMBERSHIP__ValidateMembership_LabelText,
	        body: COSTCO.util.tmpl(errorTemplate, data),
	        primary: messages.MEMBERVERIFICATION_MEMBERSHIP__Continue_ButtonText,
	        primary_event: function primary_event() {
	          COSTCO.dialog.close();
	          location.reload();
	        },
	        close: function close() {
	          if (isDmcPage) {
	            MemberVerification.proceedeToDMCCheck('verification', false);
	          } else {
	            COSTCO.dialog.close();
	            location.reload();
	          }
	        },
	        onshown: function onshown() {
	          COSTCO.util.maskMembershipInput();
	        }
	      });
	    }
	
	  };
	  if (typeof window.COSTCO == 'undefined') {
	    window.COSTCO = {};
	  }
	  window.COSTCO.MemberVerification = MemberVerification;
	  return MemberVerification;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title renew-membership.js: Sub-module for Account pages
	 * @description This module is used to handle renew membership tasks
	 * @dependency
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8), __webpack_require__(19), __webpack_require__(21), __webpack_require__(22), __webpack_require__(11)], __WEBPACK_AMD_DEFINE_RESULT__ = function (util, verification, creditcard, affForm, helper) {
	  var RenewMembership = {
	    sessionId: '',
	    authToken: '',
	    membershipData: {},
	    getForm: function getForm() {
	      return $('#StorePaymentForm');
	    },
	    renewCreditCardData: {},
	    cybersourceEnabled: false,
	    /**
	     * Initialization of the module.
	     * @return {void} [description]
	     */
	    init: function init() {
	      /**
	       * From AccountRenewMembership_Data.jsp
	       * @type {Object}
	       */
	      //feature flag for cybersource
	      this.cybersourceEnabled = $("#cybersourceEnabled").val() == 'true';
	      this.membershipData = membershipData;
	      this.validationRules();
	      this.maskInput();
	      verification.init();
	
	      this.authToken = $('[name=authToken]').val();
	
	      if (!helper.isQuickMembership && $('#auto-renew-payment').length === 0) {
	        TokenGateway.refreshGateway();
	      }
	      /**
	       * Binding header and footer links for leave page modal
	       * for given action, depending if it is purchase or renewal flow
	       */
	      COSTCO.util.activateKeyboardAccesiblePopover('co-help');
	      console.log('Renew Membership module initialized');
	
	      if (!$("#autoRenewConsentOptionDiv").is(":hidden") && $('input[name="ftc-click-to-enrole"]').length > 0) {
	        if (!$('input[type="radio"][name="ftc-click-to-enrole"]:checked').val()) {
	          COSTCO.RenewMembership.autoRenew.noConsentInfo();
	        } else {
	          $('input[type="radio"][name="ftc-click-to-enrole"]:checked').trigger('click');
	        }
	      }
	
	      reloadSessionJS();
	    },
	    autoRenew: {
	
	      /**
	       * Constants
	       */
	      constants: {
	        modeType: {
	          ADD: 'ADD_MODE',
	          EDIT: 'EDIT_MODE'
	        },
	
	        autoRenewCardBinRangeRegexPattern: '',
	        testAutoRenewExpirationDateEnabled: false,
	        testAutoRenewExpirationDate: ''
	      },
	      /**
	       * Setting autoRenewCardBinRangeRegexPattern variable
	       * @param {String} binRange - bin range that is stored in XAPPLICATION table
	       * @return {void}
	       */
	      setAutoRenewCardBinRange: function setAutoRenewCardBinRange(binRange) {
	        RenewMembership.autoRenew.constants.autoRenewCardBinRangeRegexPattern = new RegExp(binRange);
	      },
	      /**
	       * Setting testAutoRenewExpirationDateEnabled and testAutoRenewExpirationDate variable
	       * @param {String} testAutoRenewExpirationDateEnabled and testAutoRenewExpirationDate - stored in XAPPLICATION table
	       * @return {void}
	       */
	      setTestAutoRenew: function setTestAutoRenew(testAutoRenewExpirationDateEnabled, testAutoRenewExpirationDate) {
	        RenewMembership.autoRenew.constants.testAutoRenewExpirationDateEnabled = testAutoRenewExpirationDateEnabled;
	        RenewMembership.autoRenew.constants.testAutoRenewExpirationDate = testAutoRenewExpirationDate;
	      },
	      /**
	       * Hide section with last name and zip code for validate membership
	       * @return {void}
	       */
	      hideValidationFieldsForValidatedUser: function hideValidationFieldsForValidatedUser() {
	        if (sessionStorage.getItem("changeValidationFlag") != "true") {
	          $('#vallidation-questions').removeClass('hide');
	        } else {
	          $('#vallidation-questions').addClass('hide');
	        }
	      },
	      validateLastNameZipCode: function validateLastNameZipCode() {
	        var questionLastName = $("#validationQuestionLastName");
	        var lastName = $.trim(questionLastName.val());
	        isLastNameValid = false;
	        if (lastName !== undefined && lastName !== '') {
	          questionLastName.parent()[0].classList.remove("mdc-text-field--invalid");
	          questionLastName[0].classList.remove("highlightError");
	
	          questionLastName.removeProp('required');
	          questionLastName.parent()[0].nextElementSibling.children[0].innerHTML = "";
	          questionLastName.parent()[0].nextElementSibling.style.display = 'none';
	          isLastNameValid = true;
	        } else {
	          questionLastName.parent()[0].classList.add('mdc-text-field--invalid');
	          questionLastName[0].classList.add('highlightError');
	          questionLastName.prop('required', true);
	          questionLastName.parent()[0].nextElementSibling.children[0].innerHTML = messages.ERR_INVALID_LASTNAME;
	          questionLastName.parent()[0].nextElementSibling.style.display = 'block';
	          questionLastName.focus();
	          isLastNameValid = false;
	        }
	        var questionZip = $("#validationQuestionZip");
	        var zipCode = $.trim(questionZip.val());
	        isZipValid = false;
	        if (zipCode !== undefined && zipCode !== '' && COSTCO.util.POSTAL_CODE_REGEX_CA.test(zipCode)) {
	          questionZip.parent()[0].classList.remove("mdc-text-field--invalid");
	          questionZip[0].classList.remove("highlightError");
	          questionZip.removeProp('required');
	          questionZip.parent()[0].nextElementSibling.children[0].innerHTML = "";
	          questionZip.parent()[0].nextElementSibling.style.display = 'none';
	          isZipValid = true;
	        } else {
	          questionZip.parent()[0].classList.add('mdc-text-field--invalid');
	          questionZip[0].classList.add('highlightError');
	          questionZip.prop('required', true);
	          questionZip.parent()[0].nextElementSibling.children[0].innerHTML = messages.ERR_ENTER_ZIPCODE;
	          questionZip.parent()[0].nextElementSibling.style.display = 'block';
	          if (isLastNameValid) {
	            questionZip.focus();
	          }
	          isZipValid = false;
	        }
	        return isZipValid && isLastNameValid;
	      },
	
	      /**
	       * Add card for auto renew payment. Added check for zipcode and lastname to be sure user is valid and
	       * check if user has attempted to enter wrong parameters more times than allowed. 
	       * @param  {HTMLFormElement} form form Auto renew payment form
	       * @return {void}      [description]
	       */
	      addCard: function addCard(form) {
	
	        $form = $(form);
	
	        var displayMode = $form.find('input[id="displayMode"]').val();
	
	        if ($("#ftc-click-to-enrole").prop('checked') == false && displayMode == 'add') {
	          $("#ftc-enrole").addClass("critical-notification");
	          return;
	        } else {
	          $("#ftc-enrole").removeClass("critical-notification");
	        }
	
	        var sessionId = $form.find('input[id="tokenSessionId"]').val();
	
	        var lastName = $form.find('input[id="questionLastName"]').length > 0 ? $form.find('input[id="questionLastName"]').val() : '';
	        var zipCode = $form.find('input[id="questionZip"]').length > 0 ? $form.find('input[id="questionZip"]').val() : '';
	
	        var isAddAutoRenew = displayMode == 'add' ? true : false; // Default value
	        var isAddAutoRenewConsent = displayMode == 'add' ? true : false; // Default value
	
	        var isAutoRenewSelected = $form.find('input[id="cardForAutorenew"]');
	        if (isAutoRenewSelected.length == 1) {
	          isAddAutoRenew = $form.find('input[id="cardForAutorenew"]').prop('checked');
	        }
	
	        var cardHolderName = $form.find('input[id="cc_nameoncard"]').val();
	
	        var expDate = $form.find('input[id="cc_expiry_date"]').val().split('/');
	
	        var expMonth = void 0;
	        var expYear = void 0;
	        if (expDate.length == 2) {
	          expMonth = expDate[0];
	          expYear = '20' + expDate[1];
	        }
	        var data = {};
	
	        if ($('input[name="ftc-click-to-enrole"]').length > 0) {
	          data = {
	            'action': 'create_token',
	            'sessionId': sessionId,
	            'isAddAutoRenew': isAddAutoRenew,
	            'autoRenewConsent': isAddAutoRenewConsent,
	            'cardHolderName': cardHolderName,
	            'expiryMonth': expMonth,
	            'expiryYear': expYear,
	            'authToken': RenewMembership.authToken
	          };
	        } else {
	          data = {
	            'action': 'create_token',
	            'sessionId': sessionId,
	            'isAddAutoRenew': isAddAutoRenew,
	            'cardHolderName': cardHolderName,
	            'expiryMonth': expMonth,
	            'expiryYear': expYear,
	            'authToken': RenewMembership.authToken
	          };
	        }
	
	        if (sessionStorage.getItem("changeValidationFlag") !== "true" && membershipData.validated && !membershipData.verified) {
	          var url = COSTCO.util.makeUrl('/AjaxAccountAutoRenewMembershipValidationCmd', {
	            lastName: $('#validationQuestionLastName').val().trim(),
	            zipCode: $('#validationQuestionZip').val().trim()
	          });
	
	          COSTCO.MemberVerification.submitRequest(url).then(function (data) {
	            // Check if user entered invalid parameters more times than allowed
	            if (data.memberAccountRecordCheckMaxAttempsReached != 'true') {
	              // Check if user is valid and proceed to add the card
	              if (data.memberAccountRecordMatch == 'true') {
	                sessionStorage.setItem("changeValidationFlag", true);
	                TokenGateway.updateSessionFromForm('card', function () {
	                  data.payMethodId = $('input[name=payMethodId]').val();
	                  if (RenewMembership.cybersourceEnabled) {
	                    data.sessionId = $form.find('input[id="tokenSessionId"]').val();
	                    data.number = $form.find('input[id="number"]').val();
	                  }
	                  RenewMembership.autoRenew.services.ajaxManageAutoRenewPayment(data);
	                  window.digitalDataEvents = window.digitalDataEvents || [];
	                  digitalDataEvents.push({ ui: "Account | Renew Membership | Add Payment Method" });
	                  if ($('input[name="ftc-click-to-enrole"]').length > 0) {
	                    digitalDataEvents.push({ renewAuto: "Enrolled" });
	                  }
	                }, $form.attr('id'));
	              } else {
	                // Error message if user is not valid
	                $('#account-renew-check-error-wrapper').removeAttr('hidden');
	                // clear payment info
	                $('#card_number').val('');
	                $('#cc_expiry_date').val('');
	                $('#cc_nameoncard').val('');
	                $('#cc_nameoncard_label').removeClass('active');
	                TokenGateway.refreshGateway();
	                COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, [data.message], false, '#account-renew-check-error-wrapper', 'span');
	              }
	            } else {
	              // Error message if user has entered invalid parameters more times than allowed in previous 24h.
	              $('#account-renew-check-error-wrapper').removeAttr('hidden');
	              $('#renew-validate-membership').addClass('hidden');
	              COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, [data.message], false, '#account-renew-check-error-wrapper', 'span');
	              $('.renew-membership-form-and-text').hide();
	            }
	          });
	        } else {
	          TokenGateway.updateSessionFromForm('card', function () {
	            data.payMethodId = $('input[name=payMethodId]').val();
	            if (RenewMembership.cybersourceEnabled) {
	              data.sessionId = $form.find('input[id="tokenSessionId"]').val();
	              data.number = $form.find('input[id="number"]').val();
	            }
	            RenewMembership.autoRenew.services.ajaxManageAutoRenewPayment(data);
	            window.digitalDataEvents = window.digitalDataEvents || [];
	            digitalDataEvents.push({ ui: "Account | Renew Membership | Add Payment Method" });
	            if ($('input[name="ftc-click-to-enrole"]').length > 0 && $('#selectedCardForAutoRenew').val() == '') {
	              digitalDataEvents.push({ renewAuto: "Enrolled" });
	            }
	          }, $form.attr('id'));
	        }
	      },
	
	      /**
	       * cancel add another card
	       */
	      cancelAddCard: function cancelAddCard(form) {
	        $('#add-another-card-form').empty();
	        $('#add-another-card-form').hide();
	        $('#add-another-card-link').show();
	
	        if ($('#selectedCardForAutoRenew').val() == '') {
	          $('#saveAutoRenewSettingBtn').show();
	          $('#cancelAutoRenewBtn').hide();
	        } else {
	          var checkboxes = document.querySelectorAll('input[type="checkbox"]');
	          var cardCheckboxes = Array.from(checkboxes).filter(function (checkbox) {
	            return checkbox.name.startsWith("cardForAutorenew_" + $('#selectedCardForAutoRenew').val()) && $(checkbox).prop("checked");
	          });
	
	          if (cardCheckboxes.length) {
	            $('#saveAutoRenewSettingBtn').hide();
	            $('#cancelAutoRenewBtn').show();
	          } else {
	            $('#saveAutoRenewSettingBtn').show();
	            $('#cancelAutoRenewBtn').hide();
	          }
	        }
	      },
	      /**
	       * Edit auto renew payment info
	       * @param  {HTMLFormElement} form   form Auto renew payment form
	       * @param  {String} cardId Card id
	       * @return {void}
	       */
	      editCard: function editCard(form, cardId) {
	        $form = $(form);
	
	        var sessionId = $form.find('input[id="tokenSessionId"]').val();
	
	        var isAddAutoRenew = $('input[name="ftc-click-to-enrole"]').length > 0 ? false : true; // Default value
	        var isAutoRenewSelected = $form.find('input[id="cardForAutorenew"]');
	        if (isAutoRenewSelected.length == 1) {
	          isAddAutoRenew = $form.find('input[id="cardForAutorenew"]').prop('checked');
	        }
	
	        var cardHolderName = $form.find('input[id="cc_nameoncard"]').val();
	
	        var expDate = $form.find('input[id="cc_expiry_date"]').val().split('/');
	
	        var number = $form.find('input[id="card_number"]').val();
	
	        var expMonth = void 0;
	        var expYear = void 0;
	        if (expDate.length == 2) {
	          expMonth = expDate[0];
	          expYear = '20' + expDate[1];
	        }
	
	        var data = {};
	        if ($('input[name="ftc-click-to-enrole"]').length > 0) {
	          if ($("#ftc-click-to-enrole").prop('checked') != true && $('#selectedCardForAutoRenew').val() == cardId) {
	            util.notification.clearNotification($('#auto-renew-notification'));
	            util.notification.displayNotification(COSTCO.util.notification.type.ERROR, [messages.AUTO_RENEW_CONSENT_INFORMATION_ERROR], true, $('#auto-renew-notification'), 'div');
	            $('#auto-renew-notification').addClass('cds-u-space-mb-md');
	            $('#auto-renew-notification').show();
	            $('#auto-renew-notification').focus();
	            return;
	          } else if ($('#selectedCardForAutoRenew').val() != cardId) {
	            data = {
	              'action': 'update_token',
	              'sessionId': sessionId,
	              'memberCreditAccountId': cardId,
	              'isAddAutoRenew': false,
	              'autoRenewConsent': false,
	              'cardHolderName': cardHolderName,
	              'expiryMonth': expMonth,
	              'expiryYear': expYear,
	              'authToken': RenewMembership.authToken,
	              'number': number
	            };
	          } else {
	            isAddAutoRenew = true;
	            data = {
	              'action': 'update_token',
	              'sessionId': sessionId,
	              'memberCreditAccountId': cardId,
	              'isAddAutoRenew': isAddAutoRenew,
	              'autoRenewConsent': isAddAutoRenew && $("#ftc-click-to-enrole").prop('checked') && $('#selectedCardForAutoRenew').val() != '',
	              'cardHolderName': cardHolderName,
	              'expiryMonth': expMonth,
	              'expiryYear': expYear,
	              'authToken': RenewMembership.authToken,
	              'number': number
	            };
	          }
	        } else {
	          data = {
	            'action': 'update_token',
	            'sessionId': sessionId,
	            'memberCreditAccountId': cardId,
	            'isAddAutoRenew': isAddAutoRenew,
	            'cardHolderName': cardHolderName,
	            'expiryMonth': expMonth,
	            'expiryYear': expYear,
	            'authToken': RenewMembership.authToken,
	            'number': number
	          };
	        }
	
	        TokenGateway.updateSessionFromForm('card', function () {
	          data.payMethodId = $('input[name=payMethodId]').val();
	          if (RenewMembership.cybersourceEnabled) {
	            data.sessionId = $form.find('input[id="tokenSessionId"]').val();
	            data.number = $form.find('input[id="number"]').val();
	          }
	
	          RenewMembership.autoRenew.services.ajaxManageAutoRenewPayment(data);
	          window.digitalDataEvents = window.digitalDataEvents || [];
	          digitalDataEvents.push({ ui: "Account | Renew Membership | Update Payment Method" });
	          if ($('input[name="ftc-click-to-enrole"]').length > 0 && $('#selectedCardForAutoRenew').val() == cardId) {
	            digitalDataEvents.push({ renewAuto: "Enrolled" });
	          }
	        }, $form.attr('id'));
	      },
	
	      /**
	       * Cancel update on canceling update of paymenr method for auto renew
	       * @param  {string} formType	Form type to show (add_another | edit)
	       * @param  {number} cardId 		Card id
	       * @return {void}
	       */
	      cancelUpdate: function cancelUpdate(formType, cardId) {
	        $('#auto-payment-item-' + cardId).removeClass('hide');
	        $('#auto-payment-form-item-' + cardId).html('');
	        if ($('#selectedCardForAutoRenew').val() == '') {
	          $('#saveAutoRenewSettingBtn').show();
	          $('#cancelAutoRenewBtn').hide();
	        } else {
	          $('#saveAutoRenewSettingBtn').hide();
	          $('#cancelAutoRenewBtn').show();
	        }
	        $('#auto-renew-notification').hide();
	        if ($('input[name="ftc-click-to-enrole"]').length > 0 && $('#selectedCardForAutoRenew').val() == cardId) {
	          $('#autoRenewConsentOptionDiv').hide();
	          $('#ftc-enrole-information').hide();
	        }
	      },
	      /**
	       * Remove credit card for auto renew
	       * @param {string} bodyMessage 	To be displayed in modal
	       * @param {string} cardId   			Card id to delete
	       */
	      deleteCard: function deleteCard(bodyMessage, cardId) {
	        //remove add another form and show add another link
	        $('#add-another-card-link').show();
	        $('#add-another-card-form').empty();
	        //remove update form and display update remove links opened for update
	        $('[data-card-id]').each(function (index, value) {
	          $value = $(value);
	          var currentId = $value.attr('data-card-id');
	          $('#auto-payment-item-' + currentId).removeClass('hide');
	          $('#auto-payment-form-item-' + currentId).empty();
	        });
	
	        if (RenewMembership.autoRenew.hasUserReachedMaxAttempts()) {
	          return;
	        } else if (!RenewMembership.autoRenew.isValidMembershipInfo()) {
	          // last name and zip code is not valid, show validation prescreen
	          COSTCO.MembershipValidation.showValidationPrescreen();
	          return;
	        }
	        COSTCO.dialog.createExtDialogBox({
	          title: messages.ACCOUNT_RENEW_MEMBERSHIP_REMOVE_CARD,
	          body: bodyMessage,
	          primary: messages.ACCOUNT_RENEW_MEMBERSHIP_REMOVE_CARD,
	          secondary: messages.JS_DIALOG_CANCEL,
	          dialogclasses: 'remove-card-modal',
	          primary_event: function primary_event() {
	            var data = {};
	            if ($('input[name="ftc-click-to-enrole"]').length > 0) {
	              if ($('#selectedCardForAutoRenew').val() == cardId) {
	                data = {
	                  'action': 'delete_token',
	                  'autoRenewConsent': false,
	                  'memberCreditAccountId': $('#selectedCardForAutoRenew').val(),
	                  'authToken': RenewMembership.authToken
	                };
	              } else {
	                data = {
	                  'action': 'delete_token',
	                  'memberCreditAccountId': cardId,
	                  'autoRenewConsent': $('#selectedCardForAutoRenew').val() != '',
	                  'authToken': RenewMembership.authToken
	                };
	              }
	            } else {
	              data = {
	                'action': 'delete_token',
	                'memberCreditAccountId': cardId,
	                'authToken': RenewMembership.authToken
	              };
	            }
	
	            RenewMembership.autoRenew.services.ajaxManageAutoRenewPayment(data);
	            window.digitalDataEvents = window.digitalDataEvents || [];
	            digitalDataEvents.push({ ui: "Account | Renew Membership | Remove Payment Method" });
	            if ($('#selectedCardForAutoRenew').val() == cardId) {
	              digitalDataEvents.push({ renewAuto: "Not Enrolled" });
	            }
	
	            COSTCO.dialog.close();
	          }
	        });
	      },
	
	      /**
	       * Sets card for auto renew (on / off)
	       * @param {Element} element Input element to get if user has checked for autorenew
	       * @param {string} cardId  Card id to update
	       */
	      setAsDefaultAutoRenew: function setAsDefaultAutoRenew(element, cardId, hasPayer) {
	        if (event.type == 'click' || event.type == 'keydown' && event.code == 'Space') {
	          if ($('#add-another-card-form').is(":visible")) {
	            $('#add-another-card-form').hide();
	            $('#saveAutoRenewSettingBtn').show();
	          }
	          if ($('#add-another-card-link').is(":hidden")) {
	            $('#add-another-card-link').show();
	          }
	          var checkboxes = document.querySelectorAll('input[type="checkbox"]');
	          var cardCheckboxes = Array.from(checkboxes).filter(function (checkbox) {
	            return checkbox.name.startsWith("cardForAutorenew_" + cardId);
	          });
	          var otherCardCheckboxes = Array.from(checkboxes).filter(function (checkbox) {
	            return checkbox.name.startsWith("cardForAutorenew_") && !checkbox.name.startsWith("cardForAutorenew_" + cardId);
	          });
	          if (RenewMembership.autoRenew.hasUserReachedMaxAttempts() || !RenewMembership.autoRenew.isValidMembershipInfo() || $('input[name="ftc-click-to-enrole"]').length > 0) {
	
	            if ($('#selectedCardForAutoRenew').val() == cardId) {
	
	              if ($(window).width() > 1024 && cardCheckboxes[1].checked || $(window).width() < 1024 && !cardCheckboxes[0].checked) {
	                $('#saveAutoRenewSettingBtn').show();
	                $('#cancelAutoRenewBtn').hide();
	              } else {
	                $('#saveAutoRenewSettingBtn').hide();
	                $('#cancelAutoRenewBtn').show();
	              }
	
	              $('#autoRenewConsentOptionDiv').hide();
	              $('#ftc-enrole-information').hide();
	            } else {
	              $('#autoRenewConsentOptionDiv').show();
	              $('#saveAutoRenewSettingBtn').show();
	              $('#cancelAutoRenewBtn').hide();
	              $('#ftc-enrole-information').show();
	            }
	            if (!RenewMembership.autoRenew.isValidMembershipInfo()) {
	              COSTCO.MembershipValidation.showValidationPrescreen();
	            }
	
	            if (cardCheckboxes.length) {
	              if ($(window).width() > 1024 && cardCheckboxes[1].checked) {
	                $("[id='cardForAutorenew_" + cardId + "']").prop("checked", false);
	              } else if ($(window).width() > 1024 && !cardCheckboxes[1].checked) {
	                $("[id='cardForAutorenew_" + cardId + "']").prop("checked", true);
	              } else if ($(window).width() < 1024 && cardCheckboxes[0].checked) {
	                $("[id='cardForAutorenew_" + cardId + "']").prop("checked", true);
	              } else if ($(window).width() < 1024 && !cardCheckboxes[0].checked) {
	                $("[id='cardForAutorenew_" + cardId + "']").prop("checked", false);
	              }
	              if (otherCardCheckboxes.length) {
	                otherCardCheckboxes.forEach(function (item) {
	                  $(item).prop("checked", false);
	                });
	              }
	            }
	
	            return;
	          }
	          if ($('input[name="ftc-click-to-enrole"]').length == 0) {
	            if (typeof hasPayer == 'undefined' && !element.checked) {
	              element.checked = true;
	
	              COSTCO.dialog.createExtDialogBox({
	                title: messages.ACCOUNT_RENEW_MEMBERSHIP_USE_CARD_FOR_AUTO_RENEW,
	                body: messages.ACCOUNT_RENEW_MEMBERSHIP_USE_CARD_FOR_AUTO_RENEW_DEFAULT_TEXT,
	                primary: messages.JS_DIALOG_YES,
	                secondary: messages.JS_DIALOG_NO,
	                dialogclasses: 'remove-card-modal',
	                primary_event: function primary_event() {
	                  var data = {
	                    'action': 'delete_renew',
	                    'memberCreditAccountId': cardId,
	                    'authToken': RenewMembership.authToken
	                  };
	
	                  RenewMembership.autoRenew.services.ajaxManageAutoRenewPayment(data);
	                  COSTCO.dialog.close();
	                },
	                secondary_event: function secondary_event() {
	                  $("[id='cardForAutorenew_" + cardId + "']").prop("checked", true);
	                  COSTCO.dialog.close();
	                }
	              });
	            } else {
	              var data = {
	                'action': 'add_renew',
	                'memberCreditAccountId': cardId,
	                'authToken': RenewMembership.authToken
	              };
	              RenewMembership.autoRenew.services.ajaxManageAutoRenewPayment(data);
	            }
	          }
	        }
	      },
	
	      /**
	       * enroll auto renew 
	       */
	      enroll: function enroll(displayMode) {
	        $('#cancelAutoRenewBtn').hide();
	        $('#displayAddEditCards').show();
	        if (displayMode == 'add') {
	          $('#saveAutoRenewSettingBtn').hide();
	        }
	        if (displayMode == 'edit' && $('#cardForAutorenew_' + $('#selectedCardForAutoRenew').val()).prop('checked') == true) {
	          RenewMembership.showCreditCardForm('edit', $('#selectedCardForAutoRenew').val(), RenewMembership.renewCreditCardData);
	
	          $('#autoRenewConsentOptionDiv').show();
	          $('#ftc-enrole-information').show();
	          $('#saveAutoRenewSettingBtn').hide();
	          $('#cancelAutoRenewBtn').hide();
	        }
	      },
	
	      noConsentInfo: function noConsentInfo() {
	
	        if ($('#selectedCardForAutoRenew').val() == '') {
	          $('#displayAddEditCards').hide();
	          $('#saveAutoRenewSettingBtn').show();
	          $('#cancelAutoRenewBtn').hide();
	          $('#autoRenewConsentOptionDiv').show();
	          $('#ftc-enrole-information').show();
	        } else {
	          $('#displayAddEditCards').show();
	          $('#saveAutoRenewSettingBtn').hide();
	          $('#cancelAutoRenewBtn').show();
	          $('#autoRenewConsentOptionDiv').hide();
	          $('#ftc-enrole-information').hide();
	        }
	        $('#auto-renew-notification').hide();
	      },
	
	      /**
	       * unenroll auto renew 
	       */
	      unenroll: function unenroll(displayMode) {
	        $('#displayAddEditCards').hide();
	        $('#saveAutoRenewSettingBtn').show();
	        $('#cancelAutoRenewBtn').hide();
	        if (displayMode == 'add') {
	          $('#card_number').val('');
	          $('#cc_expiry_date').val('');
	          $('#cc_nameoncard').val('');
	          $('#cc_nameoncard_label').removeClass('active');
	          reloadSessionJS();
	        }
	
	        if (displayMode == 'edit' && $('#cardForAutorenew_' + $('#selectedCardForAutoRenew').val()).prop('checked') == true) {
	
	          RenewMembership.autoRenew.cancelUpdate(RenewMembership.getForm(), $('#selectedCardForAutoRenew').val());
	
	          $('#autoRenewConsentOptionDiv').show();
	          $('#ftc-enrole-information').show();
	          $('#saveAutoRenewSettingBtn').show();
	          $('#cancelAutoRenewBtn').hide();
	        }
	      },
	
	      cancelAutoRenew: function cancelAutoRenew() {
	
	        if (RenewMembership.autoRenew.hasUserReachedMaxAttempts()) {
	          return;
	        } else if (!RenewMembership.autoRenew.isValidMembershipInfo()) {
	          // last name and zip code is not valid, show validation prescreen
	          COSTCO.MembershipValidation.showValidationPrescreen();
	          return;
	        }
	        var data = {
	          'action': 'delete_renew',
	          'autoRenewConsent': false,
	          'memberCreditAccountId': $('#selectedCardForAutoRenew').val(),
	          'authToken': RenewMembership.authToken
	        };
	        RenewMembership.autoRenew.services.ajaxManageAutoRenewPayment(data);
	        $('#auto-renew-notification').show();
	        $('#auto-renew-notification').focus();
	        window.digitalDataEvents = window.digitalDataEvents || [];
	        digitalDataEvents.push({ renewAuto: "Not Enrolled" });
	      },
	
	      /**
	       * save auto renew settings 
	       */
	      saveAutoRenewSettings: function saveAutoRenewSettings() {
	
	        if (RenewMembership.autoRenew.hasUserReachedMaxAttempts()) {
	          return;
	        } else if (!RenewMembership.autoRenew.isValidMembershipInfo()) {
	          // last name and zip code is not valid, show validation prescreen
	          COSTCO.MembershipValidation.showValidationPrescreen();
	          return;
	        }
	        var checkboxes = document.querySelectorAll('input[type="checkbox"]');
	        var selectedCheckboxes = Array.from(checkboxes).filter(function (checkbox) {
	          return checkbox.checked && checkbox.name.startsWith("cardForAutorenew_");
	        });
	        var renewCardCheckboxes = Array.from(checkboxes).filter(function (checkbox) {
	          return !checkbox.checked && checkbox.name.startsWith("cardForAutorenew_" + $('#selectedCardForAutoRenew').val());
	        });
	        if ($("#ftc-click-to-enrole").prop('checked') == true) {
	          if (selectedCheckboxes.length) {
	            var firsSelected = selectedCheckboxes[0];
	            var firstSelectedSplited = firsSelected.id.split('_');
	            if (firstSelectedSplited.length && firstSelectedSplited.length > 1) {
	              var selectedCardId = firstSelectedSplited[1];
	              var data = {
	                'action': 'add_renew',
	                'autoRenewConsent': true,
	                'memberCreditAccountId': selectedCardId,
	                'authToken': RenewMembership.authToken
	              };
	              $('#ftc-enrole-error').addClass('hide');
	              $("#ftc-enrole > label.control > div.control__indicator").removeClass("critical");
	              RenewMembership.autoRenew.services.ajaxManageAutoRenewPayment(data);
	              $('#auto-renew-notification').show();
	              $('#auto-renew-notification').focus();
	              window.digitalDataEvents = window.digitalDataEvents || [];
	              digitalDataEvents.push({ ui: "Account | Renew Membership | Save Payment Method Auto Renew Settings" });
	              digitalDataEvents.push({ renewAuto: "Enrolled" });
	            }
	          } else {
	            $('#auto-renew-notification').hide();
	            $('#ftc-enrole-error').removeClass('hide');
	            $('#ftc-enrole-error').focus();
	            $("#ftc-enrole > label.control > div.control__indicator").addClass("critical");
	          }
	        } else if ($("#ftc-click-to-enrole-not").prop('checked') == true || renewCardCheckboxes.length && !selectedCheckboxes.length && $('#selectedCardForAutoRenew').val() != "") {
	
	          var _data = {
	            'action': 'delete_renew',
	            'autoRenewConsent': false,
	            'memberCreditAccountId': $('#selectedCardForAutoRenew').val(),
	            'authToken': RenewMembership.authToken
	          };
	          RenewMembership.autoRenew.services.ajaxManageAutoRenewPayment(_data);
	          $('#auto-renew-notification').show();
	          $('#auto-renew-notification').focus();
	          window.digitalDataEvents = window.digitalDataEvents || [];
	          digitalDataEvents.push({ ui: "Account | Renew Membership | Save Payment Method Auto Renew Settings" });
	          digitalDataEvents.push({ renewAuto: "Not Enrolled" });
	        } else {
	          util.notification.clearNotification($('#auto-renew-notification'));
	          util.notification.displayNotification(COSTCO.util.notification.type.ERROR, [messages.AUTO_RENEW_CONSENT_INFORMATION_ERROR], true, $('#auto-renew-notification'), 'div');
	          $('#auto-renew-notification').addClass('cds-u-space-mb-md');
	          $('#auto-renew-notification').show();
	          $('#auto-renew-notification').focus();
	        }
	      },
	      /**
	       * Add placeholder on expiration date 
	       * @return void
	       */
	      addPlaceHolder: function addPlaceHolder(expirationDate) {
	        expirationDate.placeholder = "MM/YY";
	      },
	      /**
	       * Remove placeholder on expiration date 
	       * @return void
	       */
	      removePlaceHolder: function removePlaceHolder(expirationDate) {
	        if (expirationDate && expirationDate.value === '') {
	          $("label[for='" + $(expirationDate).attr('id') + "']").removeClass('active');
	          expirationDate.placeholder = "";
	        }
	      },
	      services: {
	        /**
	         * Ajax modular service for handling auto renew payment
	         * @param  {object} data   JSON Object to be sent to backend
	         */
	        ajaxManageAutoRenewPayment: function ajaxManageAutoRenewPayment(data) {
	          util.notification.clearNotification($('#auto-renew-notification'));
	          $('#auto-renew-notification').removeClass('cds-u-space-mb-md');
	          RenewMembership.validateStorePaymentForm();
	          var form = RenewMembership.getForm();
	          if (form.valid()) {
	            $('.gw-proxy-number').removeClass('card-number-error');
	
	            var autoRenewAction = data.action;
	            var autoRenewCardUpdate = data.memberCreditAccountId == $('#selectedCardForAutoRenew').val();
	
	            COSTCO.Checkout.ajax_update_state({
	              method: 'POST',
	              url: '/AjaxManageAutoRenewPayment',
	              data: data,
	              dataType: 'json',
	              done: function done(data, textStatus, jqXHR, options) {
	                // Reset content of Top Notification if user is Business membership eligible for renewal
	                if ($('#business-primary-top-notification').length) {
	                  util.notification.displayNotification(util.notification.type.WARNING, [$('#business-primary-top-notification').text().trim()]);
	                }
	                if (data != undefined) {
	                  if (data.error.application.length > 0) {
	                    util.notification.displayNotification(util.notification.type.ERROR, data.error.application, true, $('#auto-renew-notification'), 'div');
	                    $('#auto-renew-notification').addClass('cds-u-space-mb-md');
	                    if ($('input[name="ftc-click-to-enrole"]').length > 0) {
	                      if ($("#ftc-click-to-enrole").prop('checked') == true) {
	                        $("#ftc-enrole > label.control > div.control__indicator").addClass("critical");
	                      } else if ($("#ftc-click-to-enrole-not").prop('checked') == true) {
	                        $("#ftc-enrole-not > label.control > div.control__indicator").addClass("critical");
	                      }
	                    }
	                  } else {
	                    if (typeof data.payload.data.maxAttemptReached !== 'undefined' && data.payload.data.maxAttemptReached === true) {
	                      $('#notification-max-attempt-reached').removeClass('hidden');
	                      return;
	                    }
	                    COSTCO.Checkout.ajax_update_default_done(data, textStatus, jqXHR, options);
	                    if (typeof data.payload.data.autoRenewSuccess !== 'undefined' && data.payload.data.autoRenewSuccess === 'true') {
	                      var currentDate = new Date();
	                      var expirationDate = void 0;
	                      var billingDate = void 0;
	                      var twoDayesBefooreBilling = void 0;
	
	                      if (COSTCO.RenewMembership.autoRenew.constants.testAutoRenewExpirationDateEnabled === 'true' && COSTCO.RenewMembership.autoRenew.constants.testAutoRenewExpirationDate !== 'undefined') {
	                        expirationDate = new Date(COSTCO.RenewMembership.autoRenew.constants.testAutoRenewExpirationDate);
	                      } else {
	                        expirationDate = new Date(membershipData.caller.expireDate.year.value, parseInt(membershipData.caller.expireDate.month.value) - 1, membershipData.caller.expireDate.day.value, 0, 0, 0, 0);
	                      }
	                      billingDate = new Date(expirationDate);
	                      //billingDate.setMonth(billingDate.getMonth() -1);
	
	                      twoDayesBefooreBilling = new Date(billingDate);
	                      twoDayesBefooreBilling.setDate(twoDayesBefooreBilling.getDate() - 2);
	
	                      var notificationStatus = void 0;
	                      var notificationMessage = void 0;
	                      switch (autoRenewAction) {
	                        case 'delete_renew':
	                          if ($('input[name="ftc-click-to-enrole"]').length > 0) {
	                            notificationStatus = COSTCO.util.notification.type.SUCCESS;
	                          } else {
	                            notificationStatus = COSTCO.util.notification.type.WARNING;
	                          }
	                          if (currentDate.getTime() < twoDayesBefooreBilling.getTime()) {
	                            notificationMessage = messages.ACCOUNT_RENEW_MEMBERSHIP_REMOVED_AUTO_RENEW;
	                          } else if (currentDate.getTime() < billingDate.getTime()) {
	                            notificationMessage = messages.ACCOUNT_RENEW_MEMBERSHIP_REMOVED_AUTO_RENEW_AFTER_BILLING;
	                          } else {
	                            notificationMessage = messages.ACCOUNT_RENEW_MEMBERSHIP_REMOVED_AUTO_RENEW_ON_BILLING;
	                          }
	                          break;
	                        case 'delete_token':
	                          if ($('input[name="ftc-click-to-enrole"]').length > 0 && autoRenewCardUpdate) {
	                            notificationStatus = COSTCO.util.notification.type.SUCCESS;
	                          } else if ($('input[name="ftc-click-to-enrole"]').length > 0 && !autoRenewCardUpdate) {
	                            notificationStatus = "";
	                          } else {
	                            notificationStatus = COSTCO.util.notification.type.WARNING;
	                          }
	                          if (currentDate.getTime() < twoDayesBefooreBilling.getTime()) {
	                            notificationMessage = messages.ACCOUNT_RENEW_MEMBERSHIP_REMOVED_AUTO_RENEW;
	                          } else if (currentDate.getTime() < billingDate.getTime()) {
	                            notificationMessage = messages.ACCOUNT_RENEW_MEMBERSHIP_REMOVED_AUTO_RENEW_AFTER_BILLING;
	                          } else {
	                            notificationMessage = messages.ACCOUNT_RENEW_MEMBERSHIP_REMOVED_AUTO_RENEW_ON_BILLING;
	                          }
	
	                          break;
	                        default:
	                          if ($('input[name="ftc-click-to-enrole"]').length > 0 && !autoRenewCardUpdate && autoRenewAction == 'update_token') {
	                            notificationStatus = "";
	                            notificationMessage = "";
	                          } else if (currentDate.getTime() < twoDayesBefooreBilling.getTime()) {
	                            notificationStatus = COSTCO.util.notification.type.SUCCESS;
	                            notificationMessage = messages.ACCOUNT_RENEW_MEMBERSHIP_ADDED_AUTO_RENEW;
	                          } else if (currentDate.getTime() < billingDate.getTime()) {
	                            notificationStatus = COSTCO.util.notification.type.WARNING;
	                            notificationMessage = messages.ACCOUNT_RENEW_MEMBERSHIP_ADDED_AUTO_RENEW_TWO_DAYS_BEFORE_BILLING;
	                          } else {
	                            notificationStatus = COSTCO.util.notification.type.SUCCESS;
	                            notificationMessage = messages.ACCOUNT_RENEW_MEMBERSHIP_ADDED_AUTO_RENEW_AFTER_BILLING;
	                          }
	                      }
	                      if (notificationStatus && notificationMessage) {
	                        util.notification.displayNotification(notificationStatus, [notificationMessage], true, $('#auto-renew-notification'), 'div');
	                        $('#auto-renew-notification').addClass(' cds-u-space-mt-md cds-u-space-mb-md');
	                        $('#auto-renew-notification').show();
	                        $('#auto-renew-notification').focus();
	                      }
	                    }
	                  }
	                  $('input[type="radio"][name="ftc-click-to-enrole"]:checked').trigger('click');
	                }
	                TokenGateway.refreshGateway();
	              }
	            });
	          }
	        }
	      },
	      /**
	       * Opens Add Card dialog when membership is payed by someone else
	       * @param  {[type]} mode [description]
	       * @return {void}      [description]
	       */
	      openHasPayerAddCardDialog: function openHasPayerAddCardDialog(mode) {
	        var settings = {
	          title: messages.ACCOUNT_RENEW_MEMBERSHIP_Has_Payer_Add_Card_Dialog_Title_Text,
	          body: messages.ACCOUNT_RENEW_MEMBERSHIP_Has_Payer_Add_Card_Dialog_Body_Text,
	          primary: messages.ACCOUNT_RENEW_MEMBERSHIP_Has_Payer_Dialog_Add_Card_Button_Text,
	          secondary: messages.ACCOUNT_RENEW_MEMBERSHIP_Has_Payer_Dialog_Cancel_Button_Text,
	          secondary_event: function secondary_event() {
	            COSTCO.dialog.close();
	          }
	        };
	        if (mode == this.constants.modeType.ADD) {
	          settings.primary_event = function () {
	            COSTCO.RenewMembership.autoRenew.addCard($('#StorePaymentForm'));
	            COSTCO.dialog.close();
	          };
	        } else if (mode == this.constants.modeType.EDIT) {
	          settings.primary_event = function () {
	            COSTCO.RenewMembership.showCreditCardForm('add_another');
	            COSTCO.dialog.close();
	          };
	        }
	        COSTCO.dialog.createExtDialogBox(settings);
	      },
	      /**
	       * Opens Use Card dialog when membership is payed by someone else
	       * @param  {[type]} memberCreditAccountId [description]
	       * @return {void}                       [description]
	       */
	      openHasPayerUseCardDialog: function openHasPayerUseCardDialog(memberCreditAccountId) {
	        var settings = {
	          title: messages.ACCOUNT_RENEW_MEMBERSHIP_Has_Payer_Use_Card_Dialog_Title_Text,
	          body: messages.ACCOUNT_RENEW_MEMBERSHIP_Has_Payer_Use_Card_Dialog_Body_Text,
	          primary: messages.ACCOUNT_RENEW_MEMBERSHIP_Has_Payer_Dialog_Use_Card_Button_Text,
	          secondary: messages.ACCOUNT_RENEW_MEMBERSHIP_Has_Payer_Dialog_Cancel_Button_Text,
	          primary_event: function primary_event() {
	            COSTCO.RenewMembership.autoRenew.setAsDefaultAutoRenew($('#cardForAutorenew_' + memberCreditAccountId), memberCreditAccountId, true);
	            COSTCO.dialog.close();
	          },
	          secondary_event: function secondary_event() {
	            COSTCO.dialog.close();
	          }
	        };
	        COSTCO.dialog.createExtDialogBox(settings);
	      },
	
	      /**
	      * Validation to check if user already filled membership info before any action for auto renew.
	      * If not valid, dialog form will be shown
	      */
	      validateMembershipInfo: function validateMembershipInfo() {
	        if (!sessionStorage.getItem("changeValidationFlag")) {
	          COSTCO.MembershipValidation.showValidationPrescreen();
	          return false;
	        }
	        return true;
	      },
	
	      /**
	       * Validation to check if user already filled membership info before any action for auto renew.
	       */
	      isValidMembershipInfo: function isValidMembershipInfo() {
	        return membershipData.verified || sessionStorage.getItem("changeValidationFlag");
	      },
	      /**
	      * Check if user has reached max attempts to update payment info for renew membership.
	      * Needed for popup validation (check function "validateMembershipInfo")
	      * @returns boolean
	      */
	      hasUserReachedMaxAttempts: function hasUserReachedMaxAttempts() {
	        return $("#maxAttemptRetriesReached").val() === "true";
	      }
	
	    },
	
	    /**
	     * The interface to remove an affiliate from the "Renew Membership"
	     * feature (/RenewMembershipView) for business members.
	     * @param  {Number} affiliateMembershipNumber The affiliate's membership num
	     * @return {void}
	     */
	    removePerson: function removePerson(affiliateMembershipNumber, isQuickMembership) {
	      var affiliate = helper.getAffiliateFromDataBeanByNumber(this.membershipData, affiliateMembershipNumber);
	      if (isQuickMembership !== undefined && isQuickMembership !== '') {
	        helper.isQuickMembership = isQuickMembership;
	      }
	      // This is necessary because affForm.removePerson is expecting an object
	      // thats tied to how the membership application "configProduct" represents
	      // that affiliate, this will normalize that.
	      affiliate = {
	        membershipNumber: affiliate.cardNumber.value,
	        firstName: affiliate.firstName.value,
	        lastName: affiliate.lastName.value
	      };
	      affForm.removePerson({
	        affiliate: affiliate,
	        isRenew: true,
	        excludeData: true,
	        action: 'remove-affiliate',
	        isQuickMembershipCheckout: helper.isQuickMembership
	      });
	    },
	    /**
	     * The interface to remove an affiliate household from the "Renew Membership"
	     * feature (/RenewMembershipView) for business members.
	     * @param  {Number} affiliateMembershipNumber The affiliate's membership num
	     * @return {void}
	     */
	    removePersonHousehold: function removePersonHousehold(affiliateMembershipNumber) {
	      var affiliate = helper.getAffiliateFromDataBeanByNumber(this.membershipData, affiliateMembershipNumber);
	      // This is necessary because affForm.removePerson is expecting an object
	      // thats tied to how the membership application "configProduct" represents
	      // that affiliate, this will normalize that.
	      affiliate = {
	        membershipNumber: affiliate.cardNumber.value,
	        firstName: affiliate.firstName.value,
	        lastName: affiliate.lastName.value,
	        houseHold: {
	          membershipNumber: affiliate.household.cardNumber.value,
	          firstName: affiliate.household.firstName.value,
	          lastName: affiliate.household.lastName.value
	        }
	      };
	      affForm.removePerson({
	        affiliate: affiliate,
	        isRenew: true,
	        excludeData: true,
	        action: 'remove-household'
	      });
	    },
	    /**
	     * Add an affiliate using /MemberAffiliateAddCmd
	     * @method
	     * @return {void}
	     */
	    addPerson: function addPerson() {
	      affForm.openAddPersonModal({
	        isRenew: true
	      });
	    },
	    /**
	     * Add a person to a household as part of ther renew membership flow.
	     * @param  {Number} membershipNumber The Affiliate membershipNumber
	     * @return {void}
	     */
	    addPersonWithinHousehold: function addPersonWithinHousehold(membershipNumber) {
	      var affiliate = helper.getAffiliateFromDataBeanByNumber(this.membershipData, membershipNumber);
	      affForm.editPerson({
	        affiliate: affiliate,
	        action: 'update',
	        addHousehold: true,
	        isRenew: true
	      });
	    },
	    /**
	     * Validation rules
	     * @return {void} [description]
	     */
	    validationRules: function validationRules() {
	      $.validator.addMethod('membershipNumber', function (value, element) {
	        return (/^\d{12,16}$/.test(value)
	        );
	      }, messages.ACCOUNT_RENEW_MEMBERSHIP_UNVERIFIED_MembershipNumberInvalid_Text);
	
	      $.validator.addMethod('customcc', function (value, element) {
	        value = value.replace(/\s+/g, '');
	        if (value.indexOf('*') > 0 && value.length == 16) {
	          return true;
	        }
	        return this.optional(element) || /^7\d{5}\*{6}\d{4}$/.test(value) || /^\S{6}(\*{3}|\*{5})\s?\d{4}$/.test(value) || /^\S{6}\*{6}\s?\d{4}$/.test(value) || $.validator.methods.creditcard.call($.data(element.form, 'validator'), value, element);
	      });
	
	      $.validator.addMethod('autorenewcostcocc', function (value, element) {
	        return this.optional(element) || /^(2|4|5)/.test(value);
	      });
	
	      $.validator.addMethod('cobrandedcard', function (value, element) {
	        return RenewMembership.autoRenew.constants.autoRenewCardBinRangeRegexPattern.test(value);
	      });
	
	      $.validator.addMethod('checkSpecialchar', function (value, element) {
	        return this.optional(element) || !/[<>\'\"]/.test(value); // CC name shouldn't have any html tag
	      });
	
	      $.validator.addMethod('checkExpiryDate', function (value, element) {
	        return this.optional(element) || /^(0[1-9]|1[012])\/([123]\d)$/.test(value);
	      });
	
	      $.validator.addMethod('checkIsDateInPast', function (value, element) {
	        var enteredMonth = parseInt(value.split('/')[0]);
	        var enteredYear = parseInt(value.split('/')[1]);
	        var now = new Date();
	        var currentMonth = parseInt((now.getMonth() + 1).toString());
	        var currentYear = parseInt(now.getFullYear().toString().substr(-2));
	        if (enteredYear < currentYear || enteredYear == currentYear && enteredMonth < currentMonth) {
	          return false;
	        } else {
	          return true;
	        }
	      });
	      $.validator.addMethod('checkZipCode', function (value, element) {
	        var zipCode = $.trim($('#validationQuestionZip').val());
	        var langId = COSTCO.util.getLangId();
	        var regex = COSTCO.util.POSTAL_CODE_REGEX_US;
	        if (parseInt(langId) === -24 || parseInt(langId) === -25) {
	          regex = COSTCO.util.POSTAL_CODE_REGEX_CA;
	        }
	
	        return zipCode !== undefined && zipCode !== '' && regex.test($.trim(value));
	      });
	    },
	
	    /**
	     * Checks renewal date
	     * @return {void} [description]
	     */
	    checkRenewalDate: function checkRenewalDate() {
	      util.notification.clearNotification();
	      if (this.validateCheckRenewalDateForm()) {
	        COSTCO.Checkout.ajax_update_state({
	          method: 'POST',
	          url: '/AjaxMembershipCheckRenewalDateCmd',
	          data: $('#check-renewal-date').serialize(),
	          dataType: 'json',
	          done: function done(data, textStatus, jqXHR, options) {
	            var returnData = data.payload.data;
	            var statusReason = returnData.membershipStatusReason;
	            if (!returnData.isMembershipNumberValid) {
	              util.notification.displayNotification(util.notification.type.ERROR, [messages.MEMBERVERIFICATION_MEMBERSHIP__InfoDoesNotMatchOurRecords]);
	            } else {
	              if (returnData.maxAttemptReached) {
	                util.notification.displayNotification(util.notification.type.ERROR, [messages.MEMBERSHIP_UnverifiedRenewal_MaxAttemps]);
	              } else if (statusReason != '' && statusReason != 'Z10' && statusReason != 'Z24') {
	                // If we're not active ("" || Z10) or Expired (Z24), can't
	                // renew online.
	                COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, ['You\'re unable to renew online, please visit a warehouse.']);
	              } else {
	                COSTCO.Checkout.ajax_update_default_done(data, textStatus, jqXHR, options);
	              }
	            }
	          },
	          always: function always() {
	            $('.order-ajax').removeClass('ajax-busy');
	          }
	        });
	      }
	    },
	    /**
	     * Mask expiry date
	     * @return {void} [description]
	     */
	    maskInput: function maskInput() {
	      $('#cc_expiry_date').mask('00/00', {});
	      $('#card_number').mask('ZZZZ ZZZZ ZZZZ 0000', {
	        selectOnFocus: true,
	        translation: {
	          'Z': {
	            pattern: '[\\*0-9]'
	          }
	        }
	      });
	      var langId = COSTCO.util.getLangId();
	      if (parseInt(langId) === -24 || parseInt(langId) === -25) {
	        $('#validationQuestionZip').unmask().mask('S0S 0S0');
	      } else {
	        $('#validationQuestionZip').unmask().mask('00000');
	      }
	    },
	    /**
	     * Validates CheckRenewalDate form
	     * @return {[type]} [description]
	     */
	    validateCheckRenewalDateForm: function validateCheckRenewalDateForm() {
	      $('#check-renewal-date').validate({
	        rules: {
	          memberLastNameToRenew: {
	            required: true
	          },
	          membershipNumberToRenew: {
	            required: {
	              depends: function depends() {
	                $(this).val($.trim($(this).val()));
	                return true;
	              }
	            },
	            membershipNumber: true
	          }
	        },
	        messages: {
	          memberLastNameToRenew: {
	            required: messages.ACCOUNT_RENEW_MEMBERSHIP_UNVERIFIED_LastNameMissing_Text
	          },
	          membershipNumberToRenew: {
	            required: messages.ACCOUNT_RENEW_MEMBERSHIP_UNVERIFIED_MembershipNumberMissing_Text,
	            membershipNumber: messages.ACCOUNT_RENEW_MEMBERSHIP_UNVERIFIED_MembershipNumberInvalid_Text
	          }
	        }
	      });
	      return $('#check-renewal-date').valid();
	    },
	    /**
	     * Manage payment method
	     * @param  {string} action   action type (delete_renew | delete_token | )
	     * @param  {[type]} memberCreditAccountId   [member card account id]
	     * @return {void}
	     */
	    managePaymentMethods: function managePaymentMethods(action, memberCreditAccountId) {
	      COSTCO.Checkout.ajax_update_state({
	        method: 'POST',
	        url: '/AjaxManageAutoRenewPayment',
	        data: {
	          'action': action,
	          'memberCreditAccountId': memberCreditAccountId,
	          'authToken': RenewMembership.authToken
	        },
	        dataType: 'json',
	
	        done: function done(data, textStatus, jqXHR, options) {
	          util.notification.clearNotification();
	
	          if (data != undefined) {
	            if (data.error.application.length > 0) {
	              util.notification.displayNotification(util.notification.type.ERROR, data.error.application);
	            } else {
	              COSTCO.Checkout.ajax_update_default_done(data, textStatus, jqXHR, options);
	            }
	          }
	        },
	        always: function always(data, textStatus, jqXHR, options) {
	          $('.order-ajax').removeClass('ajax-busy');
	          // location.reload();
	        }
	      });
	    },
	    /**
	     * Validates the Payment Methods add/edit form
	     * @return {void}
	     */
	    validateStorePaymentForm: function validateStorePaymentForm() {
	      var form = RenewMembership.getForm();
	      var isCreditCardNumberValidationRequired = false;
	      //validate cc number when adding new card. Also validate on update card if cc number is changed:
	      if (displayMode.value.indexOf('add') >= 0 || displayMode.value.indexOf('edit') >= 0 && !$('#card_number').val()) isCreditCardNumberValidationRequired = true;
	      form.validate({
	        rules: {
	          cc_nameoncard: {
	            required: true,
	            checkSpecialchar: true
	          },
	          cc_expiry_date: {
	            required: true,
	            checkExpiryDate: true,
	            checkIsDateInPast: true
	          },
	          questionLastName: {
	            required: true
	          },
	          questionZip: {
	            required: true,
	            checkZipCode: true
	          }
	        },
	        messages: {
	          number: {
	            required: messages.ERR_CCNUM_REQ,
	            customcc: messages.ERR_INVALID_CREDITCARD_SHORT,
	            autorenewcostcocc: messages.MEMBERSHIP_RENEW__ERR_INVALID_CCNUM_AUTO_RENEW,
	            cobrandedcard: messages.ERR_COBRANDED_CREDITCARD
	          },
	          cc_nameoncard: {
	            required: messages.ERR_INVALID_CC_NAME,
	            checkSpecialchar: messages.ERR_INVALID_CC_NAME
	          },
	          cc_expiry_date: {
	            required: messages.ERR_EXPIRYDATE_REQ,
	            checkExpiryDate: messages.ACCOUNT_PAYMENT_METHODS_ERR_INVALID_DATE,
	            checkIsDateInPast: messages.ERR_INVALID_PAST_DATE
	          },
	          questionLastName: {
	            required: messages.ERR_INVALID_LASTNAME
	          },
	          questionZip: {
	            required: messages.ERR_ENTER_ZIPCODE_NEW,
	            checkZipCode: messages.ERR_ENTER_ZIPCODE
	          }
	        },
	        errorPlacement: function errorPlacement(error, element) {
	          if (element.is('#card_number_validator')) {
	            $('.gw-proxy-number').css('border', '');
	            $('.gw-proxy-number').addClass('card-number-error');
	            error.insertAfter(element);
	          } else {
	            error.insertAfter(element);
	          }
	        }
	      });
	
	      if (form.length != 0) {
	        return form.valid();
	      }
	    },
	    /**
	     * Shows credit card form on the page, and hides all other opened credit card forms
	     * @param  {string} formType	Form type to show (add_another | edit)
	     * @param  {number} cardId 		Card id
	     * @param  {[type]} data [description]
	     * @return {void}
	     */
	    showCreditCardForm: function showCreditCardForm(formType, cardId, data) {
	      if (membershipData.validated == true && membershipData.verified == false) {
	        if (RenewMembership.autoRenew.hasUserReachedMaxAttempts()) {
	          return;
	        } else if (!RenewMembership.autoRenew.isValidMembershipInfo()) {
	          // last name and zip code is not valid, show validation prescreen
	          COSTCO.MembershipValidation.showValidationPrescreen();
	          return;
	        }
	      }
	      var formHtmlBlock = void 0;
	      var template = 'tmpl_auto_renew_membership_' + formType;
	      if (!this.cybersourceEnabled || formType === 'add_another') {
	        createTokenSessionId('true');
	      }
	      //}
	      $('#saveAutoRenewSettingBtn').hide();
	      $('#cancelAutoRenewBtn').hide();
	      $('#auto-renew-notification').hide();
	      if (formType === 'add_another') {
	        $('#add-another-card-link').hide();
	        formHtmlBlock = '#add-another-card-form';
	      } else if (formType === 'edit') {
	        if ($('input[name="ftc-click-to-enrole"]').length > 0 && $('#selectedCardForAutoRenew').val() == cardId) {
	          $('#autoRenewConsentOptionDiv').show();
	          $('#ftc-enrole-information').show();
	          RenewMembership.renewCreditCardData = data;
	        } else {
	          $('#autoRenewConsentOptionDiv').hide();
	          $('#ftc-enrole-information').hide();
	        }
	        $('#add-another-card-link').show();
	        $('#add-another-card-form').empty();
	        $('#auto-payment-item-' + cardId).addClass('hide');
	        formHtmlBlock = '#auto-payment-form-item-' + cardId;
	      } else {
	        return;
	      }
	      $('[data-card-id]').each(function (index, value) {
	        $value = $(value);
	        var currentId = $value.attr('data-card-id');
	        if (formType === 'add_another') {
	          $('#auto-payment-item-' + currentId).removeClass('hide');
	          $('#auto-payment-form-item-' + currentId).html('');
	        }
	        if (formType === 'edit' && currentId !== cardId) {
	          $('#auto-payment-item-' + currentId).removeClass('hide');
	          $('#auto-payment-form-item-' + currentId).html('');
	        }
	        if ($value.attr('data-type') == 'display') {
	          if (currentId == cardId) {
	            $value.hide();
	          } else {
	            $value.show();
	          }
	        } else if ($value.attr('data-type') == 'form') {
	          if (currentId == cardId) {
	            formHtmlBlock = '#' + $value.attr('id');
	          } else {
	            $value.empty();
	          }
	        }
	      });
	
	      var htmlForm = COSTCO.util.tmpl(template, data);
	      $(formHtmlBlock).html(htmlForm);
	      $(formHtmlBlock).show();
	
	      if (this.cybersourceEnabled) {
	        this.setInputFieldsEvents();
	      } else {
	        TokenGateway.reloadOnInitialize = true;
	        TokenGateway.refreshGateway();
	      }
	      this.maskInput();
	    },
	    setInputFieldsEvents: function setInputFieldsEvents() {
	      $("#card_number").keypress(function () {
	        TokenGateway.resetCardNumber(this);
	      }).keyup(function (event) {
	        if (event.keyCode === 8 || event.keyCode === 46) {
	          TokenGateway.resetCardNumber(this);
	        }
	      });
	      $("#card_number").click(function () {
	        TokenGateway.resetCardNumber(this);
	      });
	    },
	    upgradeBusinessOnclickEvent: function upgradeBusinessOnclickEvent() {
	      // Set some state to signify the user wants to upgrade. This will tell
	      // the application to use the renewAndUpgrade price returned from CRM
	      // after any CRUD operation.
	      this.isUpgrading = true;
	      // Show the user a notification about how they need to upgrade in addition
	      // to renewing.
	      util.notification.displayNotification(util.notification.type.WARNING, [$('#businessPrimaryExpiryInfoText').text() + ' ' + $('#businessForcedRenewalUpgradeText').text()]);
	      // Update the total price using the "renewAndUpgradeAmount".
	      helper.updateTotalPrice(this.membershipData, true);
	      // Show the business executive specific details
	      $('#membership-tier-price .affiliate-primary').addClass('hide');
	      $('#membership-tier-price .affiliate-primary.upgrade').removeClass('hide');
	      // Switch the add to cart link to business executive
	      $('#renew-button').attr('onclick', $('[data-renew-upgrade]').data('renew-upgrade'));
	    },
	
	    upgradeGoldStarOnclickEvent: function upgradeGoldStarOnclickEvent() {
	      // If you're renew eligible then you are sold a upgraded renewal instead of an upgrade to the current account
	      if (membershipData.caller.renewEligible) {
	        addUpgradeMembershipToCart('GoldStarExecutive', false);
	      } else {
	        addUpgradeMembershipToCart('GoldStarUpgrade', true);
	      }
	      window.digitalDataEvents = window.digitalDataEvents || [];
	      digitalDataEvents.push({ nav: "Account | Membership | Upgrade Membership" });
	    },
	    /**
	     * Reverts the radio selection on Quick Renew Post Lockdown page
	     * @return void
	     */
	    revertRadioSelection: function revertRadioSelection(isUpgrade) {
	      $('#renew-membership-block, #upgrade-membership-block').toggleClass('radio-selected-background');
	      if (isUpgrade) {
	        $('#radio-renew-membership').prop('checked', true);
	      } else {
	        $('#radio-upgrade-membership').prop('checked', true);
	      }
	    }
	
	  };
	  if (typeof window.COSTCO === 'undefined') {
	    window.COSTCO = {};
	  }
	  window.COSTCO.RenewMembership = RenewMembership;
	  return RenewMembership;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
		var CreditCard = {
			initComplete: false,
			init: function init(state) {
				if (!COSTCO.CreditCard.initComplete) {
					COSTCO.CreditCard.initComplete = true;
					COSTCO.CreditCard.validationRules();
					COSTCO.CreditCard.forms.creditCardForm().validate({
						rules: {
							account: { required: true, isAmex: true, customcc: true, costcoCC: true },
							cc_cvc_validator: { required: true, cvv: true },
							cc_nameoncard: { required: true, checkSpecialchar: true },
							cc_expiry_date: { required: true, checkExpiryDate: true }
						},
						messages: {
							account: { required: messages.ERR_CCNUM_REQ, isAmex: messages._ERR_INVALID_AMEX_SELECTEDCARDTYPE, customcc: messages.ERR_INVALID_CREDITCARD_SHORT, costcoCC: messages.COSTCO_CC_DISABLED },
							cc_cvc_validator: { required: messages.ERR_CHECKOUT_PAYMENT_EMPTY_CARDNUMBE_PIN, cvv: messages.ERR_INVALID_CVV },
							cc_nameoncard: { required: messages.ERR_NAME_REQ, checkSpecialchar: messages.ERR_INVALID_CC_NAME },
							cc_expiry_date: { required: messages.ERR_EXPIRYDATE_REQ, checkExpiryDate: messages.ERR_INVALID_DATE }
						},
						errorPlacement: function errorPlacement(error, element) {
							if (element.attr('id') === 'account_validator') {
								$('#account').addClass('error-credit-card');
								$('#account_validator_err_msg').html(error.html());
								$('#account_validator_err_msg').removeClass('hide');
								if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE) {
									if (error.html() != "" & error.html() != null) {
										$('iframe').filter('.gw-proxy-number').addClass('error-credit-card');
										$('#isAutoRenew').prop("checked", false);
									} else {
										$('iframe').filter('.gw-proxy-number').removeClass('error-credit-card');
									}
								}
								$('iframe').filter('.gw-proxy-number').focus();
							} else if (element.attr('id') === 'cc_cvc_validator') {
								COSTCO.CreditCard.isCybersourceEnabled() ? $('#cc_cvc').addClass('error') : $('#cc_cvc').addClass('error-credit-card');
								$('#cc_cvc_err_msg').html(error.html());
								$('#cc_cvc_err_msg').removeClass('hide');
								if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE) {
									if (error.html() != "" & error.html() != null) {
										$('iframe').filter('.gw-proxy-securityCode').addClass('error-credit-card');
									} else {
										$('iframe').filter('.gw-proxy-securityCode').removeClass('error-credit-card');
									}
								}
								if (typeof TokenGateway !== "undefined" && TokenGateway.focusField != "cardNumber") {
									$('iframe').filter('.gw-proxy-securityCode').focus();
								}
							} else {
								error.insertAfter(element);
							}
						},
						success: function success(label, element) {
							var $element = $(element);
							if ($element.attr('id') === 'account_validator') {
								label.parent().removeClass('error');
								$('#account').removeClass('error-credit-card');
								if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE) {
									$('iframe').filter('.gw-proxy-number').removeClass('error-credit-card');
								}
								label.html('');
							} else if ($element.attr('id') === 'cc_cvc_validator') {
								label.parent().removeClass('error');
								$('#cc_cvc').removeClass('error-credit-card');
								if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE) {
									$('iframe').filter('.gw-proxy-securityCode').removeClass('error-credit-card');
								}
								label.html('');
							} else {
								label.parent().removeClass('error');
								label.remove();
							}
						}
					});
	
					$('#account').unbind('input').on('input', COSTCO.CreditCard.accountNumberChangeEvent);
	
					var cardType = COSTCO.CreditCard.forms.creditCardForm().find('input[name=payMethodId]').val();
	
					if (state == 'payment') {
						// do something if needed
					}
	
					$(".a11y-tooltip").popover();
	
					// Only need to run this onload
					var expiryDate = $('#cc_expiry_date').val();
					if (expiryDate != null && expiryDate.trim().length == 6) {
						expiryDate = '0' + expiryDate;
						$('#cc_expiry_date').val(expiryDate);
					}
	
					COSTCO.CreditCard.maskInput();
					if ($('#isBDAppVar').val() == 'BD') {
						if ($('#ach-block-form').length > 0) {
							$('#ach-block-form').validate();
						}
	
						if ($('#ar-block-form').length > 0) {
							$('#ar-block-form').validate();
						}
	
						if ($('#ordPayInsVal').length > 0) {
							var paymentType = $('#ordPayInsVal').val();
							var submitedPaymentType = $('#submitedPayMethodId').val();
							if (submitedPaymentType.length > 0) {
								paymentType = paymentType != submitedPaymentType ? submitedPaymentType : paymentType;
							}
							if (paymentType == 'Check') {
								if (!COSTCO.util.isExternalCarrierShipmode()) {
									COSTCO.wallet.showCheckOnDeliverySection();
								}
							} else if (paymentType == 'ACH') {
	
								if ($('#isBDAppVar').val() == 'BD' && COSTCO.util.isNdEnabled()) {
	
									COSTCO.wallet.showACHSection();
	
									if ($('input[name=payMethodId]').val() == 'ACH' && !COSTCO.CreditCard.isPaymentEditAreaVisible()) {
										$('#radio-ach').prop('checked', true);
										$('#save_as_default2').prop('checked', true);
									};
								} else {
									if (!COSTCO.util.isExternalCarrierShipmode()) {
										COSTCO.wallet.showACHSection();
	
										if ($('input[name=payMethodId]').val() == 'ACH' && !COSTCO.CreditCard.isPaymentEditAreaVisible()) {
											$('#radio-ach').prop('checked', true);
											$('#save_as_default2').prop('checked', true);
										};
									}
								}
							} else if (paymentType == 'LineOfCredit') {
								if (!COSTCO.util.isExternalCarrierShipmode()) {
									COSTCO.wallet.showAcctReceivableSection();
								}
							} else {
								COSTCO.wallet.showCCSection();
							}
						}
					}
				}
			},
			forms: {
				creditCardForm: function creditCardForm() {
					return $('#CheckoutPaymentForm');
				},
				achForm: function achForm() {
					return $('#ach-block-form');
				},
				arForm: function arForm() {
					return $('#ar-block-form');
				}
			},
			cardTypes: {
				VISA: 'VISA',
				AMEX: 'AMEX',
				MASTER_CARD: 'Master Card',
				DISCOVER: 'Discover',
				JCB: 'JCB',
				DINERS_CLUB: 'Discover Diners',
				CUP: 'Union Pay',
				COSTCO_CREDIT_CARD: 'Costco Credit Card',
				DEFAULT_PAYMENT: 'DefaultPayment'
			},
	
			accountNumberChangeEvent: function accountNumberChangeEvent() {
	
				var ccNumber = $(this).val();
			},
	
			updatePaymentType: function updatePaymentType(cardNumber, $cardTypeInput) {
	
				var cardType = COSTCO.CreditCard.getCardType(cardNumber);
				if (cardType != '?') {
					$cardTypeInput.val(cardType);
				}
			},
	
			isVisaCard: function isVisaCard(cardNumber) {
				return (/^(4)/.test(cardNumber)
				);
			},
			isMasterCard: function isMasterCard(cardNumber) {
				return (/^(2[2-7]|5[1-5])/.test(cardNumber)
				);
			},
			isCostcoCard: function isCostcoCard(cardNumber) {
				return (/^(7111|7003)/.test(cardNumber)
				);
			},
			isDiscoverCard: function isDiscoverCard(cardNumber) {
				return (/^(6011|65|6499|6555|6556)/.test(cardNumber)
				);
			},
			getCardType: function getCardType(a) {
	
				a = a.replace(/\s+/g, "");
	
				if (/^(34|37)/.test(a) && 15 == a.length) return COSTCO.CreditCard.cardTypes.AMEX;
				if (/^(2[2-7]|5[1-5])/.test(a) && 16 == a.length) return COSTCO.CreditCard.cardTypes.MASTER_CARD;
				if (/^(30[0-5]|3095|36[0-9]|3[8-9])/.test(a) && (14 == a.length || 16 == a.length)) return COSTCO.CreditCard.cardTypes.DINERS_CLUB;
				if (/^(3528|35[3-8]|333[7-9]|334)/.test(a) && (15 == a.length || 16 == a.length)) return COSTCO.CreditCard.cardTypes.JCB;
				if (!/^(4)/.test(a) || 13 != a.length && 16 != a.length) {
					if (/^(6011|65|6499|6555|6556|62)/.test(a) && 16 == a.length) return COSTCO.CreditCard.cardTypes.DISCOVER;
					if (/^(7111|7003)/.test(a) && 16 == a.length) return COSTCO.CreditCard.cardTypes.COSTCO_CREDIT_CARD;
					if (/^(\*)/.test(a)) return COSTCO.CreditCard.cardTypes.DEFAULT_PAYMENT;
				} else return COSTCO.CreditCard.cardTypes.VISA;
				return "?";
			},
			validationRules: function validationRules() {
	
				$.validator.setDefaults({ ignore: ".ignore,.ignoreHide" });
				$.validator.addMethod('costcoCC', function (value, element) {
					value = value.replace(/\s+/g, '');
					//check to see if value is costco cc and is disabled, otherwise return true and do normal customcc check.
					if (COSTCO.CreditCard.isCostcoCard(value)) {
						var costcoCCDisabled = $('#costcoCCDisabled').val() == 'true';
						return !costcoCCDisabled;
					}
					return true;
				});
				$.validator.addMethod("isAmex", function (value, element) {
					value = value.replace(/\s+/g, "");
					var cardTypeTmp = COSTCO.CreditCard.getCardType(value);
					if (COSTCO.CreditCard.cardTypes.AMEX == cardTypeTmp) {
						//Amex not allowed - trigger specific error message
						return false;
					} else {
						return true;
					}
				});
	
				/* Replicated $.validator.methods.creditcard() from jquery-1.10.2 for jquery-3.6.3
	   * since this is no longer defined in 3.6.3
	   * ALM 47238
	      	*/
				$.validator.addMethod('creditCard', function (value, element) {
					if (this.optional(element)) {
						return "dependency-mismatch";
					}
					if (/[^0-9 \-]+/.test(value)) {
						return false;
					}
					var n = 0,
					    i = 0,
					    r = false,
					    s,
					    o;
					value = value.replace(/\D/g, "");
					if (value.length < 13 || value.length > 19) {
						return false;
					}
					for (s = value.length - 1; s >= 0; s--) {
						o = value.charAt(s);
						i = parseInt(o, 10);
						if (r) {
							if ((i *= 2) > 9) {
								i -= 9;
							}
						}
						n += i;
						r = !r;
					}
					return n % 10 === 0;
				});
				$.validator.addMethod("customcc", function (value, element) {
	
					value = value.replace(/\s+/g, "");
					var cardTypeTmp = COSTCO.CreditCard.getCardType(value);
					if (!costcoStoreFeatures.DISCOVER_DINERSCLUB_JCB_CUP_ENABLED) {
						if (COSTCO.util.getLocale() == 'en-US' && $('#isBDAppVar').val() == 'BC' && (cardTypeTmp == COSTCO.CreditCard.cardTypes.DISCOVER || cardTypeTmp == COSTCO.CreditCard.cardTypes.DINERS_CLUB || cardTypeTmp == COSTCO.CreditCard.cardTypes.JCB || cardTypeTmp == COSTCO.CreditCard.cardTypes.CUP)) {
							return false;
						}
					}
					if ((COSTCO.util.getLocale() == 'en-CA' || COSTCO.util.getLocale() == 'fr-CA' || $('#isBDAppVar').val() == 'BD') && (cardTypeTmp == COSTCO.CreditCard.cardTypes.DISCOVER || cardTypeTmp == COSTCO.CreditCard.cardTypes.DINERS_CLUB || cardTypeTmp == COSTCO.CreditCard.cardTypes.JCB)) {
						return false;
					}
					if (value.indexOf("*") > 0 && value.length >= 14 && value.length <= 16) {
						return true;
					}
					return this.optional(element) || /^7\d{15}$/.test(value) || /^\*{11}\s?\d{4}$/.test(value) || /^\*{12}\s?\d{4}$/.test(value) || $.validator.methods.creditCard.call($.data(element.form, 'validator'), value, element);
				});
	
				$.validator.addMethod("ccTypeCheck", function (value, element) {
	
					var cc = (value + '').replace(/\s/g, ''); //remove space
					// remove spaces 
					var cardType;
					if ($('input[name=payMethodId]').val() != null) {
						cardType = $('input[name=payMethodId]').val().split(' ').join('');
					}
	
					var returnVal = false;
	
					if (this.optional(element)) {
						return this.optional(element);
					}
	
					var cardTypeTmp = COSTCO.CreditCard.getCardType(cc);
					if (cardType == cardTypeTmp || '?' != cardTypeTmp) {
						returnVal = true;
					} else if (cc.indexOf('*') != -1) {
						//This is just a safety net to catch a * in the payment type to indicate there is 
						//a default payment.  If it is falsely entered the payment gateway will catch and throw an error.
						returnVal = true;
					} else {
						returnVal = false;
					}
	
					return returnVal;
				});
	
				$.validator.addMethod("cvv", function (value, element) {
					return value.trim().length == 3;
				});
	
				$.validator.addMethod("checkSpecialchar", function (value, element) {
					// CC name shouldn't have any non-alphanumeric characters and needs at least 1 letter				
					return this.optional(element) || !COSTCO.util.CC_NAME_FIELD_REGEX.test(value) && COSTCO.util.ATLEAST_ONE_ALPHABET.test(value);
				});
	
				$.validator.addMethod("checkExpiryDate", function (value, element) {
					var success = this.optional(element) || /^(0[1-9]|1[012])\/([123]\d)$/.test(value);
					if (!success) {
						COSTCO.util.announceSRMessage(messages.ACCOUNT_PAYMENT_METHODS_ERR_INVALID_DATE);
					}
					return success;
				});
	
				$.validator.addMethod("checkIsDateInPast", function (value, element) {
					var enteredMonth = parseInt(value.split('/')[0]);
					var enteredYear = parseInt(value.split('/')[1]);
					var now = new Date();
					var currentMonth = parseInt((now.getMonth() + 1).toString());
					var currentYear = parseInt(now.getFullYear().toString().substr(-2));
					if (enteredYear < currentYear || enteredYear == currentYear && enteredMonth < currentMonth) {
						return false;
					} else {
						return true;
					}
				});
			},
			validate: {
				creditCardForm: function creditCardForm(isCvvCodeValidationIgnored) {
	
					if ($('#outstandingPrincipal').length > 0 && $('#outstandingPrincipal').val() == 0 && !COSTCO.OrderSummary.isMembershipPurchaseOptinSelected()) {
						return true;
					}
	
					var form = COSTCO.CreditCard.forms.creditCardForm();
					if ($('input[name=payMethodId]').val() == 'Costco Credit Card') {
						$('#cc_cvc_validator').val("123");
						$('#cc_expiry_date').addClass('ignore').val("");
					} else {
						$('#cc_expiry_date').removeClass('ignore');
					}
	
					//since cvv validation is only required if user clicks on change link,
					//we need to add ignore class to skip validation of blank cvv field if
					//the user does not click change.
					if ($('#cc_cvv_div').is(':hidden') || isCvvCodeValidationIgnored) {
						$('#cc_cvc_validator').addClass('ignore');
					} else {
						$('#cc_cvc_validator').removeClass('ignore');
					}
	
					if (form.length != 0) {
						return form.valid();
					}
				}
			},
			submit: {
				creditCardForm: function creditCardForm() {
					$('.order-ajax').addClass('ajax-busy');
					var form = COSTCO.CreditCard.forms.creditCardForm();
					var expDate = $(form).find('input[name=cc_expiry_date]').val().split('/');
					$('#creditCardTokenSessionId').val(modularTokenSessionId);
	
					$(form).find('input[name=expire_month]').val(expDate[0]);
					if (typeof expDate[1] != 'undefined' && expDate[1].length == 2) {
	
						$(form).find('input[name=expire_year]').val('20' + expDate[1]);
					}
					if ($('#checkoutPage').length > 0 && $('#checkoutPage').val() == 'review') {
						if ($('[name=walletCheckout]').attr('value') == 'false') {
							$(form).find('input[name=ccLastFour]').val($(form).find('input[name=account]').val().slice(-4));
						}
					}
					if (costcoStoreFeatures.MEMBERSHIP_CHECKOUT_AUTO_RENEW_OPTION_ENABLED !== 'undefined' && costcoStoreFeatures.MEMBERSHIP_CHECKOUT_AUTO_RENEW_OPTION_ENABLED && ($('input[name="isQuickPurchase"]') !== undefined && $('input[name="isQuickPurchase"]').val() === 'true' || $('input[name="isQuickPurchaseFlow"]') !== undefined && $('input[name="isQuickPurchaseFlow"]').val() === 'true')) {
	
						if ($("input[name='radio-auto-renew']:checked").val() !== undefined && $("input[name='radio-auto-renew']:checked").val() == 'optin') {
							digitalDataEvents.push({ ui: "Checkout Flow | Check | Enroll For Membership Auto Renewal" });
						} else {
							digitalDataEvents.push({ ui: "Checkout Flow | Check | Don't Enroll For Membership Auto Renewal" });
						}
					}
	
					// [0] skips jquery validation - validation must be handled in a different method
					form[0].submit();
				},
				achForm: function achForm() {
					$('.order-ajax').addClass('ajax-busy');
					var form = COSTCO.CreditCard.forms.achForm();
					form[0].submit();
				},
				arForm: function arForm() {
					$('.order-ajax').addClass('ajax-busy');
					var form = COSTCO.CreditCard.forms.arForm();
					form[0].submit();
				}
			},
			/**
	   * Uses the Jquery Mask plugin to format input fields. Use cleanVal() instead of val() to get unformatted value
	   */
			maskInput: function maskInput() {
				$('#cc_expiry_date').mask('00/00', {
					placeholder: 'MM/YY'
				});
				$('#account').mask('ZZZZ ZZZZ ZZZZ 0000', { selectOnFocus: true, translation: { 'Z': { pattern: '[\\*0-9]' } } });
				$('#cc_cvc').mask('0009');
			},
			/**
	   * Checks the state of the credit card radio button selection
	   * @return 1 if user has selected credit card radio button, otherwise returns 0
	   */
			isCreditCardOptionSelected: function isCreditCardOptionSelected() {
				return $('input[id=radio-credit-card]:checked').length || COSTCO.Checkout.displayAllPayments() && $('input[id=radio-credit-card-review]:checked').length;
			},
			showErrorBox: function showErrorBox() {
				$('#credit-card-block').addClass('error-box');
				if ($('#isBDAppVar').val() == 'BD') {
					if ($("#check-del-block") && $("#check-del-block").length > 0) {
						$('#check-del-block').addClass('error-box');
					}
					if ($("#ach-block") && $("#ach-block").length > 0) {
						$('#ach-block').addClass('error-box');
					}
					if ($("#acc-receiv-block") && $("#acc-receiv-block").length > 0) {
						$('#acc-receiv-block').addClass('error-box');
					}
				}
			},
			hideErrorBox: function hideErrorBox() {
				$('#credit-card-block').removeClass('error-box');
				if ($('#isBDAppVar').val() == 'BD') {
					if ($("#check-del-block") && $("#check-del-block").length > 0) {
						$('#check-del-block').removeClass('error-box');
					}
					if ($("#ach-block") && $("#ach-block").length > 0) {
						$('#ach-block').removeClass('error-box');
					}
					if ($("#acc-receiv-block") && $("#acc-receiv-block").length > 0) {
						$('#acc-receiv-block').removeClass('error-box');
					}
				}
			},
			isSelected: function isSelected() {
				var selected = $('#credit-card-block input[name=\'payment-radio\']:checked').val();
				return selected;
			},
			isUsed: function isUsed() {
				return $('#credit-card-info-container').length > 0 && !$('#credit-card-info-container').hasClass('hide');
			},
			isApplied: function isApplied() {
				return $('input[id=ordPayInsVal]').length > 0 && $('input[id=ordPayInsVal]').val() == 'CreditCard';
			},
			isPaymentEditAreaVisible: function isPaymentEditAreaVisible() {
				var paymentEditAreaVisible = $('#credit-card-block').length > 0 && $('#credit-card-block').attr('class') != 'hide';
				return paymentEditAreaVisible;
			},
			isCCEditAreaVisible: function isCCEditAreaVisible() {
				var creditCardEditAreaVisible = $('#credit-card-block').length > 0 && !$('#credit-card-block').hasClass('hide') && this.isCreditCardOptionSelected() > 0;
				return creditCardEditAreaVisible;
			},
			isCCEditAreaHidden: function isCCEditAreaHidden() {
				var creditCardEditAreaHidden = $('#credit-card-block').length > 0 && $('#credit-card-block').hasClass('hide') && this.isCreditCardOptionSelected() > 0;
				return creditCardEditAreaHidden;
			},
			isCybersourceEnabled: function isCybersourceEnabled() {
				return $("#cybersourceEnabled").val() === 'true';
			},
			is3DSPaymentAuthEnabled: function is3DSPaymentAuthEnabled() {
				return $("#threeDSPaymentEnabled").val() === 'true';
			},
			is3DSMemberCheckoutEnabled: function is3DSMemberCheckoutEnabled() {
				return $("#is3DSMemberCheckoutEnabled").val() === 'true';
			}
		};
	
		if (typeof window.COSTCO === 'undefined') {
			window.COSTCO = new Object();
		}
		window.COSTCO.CreditCard = CreditCard;
	
		return CreditCard;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title application-form.js: Feature level module
	 * @description Membership application form functionality
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(11)], __WEBPACK_AMD_DEFINE_RESULT__ = function (helper) {
	  var AffiliateForm = {
	    init: function init() {
	      // Moving this to application.js because we need to grab
	      // configProduct first (which is async) and then display
	      // this.reflectAffiliates();
	    },
	    /**
	     * This is business membership form specific. If the user has 6
	     * added affiliates, we don't allow any more.
	     * @param {Object} data - OPTIONAL Passed by thenable. Used to chain
	     * @return {Object} OPTIONAL - The data passed as an argument.
	     *                           Meant for chaining
	     */
	    checkAffiliateNumber: function checkAffiliateNumber(data) {
	      var affiliates = helper.getAffiliates();
	
	      if (COSTCO.MembershipHelper.isQuickMembership) {
	        if (affiliates.length == 0) {
	          $('#add-a-person').removeClass('hide');
	          $('#add-another-person').addClass('hide');
	        } else if (affiliates.length > 0 && affiliates.length < 6) {
	          $('#add-a-person').addClass('hide');
	          $('#add-another-person').removeClass('hide');
	        } else {
	          $('#add-a-person').addClass('hide');
	          $('#add-another-person').addClass('hide');
	        }
	      } else {
	        affiliates.length >= 6 ? $('#add-person-button').addClass('hide') : $('#add-person-button').removeClass('hide');
	      }
	
	      return data;
	    },
	    /**
	     * Uses the stored affiliate form (set by onclose events in editPerson
	     * /addPerson) to populate the #affiliate-form (modal). This is used to
	     * populate the affiliate form when the user escapes from a another modal
	     * and comes back to the affiliate modal e.g. Address Verification.
	     * @return {void}
	     */
	    populateUsingStoredForm: function populateUsingStoredForm() {
	      // When the modal is 'shown' or 'open' we
	      // try to populate the form with what the user last entered.
	      var affForm = AffiliateForm;
	      var storedForm = affForm.storedAffiliateForm;
	      helper.formWizBangs(affForm.getForm());
	      if (storedForm) {
	        COSTCO.MembershipHelper.populateByName(affForm.getForm(), storedForm.serializeArray());
	        if (storedForm.find('#affiliate-household').prop('checked')) {
	          affForm.getForm().find('#affiliate-household').prop('checked', true);
	          affForm.getForm().find('#affiliate-household').val(true);
	          affForm.householdToggle();
	        }
	      }
	      affForm.storedAffiliateForm = undefined;
	    },
	    /**
	     * Validation rules for the affiliate form
	     * @return {Boolean} Is the affiliate form valid?
	     */
	    validate: function validate() {
	      var dayIsOptional = $('#dobYearMonthMandatoryFlag').val() === 'true';
	      helper.goldstar.rules.dobmonth.required = dayIsOptional;
	      helper.goldstar.rules.dobyear.required = dayIsOptional;
	      var rules = helper.goldstar.rules;
	      var messages = helper.goldstar.messages();
	      var form = this.getForm().length > 0 ? this.getForm() : this.storedAffiliateForm;
	      data = COSTCO.util.objectifyArray(form.serializeArray());
	      data.householdCheckbox = data.householdCheckbox ? true : false;
	      if (data.householdCheckbox) {
	        helper.addHouseholdRules(rules, true, messages);
	      }
	      rules.email.required = false;
	      rules.emailConfirm.required = false;
	      rules.emailConfirm.equalTo = '#affiliate-email';
	      // Override validator messages
	      $.extend($.validator.messages, messages);
	      // Override $.validate.methods to accommodate affiliate context.
	      helper.addValidationMethods(this.getForm());
	      this.getForm().validate({
	        invalidHandler: COSTCO.util.invalid_handler,
	        rules: rules,
	        messages: messages
	      });
	      return this.getForm().valid();
	    },
	    /**
	     * Gets the appropriate request data for whatever CRUD operation we're
	     * performing.
	     * @param  {Object} options The object that distinguishes what CRUD op we're
	     *                          doing. Everything except 'add' action requires
	     *                          an affiliate object be attached as a property.
	     * @return {Object}         The request data to be passed to whichever cmd.
	     */
	    getRequestData: function getRequestData(options) {
	      var data = {};
	      if (options.action == 'add' || options.action == 'update') {
	        // This block takes addresses from the verification service and populates
	        // the form with that information so we can just serialize this.
	        var form = this.getForm().length > 0 ? this.getForm() : this.storedAffiliateForm;
	        addresses = Array.isArray(options.addresses) // Test if we have valid addresses
	        ? options.addresses // Using the addresses passed to "submit"
	        : helper.buildAddressArray(form, {
	          primary: helper.affiliateAddressSelectors
	        }); // using original addresse from user input
	        helper.populateAddressData(form, addresses, true);
	        // In both cases we have a form that needs to be serialized and sent.
	        data = COSTCO.util.objectifyArray(form.serializeArray());
	        data.householdCheckbox = data.householdCheckbox ? true : false;
	        var dayIsOptional = $('#dobYearMonthMandatoryFlag').val() === 'true';
	        if (dayIsOptional) {
	          //dobday is optional, if empty default it to "1"
	          if (!data.dobday) {
	            data.dobday = "1";
	          }
	          //householdDobDay is optional, if empty default it to "1"
	          if (!data.householdDobDay) {
	            data.householdDobDay = "1";
	          }
	        }
	        // If the flow is from renew or business details adjust the url
	        // approproiately. Uses /MemberAffiliateAddCmd.
	        if (options.isRenew || options.isBusinessDetails || options.isOutsideRenewal /* placeholder for isDetails */) {
	            options.addHousehold
	            // Adding a household to an affiliate
	            ? data.url = COSTCO.util.makeUrl('/MemberHouseholdAddCmd', {
	              'primaryNumber': options.affiliate.cardNumber.value,
	              'type': 'affiliate',
	              'authToken': COSTCO.Checkout.getAuthToken()
	            })
	            // Adding an affiliate to a business membership
	            : data.url = '/MemberAffiliateAddCmd';
	          } else {
	          // Membership Application flow
	          data.url = this.getUrl('/MemberApplicationAffiliateAddCmd');
	        }
	        data.isRenew = options.isRenew;
	        data.isBusinessDetails = options.isBusinessDetails;
	        data.isOutsideRenewal = options.isOutsideRenewal;
	        data.addHousehold = options.addHousehold;
	        this.storedAffiliateForm = undefined;
	      } else if (options.action == 'remove-household') {
	        if (options.isRenew || options.isBusinessDetails || options.isOutsideRenewal /* placeholder for isDetails */) {
	            data.url = COSTCO.util.makeUrl('/MemberHouseholdRemoveCmd', {
	              'primaryNumber': options.affiliate.membershipNumber,
	              'householdNumber': options.affiliate.houseHold.membershipNumber,
	              'type': 'affiliate',
	              'authToken': COSTCO.Checkout.getAuthToken()
	            });
	            data.isRenew = options.isRenew;
	            data.isBusinessDetails = options.isBusinessDetails;
	            data.isOutsideRenewal = options.isOutsideRenewal;
	            data.excludeData = options.excludeData;
	          } else {
	          // Membership Application flow
	          // We're removing a household from an affiliate.
	          var affiliate = options.affiliate;
	          var arr = helper.getSerializedAffiliateData(affiliate);
	          data = COSTCO.util.objectifyArray(arr);
	          data.url = this.getUrl('/MemberApplicationAffiliateAddCmd');
	          data.householdCheckbox = false;
	          // Backend is expecting action: update for this operation.
	          options.action = 'update';
	        }
	      } else if (options.action == 'remove-affiliate') {
	        // Removing a affiliate for the renew / business details flow.
	        data.url = COSTCO.util.makeUrl('/MemberAffiliateRemoveCmd', {
	          MembershipRenewUpgrade_removeAffiliate: options.affiliate.membershipNumber,
	          MembershipRenewUpgrade_isQuickMembershipCheckout: options.isQuickMembershipCheckout
	        });
	        data.isRenew = options.isRenew;
	        data.isBusinessDetails = options.isBusinessDetails;
	        data.isOutsideRenewal = options.isOutsideRenewal;
	        data.excludeData = options.excludeData;
	      } else {
	        // Removing an affiliate for the membership application flows
	        data.url = this.getUrl('/MemberApplicationAffiliateUpdateCmd');
	        $.extend(data, options.affiliate);
	      }
	      // In the case where we're modifying affiliates, send the corresponding
	      // membership numbers as part of the formdata.
	      if (options.affiliate) {
	        data.affiliateMembershipNumber = options.affiliate.affiliateMembershipNumber;
	        if (options.affiliate.houseHold) {
	          data.affiliateHouseholdMembershipNumber = options.affiliate.houseHold.membershipNumber;
	        }
	      }
	      data.action = options.action;
	      if (location.hostname == 'wcs.costco.com') {
	        // Show me what you got.
	        console.log(JSON.stringify(data, null, 2));
	      }
	      return data;
	    },
	    /**
	     * Returns a URL corresponding to the command we want to call. Could be
	     * /MemberApplicationAffiliate[Add|Update]Cmd. Requests to these commands
	     * require the orderItemsId (xorderitems.orderItemsId) and organizationId
	     * (business identifier) to be passed as query strings.
	     * @param  {String} command The command we want to make a request to.
	     * @return {String}         The url with appropriate querystrings.
	     */
	    getUrl: function getUrl(command) {
	      var configProduct = helper.getConfigProduct();
	      var urlParams = {
	        orderItemsId: configProduct.applicationTrackingCookie,
	        organizationId: configProduct.organizationId
	      };
	      // ALM 52783: If the form is on Membership Application or Quick Membership Checkout page, send the information that it's
	      // membership purchase flow (needed to correctly calculate membership total price after adding an affiliate)
	      if ($('div#membership-application').data('page') == COSTCO.QuickMembershipCheckout.constants.QUICK_MEMBERSHIP || $('div#quick-membership-checkout').data('page') == COSTCO.QuickMembershipCheckout.constants.QUICK_MEMBERSHIP_PURCHASE) {
	        urlParams.fromPage = COSTCO.QuickMembershipCheckout.constants.QUICK_MEMBERSHIP_PURCHASE;
	      }
	      return COSTCO.util.makeUrl(command, urlParams);
	    },
	    /**
	     * This is the primary ajax wrapper for all crud operations related to
	     * affiliates and their attached households.
	     * @param  {Object} requestData The object containing all relevant request
	     *                              data. Use this.getRequestData to get the
	     *                              correct data to be passed.
	     * @return {jQuery.Deferred}    Used to chain thenables.
	     */
	    submit: function submit(requestData) {
	      $('.order-ajax').addClass('ajax-busy');
	      var data = void 0;
	      if ((requestData.isRenew || requestData.isBusinessDetails || requestData.isOutsideRenewal) && requestData.addHousehold /* isDetails placeholder */) {
	          data = helper.transformAffiliateHouseholdInputNames(requestData);
	        } else if (requestData.isRenew || requestData.isBusinessDetails || requestData.isOutsideRenewal /* isDetails placeholder */) {
	          data = helper.transformAffiliateInputNames(requestData);
	        } else {
	        data = {
	          formdata: encodeURIComponent(JSON.stringify(requestData))
	        };
	      }
	      return COSTCO.util.ajax({
	        type: 'POST',
	        url: requestData.url, // this.getUrl(),
	        dataType: 'json',
	        global: false,
	        // If we don't need POST data, excludeData is set to true
	        // and we just pass an empty object. The request probably has
	        // the data it needs in the querystring.
	        data: requestData.excludeData ? {} : data
	      });
	    },
	    /**
	     * Returns a jQuery form object representing the Affiliate form (modal)
	     * @return {jQuery} The jQuery object represetning the form.
	     */
	    getForm: function getForm() {
	      // TRAIL - TODO: Check if better name for this form is required
	      return $('#affiliate-form');
	    },
	    /**
	     * Inline event handler for the checkbox in the add person modal to
	     * toggle hiding and showing the household form.
	     * @return {void}
	     */
	    householdToggle: function householdToggle() {
	      $('#affiliate-household-container').toggleClass('hide');
	    },
	    /**
	     * This function opens the "Add Person to Membership" modal.
	     * @param  {Object} data This is not always passed. It is passed after
	     *                       the POST to /MemberApplicationAddCmd returns. In
	     *                       the case where we're on RenewMembershipView, we
	     *                       associate the property isRenew as the contract
	     *                       with the backend is slightly different.
	     * @return {void}
	     */
	    openAddPersonModal: function openAddPersonModal(data) {
	      $('.permanent-ajax-busy').removeClass('ajax-busy');
	      if (data && data.error) {
	        // Case where we first need to POST to /MemberApplicationAddCmd
	        // before we invoke the add person modal and it returns an error.
	        // We don't want to show the modal in this case, just display the error.
	        return;
	      }
	      // 5.1 Use appropriate template for modal
	      COSTCO.dialog.modalStack({
	        title: messages.MEMBERAPPLICATION_AFFILIATE__modalAddAffiliateTitle,
	        body: COSTCO.util.tmpl('tmpl_affiliate', {
	          affiliateHousehold: COSTCO.util.tmpl('tmpl_household_info_affiliate', {})
	        }),
	        secondary: messages.JS_DIALOG_CANCEL,
	        primary: messages.MEMBERSHIP_AddPerson,
	        primary_event: function primary_event() {
	          // user selected "Add Person"
	          // 5.3 Validate the form
	          if (AffiliateForm.validate()) {
	            var options = {
	              action: 'add',
	              isRenew: data && data.isRenew || false,
	              isBusinessDetails: data && data.isBusinessDetails || false,
	              isOutsideRenewal: data && data.isOutsideRenewal || false
	            };
	            helper
	            // Execute address verification on the affiliate address.
	            .verifyAddresses({
	              form: '#affiliate-form',
	              primary: helper.affiliateAddressSelectors
	            })
	            // Invoke the address verification modal
	            .then(function (verifyResponse) {
	              return helper.invokeMultiAVS(verifyResponse, AffiliateForm.crudSequence.bind(options));
	            })
	            // If the service fails, still submit the form.
	            .fail(AffiliateForm.crudSequence.bind(options));
	          }
	        },
	        onclose: function onclose() {
	          // We'll temporary store this form so we can serialize it after its
	          // been closed and we're looking at the address verification modal.
	          // We can also use this to populate the form.
	          AffiliateForm.storedAffiliateForm = AffiliateForm.getForm();
	        },
	        onshown: function onshown() {
	          AffiliateForm.populateUsingStoredForm();
	        }
	      });
	      // A new call to open this modal shouldn't prepopulate with the result
	      // of a previously stored form.
	      this.storedAffiliateForm = undefined;
	    },
	    /**
	     * This function handles removing an affiliate or an affiliate's attached
	     * household. application.js has decorator functions that are inline event
	     * handlers that end up calling this.
	     * @param  {Object} options Options object that contains an affiliate object
	     *                          property and a switch for removing either the
	     *                          affiliate or the affiliate's household.
	     * @return {void}
	     */
	    removePerson: function removePerson(options) {
	      var _this = this;
	
	      var action = options.action;
	      options.isRenew /* isBusinessDetails */ = options && options.isRenew || false;
	      options.isBusinessDetails /* isBusinessDetails */ = options && options.isBusinessDetails || false;
	      options.isOutsideRenewal /* isBusinessDetails */ = options && options.isOutsideRenewal || false;
	      options.excludeData /* isBusinessDetails */ = options && options.excludeData || false;
	      COSTCO.dialog.showModal({
	        title: messages.ADDHOUSEHOLD_MEMBERSHIP__Remove_ModalTitle,
	        body: COSTCO.util.tmpl(options.isOutsideRenewal ? 'tmpl_remove_affiliate_outside_renewal' : 'tmpl_remove_affiliate', {
	          affiliate: action == 'remove-household'
	          // Here we send the household object to the template
	          // because we're removing the household.. just want to show
	          // the household name.
	          ? options.affiliate.houseHold : options.affiliate,
	          newCreated: options.affiliate ? options.affiliate.newCreated : false
	        }),
	        secondary: messages.JS_DIALOG_CANCEL,
	        primary: messages.ADDHOUSEHOLD_MEMBERSHIP__Remove_ModalTitle,
	        primary_event: function primary_event() {
	          // user selected "Remove Person"
	          _this.crudSequence.call(options);
	          COSTCO.dialog.close();
	        }
	      });
	    },
	    editPerson: function editPerson(options) {
	      var _this2 = this;
	
	      // See application.js.addPersonWithinHousehold for explanation here.
	      var title = options.addHousehold ? COSTCO.util.capitalize(messages.ADDHOUSEHOLD_TITLE) : options.editHousehold ? messages.EDITHOUSEHOLD_TITLE : messages.MEMBERSHIP_EditPerson;
	      COSTCO.dialog.modalStack({
	        title: title,
	        body: COSTCO.util.tmpl('tmpl_affiliate', {
	          affiliateHousehold: COSTCO.util.tmpl('tmpl_household_info_affiliate', {})
	        }),
	        secondary: messages.JS_DIALOG_CANCEL,
	        primary: options.addHousehold ? messages.MEMBERSHIP_AddPerson : messages.UPDATE,
	        primary_event: function primary_event() {
	          // user selected "Edit Person"
	          // 5.3 Validate the form
	          if (_this2.validate()) {
	            if (!options.editHousehold && !options.addHousehold) {
	              // This tells onshown to use the newly editted form if the user
	              // escapes and returns back to the affiliate form.
	              options.useStored = true;
	              helper
	              // Execute address verification on the affiliate address.
	              .verifyAddresses({
	                form: '#affiliate-form',
	                primary: helper.affiliateAddressSelectors
	              })
	              // Invoke the address verification modal
	              .then(function (verifyResponse) {
	                return helper.invokeMultiAVS(verifyResponse, AffiliateForm.crudSequence.bind(options));
	              })
	              // If the service fails, still submit the form.
	              .fail(AffiliateForm.crudSequence.bind(options));
	            } else {
	              // Household doesn't require verification.
	              _this2.crudSequence.call(options);
	              COSTCO.dialog.close();
	            }
	          }
	        },
	        onclose: function onclose() {
	          // We'll temporary store this form so we can serialize it after its
	          // been closed and we're looking at the address verification modal.
	          // We can also use this to populate the form.
	          AffiliateForm.storedAffiliateForm = AffiliateForm.getForm();
	        },
	        onshown: function onshown() {
	          if (options.useStored) {
	            // Here we use the stored affiliate form to repopulate the form
	            // as the user escaped from address verification.
	            affForm.populateUsingStoredForm();
	          }
	        }
	      });
	      var affForm = AffiliateForm;
	      // Populate date of birth selects, etc.
	      helper.formWizBangs(affForm.getForm());
	      // Populate the form with information about the affiliate
	      helper.populateElement(affForm.getForm(), options.affiliate);
	      // Clear the household values as some of these inputs share the same
	      // data-configproduct attribute. We'll populate them below if exist.
	      $('#affiliate-household-container input').val('');
	      $('#affiliate-household-container select').find('option:first').prop('selected', true);
	      // If the affiliate has a household attached, show and populate
	      if (options.affiliate.houseHold) {
	        affForm.getForm().find('#affiliate-household').prop('checked', true);
	        affForm.getForm().find('#affiliate-household').val(true);
	        helper.populateElement(affForm.getForm().find('#affiliate-household-container'), options.affiliate.houseHold);
	        affForm.householdToggle();
	      }
	      // This is the varition of the modal where we're actually just adding/editing
	      // a household. We want to hide the affiliate container and show just the
	      // household inputs.
	      if (options.addHousehold || options.editHousehold) {
	        $('.affiliate-container').addClass('hide');
	        $('#affiliate-household-container').addClass('only-household');
	        affForm.getForm().find('#affiliate-household').prop('checked', true);
	        affForm.getForm().find('#affiliate-household').val(true);
	      }
	      if (options.addHousehold) {
	        affForm.householdToggle();
	      }
	    },
	    /**
	     * This represents the sequence of actions for performing CRUD operations
	     * related to affiliates. This should include several (a)sync functions
	     * like address verification and data return handling functions.
	     * @param  {Object} addresses The addresses returned from address verification
	     * @return {void}
	     */
	    crudSequence: function crudSequence(addresses) {
	      $.extend(this, {
	        addresses: addresses
	      });
	      var requestData = AffiliateForm.getRequestData(this);
	      if (requestData.isRenew /* isDetails placeholder */) {
	          // In the case where we are in the renew or business details flow,
	          // we want to reflect the newly added affiliates and change some other state.
	          COSTCO.AffiliateForm.submit(requestData)
	          // If we have errors, display them.
	          .then(function (data) {
	            if ($('#quick-membership-checkout').length != 0) {
	              window.location.reload(true);
	            } else {
	              data.retainNotification = true;
	              return helper.handleErrors(data);
	            }
	          })
	          // After a crud operation to affiliates, reflect them using the
	          // JSON response from the server.
	          .then(helper.reflectAffiliatesAlternate)
	          // If we already have 6 newly added affiliates, we dont want to allow
	          // any more for this transaction.
	          .then(helper.canAddAffiliate)
	          // Update the total price. If the user selected the link,
	          // "upgrade to a business executive membership" (business membership
	          // flow), RenewMembership.isUpgrading was set true, show the
	          // renewAndUpgradeAmount
	          .then(function (data) {
	            var isUpgrading = COSTCO.RenewMembership.isUpgrading || false;
	            return helper.updateTotalPrice(data, isUpgrading);
	          })
	          // Switch the add person link if needed
	          .then(helper.addPersonLink)
	          // Kurt TODO: Does the add to cart link change?
	          // If the command fails, handle them
	          .fail(helper.handleErrors);
	        } else if (requestData.isBusinessDetails) {
	        COSTCO.AffiliateForm.submit(requestData)
	        // If we have errors, display them.
	        .then(function (data) {
	          if ($('#quick-membership-checkout').length != 0) {
	            window.location.reload(true);
	          } else {
	            data.retainNotification = true;
	            return helper.handleErrors(data);
	          }
	        }).then(function (data) {
	          var hasErrors = data && data.error && data.errorMessages.length > 0;
	          if (!hasErrors) {
	            return location.reload(true);
	          } else {
	            return;
	          }
	        }).fail(helper.handleErrors);
	      } else if (requestData.isOutsideRenewal) {
	        // In the case where we are in the business details flow,
	        // adding additional people outside renewal period.
	        COSTCO.AffiliateForm.submit(requestData)
	        // If we have errors, display them.
	        .then(function (data) {
	          if ($('#quick-membership-checkout').length != 0) {
	            window.location.reload(true);
	          } else {
	            data.retainNotification = true;
	            return helper.handleErrors(data);
	          }
	        })
	        // After a crud operation to affiliates, reflect them using the
	        // JSON response from the server.
	        .then(helper.reflectAffiliatesBussinessOutsideRenewal)
	        // If the command fails, handle them
	        .fail(helper.handleErrors);
	      } else {
	        // This case represents the membership application flow where we want
	        // to set the config product thats stored in local storage after
	        // submitting the request.
	        COSTCO.AffiliateForm.submit(requestData)
	        // returns configProduct
	        .then(helper.setConfigProduct)
	        // If we have errors, display them.
	        .then(helper.handleErrors)
	        // When we're done, we want to show the affiliates
	        .then(function () {
	          if ($('#quick-membership-checkout').length != 0) {
	            window.location.reload(true);
	          } else {
	            helper.reflectAffiliates();
	          }
	        })
	        // If the command fails, handle them
	        .fail(helper.handleErrors);
	      }
	    }
	  };
	  if (typeof window.COSTCO === 'undefined') {
	    window.COSTCO = {};
	  }
	  window.COSTCO.AffiliateForm = AffiliateForm;
	  return AffiliateForm;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * @title membership-validation.js: Sub-module of Register User (Create Account) page
	 * @description This module provides membership validation functionality.
	 * @dependency
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	  var MembershipValidation = {
	
	    /**
	     * Initializes the submodule data
	     * @return void
	     */
	    init: function init() {
	      this.maskInputs();
	      this.bindEvents();
	      COSTCO.util.maskMembershipInput();
	
	      $('#AddMembershipForm').keypress(function (e) {
	        if (e.which == 13) {
	          MembershipValidation.addMembershipForm.submitForm();
	        }
	      });
	    },
	
	    /**
	     * Binds event handlers
	     * @return void
	     */
	    bindEvents: function bindEvents() {
	      $('#buy-membership-button').unbind('click').bind('click', function () {
	        if ($.cookie('cartCountCookie') > 0) {
	          window.open('/join-costco.html?COSTID=Header_Membership_TOP', '_self');
	        } else {
	          window.open('/join-costco-quick.html?COSTID=Header_Membership_TOP', '_self');
	        }
	      });
	    },
	
	    /**
	     * Calls renew membership main logic
	     * @param  {String}  membershipType membership type
	     * @param  {Boolean} isExecutive    true | false
	     * @param  {Boolean} isUpgrade      true | false
	     * @param  {String} fromPage       source page to decide on redirection
	     * @return void
	     */
	    renewMembership: function renewMembership(memberType, isExecutive, isUpgrade, fromPage) {
	
	      var goldDiv = document.getElementById('membership-config-gold');
	      var uccGoldEnabled = goldDiv ? goldDiv.getAttribute('data-ucc-renew-upgrade-gold-enabled') : "false";
	      var busDiv = document.getElementById('membership-config-bus');
	      var uccBusinessEnabled = busDiv ? busDiv.getAttribute('data-ucc-renew-upgrade-business-enabled') : "false";
	
	      var uccGold = "true";
	      var uccBusiness = "true";
	
	      var addRenewMemberhsipToCartUrl = '';
	      // Check if MembershipRenewUpgradeStatic object exists (provided externally from JSP)
	      if ((typeof MembershipRenewUpgradeStatic === 'undefined' ? 'undefined' : _typeof(MembershipRenewUpgradeStatic)) == 'object') {
	        if (memberType.toUpperCase() == 'Z010') {
	          addRenewMemberhsipToCartUrl = isExecutive || isUpgrade ? MembershipRenewUpgradeStatic.goldExecRenewAddToCart : MembershipRenewUpgradeStatic.goldBasicRenewAddToCart;
	          uccGold = uccGoldEnabled;
	        } else if (memberType.toUpperCase() == 'Z020') {
	          addRenewMemberhsipToCartUrl = isExecutive || isUpgrade ? MembershipRenewUpgradeStatic.bizExecRenewAddToCart : MembershipRenewUpgradeStatic.bizBasicRenewAddToCart;
	          uccBusiness = uccBusinessEnabled;
	        } else {
	          console.error('Unsupported membership type');
	        }
	        if (fromPage && fromPage !== '') {
	          addRenewMemberhsipToCartUrl = addRenewMemberhsipToCartUrl + '&sourcePage=' + fromPage;
	        }
	
	        if (typeof dmcRenwalFlow != "undefined" ? dmcRenwalFlow : false) {
	          addRenewMemberhsipToCartUrl += '&dmcRenewalFlow=true&deviceId=' + deviceId;
	        }
	
	        if (uccGold === "true" && uccBusiness === "true") {
	
	          // Try to get cardNumber from membershipData first, then fall back to memberData
	          if (membershipData != null && membershipData !== 'undefined') {
	            var cardNumber = membershipData.caller.cardNumber.value;
	            var queryString = addRenewMemberhsipToCartUrl.split('?')[1];
	            var params = new URLSearchParams(queryString);
	            var itemNumber = params.get('itemNumber');
	
	            localStorage.setItem('cartMember', JSON.stringify({ id: cardNumber }));
	
	            window.location.href = '/cart/membership/terms?itemNumber=' + encodeURIComponent(itemNumber);
	          } else if (typeof memberData !== 'undefined' && memberData != null && memberData.caller && memberData.caller.cardNumber) {
	            var _cardNumber = memberData.caller.cardNumber.value;
	            var _queryString = addRenewMemberhsipToCartUrl.split('?')[1];
	            var _params = new URLSearchParams(_queryString);
	            var _itemNumber = _params.get('itemNumber');
	
	            localStorage.setItem('cartMember', JSON.stringify({ id: _cardNumber }));
	
	            window.location.href = '/cart/membership/terms?itemNumber=' + encodeURIComponent(_itemNumber);
	          }
	        } else {
	          this.addToCartAndRedirect(addRenewMemberhsipToCartUrl, isUpgrade);
	        }
	      } else {
	        console.error('MembershipRenewUpgradeStatic object does not exist.');
	      }
	    },
	
	    /**
	     * Calls AjaxManageShoppingCart and redirects to appropriate page
	     * @param  {String} addToCartUrl URL to call
	     * @return void
	     */
	    addToCartAndRedirect: function addToCartAndRedirect(addToCartUrl, isUpgrade) {
	      var isCartEmpty = this.isCartEmpty();
	      var requestFromPostLockdownPage = $('#membership-card-info-post-lockdown').length > 0;
	
	      if (addToCartUrl) {
	        addToCartUrl += '&unverifiedRenew=true';
	
	        if (requestFromPostLockdownPage) {
	          COSTCO.Checkout.ajax_update_state({
	            method: 'POST',
	            url: addToCartUrl,
	            dataType: 'json',
	            ajax_update_post_done: function ajax_update_post_done(data, textStatus, jqXHR, options) {
	              COSTCO.util.notification.clearNotification('#notification-message');
	              if (data.error.application.length > 0) {
	                COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, [data.error.application], false, '#notification-message');
	                COSTCO.RenewMembership.revertRadioSelection(isUpgrade);
	              }
	            }
	          });
	        } else {
	          COSTCO.util.ajax({
	            type: 'POST',
	            url: addToCartUrl,
	            dataType: 'json',
	            done: function done(data) {
	              var errorObject = !$.isEmptyObject(data.orderErrMsgObj) ? data.orderErrMsgObj : !$.isEmptyObject(data.errorMessage) ? data.errorMessage : '';
	
	              if (errorObject) {
	                COSTCO.util.notification.clearNotification('#error-message-placeholder');
	                COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, [errorObject], false, '#error-message-placeholder', 'span');
	                $('.order-ajax').removeClass('ajax-busy');
	              } else {
	                if ($('#isBDAppVar').val() === 'BD') {
	                  if (isCartEmpty) {
	                    document.location.href = '/QuickMembershipCheckoutCmd?langId=' + wcs.langId + '&storeId=' + wcs.storeId + '&catalogId=' + wcs.catalogId;
	                  } else {
	                    document.location.href = '/CheckoutCartView?langId=' + wcs.langId + '&storeId=' + wcs.storeId + '&catalogId=' + wcs.catalogId;
	                  }
	                } else {
	                  document.location.href = '/QuickMembershipCheckoutCmd?langId=' + wcs.langId + '&storeId=' + wcs.storeId + '&catalogId=' + wcs.catalogId;
	                }
	              }
	            },
	            timeout: wcs.ajaxTimeout,
	            fail: function fail(x, t, m) {
	              $('.order-ajax').removeClass('ajax-busy');
	              if (t === 'timeout') {
	                console.error('Error AJAX timeout.');
	              } else {
	                console.error('Unexpected AJAX error.');
	              }
	            }
	          });
	        }
	      } else {
	        console.error('Membership not added to cart.');
	      }
	    },
	    /**
	     * [secondaryValidationForm object for secondary validation form handling]
	     * @type {Object}
	     */
	    secondaryValidationForm: {
	
	      getForm: function getForm() {
	        return $('#SecondaryValidationForm');
	      },
	
	      inputRules: function inputRules() {
	        var rules = {};
	
	        rules.usersAnswer = {
	          required: true,
	          messages: {
	            required: messages.JS_VALID_REQUIRED
	          }
	        };
	
	        rules.usersFirstNameAnswer = {
	          required: true,
	          messages: {
	            required: messages.JS_VALID_REQUIRED
	          }
	        };
	
	        rules.usersLastNameAnswer = {
	          required: true,
	          messages: {
	            required: messages.JS_VALID_REQUIRED
	          }
	        };
	
	        rules.postalCode = {
	          required: true,
	          messages: {
	            required: messages.JS_VALID_REQUIRED
	          }
	        };
	
	        rules.employeeDate = {
	          required: true,
	          checkDate: true,
	          checkIsDateInFuture: true,
	          messages: {
	            checkDate: messages._ERR_MEMBERSHIP_SECONDARY_VALIDATION_JS_VALID_DATE,
	            required: messages.JS_VALID_REQUIRED,
	            checkIsDateInFuture: messages._ERR_MEMBERSHIP_SECONDARY_VALIDATION_JS_PAST_DATE
	          }
	        };
	
	        return rules;
	      },
	      /**
	       * validates Secondary Validation Form
	       * @return {Boolean} if form is valid or not
	       */
	      validateForm: function validateForm() {
	        var $form = MembershipValidation.secondaryValidationForm.getForm();
	        $form.validate({
	          errorPlacement: function errorPlacement(error, element) {
	            if (element.is(':radio')) {
	              error.appendTo(element.parents('.control-group'));
	            } else {
	              error.insertAfter(element);
	            }
	          }
	        });
	        $.validator.addMethod('checkDate', function (value, element) {
	          return this.optional(element) || /^(1[0-2]|0[1-9]|\d)\/(\d{2})$/.test(value);
	        });
	        $.validator.addMethod("checkIsDateInFuture", function (value, element) {
	          var isDateInFuture = false;
	          var enteredMonth = parseInt(value.split('/')[0]);
	          var enteredYear = parseInt(value.split('/')[1]);
	          var now = new Date();
	          var currentMonth = parseInt((now.getMonth() + 1).toString());
	          var currentYear = parseInt(now.getFullYear().toString().substr(-2));
	          if (enteredYear == currentYear && enteredMonth > currentMonth) {
	            isDateInFuture = true;
	          }
	          return isDateInFuture ? false : true;
	        });
	
	        var actionForm = $('#action')[0].value;
	        if (actionForm === 'primary_member_postal_code' || actionForm === 'business_postal_code') {
	          $form.find('[name="usersAnswer"]').rules('add', MembershipValidation.secondaryValidationForm.inputRules().postalCode);
	        } else if (actionForm === 'employee_start_date') {
	          $form.find('[name="usersAnswer"]').rules('add', MembershipValidation.secondaryValidationForm.inputRules().employeeDate);
	        } else if (actionForm === 'employee_first_last_name') {
	          $form.find('[name="usersFirstNameAnswer"]').rules('add', MembershipValidation.secondaryValidationForm.inputRules().usersFirstNameAnswer);
	          $form.find('[name="usersLastNameAnswer"]').rules('add', MembershipValidation.secondaryValidationForm.inputRules().usersLastNameAnswer);
	
	          $('#usersAnswer')[0].value = $form.find('[name="usersFirstNameAnswer"]').val() + '|' + $form.find('[name="usersLastNameAnswer"]').val();
	        } else if (actionForm === 'employee_last_name') {
	          $form.find('[name="usersAnswer"]').rules('add', MembershipValidation.secondaryValidationForm.inputRules().usersAnswer);
	        }
	        return $form.valid();
	      },
	      /**
	       * Submits Secondary Validation Form
	       * @return void
	       */
	      submitForm: function submitForm() {
	        if (MembershipValidation.secondaryValidationForm.validateForm()) {
	          MembershipValidation.secondaryValidationForm.getForm().submit();
	        }
	      }
	    },
	    /**
	     * [addMembershipForm Object for Add membership Form handling]
	     * @type {Object}
	     */
	    addMembershipForm: {
	      getForm: function getForm() {
	        return $('#AddMembershipForm');
	      },
	      validateForm: function validateForm() {
	        var $form = MembershipValidation.addMembershipForm.getForm();
	
	        $.validator.addMethod('costcoMembership', function (value, element) {
	          return (/^\d{12,16}$/.test(value)
	          );
	        }, messages.ERR_INVALID_MEMBERSHIP_NO);
	
	        $form.validate({
	          rules: {
	            membershipId: {
	              required: true,
	              costcoMembership: true
	            },
	            lastName: {
	              required: true
	            }
	          },
	          messages: {
	            membershipId: {
	              required: messages.JS_VALID_REQUIRED,
	              costcoMembership: messages.ERR_INVALID_MEMBERSHIP_NO
	            },
	            lastName: {
	              required: messages.JS_VALID_REQUIRED
	            }
	          }
	        });
	        return $form.valid();
	      },
	      /**
	       * Submits Add Membership form
	       * @return void
	       */
	      submitForm: function submitForm() {
	        sessionStorage.removeItem("changeValidationFlag");
	        if (MembershipValidation.addMembershipForm.validateForm()) {
	          // verifyme validation
	          if (typeof verifyMeFlowEnabled !== 'undefined' && verifyMeFlowEnabled === true && wcs.storeId !== 'undefined' && wcs.storeId === '10302' && $("#membershipNumber").parent()[0] !== 'undefined' && $("#membershipNumber").parent()[0] !== undefined && (/^$/.test($('#membershipNumber').val()) || !/^\d{12,12}$/.test($('#membershipNumber').val()))) {
	            // verify me flow enabled and CA and membership number is invalid	    	    
	            $("#membershipNumber").parent()[0].classList.add("mdc-text-field--invalid");
	            $("#membershipNumber")[0].classList.add("highlightError");
	            $("#membershipNumber").parent()[0].nextElementSibling.children[0].innerHTML = messages.ERR_INVALID_MEMBERSHIP_NO;
	            $("#membershipNumber").parent()[0].nextElementSibling.style.display = 'block';
	          } else {
	            MembershipValidation.addMembershipForm.getForm().submit();
	          }
	        } else if (memberOnlyFeatureEnabled !== undefined && memberOnlyFeatureEnabled === true) {
	          $('#membershipId label.error').insertAfter($('#membershipId label.error').next());
	        }
	      }
	    },
	
	    /**
	     * Mask input fields
	     */
	    maskInputs: function maskInputs() {
	      var $form = MembershipValidation.secondaryValidationForm.getForm();
	      if ($form.length > 0) {
	        $($form).find('#employeeStartDate').mask('00/00', {
	          placeholder: 'MM/YY'
	        });
	
	        // Set initial mask input.
	        if (COSTCO.CAddressForm.isUS()) {
	          $($form).find('#postalCode').unmask().mask('00000-0000');
	        } else {
	          $($form).find('#postalCode').unmask().mask('S0S 0S0');
	        }
	
	        // Enable both CA postal-code mask and US ZIP-code mask depending on first character,
	        // as US members must be able to link membership on CA site and vice versa.
	        // CA postal-code starts with a letter, US ZIP-code starts with a digit.
	        $($form).find('#postalCode').keypress(function (event) {
	          if ($($form).find('#postalCode').val().length == 0) {
	            if (/[a-zA-Z]/.test(event.key)) {
	              $($form).find('#postalCode').unmask().mask('S0S 0S0');
	            } else if (/[0-9]/.test(event.key)) {
	              $($form).find('#postalCode').unmask().mask('00000-0000');
	            } else {
	              $($form).find('#postalCode').val('');
	              return false;
	            }
	          }
	        });
	      }
	    },
	
	    /**
	     * Checks if cart is empty.
	     * @return {Boolean}
	     *
	     */
	    isCartEmpty: function isCartEmpty() {
	      var cartEmpty = true;
	      var cartCookie = $.cookie('cartCountCookie');
	      if (cartCookie != null && cartCookie != 'undefined') {
	        if (cartCookie > 0) {
	          cartEmpty = false;
	        }
	      }
	      return cartEmpty;
	    },
	
	    /**
	     * Opens 'Upgrade Membership' dialog modal.
	     * @return {void}
	     */
	    openUpgradeMembershipModal: function openUpgradeMembershipModal(membershipType) {
	
	      var fromPage = $('#fromPage').val();
	      if (fromPage === undefined) {
	        fromPage = '';
	      }
	
	      var modalSettings = {
	        dialogclasses: '',
	        title: messages.MEMBERSHIP_VALIDATION_UpgradeMembershipModal_Title,
	        body: COSTCO.util.tmpl('tmpl_upgrade_membership', {}),
	        primary: messages.MEMBERSHIP_VALIDATION_Expired_Upgrade_Button_Text,
	        secondary: messages.MEMBERSHIP_VALIDATION_Expired_Renew_Only_Button_Text,
	        primary_event: function primary_event() {
	          COSTCO.MembershipValidation.renewMembership(membershipType, false, true, fromPage);
	          COSTCO.dialog.close();
	        },
	        secondary_event: function secondary_event() {
	          COSTCO.MembershipValidation.renewMembership(membershipType, false, false, fromPage);
	          COSTCO.dialog.close();
	        },
	        onclose: function onclose() {
	          if (typeof isDmcPage !== 'undefined' && isDmcPage) {
	            window.location = '/DMCCheck?action=renewal&renewCanceled=true';
	          }
	        },
	        onshown: function onshown() {}
	      };
	      COSTCO.dialog.showModal(modalSettings);
	    },
	
	    /**
	     * Shows last name / zip code form to validate user for editing membership info
	     * If user entered valid last name & zip code - save info as flag
	     */
	    showValidationPrescreen: function showValidationPrescreen() {
	      var settings = {};
	      if ($("#maxAttemptMemberAccountReached").val() === "false") {
	        settings = {
	          title: messages.ACCOUNT_RENEW_MEMBERSHIP_Membership_Information_Text,
	          body: COSTCO.util.tmpl("tmpl_membership_validate_prescreen", {}),
	          primary: messages.MEMBERVERIFICATION_MEMBERSHIP__Continue_ButtonText,
	          secondary: messages.MEMBERVERIFICATION_MEMBERSHIP__Cancel_ButtonText,
	          dialogclasses: "modal-dialog-membership verify-membership-dialog",
	          primary_button_style: "rounded",
	          secondary_button_style: "rounded",
	          primary_event: function primary_event() {
	            if (COSTCO.MemberVerification.validateZipCodeForm($("#MemberValidationForm"))) {
	              var url = COSTCO.util.makeUrl('/AjaxAccountAutoRenewMembershipValidationCmd', {
	                lastName: $('#questionLastName').val(),
	                zipCode: $('#questionZip').val()
	              });
	
	              COSTCO.MemberVerification.submitRequest(url).then(function (data) {
	                $('#questionLastName').val('');
	                $('#questionZip').val('');
	                $('#labelQuestionLastName').removeClass('active');
	                $('#labelQuestionZip').removeClass('active');
	                if (data.memberAccountRecordCheckMaxAttempsReached == 'true') {
	                  var newSettings = MembershipValidation.updateValidationModal("tmpl_membership_validate_prescreen_locked");
	                  COSTCO.dialog.updateModal(newSettings);
	                  $("#maxAttemptMemberAccountReached").val("true");
	                } else if (data.memberAccountRecordMatch == 'true') {
	                  var _newSettings = MembershipValidation.updateValidationModal("tmpl_membership_validate_prescreen_success");
	                  COSTCO.dialog.updateModal(_newSettings);
	                  sessionStorage.setItem("changeValidationFlag", true);
	                } else {
	                  $("#MemberValidationForm .notification").removeClass("hidden");
	                }
	              });
	            }
	          },
	          secondary_event: function secondary_event() {
	            COSTCO.dialog.close();
	          },
	          close: function close() {
	            COSTCO.dialog.close();
	          },
	          afterclose: function afterclose() {
	            $("#costcoModal").find(".modal-dialog").removeClass("modal-dialog-membership");
	            $('#costcoModalBtn2').removeClass('primary-button-v2');
	            $('.costcoModalBtn1').removeClass('secondary-button-v2');
	          },
	          onshown: function onshown() {
	            COSTCO.util.maskMembershipInput();
	          }
	        };
	      } else {
	        settings = MembershipValidation.updateValidationModal("tmpl_membership_validate_prescreen_locked");
	      }
	      COSTCO.dialog.createExtDialogBox(settings);
	    },
	
	    /**
	     * Show different info on modal after member account check
	     * @param tmplName - template name to be loaded in modal body.
	     * @param tmplParam - parameters to be loaded for template. Default is empty.
	     */
	    updateValidationModal: function updateValidationModal(tmplName) {
	      var tmplParam = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return {
	        title: messages.ACCOUNT_RENEW_MEMBERSHIP_Membership_Information_Text,
	        body: COSTCO.util.tmpl(tmplName, tmplParam),
	        primary: messages.CLOSE,
	        primary_button_style: "rounded",
	        setHalfButtons: true,
	        primary_event: function primary_event() {
	          COSTCO.dialog.close();
	        },
	        afterclose: function afterclose() {
	          $("#costcoModal").find(".modal-dialog").removeClass("modal-dialog-membership");
	          $('#costcoModalBtn2').removeClass('primary-button-v2');
	          $('.costcoModalBtn1').removeClass('secondary-button-v2');
	        }
	      };
	    }
	  };
	
	  if (typeof window.COSTCO == 'undefined') {
	    window.COSTCO = {};
	  }
	
	  window.COSTCO.MembershipValidation = MembershipValidation;
	
	  return MembershipValidation;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title register-user.js: Sub-module for Register User (Create Account) page
	 * @description This module is used to handle registering new user account.
	 * @dependency password-strength.js
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (passwordStrength) {
	  var RegisterUser = {
	
	    /**
	     * Initialization function.
	     */
	    init: function init() {
	      COSTCO.util.maskMembershipInput();
	      if ($('#primary-membership-block').length != 0) {
	        this.focusInput('validation-error', 'first_name');
	      } else {
	        this.focusInput('validation-error', 'register_email1');
	      }
	      this.activatePopovers('co-help');
	      this.activatePopovers('tooltip-without-question-icon');
	      this.validationRules();
	      this.validateForm('RegisterForm');
	      sessionStorage.removeItem("changeValidationFlag");
	      passwordStrength.init();
	
	      $('#buy-membership-button').unbind('click').bind('click', function () {
	        if ($.cookie('cartCountCookie') > 0) {
	          window.open('/join-costco.html?COSTID=Header_Membership_TOP', '_self');
	        } else {
	          window.open('/join-costco-quick.html?COSTID=Header_Membership_TOP', '_self');
	        }
	      });
	
	      console.log('Register User sub-module initialized.');
	    },
	    /**
	     * Focuses the first input field of a given class. If there is no input element with given class,
	     * focus on default input field with given id.
	     * @param {string} inputClass - HTML class attribute of the input field to be focused.
	     * @param {string} defaultInputId - HTML it attribute of the input field to be focused if class does not exist.
	     * @return {void}
	     */
	    focusInput: function focusInput(inputClass, defaultInputId) {
	      $(window).on('load', function () {
	        if ($('input.' + inputClass).length > 0) {
	          $('input.' + inputClass + ':first').focus();
	        } else {
	          $('input#' + defaultInputId).focus();
	          //          window.scrollTo(0, 0);
	        }
	      });
	    },
	    /**
	     * Activates popovers on Costco tooltips.
	     * @param {string} tooltipClass - Tooltip class.
	     * @return {void}
	     */
	    activatePopovers: function activatePopovers(tooltipClass) {
	      $('.' + tooltipClass).popover();
	    },
	    /**
	     * Validation rules for the inputs associated with creating an account.
	     * @return {void}
	     */
	    validationRules: function validationRules() {
	      $.validator.addMethod('email', function (value, element) {
	        return (/^.+@(([^.])+\.)+([^.])+$/i.test(value)
	        );
	      }, messages.JS_VALID_EMAIL);
	
	      $.validator.addMethod('passwordRule', function (value, element) {
	        return (/^[^<,>,",\\,\s,\.]{8,20}$/.test(value) && /[a-zA-Z]/.test(value)
	        );
	      }, messages.JS_VALID_REQUIRED);
	
	      $.validator.addMethod('costcoMembership', function (value, element) {
	        return (/^\d{12,16}$/.test(value)
	        );
	      }, messages.ERR_INVALID_MEMBERSHIP_NO);
	    },
	
	    /**
	     * Checks if cart is empty.
	     * @return {void}
	     *
	     * isCartEmpty: function(){
	    	let cartEmpty = true;
	    	let cartCookie = $.cookie('cartCountCookie');
	    	if(cartCookie != null && cartCookie != 'undefined'){
	    		if(cartCookie > 0) {
	    			cartEmpty = false;
	    		}
	    	}
	    	return cartEmpty;
	    },
	      */
	
	    /**
	     * Validates the given form.
	     * @param {string} formId - ID attribute of the form.
	     * @return {void}
	     */
	    validateForm: function validateForm(formId) {
	      $('#' + formId).validate({
	
	        ignoreTitle: true,
	
	        rules: {
	          email1: {
	            required: true,
	            email: true,
	            maxlength: 251
	          },
	          logonPassword: {
	            required: true,
	            passwordRule: true
	          },
	          logonPasswordVerify: {
	            required: true,
	            passwordRule: true,
	            equalTo: '#logonPassword'
	          },
	          userField2: {
	            // required: true,
	            costcoMembership: true
	          },
	          lastNameOnMembership: {
	            // required: true,
	          }
	        },
	
	        messages: {
	          email1: {
	            required: messages.ERR_REQUIRED_LOGON,
	            email: messages.ERR_INVALID_EMAIL,
	            maxlength: messages.ERR_EMAIL_MAX_LENGTH
	          },
	          logonPassword: {
	            required: messages.ERR_REQUIRED_REGISTER_PASSWORD,
	            // Password messages already handled by PasswordStrength.jsp
	            passwordRule: '' },
	          logonPasswordVerify: {
	            required: messages.ERR_REQUIRED_CONFIRM_PASSWORD,
	            // Password messages already handled by PasswordStrength.jsp
	            passwordRule: '', // messages.ERR_CREATE_ACCOUNT_PASSWORD_INVALID,
	            equalTo: '' },
	          userField2: {
	            required: messages.JS_VALID_REQUIRED,
	            costcoMembership: messages.ERR_INVALID_MEMBERSHIP_NO
	          },
	          lastNameOnMembership: {
	            required: messages.JS_VALID_REQUIRED
	          }
	        }
	      });
	    }
	  };
	
	  if (typeof window.COSTCO === 'undefined') {
	    window.COSTCO = {};
	  }
	
	  window.COSTCO.RegisterUser = RegisterUser;
	
	  return RegisterUser;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title rxaddresshelper.js: Sub-module for Rx pages
	 * @description This module is used to handle address operations
	 * @dependency 
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(14), __webpack_require__(17), __webpack_require__(11)], __WEBPACK_AMD_DEFINE_RESULT__ = function (address, addressVerification, membershipHelper) {
	
	  var QuickRenewAddressHelper = {
	
	    addressArrayForAVS: [],
	    init: function init() {},
	
	    /**
	     * URL JSON object with manage address URL constants
	     * @type {Object}
	     */
	    url: {
	      MANAGE_ADDRESS_ADD: 'AjaxQuickRenewManageAddressCmd'
	    },
	
	    submitAddress: function submitAddress(addressAddedSuccessCallback, taxChangedCallback) {
	
	      if (QuickRenewAddressHelper.isShippingBillingAddressValid()) {
	        addressArrayForAVS = QuickRenewAddressHelper.buildAVSAddressArray();
	
	        var avsSuccessCallback = function avsSuccessCallback(addressObjArray) {
	          membershipHelper.invokeMultiAVS(addressObjArray, function (choosenAddresses) {
	            QuickRenewAddressHelper.ajaxSubmitAddress(choosenAddresses, addressObjArray, addressAddedSuccessCallback, taxChangedCallback);
	          });
	        };
	
	        var avsOptions = {
	          successCallback: avsSuccessCallback
	        };
	
	        addressVerification.addressVerification(addressArrayForAVS, undefined, true, avsOptions);
	      }
	    },
	
	    ajaxSubmitAddress: function ajaxSubmitAddress(addressArrayObj, originalAddress, callback) {
	
	      var form = $('#quick-renew-address-form');
	      QuickRenewAddressHelper.populateAddressData(form, addressArrayObj);
	
	      var addressData = QuickRenewAddressHelper.alterAddressObjectWithAVSResult(addressArrayObj, originalAddress);
	
	      var isWallet = $("input[name='walletCheckout']").val() == 'true' || $('#radio-visa').length > 0 && $('#radio-visa')[0].checked || $('#radio-master').length > 0 && $('#radio-master')[0].checked;
	      var options = {
	        url: QuickRenewAddressHelper.url.MANAGE_ADDRESS_ADD,
	        method: "POST",
	        dataType: 'json',
	        data: {
	          'authToken': COSTCO.Checkout.getAuthToken(),
	          formdata: encodeURIComponent(JSON.stringify(addressData)),
	          wallet: isWallet
	        },
	        ajax_update_post_done: function ajax_update_post_done(data) {
	          var application = data.error.application;
	          if (application.length == 0) {
	            $('body').trigger("costco.address.added", data.payload.data[1]);
	
	            var responseData = data.payload.data;
	            var taxChanged = responseData && responseData.taxChanged ? true : false;
	            var refreshTokenGateway = responseData && responseData.refreshTokenGateway ? true : false;
	
	            callback(taxChanged, refreshTokenGateway);
	          } else {
	            $('body').trigger("costco.address.error", application);
	          }
	        },
	        ajax_handle_errors: function ajax_handle_errors(response_obj, mergedOptions, defaultOptions) {
	          if ($('#isBDAppVar').val() == 'BD') {
	            $('.error:not(.error-qty-increment)').empty(); // clear any errors that may be on the page
	          }
	          var error_container = mergedOptions.error_container;
	          var input_container = mergedOptions.input_container;
	          var application = response_obj.error.application || [];
	          var exception = response_obj.error.exception || [];
	          var error_html = '';
	          if (exception.length > 0) {
	            error_html += '<p>An unexpected error has occured</p>';
	          }
	          application.forEach(function (error_message) {
	            error_html += '<p>' + error_message.replace(/''/g, '\'') + '</p>';
	          });
	          // if there is a redirect, store the error in sessionStorage and redirect user,
	          // otherwise error will show in error container
	          if (response_obj.error.redirect) {
	            if (typeof sessionStorage != 'undefined') {
	              sessionStorage.setItem('errorMessage', error_html); // store error_html in sessionStorage to show on redirected page
	            }
	            document.location.href = '/' + response_obj.error.redirect;
	            return;
	          }
	          if (typeof error_container === 'string') {
	            error_container = $(error_container);
	          }
	          if (input_container) {
	            if (application.length + exception.length > 0) {
	              $(input_container).addClass('error');
	              $(input_container).attr('aria-invalid', 'true');
	            } else {
	              $(input_container).removeClass('error');
	              $(input_container).attr('aria-invalid', 'false');
	            }
	          }
	          if (error_container == '' || error_container.length == 0) {
	            $('body').trigger('costco.ajax.content.update.sucess', response_obj);
	            return;
	          }
	          error_container.children().remove();
	          error_container.append(error_html);
	          if (mergedOptions.scrollToError && COSTCO.util.has_errors(response_obj)) {
	            $('body').trigger('costco.ajax.content.update.error', response_obj);
	            $('body, html').animate({
	              scrollTop: $(error_container).offset().top - 30
	            }, 800);
	          }
	        }
	      };
	
	      COSTCO.Checkout.ajax_update_state(options);
	    },
	
	    /**
	     * Return true if AVS fields changed
	     */
	    isAddressChanged: function isAddressChanged() {
	      var currentAddressArrayForAVS = QuickRenewAddressHelper.buildAVSAddressArray();
	      if (addressArrayForAVS.length != currentAddressArrayForAVS.length) return true;
	
	      var addressChanged = false;
	      for (var i = 0; i < addressArrayForAVS.length; i++) {
	        if (addressArrayForAVS[i].fName.trim() != currentAddressArrayForAVS[i].fName.trim() || addressArrayForAVS[i].lName.trim() != currentAddressArrayForAVS[i].lName.trim() || addressArrayForAVS[i].company.trim() != currentAddressArrayForAVS[i].company.trim() || addressArrayForAVS[i].line1.trim() != currentAddressArrayForAVS[i].line1.trim() || addressArrayForAVS[i].line2.trim() != currentAddressArrayForAVS[i].line2.trim() || addressArrayForAVS[i].city != null && addressArrayForAVS[i].city.trim() != currentAddressArrayForAVS[i].city.trim() || addressArrayForAVS[i].state != null && addressArrayForAVS[i].state.trim() != currentAddressArrayForAVS[i].state.trim() || addressArrayForAVS[i].zip.trim() != currentAddressArrayForAVS[i].zip.trim() || addressArrayForAVS[i].country.trim() != currentAddressArrayForAVS[i].country.trim() || addressArrayForAVS[i].email.trim() != currentAddressArrayForAVS[i].email.trim()) {
	          addressChanged = true;
	          break;
	        }
	      }
	      addressChanged = addressChanged || $('#shipping_set_default').prop('checked') === true || $('#billing_set_default').prop('checked') === true;
	      return addressChanged;
	    },
	
	    /**
	     * Checks whether populated address is default one
	     */
	    isDefaultAddress: function isDefaultAddress(addressType) {
	      var addressTypePrefix = 'shipping_';
	      if (addressType === 'B') {
	        addressTypePrefix = 'billing_';
	      }
	      var defaultAddress = false;
	      var addressId = $('#' + addressTypePrefix + 'addressId').val();
	      if (typeof addressId !== 'undefined' && addressId.length > 0) {
	        defaultAddress = window['ajaxAddressObject_' + addressId].isPrimary === true;
	      }
	      return defaultAddress;
	    },
	
	    /**
	     * Jquery validator implementation for shipping/billing form data, specific for renew membership address form
	     */
	    isShippingBillingAddressValid: function isShippingBillingAddressValid() {
	      COSTCO.CAddressForm.validationRules();
	      var form = $('#quick-renew-address-form');
	      var isValid = true;
	      if (form.length != 0) {
	        var differentBillingAddress = $('#use-different-address-for-billing').val() == 'true';
	        form.validate({
	          focusInvalid: false,
	          invalidHandler: COSTCO.util.invalid_handler,
	          rules: {
	            shipping_firstModal: { required: true, firstNameValidation: true },
	            shipping_lastModal: { required: true, lastNameValidation: true },
	            shipping_country: "required",
	            shipping_address1: { required: true, maxlength: 30, pobox: true },
	            shipping_address2: { maxlength: 30 },
	            shipping_company: { maxlength: 40, companyrequiredcheck: true },
	            shipping_postal: { required: true, countryspecificpostalcodePassCountrySelectorModal: true },
	            shipping_city: "required",
	            shipping_state: { required: true, notEqual: "NO_STATE_TYPE_SELECTED", hasvalidationerror: true },
	            shipping_phone: { required: true, phone: true },
	            shipping_email: { required: true, email: true },
	            shipping_contactName: "required",
	            shipping_contactPhone: "phone",
	            shipping_ext1: "digits",
	            billing_firstModal: { required: true && differentBillingAddress, firstNameValidation: true },
	            billing_lastModal: { required: true && differentBillingAddress, lastNameValidation: true },
	            billing_country: differentBillingAddress ? "required" : "",
	            billing_address1: { required: true && differentBillingAddress, maxlength: 30, pobox: true },
	            billing_address2: { maxlength: 30 },
	            billing_company: { maxlength: 40, companyrequiredcheck: true },
	            billing_postal: { required: true && differentBillingAddress, countryspecificpostalcodePassCountrySelectorModal: true },
	            billing_city: differentBillingAddress ? "required" : "",
	            billing_state: { required: true && differentBillingAddress, notEqual: "NO_STATE_TYPE_SELECTED", hasvalidationerror: true },
	            billing_phone: { required: true && differentBillingAddress, phone: true },
	            billing_email: { required: true && differentBillingAddress, email: true },
	            billing_contactName: differentBillingAddress ? "required" : "",
	            billing_contactPhone: "phone",
	            billing_ext1: "digits"
	          },
	          messages: {
	            shipping_firstModal: { required: messages.ERR_INVALID_FIRSTNAME },
	            shipping_lastModal: { required: messages.ERR_INVALID_LASTNAME },
	            shipping_country: messages.ERR_INVALID_COUNTRY,
	            shipping_address1: { required: messages.ERR_INVALID_STREETADDRESS, maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH, pobox: messages.ERR_INVALID_POBOX },
	            shipping_address2: { maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH },
	            shipping_company: { maxlength: messages.ERR_INVALID_COMPANY_NAME_LENGTH, companyrequiredcheck: messages.ERR_INVALID_COMPANY },
	            shipping_postal: messages.ERR_ENTER_ZIPCODE,
	            shipping_city: messages.ERR_INVALID_CITY,
	            shipping_state: messages.ERR_INVALID_STATE,
	            shipping_phone: { required: messages.ERR_INVALID_PHONE1, phone: messages.ERR_INVALID_PHONE1 },
	            shipping_email: { required: messages.ERR_REQUIRED_EMAIL_MY, email: messages.ERR_INVALID_EMAIL },
	            shipping_contactName: messages.ERR_INVALID_CONTACT_NAME,
	            shipping_contactPhone: messages.ERR_INVALID_PHONE1,
	            shipping_ext1: messages.ERR_INVALID_EXTN_NUMBER,
	            billing_firstModal: { required: messages.ERR_INVALID_FIRSTNAME },
	            billing_lastModal: { required: messages.ERR_INVALID_LASTNAME },
	            billing_country: messages.ERR_INVALID_COUNTRY,
	            billing_address1: { required: messages.ERR_INVALID_STREETADDRESS, maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH, pobox: messages.ERR_INVALID_POBOX },
	            billing_address2: { maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH },
	            billing_company: { maxlength: messages.ERR_INVALID_COMPANY_NAME_LENGTH, companyrequiredcheck: messages.ERR_INVALID_COMPANY },
	            billing_postal: messages.ERR_ENTER_ZIPCODE,
	            billing_city: messages.ERR_INVALID_CITY,
	            billing_state: messages.ERR_INVALID_STATE,
	            billing_phone: { required: messages.ERR_INVALID_PHONE1, phone: messages.ERR_INVALID_PHONE1 },
	            billing_email: { required: messages.ERR_REQUIRED_EMAIL_MY, email: messages.ERR_INVALID_EMAIL },
	            billing_contactName: messages.ERR_INVALID_CONTACT_NAME,
	            billing_contactPhone: messages.ERR_INVALID_PHONE1,
	            billing_ext1: messages.ERR_INVALID_EXTN_NUMBER
	          },
	          errorPlacement: function errorPlacement(error, element) {
	            if (element.attr("name") == "shipping_state") {
	              element.parent().addClass('error');
	              error.insertAfter($('[name=shipping_state]').parent());
	            } else if (element.attr("name") == "shipping_country") {
	              element.parent().addClass('error');
	              error.insertAfter($('[name=shipping_country]').parent());
	            } else if (differentBillingAddress && element.attr("name") == "billing_state") {
	              element.parent().addClass('error');
	              error.insertAfter($('[name=billing_state]').parent());
	            } else if (differentBillingAddress && element.attr("name") == "billing_country") {
	              element.parent().addClass('error');
	              error.insertAfter($('[name=billing_country]').parent());
	            } else {
	              error.insertAfter(element);
	            }
	          }
	        });
	
	        var selectsValid = true;
	
	        form.find('.style-select > select').each(function () {
	          $(this).unbind('change').change(function () {
	            if ($(this).val() === "NO_STATE_TYPE_SELECTED") {
	              selectsValid = false;
	              $(this).parent().addClass('error');
	            } else {
	              $(this).parent().removeClass('error');
	              if ($(this).attr('hasvalidationerror') != undefined && $(this).attr('hasvalidationerror') != null) {
	                $(this).attr('hasvalidationerror', false);
	              }
	            }
	          });
	        });
	
	        form.find('.style-select > select').change();
	
	        isValid = form.valid() && selectsValid;
	      }
	      return isValid;
	    },
	
	    /**
	     * Use user selected address details (after AVS result is displayed to the user to choose an address),
	     * and alter original address obj that will be sent to 'address add' service with choosen values.
	     */
	    alterAddressObjectWithAVSResult: function alterAddressObjectWithAVSResult(choosenAddresses, originalAddresses) {
	
	      $.each(originalAddresses.Address, function (index, value) {
	        originalAddresses.Address[index].line1 = choosenAddresses[index].line1;
	        originalAddresses.Address[index].line2 = choosenAddresses[index].line2;
	        originalAddresses.Address[index].city = choosenAddresses[index].city;
	        originalAddresses.Address[index].state = choosenAddresses[index].state;
	        originalAddresses.Address[index].zip = choosenAddresses[index].zip;
	        originalAddresses.Address[index].country = choosenAddresses[index].country;
	      });
	
	      var finalAddressArray = {};
	      if (originalAddresses.Address.length > 0) {
	        finalAddressArray = QuickRenewAddressHelper.transormAddressObj(originalAddresses.Address[0]);
	      }
	
	      if (originalAddresses.Address.length == 2) {
	        var bTransformedAddy = QuickRenewAddressHelper.transormAddressObj(originalAddresses.Address[1]);
	        finalAddressArray = $.extend(finalAddressArray, bTransformedAddy);
	      }
	
	      return finalAddressArray;
	    },
	
	    /**
	     * This function populates a given form. Its meant to replace the values
	     * of each designated field with what the addresses selected after the
	     * verification process. We then can just serialize the form to send to the
	     * backend.
	     * @param  {jQuery} form        The form to populate
	     * @param  {Array} addresses    Array of validated addresses to get address
	     *                              details from it and send with membership
	     *                              application form.
	     * @param  {boolean} isAffiliate Are we populating the affiliate form?
	     * @return {void}
	     */
	    populateAddressData: function populateAddressData(form, addresses) {
	
	      if (addresses.length > 0) {
	        var shippingAddress = addresses[0];
	        var prefix = 'shipping_';
	        QuickRenewAddressHelper.populateAddressFormElement(form, shippingAddress, prefix);
	
	        if (addresses.length > 1) {
	          var billingAddress = addresses[1];
	          var _prefix = 'billing_';
	          QuickRenewAddressHelper.populateAddressFormElement(form, billingAddress, _prefix);
	        }
	      }
	    },
	
	    /**
	     * Populate etither shipping or billing form inputs with what user has choosen after AVS suggestion
	     */
	    populateAddressFormElement: function populateAddressFormElement(form, address, prefix) {
	      form.find('input[name=' + prefix + 'address1],input[name=' + prefix + 'line1]').val(address.line1);
	      form.find('input[name=' + prefix + 'address2],input[name=' + prefix + 'line2]').val(address.line2);
	
	      var addressCity = costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED && $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === "true" ? COSTCO.CAddressForm.matchCityOption(form.find('[name=' + prefix + 'city]'), address.city) : address.city;
	
	      form.find('[name=' + prefix + 'city]').val(addressCity);
	      form.find('select[name=' + prefix + 'state]').val(address.state);
	      form.find('input[name=' + prefix + 'postalcode],input[name=' + prefix + 'zip]').val(address.zip);
	      form.find('input[name=' + prefix + 'country]').val(address.country);
	    },
	
	    /*
	     * Build Address Array for AVS from a query selector.
	     * Based on address type it gets data from shipping/billing form section using prefixes shipping_/billing_
	     */
	    buildAVSAddressArray: function buildAVSAddressArray() {
	      var shippingAddress = QuickRenewAddressHelper.buildAddressObjByType('S');
	      var billingAddress = QuickRenewAddressHelper.buildAddressObjByType('B');
	
	      var addressArray = [];
	      if (QuickRenewAddressHelper.isAddressNotEmpty(shippingAddress)) {
	        addressArray.push(shippingAddress);
	      }
	
	      if (QuickRenewAddressHelper.isAddressNotEmpty(billingAddress)) {
	        addressArray.push(billingAddress);
	      }
	
	      $.each(addressArray, function (index, value) {
	        if (value.id == '') {
	          addressArray[index].id = index;
	        }
	      });
	
	      return addressArray;
	    },
	
	    /**
	     * Build a clean address object by stripping shipping_/billing_ prefixes from address input form elements.
	     * New address object will be passed to AVS service who only understand clean field names.
	     * @param {string} type Address type. Defaults to 'S', otherwise it can accpet 'B' as well
	     */
	    buildAddressObjByType: function buildAddressObjByType(type) {
	      var addressObject = {};
	      var _baseAddr = $('#quick-renew-address-form');
	
	      var addressPrefix = 'shipping_';
	      var label = 'Shipping Address';
	      if (type == 'B') {
	        addressPrefix = 'billing_';
	        label = 'Billing Address';
	      }
	
	      addressObject['id'] = _baseAddr.find('[name=' + addressPrefix + 'addressId]').val() ? _baseAddr.find('[name=' + addressPrefix + 'addressId]').val() : '';
	      addressObject['fName'] = _baseAddr.find('#' + addressPrefix + 'firstId').val();
	      addressObject['lName'] = _baseAddr.find('#' + addressPrefix + 'lastId').val();
	      addressObject['company'] = _baseAddr.find('[name=' + addressPrefix + 'company]').val();
	      addressObject['country'] = _baseAddr.find('[name=' + addressPrefix + 'country]').val();
	      addressObject['line1'] = _baseAddr.find('[name=' + addressPrefix + 'address1]').val();
	      addressObject['line2'] = _baseAddr.find('[name=' + addressPrefix + 'address2]').val();
	      addressObject['zip'] = _baseAddr.find('[name=' + addressPrefix + 'postal]').val();
	      addressObject['city'] = _baseAddr.find('[name=' + addressPrefix + 'city]').val();
	      addressObject['state'] = _baseAddr.find('[name=' + addressPrefix + 'state]').val();
	
	      var pNumber = _baseAddr.find('[name=' + addressPrefix + 'phone]');
	      if (pNumber.length > 0) {
	        addressObject['pNumber'] = pNumber.cleanVal();
	      }
	
	      addressObject['nickname'] = _baseAddr.find('[name=' + addressPrefix + 'nickname]').val();
	      addressObject['email'] = _baseAddr.find('[name=' + addressPrefix + 'email]').val();
	      addressObject['mInitial'] = _baseAddr.find('[name=' + addressPrefix + 'mInitial]').val();
	      addressObject['addressType'] = type;
	      addressObject['label'] = label;
	      addressObject['setDefault'] = _baseAddr.find('[name=' + addressPrefix + 'set_default]').prop('checked');
	
	      return addressObject;
	    },
	
	    /**
	     * Checks if address object is not empty. It is enough to verify if first name is not present.
	     */
	    isAddressNotEmpty: function isAddressNotEmpty(addressObj) {
	      if (addressObj && addressObj.fName && addressObj.fName.length > 0) {
	        return true;
	      } else {
	        return false;
	      }
	    },
	
	    /**
	     * Transofrms address JSON obj to format accepted by QuickRenewManageAddressHandler.
	     * This assumes that depending on the address type S/B we have to append specific prefix to
	     * each of the JSON names e.g. for address type 'S' change 'fName' to 'shipping_fName'
	     */
	    transormAddressObj: function transormAddressObj(origAddress) {
	
	      var addressPrefix = 'shipping_';
	      if (origAddress.addressType == 'B') {
	        addressPrefix = 'billing_';
	      }
	
	      var transformed = {};
	
	      transformed[addressPrefix + 'id'] = origAddress.id;
	      transformed[addressPrefix + 'fName'] = origAddress.fName;
	      transformed[addressPrefix + 'lName'] = origAddress.lName;
	      transformed[addressPrefix + 'company'] = origAddress.company;
	      transformed[addressPrefix + 'country'] = origAddress.country;
	      transformed[addressPrefix + 'line1'] = origAddress.line1;
	      transformed[addressPrefix + 'line2'] = origAddress.line2;
	      transformed[addressPrefix + 'zip'] = origAddress.zip;
	      transformed[addressPrefix + 'city'] = origAddress.city;
	      transformed[addressPrefix + 'state'] = origAddress.state;
	      transformed[addressPrefix + 'pNumber'] = origAddress.pNumber;
	      transformed[addressPrefix + 'nickname'] = origAddress.nickname;
	      transformed[addressPrefix + 'email'] = origAddress.email;
	      transformed[addressPrefix + 'mInitial'] = origAddress.mInitial;
	      transformed[addressPrefix + 'addressType'] = origAddress.addressType;
	      transformed[addressPrefix + 'setDefault'] = origAddress.setDefault;
	
	      return transformed;
	    },
	
	    /**
	     * Creates inline address form.
	     * @return {void}
	     */
	    createInlineAddressForm: function createInlineAddressForm(shippingAddressId, billingAddressId) {
	
	      var addressType = 'S';
	
	      var template = COSTCO.util.tmpl('tmpl_quick_renew_address_form', {});
	      template = $(template);
	
	      var shippingTemplate = COSTCO.util.tmpl('tmpl_quick_renew_address_form_shipping_data', {});
	      shippingTemplate = $(shippingTemplate);
	
	      QuickRenewAddressHelper.populateCountryState(shippingTemplate, addressType);
	      QuickRenewAddressHelper.bindZipCodeChangeEvents(shippingTemplate, addressType);
	
	      shippingTemplate.find('#use-different-address-for-billing').click(function () {
	        var showBillingAddress = false;
	        if ($(this).prop('checked')) {
	          showBillingAddress = true;
	        }
	        QuickRenewAddressHelper.showBillingAddressForm(template, showBillingAddress, billingAddressId);
	      });
	
	      QuickRenewAddressHelper.populateAddress(shippingTemplate, shippingAddressId);
	
	      QuickRenewAddressHelper.maskAddressInputs(shippingTemplate, addressType);
	
	      template.find('#quick-renew-shipping-data').html(shippingTemplate);
	
	      $('#address-block-shipping-billing').html(template);
	
	      addressArrayForAVS = QuickRenewAddressHelper.buildAVSAddressArray();
	
	      QuickRenewAddressHelper.displayCityState(template, 'shipping_');
	    },
	
	    /**
	     * Show/hide billing address form section.
	     * @param {object} template
	     * @param {boolean} show
	     * @return {void}
	     */
	    showBillingAddressForm: function showBillingAddressForm(template, show, billingAddressId) {
	      if (show) {
	
	        var addressType = 'B';
	
	        var billingTemplate = COSTCO.util.tmpl('tmpl_quick_renew_address_form_billing_data', {});
	        billingTemplate = $(billingTemplate);
	
	        QuickRenewAddressHelper.populateCountryState(billingTemplate, addressType);
	
	        QuickRenewAddressHelper.bindZipCodeChangeEvents(billingTemplate, addressType);
	
	        QuickRenewAddressHelper.populateAddress(billingTemplate, billingAddressId);
	        QuickRenewAddressHelper.maskAddressInputs(billingTemplate, addressType);
	
	        template.find('#quick-renew-billing-data').html(billingTemplate);
	        var billingAddress = QuickRenewAddressHelper.buildAddressObjByType('B');
	        addressArrayForAVS.push(billingAddress);
	      } else {
	        $(template.find('#quick-renew-billing-data')).empty();
	        if (addressArrayForAVS.length > 1) {
	          addressArrayForAVS.pop();
	        }
	      }
	
	      QuickRenewAddressHelper.handleDefaultAddressCheckboxes(show);
	      QuickRenewAddressHelper.displayCityState(template, 'billing_');
	    },
	
	    /**
	     * Populates country/state.
	     * @param {object} template
	     * @param {string} addressType
	     * @return {void}
	     */
	    populateCountryState: function populateCountryState(template, addressType) {
	
	      var isDeriveCityStateEnabled = costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED && $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === "true";
	      var stateProvList = COSTCO.CAddress.getStateProvJson();
	      var stateOptions = COSTCO.CAddressForm.getStateOptions(stateProvList, addressType);
	
	      if (!isDeriveCityStateEnabled) {
	        template.find('.stateprov-select').append(stateOptions);
	      }
	
	      var countryOptions = COSTCO.CAddressForm.getCountryOptions(addressType);
	
	      template.find('.country-select').append(countryOptions).change(function () {
	        var country = $(this).val();
	        var stateOptions = COSTCO.CAddressForm.getStateOptions(stateProvList, addressType, { country: country });
	        if (!isDeriveCityStateEnabled) {
	          template.find('.stateprov-select').empty().append(stateOptions);
	        }
	        QuickRenewAddressHelper.updateCountryLabels(template, country, addressType);
	        QuickRenewAddressHelper.maskAddressInputs(template, addressType);
	      });
	    },
	
	    /**
	     * Update labels depending on selected country.
	     * 
	     * @param {object} template
	     * @param {string} country
	     * @param {string} addressType
	     * @return {void}
	     */
	    updateCountryLabels: function updateCountryLabels(template, country, addressType) {
	      var addressTypePrefix = 'shipping_';
	      if (addressType === 'B') {
	        addressTypePrefix = 'billing_';
	      }
	
	      if (country == 'US') {
	        template.find('label[for="' + addressTypePrefix + 'postalId"]').html(addressInputLabels.uspostallabel);
	        template.find('label[for="' + addressTypePrefix + 'stateId"]').html(addressInputLabels.usstatelabel);
	      } else {
	        template.find('label[for="' + addressTypePrefix + 'postalId"]').html(addressInputLabels.capostallabel);
	        template.find('label[for="' + addressTypePrefix + 'stateId"]').html(addressInputLabels.castatelabel);
	      }
	    },
	
	    /**
	     * Populates address.
	     * @param {string} addresId
	     * @return {void}
	     */
	    populateAddress: function populateAddress(template, addressId) {
	      var address = window['ajaxAddressObject_' + addressId];
	      var addressPrefix = 'shipping_';
	      if (address && address.addressType === 'B') {
	        addressPrefix = 'billing_';
	      }
	
	      if (address) {
	        $(template).find('#' + addressPrefix + 'addressId').val(address.id);
	        $(template).find('#' + addressPrefix + 'firstId').val(address.first);
	        $(template).find('#' + addressPrefix + 'lastId').val(address.last);
	        $(template).find('#' + addressPrefix + 'companyId').val(address.company);
	        $(template).find('#' + addressPrefix + 'countryId').val(address.country);
	        $(template).find('#' + addressPrefix + 'address1Id').val(address.line1);
	        $(template).find('#' + addressPrefix + 'address2Id').val(address.line2);
	        $(template).find('#' + addressPrefix + 'postalId').val(address.zip);
	
	        if (costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED && $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === "true") {
	          var savedAddrCity = address.city;
	          var savedAddrState = address.state;
	          if (savedAddrCity && savedAddrState) {
	            COSTCO.CAddress.geocodeApiCityState($(template).find('#' + addressPrefix + 'postalId'), '[name=' + addressPrefix + 'city]', '[name=' + addressPrefix + 'state]', savedAddrCity, savedAddrState);
	          }
	        } else {
	          $(template).find('#' + addressPrefix + 'cityId').val(address.city);
	          $(template).find('#' + addressPrefix + 'stateId').val(address.state);
	        }
	
	        $(template).find('#' + addressPrefix + 'phoneId').val(address.phone);
	        $(template).find('#' + addressPrefix + 'nickname').val(address.nickname);
	        $(template).find('#' + addressPrefix + 'emailId').val(address.email);
	        $(template).find('#' + addressPrefix + 'mInitial').val(address.mInitial);
	        $(template).find('#' + addressPrefix + 'addressType').val(address.addressType);
	      }
	    },
	
	    /**
	     * Uses Jquery Mask plugin to format input.
	     * Use cleanVal() instead of val() to get unformatted value
	     * @param {object} template
	     * @param {string} addressType
	     * @return {void}
	     */
	    maskAddressInputs: function maskAddressInputs(template, addressType) {
	
	      var addressTypePrefix = 'shipping_';
	      if (addressType === 'B') {
	        addressTypePrefix = 'billing_';
	      }
	
	      $(template).find('#' + addressTypePrefix + 'phoneId').unmask().mask('000-000-0000');
	      $(template).find('#' + addressTypePrefix + 'contactPhNo').unmask().mask('000-000-0000');
	
	      if (QuickRenewAddressHelper.isUS(addressTypePrefix)) {
	        $(template).find('#' + addressTypePrefix + 'postalId').unmask().mask('00000-0000');
	      } else {
	        $(template).find('#' + addressTypePrefix + 'postalId').unmask().mask('S0S 0S0');
	      }
	    },
	
	    /**
	     * check is selected country US
	     * 
	     * @param {string} addressTypePrefix
	     *  
	     */
	    isUS: function isUS(addressTypePrefix) {
	      var form = $('#quick-renew-address-form');
	
	      var country = 'US';
	
	      if ($(form).find('[name=' + addressTypePrefix + 'country]').val() != 'undefined' && $(form).find('[name=' + addressTypePrefix + 'country]').val() != null) {
	        country = $(form).find('[name=' + addressTypePrefix + 'country]').val();
	      } else {
	        if (COSTCO.util.getLangId() != -1) {
	          country = 'CA';
	        }
	      }
	      return country == 'US';
	    },
	
	    /**
	     * Binds ZIP code change events.
	     * @param {object} template
	     * @param {string} addressType
	     * @return {void}
	     */
	    bindZipCodeChangeEvents: function bindZipCodeChangeEvents(template, addressType) {
	      var addressTypePrefix = 'shipping_';
	      if (addressType === 'B') {
	        addressTypePrefix = 'billing_';
	      }
	
	      template.find('[name=' + addressTypePrefix + 'postal]').on('input', function (event) {
	        var value = $(this).val();
	        var region = COSTCO.util.isUsOrCaZipCode();
	        if ($('#isGeocodeService').val() != "true" && value != null && value != "" && value.trim().length > 4) {
	          COSTCO.CAddress.bingCityState(this, '[name=' + addressTypePrefix + 'city]', '[name=' + addressTypePrefix + 'state]');
	        }
	        if ($('#isGeocodeService').val() === "true" && value != null && value != "" && value.trim().length === value.length) {
	          if (region && COSTCO.util.POSTAL_CODE_REGEX_US.test(value.trim())) {
	            COSTCO.CAddress.geocodeApiCityState(this, '[name=' + addressTypePrefix + 'city]', '[name=' + addressTypePrefix + 'state]');
	          }
	          if (!region) {
	            if (value.trim().length === 3 && /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1}/.test(value.trim()) || value.trim().length === 7 && COSTCO.util.POSTAL_CODE_REGEX_CA.test(value.trim())) COSTCO.CAddress.geocodeApiCityState(this, '[name=' + addressTypePrefix + 'city]', '[name=' + addressTypePrefix + 'state]');
	          }
	        }
	
	        QuickRenewAddressHelper.displayCityState(template, addressTypePrefix);
	      });
	    },
	
	    /**
	     * Handles default address checkboxes: states and labels
	     * @param {boolean} billingAddressFormDisplayed 
	     */
	    handleDefaultAddressCheckboxes: function handleDefaultAddressCheckboxes(billingAddressFormDisplayed) {
	      if (billingAddressFormDisplayed) {
	        $('#shipping_set_default_span').text(addressInputLabels.setDefaultShipping);
	        $('#billing_set_default_span').text(addressInputLabels.setDefaultBilling);
	        $('#billing_set_default').prop('checked', $('#shipping_set_default').prop('checked'));
	      } else {
	        $('#shipping_set_default_span').text(addressInputLabels.setDefaultShippingAndBilling);
	      }
	    },
	
	    /**
	     * Displays the City and State fields after the default address data has been populated
	     */
	    displayCityState: function displayCityState(template, addressTypePrefix) {
	      if (template.find('#' + addressTypePrefix + 'postalId') != undefined && template.find('#' + addressTypePrefix + 'postalId').val() != '') {
	        template.find('#' + addressTypePrefix + 'city-state').removeClass('hide');
	      }
	    },
	
	    /**
	     * Opens default address change modal
	     */
	    openDefaultAddressChangeInfoModal: function openDefaultAddressChangeInfoModal(onConfirmCallback) {
	      COSTCO.dialog.createExtDialogBox({
	        title: messages.JS_CHANGE_DEFAULT_ADDRESS_TITLE,
	        body: $('#tmpl_quick_renew_default_address_info_dialog').html(),
	        primary: messages.JS_DIALOG_ACCEPT,
	        primary_event: function primary_event() {
	          COSTCO.QuickRenewAddressHelper.submitAddress(onConfirmCallback);
	        },
	        secondary: messages.JS_DIALOG_CANCEL
	      });
	    },
	
	    /**
	     */
	    configureAddressesSectionBasedOnPaymentType: function configureAddressesSectionBasedOnPaymentType(billingType) {
	
	      if (COSTCO.MembershipHelper.isQuickMembership) {
	        var quickRenew = $('#quick-renew-address-section').length > 0 ? true : false;
	
	        if (quickRenew) {
	          if (billingType == 'wallet') {
	            $('#quick-renew-address-section h4')[0].innerText = 'Shipping Address';
	            $('#use-different-address-for-billing').closest('.address-checkboxes').hide();
	            $('#shipping_set_default_span').text(addressInputLabels.setDefaultShipping);
	            $('#quick-renew-billing-data').hide();
	          } else {
	            $('#quick-renew-address-section h4')[0].innerText = 'Shipping and Billing Address';
	            $('#use-different-address-for-billing').closest('.address-checkboxes').show();
	            $('#shipping_set_default_span').text(addressInputLabels.setDefaultShippingAndBilling);
	            $('#quick-renew-billing-data').show();
	          }
	        } else {
	          if (billingType == 'wallet') {
	            $('#address-block-billing').parent().hide();
	          } else {
	            $('#address-block-billing').parent().show();
	          }
	        }
	      }
	    }
	  };
	
	  if (typeof window.COSTCO === "undefined") {
	    window.COSTCO = new Object();
	  }
	
	  window.COSTCO.QuickRenewAddressHelper = QuickRenewAddressHelper;
	
	  return QuickRenewAddressHelper;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title application.js: Feature level module
	 * @description The interface for membership application. These methods
	 *              are bound in /MembershipApplicationView
	 *              (NewMembershipApplicationBody.jsp) and use applicationForm
	 *              for primary membership interaction and applicationAffiliateForm
	 *              for affiliate interaction.
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(94), __webpack_require__(22), __webpack_require__(11)], __WEBPACK_AMD_DEFINE_RESULT__ = function (appForm, affForm, helper) {
	  var Application = {
	    /**
	     * Initialize the application specific functions
	     * @return {void}
	     */
	    init: function init() {
	      helper.init();
	      appForm.init();
	      affForm.init();
	      this.applicationPreprocesses();
	    },
	    /**
	     * This process is responsible for grabbing application meta
	     * data (configProduct) and setting inputs and then populating
	     * any affiliates that exist.
	     * @return {void}
	     */
	    applicationPreprocesses: function applicationPreprocesses() {
	      helper.getApplicationData().then(helper.prepopulateForm).then(helper.reflectAffiliates).fail(function (err) {
	        var message = 'Couldn\'t fetch membership application data';
	        console.error(message + ' ' + JSON.stringify(err.errorMessages, null, 2));
	        var appType = $('#applicationType').val();
	        if (appType === 'BD') {
	          window.location.href = '/CheckoutCartView';
	        }
	      });
	    },
	    /**
	     * Main function and inline event hanlder for "Submit and Continue"
	     * for adding personal inforamtion / businss inforamtion to the
	     * application.
	     * @return {void} [description]
	     */
	    addMember: function addMember() {
	      if (appForm.validate()) {
	        // Pages using this: QuickMembershipApplicationBody.jsp,
	        $('.permanent-ajax-busy').addClass('ajax-busy');
	        helper
	        // Attempt to call address verification service
	        .verifyAddresses({
	          form: '#MemberAddressBookForm',
	          primary: helper.personalAddressSelectors,
	          business: helper.businessAddressSelectors
	        })
	        // If the service returns successfully (200), invoke the modal
	        // and use the addresses the user selects
	        .then(function (verifyResponse) {
	          return helper.invokeMultiAVS(verifyResponse, appForm.submitContinue);
	        })
	        // If the service fails, we still want to submit the form using
	        // the addresses the user provided initially
	        .fail(appForm.submitContinue);
	      }
	    },
	    /**
	     * 
	     */
	    cancelMemberApplication: function cancelMemberApplication() {
	      if (document.referrer === "") {
	        window.location.href = '/CheckoutCartView';
	      } else if (document.referrer.includes('/QuickMembershipTermsConditionsView')) {
	        window.location.href = '/join-costco.html';
	      } else {
	        window.location.href = DOMPurify.sanitize(document.referrer);
	      }
	    },
	    /**
	     * This is the main function (and inline event handler) for
	     * adding a person (affiliate) to the membership application.
	     * This functionality has a dependency on the personal / business
	     * info being submitted first.
	     * @return {void} [description]
	     */
	    addPerson: function addPerson() {
	      var configProduct = helper.getConfigProduct();
	      // 1. Click "Add Person"
	      // If configproduct is empty or configProduct.type is empty or undefined
	      // Proceed to 2. Else Proceed to 5
	      if ($.isEmptyObject(configProduct) || !configProduct.type) {
	        $('.permanent-ajax-busy').addClass('ajax-busy');
	        // 2. Validate the personal information, business information, and
	        //  household (if entered).
	        if (appForm.validate()) {
	          helper
	          // 3. If validated, execute address verification on the personal and
	          //  business addresses. (/AjaxAddressVerificationCmd)
	          .verifyAddresses({
	            form: '#MemberAddressBookForm',
	            primary: helper.personalAddressSelectors,
	            business: helper.businessAddressSelectors
	          })
	          // 4. If the service returns successfully (200), invoke the modal
	          // and use the addresses the user selects
	          .then(function (verifyResponse) {
	            return helper.invokeMultiAVS(verifyResponse, appForm.submitInvokeAddPersonModal);
	          })
	          // 5. If the service fails, we still want to submit the form using
	          // the addresses the user provided initially and then open the
	          // add person modal
	          .fail(appForm.submitInvokeAddPersonModal);
	        }
	      } else {
	        // 5. Invoke the Add Person Modal (limit 6 additional people)
	        affForm.openAddPersonModal();
	      }
	      $('.permanent-ajax-busy').removeClass('ajax-busy');
	    },
	    /**
	     * Remove a person (affiliate) from the membership application
	     * @param  {Number} membershipNumber The affiliate membership number
	     * @return {void}
	     */
	    removePerson: function removePerson(membershipNumber) {
	      var affiliate = helper.getAffiliateByNumber(membershipNumber);
	      affForm.removePerson({
	        affiliate: affiliate,
	        action: 'remove'
	      });
	    },
	    /**
	     * Remove a person's (affiliate) household from the membership applciation
	     * @param  {Number} membershipNumber The affiliate household membership num
	     * @return {void}
	     */
	    removePersonHousehold: function removePersonHousehold(membershipNumber) {
	      var affiliate = helper.getAffiliateByHouseholdNumber(membershipNumber);
	      affForm.removePerson({
	        affiliate: affiliate,
	        action: 'remove-household'
	      });
	    },
	    /**
	     * Edit a person (affiliate) from the membership application
	     * @param  {Number} membershipNumber The affiliate membership number
	     * @return {void}
	     */
	    editPerson: function editPerson(membershipNumber) {
	      var affiliate = helper.getAffiliateByNumber(membershipNumber);
	      affForm.editPerson({
	        affiliate: affiliate,
	        action: 'update'
	      });
	    },
	    /**
	     * "Adding a person within household" is really a variation on editing the
	     * affiliate and selecting the checkbox that shows the household fields.
	     * @param  {Number} membershipNumber The Affiliate membershipNumber
	     * @return {void}
	     */
	    addPersonWithinHousehold: function addPersonWithinHousehold(membershipNumber) {
	      var affiliate = helper.getAffiliateByNumber(membershipNumber);
	      affForm.editPerson({
	        affiliate: affiliate,
	        action: 'update',
	        addHousehold: true
	      });
	    },
	    /**
	     * "Editing a person within household" is really a variation on editing the
	     * affiliate and selecting the checkbox that shows the household fields.
	     * @param  {Number} membershipNumber The Affiliate membershipNumber
	     * @return {void}
	     */
	    editPersonWithinHousehold: function editPersonWithinHousehold(membershipNumber) {
	      var affiliate = helper.getAffiliateByNumber(membershipNumber);
	      affForm.editPerson({
	        affiliate: affiliate,
	        action: 'update',
	        editHousehold: true
	      });
	    }
	  };
	  if (typeof window.COSTCO === 'undefined') {
	    window.COSTCO = {};
	  }
	  window.COSTCO.Application = Application;
	  return Application;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title application-form.js: Feature level module
	 * @description Membership application form functionality
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(11), __webpack_require__(13)], __WEBPACK_AMD_DEFINE_RESULT__ = function (helper, addressForm) {
	  var ApplicationForm = {
	    /**
	     * Initialize the module
	     * @return {void}
	     */
	    init: function init() {
	      // Now rendering os part of the JSP.
	      // this.createInline();
	      helper.formWizBangs(this.getForm());
	      this.promotionalHandlers();
	      this.defaultAddressHandler();
	    },
	
	    defaultAddressHandler: function defaultAddressHandler() {
	      var $defaultAddressCheckbox = $('#set-default');
	      var $defaultWarning = $('.defaultWarning.kb-OOS-banner');
	      $defaultAddressCheckbox.change(function () {
	        if ($defaultAddressCheckbox.is(':checked')) {
	          $defaultWarning.show();
	          $defaultAddressCheckbox.prop('value', true);
	        } else if (!$defaultAddressCheckbox.is(':checked')) {
	          $defaultWarning.hide();
	          $defaultAddressCheckbox.prop('value', false);
	        }
	      });
	    },
	    /**
	     * Determines the elements we need for which ever application we're
	     * looking at.
	     * @return {void}
	     */
	    createInline: function createInline() {
	      var elements = [];
	      // Personal Information Template
	      elements.push(['#primary-membership-block', 'tmpl_personal_info']);
	      // Business Information Template
	      if (helper.isBusinessMembership()) {
	        elements.push(['#business-membership-block', 'tmpl_business_info']);
	      }
	      // Household Template
	      elements.push(['#household-membership-block', 'tmpl_household_info']);
	      // Preferences Template
	      elements.push(['#checkboxes-membership-block', 'tmpl_checkboxes_membership']);
	      for (var i = 0; i < elements.length; i++) {
	        var placeholderId = elements[i][0];
	        var templateId = elements[i][1];
	        var html = ApplicationForm.createHtml(templateId);
	        $(placeholderId).html(html);
	      }
	    },
	    promotionalHandlers: function promotionalHandlers() {
	      // Costco connection is hidden for goldstar basic; defaulted for this product number on backend
	      // if (ApplicationStaticContent.productNumber == "35669") { $('.receivePromosAndMarketingCostcoConnection').hide() };
	      var $promoCheckboxes = $('.viewModeElement');
	      $promoCheckboxes.each(function (index, box) {
	        $(box).change(function () {
	          if ($(box).is(':checked')) {
	            $(box).val('off');
	          } else if (!$(box).is(':checked')) {
	            $(box).val('on');
	          }
	        });
	      });
	      if (typeof wcs.locale != 'undefined' && wcs.locale == 'en_US') {
	        $promoCheckboxes.each(function (index, box) {
	          // $(box).removeAttr('checked').change();
	          $(box).attr('checked', 'checked').change();
	        });
	      } else if (typeof wcs.locale != 'undefined' && (wcs.locale == 'en_CA' || wcs.locale == 'fr_CA')) {
	        $promoCheckboxes.each(function (index, box) {
	          $(box).removeAttr('checked').change();
	        });
	      }
	    },
	    /**
	     * [description]
	     * @param  {[type]} template [description]
	     * @param  {[type]} inputObj [description]
	     * @param  {[type]} error    [description]
	     * @return {[type]}          [description]
	     */
	    createHtml: function createHtml(template, inputObj, error) {
	      template = $(COSTCO.util.tmpl(template, {}));
	      if (template.find('.state-select').length) {
	        var stateProvList = helper.getStateProvJson();
	        var stateOptions = helper.getStateOptions(stateProvList);
	        template.find('.state-select').append(stateOptions);
	      }
	      if (typeof error != 'undefined') {
	        template.find('.error').html(error);
	      }
	      template.find('[name=postalcode]').on('input', function (event) {
	        var value = $(event.currentTarget).val();
	        var region = COSTCO.util.isUsOrCaZipCode();
	        if ($('#isGeocodeService').val() != "true" && value != null && value != "" && value.trim().length > 4) {
	          helper.bingCityState(event.currentTarget, '[name=city]', '[name=state]');
	        }
	        if ($('#isGeocodeService').val() === "true" && value != null && value != "" && value.trim().length === value.length) {
	          if (region && COSTCO.util.POSTAL_CODE_REGEX_US.test(value.trim())) {
	            helper.geocodeApiCityState(event.currentTarget, '[name=city]', '[name=state]');
	          }
	          if (!region) {
	            if (value.trim().length === 3 && /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1}/.test(value.trim()) || value.trim().length === 7 && COSTCO.util.POSTAL_CODE_REGEX_CA.test(value.trim())) helper.geocodeApiCityState(event.currentTarget, '[name=city]', '[name=state]');
	          }
	        }
	      });
	      template.find('[name=businessZipCode]').on('input', function (event) {
	        var value = $(event.currentTarget).val();
	        var region = COSTCO.util.isUsOrCaZipCode();
	        if ($('#isGeocodeService').val() != "true" && value != null && value != "" && value.trim().length > 4) {
	          helper.bingCityState(event.currentTarget, '[name=businessCity]', '[name=businessState]');
	        }
	        if ($('#isGeocodeService').val() === "true" && value != null && value != "" && value.trim().length === value.length) {
	          if (region && COSTCO.util.POSTAL_CODE_REGEX_US.test(value.trim())) {
	            helper.geocodeApiCityState(event.currentTarget, '[name=businessCity]', '[name=businessState]');
	          }
	          if (!region) {
	            if (value.trim().length === 3 && /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1}/.test(value.trim()) || value.trim().length === 7 && COSTCO.util.POSTAL_CODE_REGEX_CA.test(value.trim())) helper.geocodeApiCityState(event.currentTarget, '[name=businessCity]', '[name=businessState]');
	          }
	        }
	      });
	      helper.dobPopulate(template, 100);
	      helper.maskInput(template);
	      return template;
	    },
	    /**
	     * [description]
	     * @return {[type]} [description]
	     */
	    validate: function validate() {
	      // Override $.validate.methods to accommodate Mmeber Application context.
	      helper.addValidationMethods(this.getForm());
	      var rules = null;
	      var messages = null;
	      if (helper.isBusinessMembership()) {
	        rules = helper.business.rules;
	        messages = helper.business.messages();
	      } else {
	        rules = helper.goldstar.rules;
	        messages = helper.goldstar.messages();
	      }
	      helper.addHouseholdRules(rules, undefined, messages);
	
	      this.getForm().find('.style-select > select').each(function () {
	        $(this).unbind('change').change(function () {
	          if ($(this).val() === "NO_STATE_TYPE_SELECTED") {
	            selectsValid = false;
	            $(this).parent().addClass('error');
	          } else {
	            $(this).parent().removeClass('error');
	            if ($(this).attr('hasvalidationerror') != undefined && $(this).attr('hasvalidationerror') != null) {
	              $(this).attr('hasvalidationerror', false);
	            }
	            var addressType = $('#addressType').val();
	            if (addressType != 'S') {
	              var additionalBilllingStates = addressForm.getAdditionalBillingStates();
	              addressForm.hideCheckboxForAdditionalTerritories($(this).val(), additionalBilllingStates);
	            }
	          }
	        });
	      });
	      this.getForm().find('.style-select > select').change();
	      if (rules && messages) {
	        this.getForm().validate({
	          invalidHandler: COSTCO.util.invalid_handler,
	          rules: rules,
	          messages: messages
	        });
	        return this.getForm().valid();
	      } else {
	        return false;
	      }
	    },
	    /**
	     * [description]
	     * @return {[type]} [description]
	     */
	    getForm: function getForm() {
	      return $('#MemberAddressBookForm');
	    },
	    /**
	     * [description]
	     * @param  {[type]} addresses [description]
	     * @return {jQuery.Deferred} Returns a deferred object that is chainable
	     */
	    submit: function submit(addresses) {
	      var appForm = ApplicationForm;
	      addresses = Array.isArray(addresses) // Test if we have valid addresses
	      ? addresses // Using the addresses passed to "submit"
	      : helper.buildAddressArray(this.getForm(), {
	        primary: helper.personalAddressSelectors,
	        business: helper.businessAddressSelectors
	      }); // using original addresse from user input
	      helper.populateAddressData(this.getForm(), addresses);
	      var formData = COSTCO.ApplicationForm.setDefaultDayValue(appForm.getForm().serializeArray());
	      $('.order-ajax').addClass('ajax-busy');
	      return COSTCO.util.ajax({
	        type: 'POST',
	        url: '/MemberApplicationAddCmd',
	        dataType: 'json',
	        global: false,
	        data: formData,
	        always: function always() {
	          $('.order-ajax').removeClass('ajax-busy');
	        },
	        complete: function complete() {}
	      });
	    },
	    setDefaultDayValue: function setDefaultDayValue(formData) {
	      var dayIsOptional = $('#dobYearMonthMandatoryFlag').val() === 'true';
	      if (dayIsOptional) {
	        return formData.map(function (formElement) {
	          if ((formElement.name == "day" || formElement.name == "household_day") && formElement.value === "") {
	            formElement.value = "1";
	          }
	          return formElement;
	        });
	      } else {
	        return formData;
	      }
	    },
	    /**
	     * Redirect to fromPage parameter or cart depending on if we didn't
	     * get any errors.
	     * @param  {Object} data The configProduct returned from the ajax call
	     * @return {Object}      The configProduct for chaining.
	     */
	    redirect: function redirect(data) {
	      if (!data.error) {
	        var fromCheckout = false;
	        if (document.referrer.indexOf('Checkout') != -1) {
	          fromCheckout = true;
	        }
	        window.location.href = '/QuickMembershipCheckoutCmd?langId=' + wcs.langId + '&storeId=' + wcs.storeId + '&catalogId=' + wcs.catalogId;
	      } else {
	        // Remove ajax-busy as the user stays on page and must be able to edit data
	        $('.permanent-ajax-busy').removeClass('ajax-busy');
	      }
	      return data;
	    },
	    /**
	     * [description]
	     * @param  {[type]} addresses [description]
	     * @return {[type]}           [description]
	     */
	    submitContinue: function submitContinue(addresses) {
	      return COSTCO.ApplicationForm.submit(addresses)
	      // The call to /MemberApplicationAddCmd returns configProduct
	      .then(helper.setConfigProduct)
	      // If we have errors, display them.
	      .then(helper.handleErrors)
	      // If we're done, we're redirecting somewhere
	      .then(COSTCO.ApplicationForm.redirect);
	    },
	    /**
	     * [description]
	     * @param  {[type]} addresses [description]
	     * @return {[type]}           [description]
	     */
	    submitInvokeAddPersonModal: function submitInvokeAddPersonModal(addresses) {
	      return COSTCO.ApplicationForm.submit(addresses)
	      // The call to /MemberApplicationAddCmd returns configProduct
	      .then(helper.setConfigProduct)
	      // If we have errors, display them.
	      .then(helper.handleErrors)
	      // Invoke the add person modal.
	      .then(COSTCO.AffiliateForm.openAddPersonModal);
	    }
	  };
	  if (typeof window.COSTCO === 'undefined') {
	    window.COSTCO = {};
	  }
	  window.COSTCO.ApplicationForm = ApplicationForm;
	  return ApplicationForm;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title quick-application.js: Feature level module
	 * @description The interface for quick membership application. These methods
	 *              are bound in /QuickMembershipApplicationView
	 *              (QuickMembershipApplicationBody.jsp) and use applicationForm
	 *              for primary membership interaction and applicationAffiliateForm
	 *              for affiliate interaction.
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(93), __webpack_require__(3), __webpack_require__(34)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Application, Logon, RegisterUser) {
	  var QuickApplication = {
	    /**
	     * Initialize the application specific functions
	     * @return {void}
	     */
	    init: function init() {
	      Application.init();
	      COSTCO.MembershipHelper.isQuickMembership = true;
	
	      if (this.isAccountBlockDisplayed()) {
	        this.displayAccountMembershipForm();
	      }
	      this.bindEvents();
	      this.showOptionalSections();
	      $('#MemberAddressBookForm').keypress(function (e) {
	        if (e.which == 13) {
	          QuickApplication.saveContinue();
	        }
	      });
	    },
	    isAccountBlockDisplayed: function isAccountBlockDisplayed() {
	      return $('#account-membership-block').length > 0;
	    },
	    /**
	     * If there is data, expand People within Household and Additional People sections on page load.
	     * @return {void}
	     */
	    showOptionalSections: function showOptionalSections() {
	      if ($('#household_first_name').val()) {
	        $('#household-body').collapse('show');
	      }
	      if ($('.affiliate-block').length > 0) {
	        $('#additional-people-body').collapse('show');
	      }
	    },
	    /**
	     * Bind event handlers for membership application page
	     */
	    bindEvents: function bindEvents() {
	      // Copy content of email field in primary membership block to account section of the page
	      $('#email').blur(function () {
	        if ($('#register_email1').length > 0 && Boolean($('#register_email1').val()) == false) {
	          $('#register_email1').val(this.value);
	        } else if (Boolean($('#logonId').val()) == false) {
	          $('#logonId').val(this.value);
	        }
	      });
	
	      $('#set-default').click(function () {
	        if ($(this).prop('checked')) {
	          $('#save-address').prop('checked', true);
	          $('.defaultWarning.kb-OOS-banner').removeClass('hide');
	        } else {
	          $('.defaultWarning.kb-OOS-banner').addClass('hide');
	        }
	      });
	      $('#save-address').click(function () {
	        if (!$(this).prop('checked')) {
	          $('#set-default').prop('checked', false);
	        }
	      });
	    },
	    /**
	     * Submit Membership Application via Save&Continue button.
	     * @return {void}
	     */
	    submitApplication: function submitApplication(addresses) {
	      var isAppFormValid = COSTCO.ApplicationForm.validate();
	      if ($('#LogonForm').length > 0) {
	        // Try to log the user in, and then submit the MemberApplication form
	        var isLogonFormValid = $('#LogonForm').valid();
	        if (isLogonFormValid && isAppFormValid) {
	          $('.permanent-ajax-busy').addClass('ajax-busy');
	          COSTCO.util.ajax({
	            type: 'POST',
	            url: '/AjaxLogon',
	            dataType: 'json',
	            data: $('#LogonForm').serializeArray(),
	            done: function done(data, textStatus, jqXHR, options) {
	              if (data.errorMessage) {
	                $('.permanent-ajax-busy').removeClass('ajax-busy');
	                COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, [data.errorMessage], true, '#account-error');
	              } else {
	                COSTCO.util.notification.clearNotification('#account-error');
	                COSTCO.ApplicationForm.submitContinue(addresses);
	              }
	            },
	            fail: function fail(data, textStatus, jqXHR, options) {
	              $('.permanent-ajax-busy').removeClass('ajax-busy');
	              console.log('Ajax call failed!');
	            },
	            always: function always() {}
	          });
	        } else {
	          $('.permanent-ajax-busy').removeClass('ajax-busy');
	        }
	      } else if ($('#RegisterForm').length > 0) {
	        // Try to register the user first, and then submit the MemberApplication form
	        var isRegisterFormValid = $('#RegisterForm').valid();
	        if (isAppFormValid && isRegisterFormValid) {
	          $('.permanent-ajax-busy').addClass('ajax-busy');
	          COSTCO.util.ajax({
	            type: 'POST',
	            url: '/AjaxUserRegistrationAdd',
	            dataType: 'json',
	            data: $('#RegisterForm').serializeArray(),
	            done: function done(data, textStatus, jqXHR, options) {
	              if (data.errorMessage) {
	                $('.permanent-ajax-busy').removeClass('ajax-busy');
	                COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, [data.errorMessage], true, '#account-error');
	              } else {
	                COSTCO.util.notification.clearNotification('#account-error');
	                COSTCO.ApplicationForm.submitContinue(addresses);
	              }
	            },
	            fail: function fail(data, textStatus, jqXHR, options) {
	              $('.permanent-ajax-busy').removeClass('ajax-busy');
	              console.log('Ajax call failed!');
	            },
	            always: function always() {}
	          });
	        } else {
	          $('.permanent-ajax-busy').removeClass('ajax-busy');
	        }
	      } else {
	        if (isAppFormValid) {
	          $('.permanent-ajax-busy').addClass('ajax-busy');
	          COSTCO.ApplicationForm.submitContinue(addresses);
	        } else {
	          $('.permanent-ajax-busy').removeClass('ajax-busy');
	        }
	      }
	    },
	    /**
	     * Main function and inline event handler for "Save and Continue"
	     * for adding personal information / business information to the
	     * application.
	     * @return {void} [description]
	     */
	    saveContinue: function saveContinue() {
	      if (COSTCO.ApplicationForm.validate() && COSTCO.QuickApplication.passwordMatch()) {
	        $('#MemberAddressBookForm').find('input[id="addressEnteredForCheck"]').remove();
	        $('#MemberAddressBookForm').append('<input type="hidden" id="addressEnteredForCheck" value="' + $('#address1').val() + '"/>');
	        // Pages using this: QuickMembershipApplicationBody.jsp,
	        COSTCO.MembershipHelper
	        // Attempt to call address verification service
	        .verifyAddresses({
	          form: '#MemberAddressBookForm',
	          primary: COSTCO.MembershipHelper.personalAddressSelectors,
	          business: COSTCO.MembershipHelper.businessAddressSelectors
	        })
	        // If the service returns successfully (200), invoke the modal
	        // and use the addresses the user selects
	        .then(function (verifyResponse) {
	          return COSTCO.MembershipHelper.invokeMultiAVS(verifyResponse, QuickApplication.submitApplication);
	        })
	        // If the service fails, we still want to submit the form using
	        // the addresses the user provided initially
	        .fail(QuickApplication.submitApplication);
	      }
	    },
	
	    passwordMatch: function passwordMatch() {
	      var equals = false;
	      if ($('#alreadyHaveAccount:checkbox:checked').length > 0) {
	        equals = true;
	      } else if ($('#logonPassword').length === 0 && $('#logonPasswordVerify').length === 0) {
	        equals = true;
	      } else if ($('#logonPasswordVerify').length > 0 && $('#logonPassword').length > 0) {
	        equals = $('#logonPasswordVerify').val() === $('#logonPassword').val();
	      }
	      return equals;
	    },
	    /**
	     * Displays a register or logon form depending of user selected "I already have a Costco.com account" checkbox
	     */
	    displayAccountMembershipForm: function displayAccountMembershipForm() {
	      if ($('#alreadyHaveAccount').prop('checked')) {
	        $('#account-membership-block').html(COSTCO.util.tmpl('tmpl_logon_membership', {
	          emailValue: $('#email').val()
	        }));
	        Logon.init();
	      } else {
	        $('#account-membership-block').html(COSTCO.util.tmpl('tmpl_register_membership', {
	          emailValue: $('#email').val()
	        }));
	        RegisterUser.init();
	      }
	    }
	  };
	  if (typeof window.COSTCO === 'undefined') {
	    window.COSTCO = {};
	  }
	  window.COSTCO.QuickApplication = QuickApplication;
	  return QuickApplication;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title quick-membership-checkout.js: Feature level module
	 * @description The interface for quick membership checkout. These methods
	 *              are bound in /QuickMembershipCheckoutView
	 *              (QuickMembershipPurchaseCheckoutBody.jsp).
	*/
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(20), __webpack_require__(73), __webpack_require__(33)], __WEBPACK_AMD_DEFINE_RESULT__ = function (RenewMembership, QuickRenewAddressHelper, MembershipValidation) {
	  var QuickMembershipCheckout = {
	    /**
	     * Initialize the quick membership checkout specific functions
	     * @return {void}
	     */
	    init: function init(page) {
	
	      COSTCO.MembershipHelper.isQuickMembership = true;
	
	      QuickRenewAddressHelper.init();
	
	      switch (page) {
	        case QuickMembershipCheckout.constants.QUICK_MEMBERSHIP_PURCHASE:
	          COSTCO.Application.applicationPreprocesses();
	          QuickMembershipCheckout.bindHeaderAndFooterLinksForLeavePageModal(QuickMembershipCheckout.constants.QUICK_MEMBERSHIP_PURCHASE);
	          break;
	        case QuickMembershipCheckout.constants.QUICK_MEMBERSHIP_RENEW:
	          RenewMembership.init();
	          QuickMembershipCheckout.bindHeaderAndFooterLinksForLeavePageModal(QuickMembershipCheckout.constants.QUICK_MEMBERSHIP_RENEW);
	          break;
	      }
	
	      this.initDefaultPaymentCheckbox();
	      this.setValidationDefaults();
	    },
	    constants: {
	      QUICK_MEMBERSHIP: 'quick-membership',
	      QUICK_MEMBERSHIP_PURCHASE: 'quick-membership-purchase',
	      QUICK_MEMBERSHIP_RENEW: 'quick-membership-renew'
	    },
	    /**
	     * Sets validation defaults specific for this sub-module.
	     * @return {void}
	     */
	    setValidationDefaults: function setValidationDefaults() {
	      try {
	        if ($.validator.defaults.ignore.indexOf(':hidden') == -1) {
	          var ignoreSelectors = $.validator.defaults.ignore.length > 0 ? $.validator.defaults.ignore + ", :hidden" : ":hidden";
	          $.validator.setDefaults({ ignore: ignoreSelectors });
	        }
	      } catch (err) {
	        console.error('Error while setting validation rules: ' + err.message);
	      }
	    },
	    /**
	     * Ticks the Default Payment checkbox for US store
	     * @return {void}
	    */
	    initDefaultPaymentCheckbox: function initDefaultPaymentCheckbox() {
	      if (wcs.storeId == '10301') {
	        $('#CheckoutPaymentForm').find('#save_CC').prop('checked', true);
	      }
	    },
	    /**
	     * Handles Choose a Membership radio button interaction on Quick Renew Post-Lockdown page
	     * @return {void}
	     */
	    chooseMembership: function chooseMembership(memberType, isUpgrade) {
	      $('#renew-membership-block, #upgrade-membership-block').toggleClass('radio-selected-background');
	      var tncDiv = $('#membership-terms-div');
	      isUpgrade ? tncDiv.removeClass('hide') : tncDiv.addClass('hide');
	      MembershipValidation.renewMembership(memberType, false, isUpgrade, 'postLockdown');
	    },
	    /**
	     * Showing leave page modal if user chooses to cancel shopping
	     * @param {string} flowType	type of quick membership checkout flow (QUICK_MEMBERSHIP_PURCHASE | QUICK_MEMBERSHIP_RENEW)
	     * @param {string} secondaryButtonHref	To set where secondary button should redirect
	     */
	    initiateLeavePageModal: function initiateLeavePageModal(flowType, secondaryButtonHref) {
	      var isCanadaFrench = wcs.langId === '-25' && wcs.storeId === '10302';
	      var dialogClasses = 'leave-page-modal ' + (isCanadaFrench ? 'button-modal-fix' : '');
	      var modalTextObj = {};
	      switch (flowType) {
	        case QuickMembershipCheckout.constants.QUICK_MEMBERSHIP_PURCHASE:
	          modalTextObj.primaryButton = messages.STAY_ON_PAGE_BUTTON;
	          modalTextObj.secondaryButton = memberOnlyFeatureEnabled ? messages.MEMBERSHIP_VALIDATION_Browse_Button_Text : messages.LEAVE_PAGE_BUTTON;
	          modalTextObj.body = memberOnlyFeatureEnabled ? messages.MOP_QUICK_PURCHASE_Checkout_PostLockdown_Leave_Page_Body : messages.LEAVE_PAGE_POP_UP_BODY;
	          break;
	        case QuickMembershipCheckout.constants.QUICK_MEMBERSHIP_RENEW:
	          modalTextObj.primaryButton = messages.STAY_ON_PAGE_BUTTON;
	          modalTextObj.secondaryButton = memberOnlyFeatureEnabled ? messages.MEMBERSHIP_VALIDATION_Browse_Button_Text : messages.LEAVE_PAGE_BUTTON;
	          modalTextObj.body = memberOnlyFeatureEnabled ? messages.MOP_QUICK_PURCHASE_Checkout_PostLockdown_Leave_Page_Body_Renew : messages.LEAVE_PAGE_POP_UP_BODY;
	          break;
	      }
	
	      COSTCO.dialog.createExtDialogBox({
	        title: messages.LEAVE_PAGE_POP_UP_TITLE,
	        body: modalTextObj.body,
	        primary: modalTextObj.primaryButton,
	        secondary: modalTextObj.secondaryButton,
	        dialogclasses: dialogClasses,
	        primary_event: function primary_event() {
	          COSTCO.dialog.close();
	        },
	        secondary_event: function secondary_event() {
	          var urlParam = { 'actionType': 'clearTargetedCart', 'backURL': secondaryButtonHref };
	          var clearCartUrl = $('#clear-cart-cmd').val() + '?' + jQuery.param(urlParam);
	
	          window.location.href = clearCartUrl;
	        }
	      });
	    },
	
	    /**
	     * Binding header and footer links for initiating leave page modal
	     * @param {string} flowType	type of quick membership checkout flow (QUICK_MEMBERSHIP_PURCHASE | QUICK_MEMBERSHIP_RENEW)
	     */
	    bindHeaderAndFooterLinksForLeavePageModal: function bindHeaderAndFooterLinksForLeavePageModal(flowType) {
	
	      var headerAndFooterLinks = $('#header-checkout-widget, #footer-bottom').find("a");
	      headerAndFooterLinks.click(function () {
	        var addressValue = $(this).attr("href");
	        if (addressValue != '#') QuickMembershipCheckout.initiateLeavePageModal(flowType, addressValue);
	        return false;
	      });
	    },
	    /**
	     * Setting individual price amount for affiliate member
	     */
	    setAffiliateMembershipPriceIfAddingNewAffiliates: function setAffiliateMembershipPriceIfAddingNewAffiliates() {
	
	      var configProduct = COSTCO.util.getFromSession('configProduct');
	      if (configProduct.type == 'ADDMEMBER_AFFILIATE_BUSINESS') {
	        $('#membership-price').hide();
	        var affiliateCount = $('.affiliate-price').length;
	        var totalPrice = $('#outstandingPrincipal').val();
	        var affiliatePrice = totalPrice / affiliateCount;
	        QuickMembershipCheckout.setAffiliatePrice(affiliatePrice);
	      }
	    },
	    /**
	     * For each affiliate set appropriate price
	     * @param {string} price
	     */
	    setAffiliatePrice: function setAffiliatePrice(price) {
	      return $('.affiliate-price').map(function () {
	        this.innerHTML = '$' + parseFloat(Math.round(price * 100) / 100).toFixed(2);
	      });
	    }
	  };
	  if (typeof window.COSTCO === 'undefined') {
	    window.COSTCO = {};
	  }
	  window.COSTCO.QuickMembershipCheckout = QuickMembershipCheckout;
	  return QuickMembershipCheckout;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }
/******/ ]);


// WEBPACK FOOTER //
// membership.module.min.js